/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 94);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(101);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.presets=exports.scenario=exports.score=exports.news=exports.date=exports.time=exports.offers=exports.finance=exports.cropPlan=exports.shipment=exports.storageStore=exports.dcUnitsStore=exports.receptionBunkersStore=exports.transportStore=undefined;var _news=__webpack_require__(137);var _news2=_interopRequireDefault(_news);var _date=__webpack_require__(138);var _date2=_interopRequireDefault(_date);var _time=__webpack_require__(139);var _time2=_interopRequireDefault(_time);var _score=__webpack_require__(140);var _score2=_interopRequireDefault(_score);var _scenario=__webpack_require__(141);var _scenario2=_interopRequireDefault(_scenario);var _ShipmentStore=__webpack_require__(142);var _ShipmentStore2=_interopRequireDefault(_ShipmentStore);var _presetsStore=__webpack_require__(143);var _presetsStore2=_interopRequireDefault(_presetsStore);var _financeData=__webpack_require__(165);var _financeData2=_interopRequireDefault(_financeData);var _cropPlan=__webpack_require__(167);var _cropPlan2=_interopRequireDefault(_cropPlan);var _ReceptionTransportStore=__webpack_require__(56);var _ReceptionTransportStore2=_interopRequireDefault(_ReceptionTransportStore);var _ReceptionBunkersStore=__webpack_require__(168);var _ReceptionBunkersStore2=_interopRequireDefault(_ReceptionBunkersStore);var _DCunitsStore=__webpack_require__(169);var _DCunitsStore2=_interopRequireDefault(_DCunitsStore);var _StorageStore=__webpack_require__(170);var _StorageStore2=_interopRequireDefault(_StorageStore);var _offersStore=__webpack_require__(171);var _offersStore2=_interopRequireDefault(_offersStore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var transportStore=exports.transportStore=new _ReceptionTransportStore2.default();var receptionBunkersStore=exports.receptionBunkersStore=new _ReceptionBunkersStore2.default();var dcUnitsStore=exports.dcUnitsStore=new _DCunitsStore2.default();var storageStore=exports.storageStore=new _StorageStore2.default();var shipment=exports.shipment=new _ShipmentStore2.default();var cropPlan=exports.cropPlan=new _cropPlan2.default();var finance=exports.finance=new _financeData2.default();var offers=exports.offers=new _offersStore2.default();var time=exports.time=new _time2.default();var date=exports.date=new _date2.default();var news=exports.news=new _news2.default();var score=exports.score=new _score2.default();var scenario=exports.scenario=new _scenario2.default();var presets=exports.presets=new _presetsStore2.default();

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observer", function() { return observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observer", function() { return Observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderReporter", function() { return renderReporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistery", function() { return componentByNodeRegistery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackComponents", function() { return trackComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStaticRendering", function() { return useStaticRendering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableObject"];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableMap"];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) return;
        // Generate friendly name for debugging
        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Atom"]("reactive " + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, "props");
        // make state an observable reference
        makePropertyObservableReference.call(this, "state");

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Reaction"](initialName + "#" + rootNodeID + ".render()", function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this);
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) reaction.dispose();
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender();
        };

        var reactiveRender = function reactiveRender() {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderStart = Date.now();
                }
                try {
                    rendering = __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].allowStateChanges(false, baseRender);
                } catch (e) {
                    exception = e;
                }
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderEnd = Date.now();
                }
            });
            if (exception) {
                errorsReporter.emit(exception);
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistery) {
                componentByNodeRegistery.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    var InjectComponent = inject(observerInject)(component);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["extras"]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]);else if (typeof unstable_batchedUpdates$1 === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(unstable_batchedUpdates$1);

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["spy"], extras: __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"] };
    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}




/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extras", function() { return extras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reaction", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untracked", function() { return untracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDerivationState", function() { return IDerivationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Atom", function() { return Atom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAtom", function() { return BaseAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStrict", function() { return useStrict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStrictModeEnabled", function() { return isStrictModeEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spy", function() { return spy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comparer", function() { return comparer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asReference", function() { return asReference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asFlat", function() { return asFlat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asStructure", function() { return asStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asMap", function() { return asMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isModifierDescriptor", function() { return isModifierDescriptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableObject", function() { return isObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function() { return isObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableArray", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableMap", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableMap", function() { return isObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transaction", function() { return transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputed", function() { return isComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendObservable", function() { return extendObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendShallowObservable", function() { return extendShallowObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intercept", function() { return intercept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorun", function() { return autorun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorunAsync", function() { return autorunAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "when", function() { return when; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reaction", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAction", function() { return isAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runInAction", function() { return runInAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expr", function() { return expr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransformer", function() { return createTransformer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whyRun", function() { return whyRun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return trace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var BaseAtom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function BaseAtom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    BaseAtom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     */
    BaseAtom.prototype.reportObserved = function () {
        reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    BaseAtom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    BaseAtom.prototype.toString = function () {
        return this.name;
    };
    return BaseAtom;
}());
var Atom = /** @class */ (function (_super) {
    __extends(Atom, _super);
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.onBecomeObservedHandler = onBecomeObservedHandler;
        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
        _this.isPendingUnobservation = false; // for effective unobserving.
        _this.isBeingTracked = false;
        return _this;
    }
    Atom.prototype.reportObserved = function () {
        startBatch();
        _super.prototype.reportObserved.call(this);
        if (!this.isBeingTracked) {
            this.isBeingTracked = true;
            this.onBecomeObservedHandler();
        }
        endBatch();
        return !!globalState.trackingDerivation;
        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
    };
    Atom.prototype.onBecomeUnobserved = function () {
        this.isBeingTracked = false;
        this.onBecomeUnobservedHandler();
    };
    return Atom;
}(BaseAtom));
var isAtom = createInstanceofPredicate("Atom", BaseAtom);

function hasInterceptors(interceptable) {
    return interceptable.interceptors && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = objectAssign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(objectAssign({}, change, END_EVENT));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        var idx = globalState.spyListeners.indexOf(listener);
        if (idx !== -1)
            globalState.spyListeners.splice(idx, 1);
    });
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
var IS_ITERATING_MARKER = "__$$iterating";
function arrayAsIterator(array) {
    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
    // yet it is quite convenient to be able to use the response both as array directly and as iterator
    // it is suboptimal, but alas...
    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
    var idx = -1;
    addHiddenFinalProp(array, "next", function next() {
        idx++;
        return {
            done: idx >= this.length,
            value: idx < this.length ? this[idx] : undefined
        };
    });
    return array;
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.interceptors = null;
        this.changeListeners = null;
        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = [];
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = oldItems.slice(0, toIndex).concat([
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    return arrayAsIterator(this.slice());
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            // TODO: Check `this`?, see #752?
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var UNCHANGED = {};
var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.dehancer = undefined;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", object: _this, newValue: _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    object: this,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(BaseAtom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var messages = {
    m001: "It is not allowed to assign new values to @action fields",
    m002: "`runInAction` expects a function",
    m003: "`runInAction` expects a function without arguments",
    m004: "autorun expects a function",
    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
    m012: "computed takes one or two arguments if used as function",
    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
    m014: "extendObservable expected 2 or more arguments",
    m015: "extendObservable expects an object as first argument",
    m016: "extendObservable should not be used on maps, use map.merge instead",
    m017: "all arguments of extendObservable should be objects",
    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
    m020: "modifiers can only be used for individual object properties",
    m021: "observable expects zero or one arguments",
    m022: "@observable can not be used on getters, use @computed instead",
    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
    m025: "whyRun can only be used on reactions and computed values",
    m026: "`action` can only be invoked on functions",
    m028: "It is not allowed to set `useStrict` when a derivation is running",
    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
    m033: "`observe` doesn't support the fire immediately property for observable maps.",
    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
    m035: "Cannot make the designated object observable; it is not extensible",
    m036: "It is not possible to get index atoms from arrays",
    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
};
function getMessage(id) {
    return messages[id];
}

function createAction(actionName, fn) {
    invariant(typeof fn === "function", getMessage("m026"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.originalFn = fn;
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            fn: fn,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function useStrict(strict) {
    invariant(globalState.trackingDerivation === null, getMessage("m028"));
    globalState.strictMode = strict;
    globalState.allowStateChanges = !strict;
}
function isStrictModeEnabled() {
    return globalState.strictMode;
}
function allowStateChanges(allowStateChanges, func) {
    // TODO: deprecate / refactor this function in next major
    // Currently only used by `@observer`
    // Proposed change: remove first param, rename to `forbidStateChanges`,
    // require error callback instead of the hardcoded error message now used
    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

/**
 * Constructs a decorator, that normalizes the differences between
 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
 * values during instance creation to properties that have a getter setter.
 *
 * - Sigh -
 *
 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
 */
function createClassPropertyDecorator(
/**
 * This function is invoked once, when the property is added to a new instance.
 * When this happens is not strictly determined due to differences in TS and Babel:
 * Typescript: Usually when constructing the new instance
 * Babel, sometimes Typescript: during the first get / set
 * Both: when calling `runLazyInitializers(instance)`
 */
onInitialize, get, set, enumerable, 
/**
 * Can this decorator invoked with arguments? e.g. @decorator(args)
 */
allowCustomArguments) {
    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
        if (argLen === void 0) { argLen = 0; }
        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
        if (!descriptor) {
            // typescript (except for getter / setters)
            var newDescriptor = {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
                    }
                    else {
                        set.call(this, key, v);
                    }
                }
            };
            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
                // Typescript target is ES3, so it won't define property for us
                // or using Reflect.decorate polyfill, which will return no descriptor
                // (see https://github.com/mobxjs/mobx/issues/333)
                Object.defineProperty(target, key, newDescriptor);
            }
            return newDescriptor;
        }
        else {
            // babel and typescript getter / setter props
            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
                );
            }
            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
            target.__mobxLazyInitializers.push(function (instance) {
                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
            });
            return {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    set.call(this, key, v);
                }
            };
        }
    }
    if (allowCustomArguments) {
        /** If custom arguments are allowed, we should return a function that returns a decorator */
        return function () {
            /** Direct invocation: @decorator bla */
            if (quacksLikeADecorator(arguments))
                return classPropertyDecorator.apply(null, arguments);
            /** Indirect invocation: @decorator(args) bla */
            var outerArgs = arguments;
            var argLen = arguments.length;
            return function (target, key, descriptor) {
                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
            };
        };
    }
    return classPropertyDecorator;
}
function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
        addHiddenProp(instance, "__mobxInitializedProps", {});
    instance.__mobxInitializedProps[key] = true;
    onInitialize(instance, key, v, customArgs, baseDescriptor);
}
function runLazyInitializers(instance) {
    if (instance.__mobxDidRunLazyInitializers === true)
        return;
    if (instance.__mobxLazyInitializers) {
        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
        instance.__mobxDidRunLazyInitializers &&
            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
    }
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
}

var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
    var wrappedAction = action(actionName, value);
    addHiddenProp(target, key, wrappedAction);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, true);
var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
    defineBoundAction(target, key, value);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, false);
var action = function action(arg1, arg2, arg3, arg4) {
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = function boundAction(arg1, arg2, arg3) {
    if (typeof arg1 === "function") {
        var action_1 = createAction("<not yet bound action>", arg1);
        action_1.autoBind = true;
        return action_1;
    }
    return boundActionDecorator.apply(null, arguments);
};
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor && typeof descriptor.value === "function") {
            // TypeScript @action method() { }. Defined on proto before being decorated
            // Don't use the field decorator if we are just decorating a method
            descriptor.value = createAction(name, descriptor.value);
            descriptor.enumerable = false;
            descriptor.configurable = true;
            return descriptor;
        }
        if (descriptor !== undefined && descriptor.get !== undefined) {
            throw new Error("[mobx] action is not expected to be used with getters");
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function runInAction(arg1, arg2, arg3) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    var scope = typeof arg1 === "function" ? arg2 : arg3;
    invariant(typeof fn === "function", getMessage("m002"));
    invariant(fn.length === 0, getMessage("m003"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    return executeAction(actionName, fn, scope, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    var res = function () {
        return executeAction(propertyName, fn, target, arguments);
    };
    res.isMobxAction = true;
    addHiddenProp(target, propertyName, res);
}

var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a), key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isObservableMap(a))
        return a.entries();
    if (isES6Map(a))
        return iteratorToArray(a.entries());
    return a;
}
function has(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

function autorun(arg1, arg2, arg3) {
    var name, view, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        view = arg2;
        scope = arg3;
    }
    else {
        name = arg1.name || "Autorun@" + getNextId();
        view = arg1;
        scope = arg2;
    }
    invariant(typeof view === "function", getMessage("m004"));
    invariant(isAction(view) === false, getMessage("m005"));
    if (scope)
        view = view.bind(scope);
    var reaction = new Reaction(name, function () {
        this.track(reactionRunner);
    });
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
function when(arg1, arg2, arg3, arg4) {
    var name, predicate, effect, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        predicate = arg2;
        effect = arg3;
        scope = arg4;
    }
    else {
        name = "When@" + getNextId();
        predicate = arg1;
        effect = arg2;
        scope = arg3;
    }
    var disposer = autorun(name, function (r) {
        if (predicate.call(scope)) {
            r.dispose();
            var prevUntracked = untrackedStart();
            effect.call(scope);
            untrackedEnd(prevUntracked);
        }
    });
    return disposer;
}
function autorunAsync(arg1, arg2, arg3, arg4) {
    var name, func, delay, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        func = arg2;
        delay = arg3;
        scope = arg4;
    }
    else {
        name = arg1.name || "AutorunAsync@" + getNextId();
        func = arg1;
        delay = arg2;
        scope = arg3;
    }
    invariant(isAction(func) === false, getMessage("m006"));
    if (delay === void 0)
        delay = 1;
    if (scope)
        func = func.bind(scope);
    var isScheduled = false;
    var r = new Reaction(name, function () {
        if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                if (!r.isDisposed)
                    r.track(reactionRunner);
            }, delay);
        }
    });
    function reactionRunner() {
        func(r);
    }
    r.schedule();
    return r.getDisposer();
}
function reaction(expression, effect, arg3) {
    if (arguments.length > 3) {
        fail(getMessage("m007"));
    }
    if (isModifierDescriptor(expression)) {
        fail(getMessage("m008"));
    }
    var opts;
    if (typeof arg3 === "object") {
        opts = arg3;
    }
    else {
        opts = {};
    }
    opts.name =
        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
    opts.delay = opts.delay || 0;
    opts.compareStructural = opts.compareStructural || opts.struct || false;
    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
    if (opts.context) {
        expression = expression.bind(opts.context);
    }
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    var r = new Reaction(opts.name, function () {
        if (firstTime || opts.delay < 1) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                reactionRunner();
            }, opts.delay);
        }
    });
    function reactionRunner() {
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effect(value, r);
        if (!firstTime && changed === true)
            effect(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(derivation, scope, equals, name, setter) {
        this.derivation = derivation;
        this.scope = scope;
        this.equals = equals;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        this.name = name || "ComputedValue@" + getNextId();
        if (setter)
            this.setter = createAction(name + "-setter", setter);
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        clearObserving(this);
        this.value = undefined;
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
        if (globalState.inBatch === 0) {
            // This is an minor optimization which could be omitted to simplify the code
            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
            // tracking as it will never be called again inside this batch.
            startBatch();
            if (shouldCompute(this)) {
                if (this.isTracing !== TraceMode.NONE) {
                    console.log("[mobx.trace] '" + this
                        .name + "' is being read outside a reactive context and doing a full recompute");
                }
                this.value = this.computeValue(false);
            }
            endBatch();
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "[ComputedValue '" + this
                .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                fn: this.derivation
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = (this.value = this.computeValue(true));
        return (wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue));
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            try {
                res = this.derivation.call(this.scope);
            }
            catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype.whyRun = function () {
        var isTracking = Boolean(globalState.trackingDerivation);
        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
            ? "[active] the value of this computation is needed by a reaction"
            : this.isComputing
                ? "[get] The value of this computed was requested outside a reaction"
                : "[idle] not running at the moment") + "\n" +
            (this.dependenciesState === IDerivationState.NOT_TRACKING
                ? getMessage("m032")
                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
                    ? " (... or any observable accessed during the remainder of the current run)"
                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name) {
        this.target = target;
        this.name = name;
        this.values = {};
        this.changeListeners = null;
        this.interceptors = null;
    }
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name) {
    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
        return target.$mobx;
    invariant(Object.isExtensible(target), getMessage("m035"));
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, name);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
        // already observable property
        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
        return;
    }
    // not yet observable property
    if ("value" in descriptor) {
        // not a computed value
        if (isModifierDescriptor(descriptor.value)) {
            // x : ref(someValue)
            var modifierDescriptor = descriptor.value;
            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
        }
        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
        }
        else if (isComputedValue(descriptor.value)) {
            // x: computed(someExpr)
            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
        }
        else {
            // x: someValue
            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
        }
    }
    else {
        // get x() { return 3 } set x(v) { }
        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
    }
}
function defineObservableProperty(adm, propName, newValue, enhancer) {
    assertPropertyConfigurable(adm.target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: adm.target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
    notifyPropertyAddition(adm, adm.target, propName, newValue);
}
function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
    if (asInstanceProperty)
        assertPropertyConfigurable(adm.target, propName);
    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
    if (asInstanceProperty) {
        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
    }
}
function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
    var name = adm.name + "." + propName;
    computedValue.name = name;
    if (!computedValue.scope)
        computedValue.scope = adm.target;
    adm.values[propName] = computedValue;
    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                setPropertyValue(this, propName, v);
            }
        }));
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                return this.$mobx.values[propName].set(v);
            }
        }));
}
function setPropertyValue(instance, name, newValue) {
    var adm = instance.$mobx;
    var observable = adm.values[name];
    // intercept
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            type: "update",
            object: instance,
            name: name,
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    newValue = observable.prepareNewValue(newValue);
    // notify spy & observers
    if (newValue !== UNCHANGED) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "update",
                object: instance,
                oldValue: observable.value,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        observable.setNewValue(newValue);
        if (notify)
            notifyListeners(adm, change);
        if (notifySpy)
            spyReportEnd();
    }
}
function notifyPropertyAddition(adm, object, name, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: name,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(change);
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

/**
 * Returns true if the provided value is reactive.
 * @param value object, function or array
 * @param property if property is specified, checks whether value.property is reactive.
 */
function isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableArray(value) || isObservableMap(value))
            throw new Error(getMessage("m019"));
        else if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}

function createDecoratorForEnhancer(enhancer) {
    invariant(!!enhancer, ":(");
    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
        assertPropertyConfigurable(target, name);
        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
        var adm = asObservableObject(target, undefined);
        defineObservableProperty(adm, name, baseValue, enhancer);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        setPropertyValue(this, name, value);
    }, true, false);
}

function extendObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, deepEnhancer, properties);
}
function extendShallowObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, referenceEnhancer, properties);
}
function extendObservableHelper(target, defaultEnhancer, properties) {
    invariant(arguments.length >= 2, getMessage("m014"));
    invariant(typeof target === "object", getMessage("m015"));
    invariant(!isObservableMap(target), getMessage("m016"));
    properties.forEach(function (propSet) {
        invariant(typeof propSet === "object", getMessage("m017"));
        invariant(!isObservable(propSet), getMessage("m018"));
    });
    var adm = asObservableObject(target);
    var definedProps = {};
    // Note could be optimised if properties.length === 1
    for (var i = properties.length - 1; i >= 0; i--) {
        var propSet = properties[i];
        for (var key in propSet)
            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
                definedProps[key] = true;
                if (target === propSet && !isPropertyConfigurable(target, key))
                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
            }
    }
    return target;
}

var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v) {
    if (v === void 0) { v = undefined; }
    // @observable someProp;
    if (typeof arguments[1] === "string")
        return deepDecorator.apply(null, arguments);
    invariant(arguments.length <= 1, getMessage("m021"));
    invariant(!isModifierDescriptor(v), getMessage("m020"));
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = deepEnhancer(v, undefined, undefined);
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    return observable.box(v);
}
var observableFactories = {
    box: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        return new ObservableValue(value, deepEnhancer, name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        return new ObservableValue(value, referenceEnhancer, name);
    },
    array: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        return new ObservableArray(initialValues, deepEnhancer, name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        return new ObservableArray(initialValues, referenceEnhancer, name);
    },
    map: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        return new ObservableMap(initialValues, deepEnhancer, name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        return new ObservableMap(initialValues, referenceEnhancer, name);
    },
    object: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("object");
        var res = {};
        // convert to observable object
        asObservableObject(res, name);
        // add properties
        extendObservable(res, props);
        return res;
    },
    shallowObject: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowObject");
        var res = {};
        asObservableObject(res, name);
        extendShallowObservable(res, props);
        return res;
    },
    ref: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(referenceEnhancer, arguments[0]);
        }
        else {
            return refDecorator.apply(null, arguments);
        }
    },
    shallow: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(shallowEnhancer, arguments[0]);
        }
        else {
            return shallowDecorator.apply(null, arguments);
        }
    },
    deep: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepEnhancer, arguments[0]);
        }
        else {
            return deepDecorator.apply(null, arguments);
        }
    },
    struct: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
        }
        else {
            return deepStructDecorator.apply(null, arguments);
        }
    }
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
observable.deep.struct = observable.struct;
observable.ref.struct = function () {
    if (arguments.length < 2) {
        return createModifierDescriptor(refStructEnhancer, arguments[0]);
    }
    else {
        return refStructDecorator.apply(null, arguments);
    }
};
function incorrectlyUsedAsDecorator(methodName) {
    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function isModifierDescriptor(thing) {
    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
}
function createModifierDescriptor(enhancer, initialValue) {
    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
    return {
        isMobxModifierDescriptor: true,
        initialValue: initialValue,
        enhancer: enhancer
    };
}
function deepEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, name);
    if (isPlainObject(v))
        return observable.object(v, name);
    if (isES6Map(v))
        return observable.map(v, name);
    return v;
}
function shallowEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.shallowArray(v, name);
    if (isPlainObject(v))
        return observable.shallowObject(v, name);
    if (isES6Map(v))
        return observable.shallowMap(v, name);
    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function deepStructEnhancer(v, oldValue, name) {
    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
    // more suited for immutable objects
    if (deepEqual(v, oldValue))
        return oldValue;
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return new ObservableArray(v, deepStructEnhancer, name);
    if (isES6Map(v))
        return new ObservableMap(v, deepStructEnhancer, name);
    if (isPlainObject(v)) {
        var res = {};
        asObservableObject(res, name);
        extendObservableHelper(res, deepStructEnhancer, [v]);
        return res;
    }
    return v;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._data = Object.create(null);
        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        this.interceptors = null;
        this.changeListeners = null;
        this.dehancer = undefined;
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return typeof this._data[key] !== "undefined";
    };
    ObservableMap.prototype.has = function (key) {
        if (!this.isValidKey(key))
            return false;
        key = "" + key;
        if (this._hasMap[key])
            return this._hasMap[key].get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        this.assertValidKey(key);
        key = "" + key;
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        this.assertValidKey(key);
        key = "" + key;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data[key].value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data[key];
                observable$$1.setNewValue(undefined);
                _this._data[key] = undefined;
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap[key];
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (name, newValue) {
        var observable$$1 = this._data[name];
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: name,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (name, newValue) {
        var _this = this;
        transaction(function () {
            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(name, true);
            _this._keys.push(name);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        key = "" + key;
        if (this.has(key))
            return this.dehanceValue(this._data[key].get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return arrayAsIterator(this._keys.slice());
    };
    ObservableMap.prototype.values = function () {
        return arrayAsIterator(this._keys.map(this.get, this));
    };
    ObservableMap.prototype.entries = function () {
        var _this = this;
        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this.keys().forEach(_this.delete, _this);
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this.keys();
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values might still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = {};
        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableMap.prototype.isValidKey = function (key) {
        if (key === null || key === undefined)
            return false;
        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
            return true;
        return false;
    };
    ObservableMap.prototype.assertValidKey = function (key) {
        if (!this.isValidKey(key))
            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        invariant(fireImmediately !== true, getMessage("m033"));
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
function map(initialValues) {
    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
    return observable.map(initialValues);
}
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message, thing) {
    invariant(false, message, thing);
    throw "X"; // unreachable
}
function invariant(check, message, thing) {
    if (!check)
        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function joinStrings(things, limit, separator) {
    if (limit === void 0) { limit = 100; }
    if (separator === void 0) { separator = " - "; }
    if (!things)
        return "";
    var sliced = things.slice(0, limit);
    return "" + sliced.join(separator) + (things.length > limit
        ? " (... and " + (things.length - limit) + "more)"
        : "");
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function objectAssign() {
    var res = arguments[0];
    for (var i = 1, l = arguments.length; i < l; i++) {
        var source = arguments[i];
        for (var key in source)
            if (hasOwnProperty(source, key)) {
                res[key] = source[key];
            }
    }
    return res;
}
var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(object, propName) {
    return prototypeHasOwnProperty.call(object, propName);
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map$$1) {
    if (isPlainObject(map$$1))
        return Object.keys(map$$1);
    if (Array.isArray(map$$1))
        return map$$1.map(function (_a) {
            var key = _a[0];
            return key;
        });
    if (isES6Map(map$$1))
        return Array.from(map$$1.keys());
    if (isObservableMap(map$$1))
        return map$$1.keys();
    return fail("Cannot get keys from " + map$$1);
}
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.strictMode = false;
        /**
         * Used by createTransformer to detect that the global state has been reset.
         */
        this.resetId = 0;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var shareGlobalStateCalled = false;
var runInIsolationCalled = false;
var warnedAboutMultipleInstances = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
                warnedAboutMultipleInstances = true;
                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        }, 1);
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function shareGlobalState() {
    // TODO: remove in 4.0; just use peer dependencies instead.
    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
    shareGlobalStateCalled = true;
    var global = getGlobal();
    var ownState = globalState;
    /**
     * Backward compatibility check
     */
    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
    if (global.__mobxGlobal)
        globalState = global.__mobxGlobal;
    else
        global.__mobxGlobal = ownState;
}
function getGlobalState() {
    return globalState;
}

/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    globalState.resetId++;
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.strictMode;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            invariant(property === undefined, getMessage("m036"));
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data[property] || anyThing._hasMap[property];
            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072 // TODO: remove in 4.0
        if (isObservableObject(thing)) {
            if (!property)
                return fail("please specify a property");
            var observable = thing.$mobx.values[property];
            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    invariant(thing, "Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    runLazyInitializers(thing);
    if (thing.$mobx)
        return thing.$mobx;
    invariant(false, "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (!observable.isPendingUnobservation) {
        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                observable.onBecomeUnobserved();
                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
        }
    }
    else if (observable.observers.length === 0) {
        queueForUnobservation(observable);
    }
}
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    try {
                        obj.get();
                    }
                    catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail(getMessage("m031") + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && hasObservers$$1)
        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    try {
        result = f.call(context);
    }
    catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

function log(msg) {
    console.log(msg);
    return msg;
}
function whyRun(thing, prop) {
    deprecated("`whyRun` is deprecated in favor of `trace`");
    thing = getAtomFromArgs(arguments);
    if (!thing)
        return log(getMessage("m024"));
    if (isComputedValue(thing) || isReaction(thing))
        return log(thing.whyRun());
    return fail(getMessage("m025"));
}
function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                this.onInvalidate();
                if (this._isTrackPending && isSpyEnabled()) {
                    // onInvalidate didn't trigger track right away..
                    spyReport({
                        object: this,
                        type: "scheduled-reaction"
                    });
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                object: this,
                type: "reaction",
                fn: fn
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        var messageToUser = getMessage("m037");
        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                message: message,
                error: error,
                object: this
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        r.onError = registerErrorHandler;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.whyRun = function () {
        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
            ? "stopped"
            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
            ? " (... or any observable accessed during the remainder of the current run)"
            : "") + "\n\t" + getMessage("m038") + "\n";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function registerErrorHandler(handler) {
    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
    this.$mobx.errorHandler = handler;
}
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function asReference(value) {
    deprecated("asReference is deprecated, use observable.ref instead");
    return observable.ref(value);
}
function asStructure(value) {
    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
    return observable.struct(value);
}
function asFlat(value) {
    deprecated("asFlat is deprecated, use observable.shallow instead");
    return observable.shallow(value);
}
function asMap(data) {
    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
    return observable.map(data || {});
}

function createComputedDecorator(equals) {
    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
        var adm = asObservableObject(target, "");
        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        this.$mobx.values[name].set(value);
    }, false, false);
}
var computedDecorator = createComputedDecorator(comparer.default);
var computedStructDecorator = createComputedDecorator(comparer.structural);
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        return computedDecorator.apply(null, arguments);
    }
    invariant(typeof arg1 === "function", getMessage("m011"));
    invariant(arguments.length < 3, getMessage("m012"));
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
};
computed.struct = computedStructDecorator;
computed.equals = createComputedDecorator;

function isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

/**
 * expr can be used to create temporarily views inside views.
 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
 *
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * reactiveComponent((props) => {
 *     const todo = props.todo;
 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * });
 *
 */
function expr(expr, scope) {
    if (!isComputingDerivation())
        console.warn(getMessage("m013"));
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return computed(expr, { context: scope }).get();
}

function toJS(source, detectCycles, __alreadySeen) {
    if (detectCycles === void 0) { detectCycles = true; }
    if (__alreadySeen === void 0) { __alreadySeen = []; }
    // optimization: using ES6 map would be more efficient!
    // optimization: lift this function outside toJS, this makes recursion expensive
    function cache(value) {
        if (detectCycles)
            __alreadySeen.push([source, value]);
        return value;
    }
    if (isObservable(source)) {
        if (detectCycles && __alreadySeen === null)
            __alreadySeen = [];
        if (detectCycles && source !== null && typeof source === "object") {
            for (var i = 0, l = __alreadySeen.length; i < l; i++)
                if (__alreadySeen[i][0] === source)
                    return __alreadySeen[i][1];
        }
        if (isObservableArray(source)) {
            var res = cache([]);
            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
            res.length = toAdd.length;
            for (var i = 0, l = toAdd.length; i < l; i++)
                res[i] = toAdd[i];
            return res;
        }
        if (isObservableObject(source)) {
            var res = cache({});
            for (var key in source)
                res[key] = toJS(source[key], detectCycles, __alreadySeen);
            return res;
        }
        if (isObservableMap(source)) {
            var res_1 = cache({});
            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
            return res_1;
        }
        if (isObservableValue(source))
            return toJS(source.get(), detectCycles, __alreadySeen);
    }
    return source;
}

function createTransformer(transformer, onCleanup) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var objectCache = {};
    // If the resetId changes, we will clear the object cache, see #163
    // This construction is used to avoid leaking refs to the objectCache directly
    var resetId = globalState.resetId;
    // Local transformer class specifically for this transformer
    var Transformer = /** @class */ (function (_super) {
        __extends(Transformer, _super);
        function Transformer(sourceIdentifier, sourceObject) {
            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
            _this.sourceIdentifier = sourceIdentifier;
            _this.sourceObject = sourceObject;
            return _this;
        }
        Transformer.prototype.onBecomeUnobserved = function () {
            var lastValue = this.value;
            _super.prototype.onBecomeUnobserved.call(this);
            delete objectCache[this.sourceIdentifier];
            if (onCleanup)
                onCleanup(lastValue, this.sourceObject);
        };
        return Transformer;
    }(ComputedValue));
    return function (object) {
        if (resetId !== globalState.resetId) {
            objectCache = {};
            resetId = globalState.resetId;
        }
        var identifier = getMemoizationId(object);
        var reactiveTransformer = objectCache[identifier];
        if (reactiveTransformer)
            return reactiveTransformer.get();
        // Not in cache; create a reactive view
        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
        return reactiveTransformer.get();
    };
}
function getMemoizationId(object) {
    if (typeof object === "string" || typeof object === "number")
        return object;
    if (object === null || typeof object !== "object")
        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = getNextId();
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
var extras = {
    allowStateChanges: allowStateChanges,
    deepEqual: deepEqual,
    getAtom: getAtom,
    getDebugName: getDebugName,
    getDependencyTree: getDependencyTree,
    getAdministration: getAdministration,
    getGlobalState: getGlobalState,
    getObserverTree: getObserverTree,
    interceptReads: interceptReads,
    isComputingDerivation: isComputingDerivation,
    isSpyEnabled: isSpyEnabled,
    onReactionError: onReactionError,
    reserveArrayBuffer: reserveArrayBuffer,
    resetGlobalState: resetGlobalState,
    isolateGlobalState: isolateGlobalState,
    shareGlobalState: shareGlobalState,
    spyReport: spyReport,
    spyReportEnd: spyReportEnd,
    spyReportStart: spyReportStart,
    setReactionScheduler: setReactionScheduler
};
var everything = {
    Reaction: Reaction,
    untracked: untracked,
    Atom: Atom,
    BaseAtom: BaseAtom,
    useStrict: useStrict,
    isStrictModeEnabled: isStrictModeEnabled,
    spy: spy,
    comparer: comparer,
    asReference: asReference,
    asFlat: asFlat,
    asStructure: asStructure,
    asMap: asMap,
    isModifierDescriptor: isModifierDescriptor,
    isObservableObject: isObservableObject,
    isBoxedObservable: isObservableValue,
    isObservableArray: isObservableArray,
    ObservableMap: ObservableMap,
    isObservableMap: isObservableMap,
    map: map,
    transaction: transaction,
    observable: observable,
    computed: computed,
    isObservable: isObservable,
    isComputed: isComputed,
    extendObservable: extendObservable,
    extendShallowObservable: extendShallowObservable,
    observe: observe,
    intercept: intercept,
    autorun: autorun,
    autorunAsync: autorunAsync,
    when: when,
    reaction: reaction,
    action: action,
    isAction: isAction,
    runInAction: runInAction,
    expr: expr,
    toJS: toJS,
    createTransformer: createTransformer,
    whyRun: whyRun,
    isArrayLike: isArrayLike,
    extras: extras
};
var warnedAboutDefaultExport = false;
var _loop_1 = function (p) {
    var val = everything[p];
    Object.defineProperty(everything, p, {
        get: function () {
            if (!warnedAboutDefaultExport) {
                warnedAboutDefaultExport = true;
                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
                    "and won’t work in mobx@4.0.0\n" +
                    "Use `import * as mobx from 'mobx'` instead");
            }
            return val;
        }
    });
};
for (var p in everything) {
    _loop_1(p);
}
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
}

/* harmony default export */ __webpack_exports__["default"] = (everything);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(31)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(106)();
}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"iconCleaning":"_1M7QSrCV9onxaEhsYiY2jF","iconCloudy":"_2ndrjGVTp3FO-iJNzahRkO","corn":"_2rYXlYNRZYv69OX4CWANNf","iconDrying":"_2BLRMr8A1Q4nQG4tu4w50w","iconInput":"BsoLtAC213-sTWC0vFi1h","iconOutput":"_3ebUsE2CNa0UdSjKwvsOMQ","iconRain":"_372YDRwxItppJVLsHWytyc","rape":"_298Ey8M9472r8uHZHPsNbM","iconRoce":"v5ln2lzoeTm4hxHoBtdua","soy":"_1B2EsdjZTgdM3OpXjMVB17","iconStoring":"_1-8aIdErp0uKC1Bo-eN-Op","sunflower":"nqkbCgyLr1DtHDP0XgpZs","iconSunny":"_1VbikakIgclvvq53FDDqCB","iconTranshipment":"_19k6Ur48a6o9dwPb1hIeTB","wheat":"sHMqQhJdTkbvfiTgBVVUx","iconPlay":"_3QBzI5F_TaP9Foc25-5yBm","iconPause":"_2JJ9lOWYIQTq_S30dgCsBs"};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {"wheat":{"volume":0.96,"baseWaste":2,"baseMoisture":14,"critWaste":5,"critMoisture":20},"rape":{"volume":0.8,"baseWaste":3,"baseMoisture":8,"critWaste":10,"critMoisture":18},"soy":{"volume":0.86,"baseWaste":3,"baseMoisture":12,"critWaste":10,"critMoisture":18},"corn":{"volume":0.88,"baseWaste":2,"baseMoisture":14,"critWaste":10,"critMoisture":35},"sunflower":{"volume":0.52,"baseWaste":3,"baseMoisture":8,"critWaste":10,"critMoisture":16},"None":{"volume":0,"baseWaste":0,"baseMoisture":0,"critWaste":0,"critMoisture":0}}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Hopper=exports.Silo=exports.DryingCleaningUnit=exports.RailCart=exports.Truck=exports.Noria=exports.Bubbles=exports.Bunker=exports.Popup=undefined;var _Popup2=__webpack_require__(181);var _Popup3=_interopRequireDefault(_Popup2);var _Bunker2=__webpack_require__(183);var _Bunker3=_interopRequireDefault(_Bunker2);var _Bubbles2=__webpack_require__(185);var _Bubbles3=_interopRequireDefault(_Bubbles2);var _Noria2=__webpack_require__(187);var _Noria3=_interopRequireDefault(_Noria2);var _Truck2=__webpack_require__(188);var _Truck3=_interopRequireDefault(_Truck2);var _RailCart2=__webpack_require__(190);var _RailCart3=_interopRequireDefault(_RailCart2);var _DCUnit=__webpack_require__(192);var _DCUnit2=_interopRequireDefault(_DCUnit);var _Silo2=__webpack_require__(60);var _Silo3=_interopRequireDefault(_Silo2);var _Hopper2=__webpack_require__(61);var _Hopper3=_interopRequireDefault(_Hopper2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.Popup=_Popup3.default;exports.Bunker=_Bunker3.default;exports.Bubbles=_Bubbles3.default;exports.Noria=_Noria3.default;exports.Truck=_Truck3.default;exports.RailCart=_RailCart3.default;exports.DryingCleaningUnit=_DCUnit2.default;exports.Silo=_Silo3.default;exports.Hopper=_Hopper3.default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _screenReaderStyles = __webpack_require__(172);

var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A React component for the font-awesome icon library.
 *
 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @param {String} [className] An extra set of CSS classes to add to the component
 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
 * @param {String} [flip=false] Flip the icon's orientation.
 * @param {Boolean} [inverse=false]Inverse the icon's color
 * @param {String} name Name of the icon to use
 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
 * @param {Number} [rotate] The degress to rotate the icon by
 * @param {String} [size] The icon scaling size
 * @param {Boolean} [spin=false] Spin the icon
 * @param {String} [stack] Stack an icon on top of another
 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
 * @module FontAwesome
 * @type {ReactClass}
 */
var FontAwesome = function (_React$Component) {
  _inherits(FontAwesome, _React$Component);

  function FontAwesome() {
    _classCallCheck(this, FontAwesome);

    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));

    _this.displayName = 'FontAwesome';
    return _this;
  }

  _createClass(FontAwesome, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          cssModule = _props.cssModule,
          className = _props.className,
          fixedWidth = _props.fixedWidth,
          flip = _props.flip,
          inverse = _props.inverse,
          name = _props.name,
          pulse = _props.pulse,
          rotate = _props.rotate,
          size = _props.size,
          spin = _props.spin,
          stack = _props.stack,
          _props$tag = _props.tag,
          tag = _props$tag === undefined ? 'span' : _props$tag,
          ariaLabel = _props.ariaLabel,
          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);

      var classNames = [];

      if (cssModule) {
        classNames.push(cssModule['fa']);
        classNames.push(cssModule['fa-' + name]);
        size && classNames.push(cssModule['fa-' + size]);
        spin && classNames.push(cssModule['fa-spin']);
        pulse && classNames.push(cssModule['fa-pulse']);
        border && classNames.push(cssModule['fa-border']);
        fixedWidth && classNames.push(cssModule['fa-fw']);
        inverse && classNames.push(cssModule['fa-inverse']);
        flip && classNames.push(cssModule['fa-flip-' + flip]);
        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
        stack && classNames.push(cssModule['fa-stack-' + stack]);
      } else {
        classNames.push('fa');
        classNames.push('fa-' + name);
        size && classNames.push('fa-' + size);
        spin && classNames.push('fa-spin');
        pulse && classNames.push('fa-pulse');
        border && classNames.push('fa-border');
        fixedWidth && classNames.push('fa-fw');
        inverse && classNames.push('fa-inverse');
        flip && classNames.push('fa-flip-' + flip);
        rotate && classNames.push('fa-rotate-' + rotate);
        stack && classNames.push('fa-stack-' + stack);
      }

      // Add any custom class names at the end.
      className && classNames.push(className);
      return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
    }
  }]);

  return FontAwesome;
}(_react2.default.Component);

FontAwesome.propTypes = {
  ariaLabel: _propTypes2.default.string,
  border: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  cssModule: _propTypes2.default.object,
  fixedWidth: _propTypes2.default.bool,
  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  inverse: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  pulse: _propTypes2.default.bool,
  rotate: _propTypes2.default.oneOf([90, 180, 270]),
  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
  spin: _propTypes2.default.bool,
  stack: _propTypes2.default.oneOf(['1x', '2x']),
  tag: _propTypes2.default.string
};

exports.default = FontAwesome;
module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1eaIUug04OJYkTsktDmSYq","trucksContainer":"_3Am6f0u64Vl7TexKbIIOhE","transportMask":"_13SZFlD5u585RlnT1Av8yp","dropStyle":"d1yAuqjBj9A7yxz_bRYRO","dropfield":"_2SY33oreclLuRVMGjGGTiL","dropfieldBack":"_1So59BQOY3ASlTEdsKdOsr","indicator":"_29HIJcORVoFWWqPie1RkOZ","innerContainer":"_32gGKlMdMLHCU0j1CIGnnu","content":"_3vvE3UjzJDmfApwY6JLnTI","inputFlow":"_2q4dFwMX9llrk36_Mqgp_-","outputFlow":"_1kC-sAoPenQgnrh3si5hVm","activeTab":"KO8dUn9gEDAI0DkyBYL3N","stateToggleButton":"BwIvSfM7JrElv890lci0a","queueContainer":"_1z1AR5EgFhn6hF37VtCsXk","queueBubbles":"f3a2Z13HqEHYJwiit7Mcd","elevatorField":"_3wm6jGxkOILLJUrFRjZuUp","noriaContainer":"uoHUMC8DOZES_EItrrmQv","noria":"oMl1C0WSoGSciK4qdFj8d","wheat":"_2IZBBSmRguBgig1NFBTfm1","rape":"_19_88jX2oOgOl7jHLF4SM0","soy":"_1m0Gl2oZ_pRGSwSF6KnG1i","corn":"_2-vQmIQkxrmcL2954JHoMm","sunflower":"_2BsS0YYbwtvZfBl8mdoj2m","noria-push":"_2bH0OIkXpVkq2F7gzM2-iP","noriaLineInput":"_2Kz6K5iV32SamJppKkdDf8","noriaLineOutput":"_23Gbsx0-eOF0BuW84isvL8","noriaContainerBeforeSilos":"qjaOo_QfY3V6s8yJOanBl","clogged":"_1QYK8OT8sZgX8Tzr6i644G","none":"JI0aNzVLvZsOScrRMFaOa","cloggedNoria":"_3PABoAs25wNiVOvhQH5bbp","bunkerFakeContainer":"_3dtkQb9_VXozGLNsrGMQhN","bunkerLevel":"mkgOdQMGSte_Ie5Bav4Ei","bunkerLevelFloat":"_2qfm_aYUB8_2k0jEW9uiOt","bunkerLines":"_2TiEcMHwaF9AewOhgJOjk","bunkerBubbles":"EXxkPtJ-UMEY0nhktRN-x","bunkerInputLine":"_1OTMQWP3DoxKYtaJYF3scX","bunkerRow":"_3xmxjEIGaVqGpMsH4hkYmQ","bunker":"_2V1RfyXSFUn0fUMjOmD6aK","bunkerType":"_1yh5TkkjvRNmeZXqyPcU5b","stackElement":"_2fZEQ0m_bZ1Uul2CWj2QyZ","stackDropfield":"_1fvNTs0pE1c856d9VqLQJj"};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"itemContainer":"_3fz-K_UPySiId7j5P59bj","cover":"_3zp9tboZTFrRXSGg0HNj6v","body":"_2uOX9rLwyoCtt62kGEHs5N","cultureIcon":"_16DtjosZKOnYnfJZ5QMejA","groupData":"_1NNJv7MxCGfGXRcOlFwnF9","pathBody":"_2GGavq5gV6yE0fYU0KRlyC","scrollablePath":"_2Vl4Np52DelJknR-G6-E42","dragContainer":"_1L4uIabj6VwEI4Ah4hVULj","doc":"_18R-Wzi_xxw1Jo9rnDhA7r","pathFooter":"_1wuCmXQCA-H6OWRfXg52Yn","pathBodyElement":"_2OuH97w_68swuKJSPTYCjR","truckRailCartFrame":"ebYF-YV-DqT05k6g5m7jy","bunkerInputBubbles":"YP-2kRRv8j8udCbV_QTWa","startFinishItem":"_3-XqrVe9G8XRCCfW4acwlY","actionCircle":"_2eGZGreKRLz557OjYSHdNY","pathPlus":"_2E8_0Al-fNHghLTpIlGJor","pathEndPlus":"_2gx9UiBWI25ZliOF3qg0_b","pathItem":"IpfWNtvn6f8dS4BMivsWV","actionIcon":"mdpMfLrH8ZLzfaAJZNUJV","actionDismiss":"_3Vr6x87V2Z6eni4EFT_qif","actionDCContainer":"_134XntAc6aGrVxRu_PMkba","pathItemDefinition":"_3K6V5wWpgV-IQhfweXdN-X","pathOptions":"_3XrT3wGvdyXcYh4tl7VWfx","pathOption":"_2BTGfSSPmi9rchh91ODwac","optionIcon":"_18RM1MbO4Y8okcDdVLERnN","pathButtons":"D04UOuvhKguBq-_izbrdz","button":"_3_wd9V-cRj8HCow6Xh9Kz5","active":"_1uACzDbkpMJpXiLRv5LRp_","inactive":"_2K0gaMBnQXVTpdyf4jHqSt","siloContainer":"_39EPGwmXvxjxd_0zO2QaxX","actionContainer":"_2PhY0D4zx8GIPK3VR5NMrZ","list":"_3dEUQi3ekvPVDikze4xVKe","actionHopper":"_3ucgREekPXc9TPW6Q-6__d","currentItem":"_258jjKjUCwgcCQOj_yo4PW","tabs":"_1N2HDYiGMversL-LbjMfX6","activeTab":"_1ybnfvEpXnYUTrmQSMeRKW","bordur":"_38QSFuYcRBaOnsWiJD7Fww","drag":"ZpIkpH99XsaF3Eh4-Up0r","footerDND":"_2MyOPZvYi33UvCq_Wocfw-","description":"_2RWsluYAzh3fRviRU3o2EA","descriptionPathBody":"_1N4KPfRyoioPwR6u6oqGul","dragDesciption":"_3LvQfvAaWbQlBRY9VVzhQM","mask":"_3KSGCRlnarq2Atrif2G1y4","dropDownContainer":"_3IAjeKDPlC4Spib9HFHyPg","dropfield":"_1boXVrGpWweJYJX6Lu_EVN","dropPlace":"_2FVBHRz6a6RnEbP_yoflnQ"};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(111);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _mobx=__webpack_require__(3);var _index=__webpack_require__(1);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Parent=(_class=function(){function Parent(num){var culture=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'None';var scenario=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var amount=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var moistureLevel=arguments[4];var wasteLevel=arguments[5];var status=arguments[6];var name=arguments.length>7&&arguments[7]!==undefined?arguments[7]:'';_classCallCheck(this,Parent);_initDefineProp(this,'totalCapacity',_descriptor,this);_initDefineProp(this,'amount',_descriptor2,this);_initDefineProp(this,'culture',_descriptor3,this);_initDefineProp(this,'moistureLevel',_descriptor4,this);_initDefineProp(this,'wasteLevel',_descriptor5,this);_initDefineProp(this,'scenario',_descriptor6,this);_initDefineProp(this,'status',_descriptor7,this);_initDefineProp(this,'active',_descriptor8,this);_initDefineProp(this,'name',_descriptor9,this);_initDefineProp(this,'currentOperation',_descriptor10,this);this.num=num;this.amount=amount;this.culture=culture;this.moistureLevel=moistureLevel;this.wasteLevel=wasteLevel;this.scenario=scenario;this.status=status;this.active=false;this.name=name;this.currentOperation=-1;this.errorStatus='';}_createClass(Parent,[{key:'initScenario',value:function initScenario(script,operation){this.scenario=script;this.currentOperation=operation;}},{key:'setUnit',value:function setUnit(){var amount=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var culture=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"None";var moisture=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var waste=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var active=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;this.amount=amount;this.culture=culture;this.moistureLevel=moisture;this.wasteLevel=waste;this.active=active;this.status='';this.statusErr='';if(this.type!=='bunker'&&this.type!=='silo'){this.initScenario([],0);}}},{key:'mixingTest',value:function mixingTest(){if(this.nextOperationItem.culture!=='None'&&this.nextOperationItem.culture!==this.culture){this.status=this.nextOperationItem.status='clogged';this.errorStatus=this.nextOperationItem.errorStatus="Змішання культур!!!";console.log("Змішання культур!!!",this.nextOperationItem.type);return false;}return true;}},{key:'amountTest',value:function amountTest(){if(this.nextOperationItem.totalCapacity&&this.nextOperationItem.totalCapacity*_cultureSettings2.default[this.culture].volume<=this.nextOperationItem.amount){this.status=this.nextOperationItem.status='clogged';this.errorStatus=this.nextOperationItem.errorStatus="Недостатньо місця!!!";console.log("Недостатньо місця в следующем элементе сценария",this.nextOperationItem.type);return false;}return true;}},{key:'DCTest',value:function DCTest(){if((this.nextOperationItem.type==='drying'||this.nextOperationItem.type==='cleaning')&&this.nextOperationItem.amount){return false;}return true;}},{key:'scenarioTest',value:function scenarioTest(){if(!!this.nextOperationItem.getScenarioLength&&this.nextOperationItem.type!=='silo'&&this.nextOperationItem.type!=='hopper'&&(this.getScenarioLength!==this.nextOperationItem.getScenarioLength||this.nextOperationItem.scenario[0].type!==this.scenario[0].type||this.nextOperationItem.scenario[0].num!==this.scenario[0].num)){this.status='clogged';this.errorStatus="Наступний елемент зайнятий іншим сценарієм!!!";console.log("Наступний елемент зайнятий іншим сценарієм",this.nextOperationItem.type);return false;}return true;}},{key:'nextItemErrorStatusTest',value:function nextItemErrorStatusTest(){if(this.nextOperationItem.status==='clogged'&&!this.nextOperationItem.totalCapacity){this.status='clogged';this.errorStatus="Наступний елемент сценарію забитий!!!";console.log("Наступний елемент сценарію забитий",this.nextOperationItem.type);return false;}return true;}},{key:'setErrorStatus',value:function setErrorStatus(){var status=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var errorStatus=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';this.status=this.nextOperationItem.status=status;this.errorStatus=errorStatus;}},{key:'baseTest',value:function baseTest(){if(this.nextOperationItem.type==='output'){if(this.moistureLevel>_cultureSettings2.default[this.culture].baseMoisture||this.wasteLevel>_cultureSettings2.default[this.culture].baseWaste){this.status=this.nextOperationItem.status='clogged';this.errorStatus="Не соответствует базовым показателям сорности/влажности!!!";console.log("Не соответствует базовым показателям сорности/влажности!!!");return false;}else{var find=this.nextOperationItem.findTransport(this.culture);if((this.nextOperationItem.activeTransport.disabled||this.nextOperationItem.activeTransport.culture!==this.culture)&&find===-1){this.status=this.nextOperationItem.status='clogged';this.errorStatus=this.nextOperationItem.errorStatus="Недостатньо транспорту!!!";console.log("Недостатньо транспорту!!!");return false;}}}return true;}},{key:'checkUnit',value:function checkUnit(){var speed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;if(this.amount<=0&&this.culture!=='None'){this.setUnit();}else{if(this.getScenarioLength&&this.culture!=='None'){if(!this.active){this.active=true;}if(this.currentOperation!==this.getScenarioLength-1&&this.scenarioTest()){this.nextOperationItem.initScenario(this.scenario,this.currentOperation+1);}if(this.nextOperationItem.culture==='None'){this.nextOperationItem.setUnit(0,this.culture);}if(this.mixingTest()&&this.amountTest()&&this.scenarioTest()&&this.baseTest()&&this.nextItemErrorStatusTest()&&this.DCTest()){if(this.nextOperationItem.type==='cleaning'){this.nextOperationItem.setSpeed(this.wasteLevel<_cultureSettings2.default[this.culture].baseWaste?this.nextOperationItem.speedParams[this.culture].min:this.wasteLevel>_cultureSettings2.default[this.culture].critWaste?this.nextOperationItem.speedParams[this.culture].max:(this.wasteLevel-_cultureSettings2.default[this.culture].critWaste)*(this.wasteLevel-_cultureSettings2.default[this.culture].critWaste)*(this.nextOperationItem.speedParams[this.culture].min-this.nextOperationItem.speedParams[this.culture].max)/((_cultureSettings2.default[this.culture].critWaste-_cultureSettings2.default[this.culture].baseWaste)*(_cultureSettings2.default[this.culture].critWaste-_cultureSettings2.default[this.culture].baseWaste))+this.nextOperationItem.speedParams[this.culture].max);this.shippingFrom(this.nextOperationItem.speed/60*_index.time.tickCoef);}else{if(this.nextOperationItem.type==='drying'){this.nextOperationItem.setSpeed(this.moistureLevel<_cultureSettings2.default[this.culture].baseMoisture?this.nextOperationItem.speedParams[this.culture].min:this.moistureLevel>_cultureSettings2.default[this.culture].critMoisture?this.nextOperationItem.speedParams[this.culture].max:(this.moistureLevel-_cultureSettings2.default[this.culture].critMoisture)*(this.moistureLevel-_cultureSettings2.default[this.culture].critMoisture)*(this.nextOperationItem.speedParams[this.culture].min-this.nextOperationItem.speedParams[this.culture].max)/((_cultureSettings2.default[this.culture].critMoisture-_cultureSettings2.default[this.culture].baseMoisture)*(_cultureSettings2.default[this.culture].critMoisture-_cultureSettings2.default[this.culture].baseMoisture))+this.nextOperationItem.speedParams[this.culture].max);this.shippingFrom(this.nextOperationItem.speed/60*_index.time.tickCoef);}else{if(this.nextOperationItem.type==='output'){this.shippingFrom(this.nextOperationItem.getOutputSpeed());}else{this.shippingFrom(speed);}}}}}else{if(this.status==='clogged'){this.status=this.statusErr='';}if(this.active){this.active=false;}}}}},{key:'shippingFrom',value:function shippingFrom(speed){if(this.status==='clogged'){this.status=this.statusErr='';}var rem=this.amount-speed;if(!this.nextOperationItem.totalCapacity){if(rem<0){this.nextOperationItem.filling(this.culture,this.amount,this.wasteLevel,this.moistureLevel);this.amount=0;}else{this.nextOperationItem.filling(this.culture,speed,this.wasteLevel,this.moistureLevel);this.amount-=speed;}}else{var delta=this.nextOperationItem.totalCapacity*_cultureSettings2.default[this.culture].volume-this.nextOperationItem.amount;if(rem<0){if(delta<=this.amount){this.nextOperationItem.filling(this.culture,delta,this.wasteLevel,this.moistureLevel);this.amount-=delta;}else{this.nextOperationItem.filling(this.culture,this.amount,this.wasteLevel,this.moistureLevel);this.amount=0;}}else{if(delta<=speed){this.nextOperationItem.filling(this.culture,delta,this.wasteLevel,this.moistureLevel);this.amount-=delta;}else{this.nextOperationItem.filling(this.culture,speed,this.wasteLevel,this.moistureLevel);this.amount-=speed;}}}}},{key:'filling',value:function filling(culture,delta,waste,moisture){if(this.culture===culture){this.moistureLevel=Math.round((this.amount*this.moistureLevel+delta*moisture)/((this.amount+delta)/10000))/10000;this.wasteLevel=Math.round((this.amount*this.wasteLevel+delta*waste)/((this.amount+delta)/10000))/10000;this.amount+=delta;}else{console.log('filling error');}}},{key:'getScenarioLength',get:function get(){return this.scenario.length;}},{key:'nextOperationItem',get:function get(){return this.scenario[this.currentOperation];}}]);return Parent;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'totalCapacity',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'amount',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'culture',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'moistureLevel',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'wasteLevel',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'scenario',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'status',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'active',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'name',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'currentOperation',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'initScenario',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'initScenario'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setUnit',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setUnit'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getScenarioLength',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getScenarioLength'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'nextOperationItem',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'nextOperationItem'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'mixingTest',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'mixingTest'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'amountTest',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'amountTest'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'DCTest',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'DCTest'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'scenarioTest',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'scenarioTest'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'nextItemErrorStatusTest',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'nextItemErrorStatusTest'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setErrorStatus',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setErrorStatus'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'baseTest',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'baseTest'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkUnit',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkUnit'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'shippingFrom',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'shippingFrom'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'filling',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'filling'),_class.prototype)),_class);exports.default=Parent;module.exports=exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(70);

var warning = __webpack_require__(39);
var canDefineProperty = __webpack_require__(68);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(71);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(226);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(245);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var fontSize = function fontSize(size) {
  if (size.toLowerCase() === 'large') {
    return '22pt';
  } else if (size.toLowerCase() === 'small') {
    return '8pt';
  }
  return '18px';
};

var SimpleLineIcon = function SimpleLineIcon(_ref) {
  var name = _ref.name,
      color = _ref.color,
      size = _ref.size,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ['name', 'color', 'size', 'style']);

  return _react2.default.createElement('div', _extends({
    className: 'icon-' + name,
    style: _extends({
      color: color,
      fontSize: fontSize(size)
    }, style)
  }, rest));
};

SimpleLineIcon.propTypes = {
  name: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['Large', 'large', 'Medium', 'medium', 'Small', 'small']),
  style: _propTypes2.default.object
};

SimpleLineIcon.defaultProps = {
  color: null,
  size: 'Medium',
  style: {}
};

exports.default = SimpleLineIcon;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(25);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(268);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"activeTruck":"_3MPh6-VKFVclkIyF2wvDIg","contentError":"_3KCA2i4ZT-a7AyqVG0Xib8","bunkerContainer":"_10eZIlcMYPVbMeUCZHzTWU","bunkerRow":"_2Arf5XlEmJE5kRaHi0u7ot","bunkerInline":"_17Ejmw-CfsUeBiVkr08RO2","truckRailCartHolder":"QIyWJfXsDnRluaGNfsL7C","nearestQueueThumbs":"gvUbYEtkTUrWYd1oqrXtW","noria":"_2xXebdBKPuTmstf3fkV7hx","bunkerLines":"_1DH62cedsKfd17ebot0CsQ","bunkerInputLine":"_39Jvz-wb_hV1wt169NZugF","inputLine":"vCQB7K07nYjIQP_iIvKeI","wheat":"_10xWARV2LMAAWE-jD2zhw","rape":"_3pgJ3i7aZXO4n0zmPu4zjP","soy":"_9T02wHoQGzRutjxt3R8YT","corn":"_20RoOdJNrRkFQgbfOminIK","sunflower":"_3bRtUMa2YDRJ53253PyVXa","idle":"_27r4flMnrF864XtDrOrKw1","clogged":"_1iUcgkabQJa9iCAd7DJzA-","notGroup":"_1mz-9chgHZjG9i6A6gr__J","queues":"_3lvCGE8gTAtVMJpCeUmsJj","nearestQueue":"_-0LLDjqaVVqvCixrhyYu3","bulkQueue":"_17_YX360o8g_vNtM16sF9X","queueRow":"NAd9ToBPV4rqLfKb7IWRg","railCartContainer":"_1yc5hoV4puK0KsS1Nx1Ry5","dropPlace":"_2U-bRejLMmtr-5aWBvHe5s","cultureCircle":"_3A69RY43r3DN1svjhrCBu3","dropPlaceBack":"_3_ii7kmQmAH1UnW-erzIr_","railCartsBulkQueue":"fWNiOJKdcy1m21z3KoTbH","trucksBulkQueue":"_1UmiJOmWAGC39T-qvlWHkq"};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(102);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(34);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;var _mobx=__webpack_require__(3);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Transport=(_class=function(){function Transport(culture,capacity){var amount=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var moistureLevel=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var wasteLevel=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0;var groupQuantity=arguments.length>5&&arguments[5]!==undefined?arguments[5]:0;var status=arguments.length>6&&arguments[6]!==undefined?arguments[6]:'alert';_classCallCheck(this,Transport);_initDefineProp(this,'amount',_descriptor,this);_initDefineProp(this,'groupQuantity',_descriptor2,this);_initDefineProp(this,'transportStatus',_descriptor3,this);_initDefineProp(this,'active',_descriptor4,this);this.totalCapacity=capacity;this.culture=culture;this.amount=amount;this.moistureLevel=moistureLevel;this.wasteLevel=wasteLevel;this.groupQuantity=groupQuantity;this.transportStatus=status;this.active=false;}_createClass(Transport,[{key:'setAmount',value:function setAmount(amount){this.amount=amount;}},{key:'setGroupQuantity',value:function setGroupQuantity(quantity){this.groupQuantity=quantity;}},{key:'setStatus',value:function setStatus(status){this.status=status;}},{key:'setActive',value:function setActive(active){this.active=active;}},{key:'filling',value:function filling(delta){this.amount+=delta;}},{key:'shipping',value:function shipping(delta,type){if(delta>=this.amount){this.groupQuantity-=1;this.amount=(type==='truck'?20:60)*_cultureSettings2.default[this.culture].volume;}else{this.amount-=delta;}}}]);return Transport;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'amount',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'groupQuantity',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'transportStatus',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'active',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'setAmount',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setAmount'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setGroupQuantity',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setGroupQuantity'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setStatus',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setStatus'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setActive',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setActive'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'filling',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'filling'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'shipping',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'shipping'),_class.prototype)),_class);exports.default=Transport;module.exports=exports['default'];

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Drop=exports.Drag=undefined;var _index=__webpack_require__(62);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(63);var _index4=_interopRequireDefault(_index3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.Drag=_index2.default;exports.Drop=_index4.default;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"silo":"_2neUjqCPJQysXI8535v9bu","content":"_1h6-RC-oimgaYiDj9t8ETV","elevatorFieldContainer":"_4dA4Z_RsE8_GTvEQqRRe-","lowerBus":"_1VX5EBZFJNQOoQBQbp2vHF","wheat":"_2AdfbpspF-Yh7onWHgUExL","rape":"_15Cb21dqZwQw_v9yyRO7HO","soy":"_1-Q-LkDeY9JNDT86Z2Rhwh","corn":"_2jvu2wPAgCIw2yfmAth29L","sunflower":"jo65J0SAz3WgWoxXxnC-i","clogged":"_5LkOaxwRC3TlT7L88_Nsu","dryingContainer":"_2fEsKAkt6HshadtIiL11Ts","cleaningContainer":"_2pjnEM2LciTm79dQhMHwAL","hopperContainer":"_2LdkB2mWhgcRPpBLWEY33U","dcOutputBubbles":"_1HuKx5NSuugXiW9Fbe7_5h","dcOutputLine":"_1Vc-5l8lAp6ZVdnGGQYs5m","dcTitle":"WA7xigkDYICK-a3TDOq7v","dcIcon":"_2bQD93sctP5e-SJhI7lR-N","dcIconRotate":"Of3k81GqminBOmNzQYFV","silosContainer":"_2m0VUx_0MWRjWGewLw933n","siloContainerDSIcons":"_6utbVxYDKMi1O26fI1iz9","siloLinesContainer":"JjEb2w59Y-U7xHBOOdoup","fakeContainerForStackingIndex":"_3aCooUiM3KowII2deiXuvU","siloLineInput":"_3amCzgrQLV8HuhGJAC7NiZ","idle":"_3sbPFAyTysPJitZkDArmeH","activeLine":"_3KR4ZGpT-Ni-sVkVHt7851","hoppersNoriasToHoppersContainer":"_1bMfvcfkFWZbXOUCvIbzET","hoppersContainerToDryingNorias":"_2X2-r4yHeBEGu5Gh9LZvh-","dryingNoriasToDryingContainer":"_3GQcVrEKKrO26emmdYjZuo","dryingContainerToCleaningNorias":"_3moKmiKDtMdzo98B7ySyny","cleaningContainerToSilosNorias":"_1iVq6RnJesmRpmQoDW9JN0","cleaningNoriasToCleaningContainer":"_2ejrCmS_Ynvtji1wNfr9eb","silosNoriasToSilo":"_1frdNfT1S6oXGRf0GjMT3Z","siloToSilo":"_2q46pOMZStuFwuxgIRtikA","None":"uNahi1oCJHQvayydShcDU"};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(67);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(20);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return callAll; });
var callAll = function callAll() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fns.forEach(function (fn) {
      return fn && fn.apply(void 0, args);
    });
  };
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(97);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(47);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(35);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(116)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FinanceData=exports.Plan=exports.PathPopup=exports.Requests=exports.OutputFlow=exports.ElevatorField=exports.InputFlow=exports.Weather=exports.News=exports.Menu=exports.FooterMenu=exports.Tabs=undefined;var _Tabs2=__webpack_require__(133);var _Tabs3=_interopRequireDefault(_Tabs2);var _FooterMenu2=__webpack_require__(135);var _FooterMenu3=_interopRequireDefault(_FooterMenu2);var _Menu2=__webpack_require__(173);var _Menu3=_interopRequireDefault(_Menu2);var _News2=__webpack_require__(176);var _News3=_interopRequireDefault(_News2);var _Weather2=__webpack_require__(178);var _Weather3=_interopRequireDefault(_Weather2);var _InputFlow2=__webpack_require__(180);var _InputFlow3=_interopRequireDefault(_InputFlow2);var _ElevatorField2=__webpack_require__(201);var _ElevatorField3=_interopRequireDefault(_ElevatorField2);var _OutputFlow2=__webpack_require__(204);var _OutputFlow3=_interopRequireDefault(_OutputFlow2);var _Requests2=__webpack_require__(206);var _Requests3=_interopRequireDefault(_Requests2);var _PathPopup2=__webpack_require__(208);var _PathPopup3=_interopRequireDefault(_PathPopup2);var _Plan2=__webpack_require__(215);var _Plan3=_interopRequireDefault(_Plan2);var _FinanceData2=__webpack_require__(217);var _FinanceData3=_interopRequireDefault(_FinanceData2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.Tabs=_Tabs3.default;exports.FooterMenu=_FooterMenu3.default;exports.Menu=_Menu3.default;exports.News=_News3.default;exports.Weather=_Weather3.default;exports.InputFlow=_InputFlow3.default;exports.ElevatorField=_ElevatorField3.default;exports.OutputFlow=_OutputFlow3.default;exports.Requests=_Requests3.default;exports.PathPopup=_PathPopup3.default;exports.Plan=_Plan3.default;exports.FinanceData=_FinanceData3.default;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = {"wheat":{"date":"2019-7-15","duration":25},"rape":{"date":"2019-7-10","duration":10},"soy":{"date":"2019-9-16","duration":15},"sunflower":{"date":"2019-9-1","duration":15},"corn":{"date":"2019-10-1","duration":40}}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _desc,_value,_class,_descriptor;var _mobx=__webpack_require__(3);var _emptyCell=__webpack_require__(53);var _emptyCell2=_interopRequireDefault(_emptyCell);var _parent=__webpack_require__(18);var _parent2=_interopRequireDefault(_parent);var _transport=__webpack_require__(36);var _transport2=_interopRequireDefault(_transport);var _index=__webpack_require__(1);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var OutputBunker=(_class=function(_Parent){_inherits(OutputBunker,_Parent);function OutputBunker(num,bunkerType){var name=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var culture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"None";var amount=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0;var moistureLevel=arguments.length>5&&arguments[5]!==undefined?arguments[5]:0;var wasteLevel=arguments.length>6&&arguments[6]!==undefined?arguments[6]:0;var scenario=arguments.length>7&&arguments[7]!==undefined?arguments[7]:[];var status=arguments.length>8&&arguments[8]!==undefined?arguments[8]:'';_classCallCheck(this,OutputBunker);var _this=_possibleConstructorReturn(this,(OutputBunker.__proto__||Object.getPrototypeOf(OutputBunker)).call(this,num,culture,scenario,amount,moistureLevel,wasteLevel,status,name));_initDefineProp(_this,'activeTransport',_descriptor,_this);_this.bunkerType=bunkerType;_this.activeTransport=new _emptyCell2.default();_this.type='output';return _this;}_createClass(OutputBunker,[{key:'findTransport',value:function findTransport(culture){var _this2=this;return _index.shipment.outputTransport.findIndex(function(item){return item.type===_this2.bunkerType&&item.culture===culture;});}},{key:'filling',value:function filling(culture,delta,waste,moisture){this.active=true;_get(OutputBunker.prototype.__proto__||Object.getPrototypeOf(OutputBunker.prototype),'filling',this).call(this,culture,delta,waste,moisture);}},{key:'shippingFrom',value:function shippingFrom(){if(!this.active&&this.amount<=0&&this.culture!=='None')this.setUnit();if(this.activeTransport.culture!==this.culture){var availableTrain=this.findTransport(this.culture);if(availableTrain!==-1){if(_index.shipment.outputTransport[availableTrain].offer)this.offer=_index.shipment.outputTransport[availableTrain].offer;_index.shipment.outputTransport[availableTrain].quantity--;if(!_index.shipment.outputTransport[availableTrain].quantity){_index.shipment.removeOutputTransport(availableTrain);}this.activeTransport=new _transport2.default(this.culture,Math.floor((this.bunkerType==='truck'?20:60)*_cultureSettings2.default[this.culture].volume*10)/10,0,this.moistureLevel,this.wasteLevel);}}if(!this.activeTransport.disabled&&this.amount>0){var transport=this.activeTransport;transport.filling(this.amount);if(transport.totalCapacity<=transport.amount){var _availableTrain=this.findTransport(this.culture);if(_availableTrain!==-1){if(_index.shipment.outputTransport[_availableTrain].offer)this.offer=_index.shipment.outputTransport[_availableTrain].offer;_index.shipment.outputTransport[_availableTrain].quantity--;if(!_index.shipment.outputTransport[_availableTrain].quantity){_index.shipment.removeOutputTransport(_availableTrain);}this.activeTransport=new _transport2.default(this.culture,Math.floor((this.bunkerType==='truck'?20:60)*_cultureSettings2.default[this.culture].volume*10)/10,0,this.moistureLevel,this.wasteLevel);}else{this.activeTransport=new _emptyCell2.default();this.offer=null;}}_index.finance.incParams('output',transport.culture,this.amount);if(this.offer){this.offer.decRem(this.amount);}this.amount=0;}this.active=false;}},{key:'getOutputSpeed',value:function getOutputSpeed(){var speed=1.5*_index.time.tickCoef;if(this.activeTransport.disabled){var availableTrain=this.findTransport(this.culture);if(availableTrain!==-1){_index.shipment.outputTransport[availableTrain].quantity--;if(!_index.shipment.outputTransport[availableTrain].quantity){_index.shipment.removeOutputTransport(availableTrain);}this.activeTransport=new _transport2.default(this.culture,Math.floor((this.bunkerType==='truck'?20:60)*_cultureSettings2.default[this.culture].volume*10)/10,0,this.moistureLevel,this.wasteLevel);}return speed;}else{if(this.activeTransport.totalCapacity-this.activeTransport.amount-speed<=0)return this.activeTransport.totalCapacity-this.activeTransport.amount;return speed;}}}]);return OutputBunker;}(_parent2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'activeTransport',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'filling',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'filling'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'shippingFrom',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'shippingFrom'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getOutputSpeed',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'getOutputSpeed'),_class.prototype)),_class);exports.default=OutputBunker;module.exports=exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(3);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Cell=(_class=function(){function Cell(){_classCallCheck(this,Cell);_initDefineProp(this,'active',_descriptor,this);_initDefineProp(this,'disabled',_descriptor2,this);this.disabled=true;this.active=false;}_createClass(Cell,[{key:'setActive',value:function setActive(state){this.active=state;}}]);return Cell;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'active',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'disabled',[_mobx.observable],{enumerable:true,initializer:null})),_class);exports.default=Cell;module.exports=exports['default'];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(3);var _emptyCell=__webpack_require__(53);var _emptyCell2=_interopRequireDefault(_emptyCell);var _index=__webpack_require__(1);var _parent=__webpack_require__(18);var _parent2=_interopRequireDefault(_parent);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Bunker=(_class=function(_Parent){_inherits(Bunker,_Parent);function Bunker(num,capacity){var bunkerName=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var culture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"None";var amount=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0;var moistureLevel=arguments.length>5&&arguments[5]!==undefined?arguments[5]:0;var wasteLevel=arguments.length>6&&arguments[6]!==undefined?arguments[6]:0;var scenario=arguments.length>7&&arguments[7]!==undefined?arguments[7]:[];var status=arguments.length>8&&arguments[8]!==undefined?arguments[8]:'';var bunkerType=arguments.length>9&&arguments[9]!==undefined?arguments[9]:'truck';_classCallCheck(this,Bunker);var _this=_possibleConstructorReturn(this,(Bunker.__proto__||Object.getPrototypeOf(Bunker)).call(this,num,culture,scenario,amount,moistureLevel,wasteLevel,status,bunkerName));_initDefineProp(_this,'transportStack',_descriptor,_this);_initDefineProp(_this,'stackActive',_descriptor2,_this);_initDefineProp(_this,'activeTransport',_descriptor3,_this);_this.totalCapacity=capacity;_this.type='bunker';_this.currentOperation=1;_this.bunkerType=bunkerType;_this.stackActive=false;_this.activeTransport=new _emptyCell2.default();_this.transportStack=[0,0,0,0];return _this;}_createClass(Bunker,[{key:'removeTransportFromStack',value:function removeTransportFromStack(id){this.transportStack.splice(id,1);this.transportStack.push(0);}},{key:'setActiveTransport',value:function setActiveTransport(obj){this.activeTransport=obj;}},{key:'addToStack',value:function addToStack(id,obj){var del=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;if(this.transportStack[id]){this.transportStack.splice(id,del,obj);this.transportStack.splice(4,1);}else{if(this.activeTransport.disabled&&!this.transportStack[0]){this.activeTransport=obj;}else{this.transportStack[this.transportStack.findIndex(function(item){return!item;})]=obj;}}}},{key:'setTransportStack',value:function setTransportStack(id,obj){this.transportStack[id]=obj;}},{key:'checkActiveTransport',value:function checkActiveTransport(){if(this.transportStack[0]){this.setActiveTransport(this.transportStack.shift());this.transportStack.push(0);}else{this.setActiveTransport(new _emptyCell2.default());}}},{key:'checkBunker',value:function checkBunker(){this.checkUnit();if(!this.activeTransport.disabled&&(this.activeTransport.culture===this.culture||this.culture==='None')&&this.amount<this.totalCapacity){var transport=this.activeTransport;if(this.culture==='None'){_get(Bunker.prototype.__proto__||Object.getPrototypeOf(Bunker.prototype),'setUnit',this).call(this,0,transport.culture,transport.moistureLevel,transport.wasteLevel);}var sum=Math.floor(_cultureSettings2.default[this.culture].volume*2*_index.time.tickCoef*10)/10;sum=transport.amount-sum<=0?transport.amount:sum;var delta=Math.floor(this.totalCapacity*_cultureSettings2.default[this.culture].volume)-this.amount-sum;var rem=Math.floor(this.totalCapacity*_cultureSettings2.default[this.culture].volume)-this.amount;if(delta<=0){this.filling(transport.culture,rem,transport.wasteLevel,transport.moistureLevel);_index.finance.incParams('input',transport.culture,rem);transport.shipping(rem,this.bunkerType);if(transport.groupQuantity===0){this.checkActiveTransport();}}else{this.filling(transport.culture,sum,transport.wasteLevel,transport.moistureLevel);_index.finance.incParams('input',transport.culture,sum);transport.shipping(sum,this.bunkerType);if(transport.groupQuantity===0){this.checkActiveTransport();}}}}},{key:'getThumbs',get:function get(){var result=[];this.transportStack.forEach(function(item){if(item){result.push({culture:item.culture,number:item.groupQuantity});}});return result;}}]);return Bunker;}(_parent2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'transportStack',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'stackActive',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'activeTransport',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'removeTransportFromStack',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'removeTransportFromStack'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setActiveTransport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setActiveTransport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addToStack',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addToStack'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setTransportStack',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setTransportStack'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkActiveTransport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkActiveTransport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getThumbs',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getThumbs'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkBunker',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkBunker'),_class.prototype)),_class);// if(delta<0){delta = 0}
// let rem = transport.amount - sum;
// if(delta < sum || rem < 0){
//     //please check this. WTF???
//     if (rem < 0 && rem <= delta && delta) {
//         this.filling(transport.culture,transport.wasteLevel,transport.moistureLevel,delta);
//         finance.incParams('input',transport.culture,delta);
//         transport.shipping(delta,this.bunkerType);
//         if (transport.groupQuantity === 0) {
//             this.checkActiveTransport();
//         }
//     }else{
//         if(delta > 0) {
//             this.filling(transport.culture, transport.wasteLevel, transport.moistureLevel, delta);
//             finance.incParams('input',transport.culture,delta);
//             transport.shipping(delta, this.bunkerType);
//         }
//     }
//
// }else {
//     this.filling(transport.culture,transport.wasteLevel,transport.moistureLevel,sum);
//     transport.shipping(sum,this.bunkerType);
//     finance.incParams('input',transport.culture,sum);
// }
exports.default=Bunker;module.exports=exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(3);var _parent=__webpack_require__(18);var _parent2=_interopRequireDefault(_parent);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);var _index=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Silos=(_class=function(_Parent){_inherits(Silos,_Parent);function Silos(num,capacity){var name=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var culture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'None';var amount=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0;var moisture=arguments.length>5&&arguments[5]!==undefined?arguments[5]:0;var waste=arguments.length>6&&arguments[6]!==undefined?arguments[6]:0;var amountState=arguments.length>7&&arguments[7]!==undefined?arguments[7]:'';var status=arguments.length>8&&arguments[8]!==undefined?arguments[8]:'';var scenario=arguments.length>9&&arguments[9]!==undefined?arguments[9]:[];_classCallCheck(this,Silos);var _this=_possibleConstructorReturn(this,(Silos.__proto__||Object.getPrototypeOf(Silos)).call(this,num,culture,scenario,amount,moisture,waste,status,name));_initDefineProp(_this,'inputLine',_descriptor,_this);_initDefineProp(_this,'amountState',_descriptor2,_this);_initDefineProp(_this,'filingStatus',_descriptor3,_this);_this.totalCapacity=capacity;_this.amountState=amountState;_this.filingStatus=false;_this.type='silo';_this.inputLine={culture:'idle',lineStatus:'idle'};return _this;}_createClass(Silos,[{key:'filling',value:function filling(culture,delta,waste,moisture){_index.finance.storage.incTotal(culture,delta);this.amountState='increasing';this.filingStatus=true;_get(Silos.prototype.__proto__||Object.getPrototypeOf(Silos.prototype),'filling',this).call(this,culture,delta,waste,moisture);}},{key:'checkUnit',value:function checkUnit(){var speed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;if(this.filingStatus){this.amountState='increased';this.filingStatus=false;}if(this.amountState='decreasing'){this.amountState='decreased';}if(this.culture!=="None"){_index.finance.storage.incParam(this.culture,"cashYield",this.amount/30/24/60);_index.finance.storage.incParam(this.culture,"directExpends",this.amount/30/24/60);_index.finance.storage.incParam(this.culture,"indirectExpends",this.amount/30/24/60/10);}_index.score.storage+=this.amount*_cultureSettings2.default[this.culture].storage/1000;_get(Silos.prototype.__proto__||Object.getPrototypeOf(Silos.prototype),'checkUnit',this).call(this,speed);}},{key:'shippingFrom',value:function shippingFrom(){var speed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;_get(Silos.prototype.__proto__||Object.getPrototypeOf(Silos.prototype),'shippingFrom',this).call(this,speed);this.amountState='decreasing';}// @action shippingFrom(){
//     super.shippingFrom();
//     if(this.culture !== "None") {
//         finance.storage.incParam(this.culture, "cashYield", this.amount/30/24/60);
//         finance.storage.incParam(this.culture, "directExpends", this.amount/30/24/60);
//         finance.storage.incParam(this.culture, "indirectExpends", this.amount/30/24/60/10);
//     }
//     score.storage += this.amount*settings[this.culture].storage/1000;
//
//     if (!this.filingStatus){
//         if(this.inputLine.culture !== 'idle'){
//             this.amountState = 'increased';
//             this.status = '';
//             this.inputLine = {
//                 culture: 'idle',
//                 lineStatus: 'idle'
//             }
//         }
//     }else{
//         this.filingStatus = false;
//     }
//     if(this.active && this.amountState !== 'decreasing'){
//         this.amountState = 'decreasing';
//     }
// }
}]);return Silos;}(_parent2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'inputLine',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'amountState',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'filingStatus',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'filling',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'filling'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkUnit',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkUnit'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'shippingFrom',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'shippingFrom'),_class.prototype)),_class);// inputLine:{
//     culture: 'wheat',
//     lineStatus: 'clogged'
// }}
// inputLine:{
//     culture: 'corn',
//     lineStatus: 'active'
// }}
exports.default=Silos;module.exports=exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(3);var _transport=__webpack_require__(36);var _transport2=_interopRequireDefault(_transport);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ReceptionTransportStore=(_class=function(){function ReceptionTransportStore(){_classCallCheck(this,ReceptionTransportStore);_initDefineProp(this,'receptionTruck',_descriptor,this);_initDefineProp(this,'receptionTrain',_descriptor2,this);this.receptionTruck=[// new Transport('wheat',19.2,19.2,10,10,30,'alert'),
// new Transport('rape',20,16,10,10,50,'alert'),
// new Transport('soy',19.2,19.2,10,10,50,'alert'),
// new Transport('corn',19.2,19.2,10,10,50,'alert'),
// new Transport('sunflower',19.2,19.2,10,10,50,'alert')
];this.receptionTrain=[// new Transport('wheat',60,60,5,7,50,'alert')
];}_createClass(ReceptionTransportStore,[{key:'removeTransport',value:function removeTransport(id){this.receptionTruck.splice(id,1);}},{key:'addTransport',value:function addTransport(transport){this.receptionTruck.push(transport);}// @action removeTransport(id,del,type){
//     if (type === 'truck'){
//         this.receptionTruck.splice(id, del);
//     }else{
//         this.receptionTrain.splice(id, del);
//     }
// }
},{key:'getTotalWheat',get:function get(){return this.receptionTruck.reduce(function(prev,current){return current.culture==='wheat'?current.groupQuantity+prev:prev;},0);}},{key:'getTotalSoy',get:function get(){return this.receptionTruck.reduce(function(prev,current){return current.culture==='soy'?current.groupQuantity+prev:prev;},0);}},{key:'getTotalRape',get:function get(){return this.receptionTruck.reduce(function(prev,current){return current.culture==='rape'?current.groupQuantity+prev:prev;},0);}},{key:'getTotalSunflower',get:function get(){return this.receptionTruck.reduce(function(prev,current){return current.culture==='sunflower'?current.groupQuantity+prev:prev;},0);}},{key:'getTotalCorn',get:function get(){return this.receptionTruck.reduce(function(prev,current){return current.culture==='corn'?current.groupQuantity+prev:prev;},0);}}]);return ReceptionTransportStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'receptionTruck',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'receptionTrain',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'getTotalWheat',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalWheat'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalSoy',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalSoy'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalRape',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalRape'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalSunflower',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalSunflower'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalCorn',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalCorn'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'removeTransport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'removeTransport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addTransport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addTransport'),_class.prototype)),_class);exports.default=ReceptionTransportStore;module.exports=exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _desc,_value,_class,_descriptor;var _parent=__webpack_require__(18);var _parent2=_interopRequireDefault(_parent);var _mobx=__webpack_require__(3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Hopper=(_class=function(_Parent){_inherits(Hopper,_Parent);function Hopper(num,capacity){var name=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"Hopper";var culture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'None';var amount=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0;var moisture=arguments.length>5&&arguments[5]!==undefined?arguments[5]:0;var waste=arguments.length>6&&arguments[6]!==undefined?arguments[6]:0;var amountState=arguments.length>7&&arguments[7]!==undefined?arguments[7]:'';var status=arguments.length>8&&arguments[8]!==undefined?arguments[8]:'';var scenario=arguments.length>9&&arguments[9]!==undefined?arguments[9]:[];_classCallCheck(this,Hopper);var _this=_possibleConstructorReturn(this,(Hopper.__proto__||Object.getPrototypeOf(Hopper)).call(this,num,culture,scenario,amount,moisture,waste,status,name));_initDefineProp(_this,"fillingStatus",_descriptor,_this);_this.totalCapacity=capacity;_this.type='hopper';_this.fillingStatus=false;return _this;}_createClass(Hopper,[{key:"filling",value:function filling(culture,delta,waste,moisture){_get(Hopper.prototype.__proto__||Object.getPrototypeOf(Hopper.prototype),"filling",this).call(this,culture,delta,waste,moisture);this.fillingStatus=true;}},{key:"checkUnit",value:function checkUnit(){var speed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;_get(Hopper.prototype.__proto__||Object.getPrototypeOf(Hopper.prototype),"checkUnit",this).call(this,speed);this.fillingStatus=false;}}]);return Hopper;}(_parent2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,"fillingStatus",[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,"filling",[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,"filling"),_class.prototype),_applyDecoratedDescriptor(_class.prototype,"checkUnit",[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,"checkUnit"),_class.prototype)),_class);exports.default=Hopper;module.exports=exports["default"];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(3);var _index=__webpack_require__(1);var _parent=__webpack_require__(18);var _parent2=_interopRequireDefault(_parent);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var CleaningUnit=(_class=function(_Parent){_inherits(CleaningUnit,_Parent);function CleaningUnit(num){var DCName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var culturePercents=arguments[2];var speed=arguments[3];var status=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'';var culture=arguments.length>5&&arguments[5]!==undefined?arguments[5]:'None';var amount=arguments.length>6&&arguments[6]!==undefined?arguments[6]:0;var waste=arguments.length>7&&arguments[7]!==undefined?arguments[7]:0;var moisture=arguments.length>8&&arguments[8]!==undefined?arguments[8]:0;var scenario=arguments.length>9&&arguments[9]!==undefined?arguments[9]:[];_classCallCheck(this,CleaningUnit);var _this=_possibleConstructorReturn(this,(CleaningUnit.__proto__||Object.getPrototypeOf(CleaningUnit)).call(this,num,culture,scenario,amount,moisture,waste,status,DCName));_initDefineProp(_this,'percents',_descriptor,_this);_initDefineProp(_this,'speed',_descriptor2,_this);_this.culturePercents=culturePercents;_this.speedParams=speed;_this.speed=0;_this.type="cleaning";return _this;}_createClass(CleaningUnit,[{key:'setSpeed',value:function setSpeed(speed){this.speed=speed;}},{key:'setUnit',value:function setUnit(){var amount=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var culture=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"None";var moisture=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var waste=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var active=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;_get(CleaningUnit.prototype.__proto__||Object.getPrototypeOf(CleaningUnit.prototype),'setUnit',this).call(this,amount,culture,moisture,waste,active);this.speed=0;}},{key:'shippingFrom',value:function shippingFrom(speed){if(this.culture!=='None'&&this.amount>0){_get(CleaningUnit.prototype.__proto__||Object.getPrototypeOf(CleaningUnit.prototype),'shippingFrom',this).call(this,this.amount);}}},{key:'filling',value:function filling(culture,delta,waste,moisture){_get(CleaningUnit.prototype.__proto__||Object.getPrototypeOf(CleaningUnit.prototype),'filling',this).call(this,culture,delta,waste,moisture);this.setWasteLevel();}},{key:'setWasteLevel',value:function setWasteLevel(){if(this.wasteLevel>_cultureSettings2.default[this.culture].baseWaste){_index.finance.incDCParams('cleaning',this.culture,this.amount,this.wasteLevel-_cultureSettings2.default[this.culture].baseWaste>0?this.wasteLevel-_cultureSettings2.default[this.culture].baseWaste:0);this.wasteLevel=_cultureSettings2.default[this.culture].baseWaste;}}}]);return CleaningUnit;}(_parent2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'percents',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'speed',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'setSpeed',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setSpeed'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setUnit',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setUnit'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'shippingFrom',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'shippingFrom'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'filling',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'filling'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setWasteLevel',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setWasteLevel'),_class.prototype)),_class);exports.default=CleaningUnit;module.exports=exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(3);var _index=__webpack_require__(1);var _parent=__webpack_require__(18);var _parent2=_interopRequireDefault(_parent);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var DryingUnit=(_class=function(_Parent){_inherits(DryingUnit,_Parent);function DryingUnit(num){var DCName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var culturePercents=arguments[2];var speed=arguments[3];var status=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'';var culture=arguments.length>5&&arguments[5]!==undefined?arguments[5]:'None';var amount=arguments.length>6&&arguments[6]!==undefined?arguments[6]:0;var waste=arguments.length>7&&arguments[7]!==undefined?arguments[7]:0;var moisture=arguments.length>8&&arguments[8]!==undefined?arguments[8]:0;var capacity=arguments.length>9&&arguments[9]!==undefined?arguments[9]:1000;var scenario=arguments.length>10&&arguments[10]!==undefined?arguments[10]:[];_classCallCheck(this,DryingUnit);var _this=_possibleConstructorReturn(this,(DryingUnit.__proto__||Object.getPrototypeOf(DryingUnit)).call(this,num,culture,scenario,amount,moisture,waste,status,DCName));_initDefineProp(_this,'percents',_descriptor,_this);_initDefineProp(_this,'speed',_descriptor2,_this);_this.culturePercents=culturePercents;_this.speedParams=speed;_this.speed=0;_this.type="drying";return _this;}_createClass(DryingUnit,[{key:'shippingFrom',value:function shippingFrom(speed){if(this.culture!=='None'&&this.amount>0){_get(DryingUnit.prototype.__proto__||Object.getPrototypeOf(DryingUnit.prototype),'shippingFrom',this).call(this,this.amount);}}},{key:'setUnit',value:function setUnit(){var amount=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var culture=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"None";var moisture=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var waste=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var active=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;_get(DryingUnit.prototype.__proto__||Object.getPrototypeOf(DryingUnit.prototype),'setUnit',this).call(this,amount,culture,moisture,waste,active);this.speed=0;}},{key:'filling',value:function filling(culture,delta,waste,moisture){_get(DryingUnit.prototype.__proto__||Object.getPrototypeOf(DryingUnit.prototype),'filling',this).call(this,culture,delta,waste,moisture);this.setMoistureLevel();}},{key:'setMoistureLevel',value:function setMoistureLevel(){if(this.moistureLevel>_cultureSettings2.default[this.culture].baseMoisture){// let coef = Math.floor(((this.moistureLevel < (settings[this.culture].baseMoisture * 0.7)) ?
//         (this.culturePercents[this.culture].min * 0.2)
//         :
//         ((this.moistureLevel < (settings[this.culture].baseMoisture)) ?
//                 (this.culturePercents[this.culture].min)
//                 :
//                 (this.moistureLevel >= settings[this.culture].critMoisture ?
//                         this.culturePercents[this.culture].max
//                         :
//                         ((((this.moistureLevel - settings[this.culture].critMoisture) * (this.moistureLevel - settings[this.culture].critMoisture)) *
//                             (this.culturePercents[this.culture].min - this.culturePercents[this.culture].max)) /
//                             ((settings[this.culture].critMoisture - settings[this.culture].baseMoisture) * (settings[this.culture].critMoisture - settings[this.culture].baseMoisture))) +
//                         this.culturePercents[this.culture].max
//                 )
//         )
// ) * 100) / 100;
// if (this.moistureLevel <= coef || (this.moistureLevel - coef) < settings[this.culture].baseMoisture) {
//     finance.incDCParams('drying', this.culture, this.amount, this.moistureLevel);
//     this.moistureLevel = settings[this.culture].baseMoisture;
// } else {
//     finance.incDCParams('drying', this.culture, this.amount, coef);
//     this.moistureLevel -= coef;
// }
_index.finance.incDCParams('drying',this.culture,this.amount,this.moistureLevel-_cultureSettings2.default[this.culture].baseMoisture>0?this.moistureLevel-_cultureSettings2.default[this.culture].baseMoisture:0);this.moistureLevel=_cultureSettings2.default[this.culture].baseMoisture;}}},{key:'setSpeed',value:function setSpeed(speed){this.speed=speed;}}]);return DryingUnit;}(_parent2.default),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'percents',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'speed',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'shippingFrom',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'shippingFrom'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setUnit',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setUnit'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'filling',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'filling'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setMoistureLevel',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setMoistureLevel'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setSpeed',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setSpeed'),_class.prototype)),_class);exports.default=DryingUnit;module.exports=exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(194);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _index3=__webpack_require__(7);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Silo=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Silo,_Component);function Silo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Silo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Silo.__proto__||Object.getPrototypeOf(Silo)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Silo,[{key:'coords',value:function coords(e){var target=e.target;var X=target.getBoundingClientRect().right+5;var Y=target.getBoundingClientRect().top-7;this.setState({active:true,x:X,y:Y});}},{key:'render',value:function render(){var _this2=this;var item=this.props.item;var per=Math.ceil(item.amount/(item.totalCapacity*_cultureSettings2.default[item.culture].volume)*100);var levelHeight={height:per+'%'};var siloHeight={height:item.totalCapacity/5000*100+'%'};var moisture=Math.round(item.moistureLevel*10)/10;var waste=Math.round(item.wasteLevel*10)/10;return _react2.default.createElement('div',{className:_index2.default.siloUnit+' '+(item.culture?' '+_index2.default[item.culture]:' '+_index2.default.idle)+(per<90&&per>30&&item.amountState==='increasing'?' '+_index2.default.increasing:'')+(per>30&&item.amountState==='decreasing'?' '+_index2.default.decreasing:'')+(per>10&&item.amountState==='decreased'?' '+_index2.default.decreased:'')+(per>10&&item.amountState==='increased'?' '+_index2.default.increased:'')+(per>90&&item.amountState==='increasing'?' '+_index2.default.increased:'')/* это временный */+(this.props.inPath?' '+_index2.default.inPath:''),style:this.props.inPath?null:siloHeight,onMouseOver:this.coords.bind(this),onMouseLeave:function onMouseLeave(){return _this2.setState({active:false});}},_react2.default.createElement('div',{className:_index2.default.siloLevel,style:levelHeight},_react2.default.createElement('div',{className:_index2.default.siloBubbles},_react2.default.createElement(_index3.Bubbles,null)),_react2.default.createElement('div',{className:_index2.default.siloLineOutput})),_react2.default.createElement('div',{className:_index2.default.siloNumbers},_react2.default.createElement('span',null,Math.ceil(item.amount)),_react2.default.createElement('hr',null),_react2.default.createElement('span',null,Math.ceil(item.totalCapacity*_cultureSettings2.default[item.culture].volume))),_react2.default.createElement('div',{className:_index2.default.siloCulture},_react2.default.createElement('i',{className:_iconfonts2.default[item.culture]})),_react2.default.createElement('div',{className:_index2.default.siloDSNumbers},_react2.default.createElement('div',null,waste,'%'),_react2.default.createElement('div',null,moisture,'%')),this.state.active?_react2.default.createElement(_index3.Popup,{x:this.state.x,y:this.state.y,item:item}):null);}}]);return Silo;}(_react.Component))||_class;exports.default=Silo;module.exports=exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(195);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(7);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Hopper=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Hopper,_Component);function Hopper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Hopper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Hopper.__proto__||Object.getPrototypeOf(Hopper)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Hopper,[{key:'coords',value:function coords(e){var target=e.target;var X=target.getBoundingClientRect().right+4;var Y=target.getBoundingClientRect().top-14;this.setState({active:true,x:X,y:Y});}},{key:'render',value:function render(){var _this2=this;var item=this.props.item;var levelHeight={height:item.amount/(item.totalCapacity*Math.pow(_cultureSettings2.default[item.culture].volume,2))*100+'%'};return _react2.default.createElement('div',{className:_index2.default.hopperContainer+(this.props.inPath?' '+_index2.default.inPath:'')},_react2.default.createElement('div',{className:_index2.default.hopper+(item.culture?' '+_index2.default[item.culture]:'')+' '+_index2.default[item.status],onMouseOver:this.coords.bind(this),onMouseLeave:function onMouseLeave(){return _this2.setState({active:false});}},_react2.default.createElement('div',{className:_index2.default.hopperLevel,style:levelHeight}),_react2.default.createElement('div',{className:_index2.default.hopperNumbers},_react2.default.createElement('span',null,Math.ceil(item.amount)),_react2.default.createElement('hr',null),_react2.default.createElement('span',null,Math.ceil(item.totalCapacity*_cultureSettings2.default[item.culture].volume))),_react2.default.createElement('div',{className:_index2.default.cloggedHopper},'!')),this.state.active?_react2.default.createElement(_index3.Popup,{x:this.state.x,y:this.state.y,item:item}):null);}}]);return Hopper;}(_react.Component))||_class;exports.default=Hopper;module.exports=exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(198);var _index2=_interopRequireDefault(_index);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Drag=function(_Component){_inherits(Drag,_Component);function Drag(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Drag);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Drag.__proto__||Object.getPrototypeOf(Drag)).call.apply(_ref,[this].concat(args))),_this),_this.state={dropStart:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Drag,[{key:'setDropStart',value:function setDropStart(){this.setState({dropStart:!this.state.dropStart});}},{key:'Drag',value:function Drag(e){var _this2=this;var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){};if(this.props.onDrag)this.props.onDrag();var touch=!!e.touches;var x=void 0,y=void 0;var Emilia=e.target;var elem=touch?e.touches[0]:e;var shiftX=elem.pageX-Emilia.getBoundingClientRect().left;var shiftY=elem.pageY-Emilia.getBoundingClientRect().top;var dragTags=Emilia.getAttribute("data-dragtype").split(',');var drops=[];dragTags.forEach(function(item){var _drops;drops=(_drops=drops).concat.apply(_drops,_toConsumableArray(document.querySelectorAll('div[data-droptype="'+item+'"]')));});var drags=document.querySelectorAll('div[data-dragtype]');drags.forEach(function(item){item.style.pointerEvents='none';});drops.forEach(function(item){item.style.opacity=null;item.style.pointerEvents='inherit';});Emilia.style.position='fixed';Emilia.style.pointerEvents='none';Emilia.style.zIndex=250;var moveAt=function moveAt(e){var elem=e.touches?e.touches[0]:e;x=elem.pageX;y=elem.pageY;Emilia.style.left=x-shiftX+'px';Emilia.style.top=y-shiftY+'px';};var MouseUp=function MouseUp(){Emilia.style.position=Emilia.style.left=Emilia.style.top=Emilia.style.pointerEvents=null;_this2.setDropStart();if(touch){window.removeEventListener('touchmove',moveAt,false);window.removeEventListener('touchend',MouseUp,false);}else{window.onmousemove=null;window.onmouseup=null;}var deepEqual=false;dragTags.forEach(function(item){if(document.elementFromPoint(x,y)&&item===document.elementFromPoint(x,y).getAttribute('data-droptype')){deepEqual=true;}});if(deepEqual){if(_this2.props.onDrop)_this2.props.onDrop();document.elementFromPoint(x,y).click();}drops.forEach(function(item){item.style.opacity=0;item.style.pointerEvents='none';Emilia.style.zIndex="inherit";});drags.forEach(function(item){item.style.pointerEvents='inherit';});callback();};moveAt(elem);if(touch){window.addEventListener('touchmove',moveAt,false);window.addEventListener('touchend',MouseUp,false);}else{window.onmousemove=moveAt;window.onmouseup=MouseUp;}}},{key:'render',value:function render(){var _this3=this;return _react2.default.createElement('div',{style:this.props.style?this.props.style:null},this.state.dropStart&&this.props.maskClassName?_react2.default.createElement('div',{className:this.props.maskClassName}):null,_react2.default.createElement('div',{onMouseOver:this.props.onMouseOver,style:this.props.style?this.props.style:null,'data-dragtype':this.props.type,className:_index2.default.dragElement,onTouchStart:function onTouchStart(e){_this3.setState({dropStart:true});e.preventDefault();_this3.Drag(e);},onMouseDown:function onMouseDown(e){e.stopPropagation();_this3.setState({dropStart:true});e.preventDefault();_this3.Drag(e);}},this.props.children));}}]);return Drag;}(_react.Component);exports.default=Drag;module.exports=exports['default'];

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(199);var _index2=_interopRequireDefault(_index);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Drop=function(_Component){_inherits(Drop,_Component);function Drop(){_classCallCheck(this,Drop);return _possibleConstructorReturn(this,(Drop.__proto__||Object.getPrototypeOf(Drop)).apply(this,arguments));}_createClass(Drop,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:_index2.default.drop+(this.props.className?' '+this.props.className:''),style:this.props.style?_extends({},this.props.style,{opacity:'0'}):{opacity:'0'},'data-droptype':this.props.type,id:this.props.id,onClick:function onClick(e){e.preventDefault();_this2.props.onDrop();}},_react2.default.createElement('div',{className:_index2.default.fields},this.props.children));}}]);return Drop;}(_react.Component);exports.default=Drop;module.exports=exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _index=__webpack_require__(1);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ReceptionDispathcer=function(){function ReceptionDispathcer(){_classCallCheck(this,ReceptionDispathcer);}_createClass(ReceptionDispathcer,null,[{key:"addTransportToBunkerStack",value:function addTransportToBunkerStack(bunkerId,stackPosition,removeTransportId){_index.receptionBunkersStore.receptionBunker[bunkerId].addToStack(stackPosition,_index.transportStore.receptionTruck[removeTransportId]);_index.transportStore.removeTransport(removeTransportId);}},{key:"switchStack",value:function switchStack(bunkerId,stackPosition,removeTransportId){_index.receptionBunkersStore.receptionBunker[bunkerId].addToStack(removeTransportId.bunkerId===bunkerId&&removeTransportId.num<stackPosition?stackPosition+1:stackPosition,_index.receptionBunkersStore.receptionBunker[removeTransportId.bunkerId].transportStack[removeTransportId.num]);_index.receptionBunkersStore.receptionBunker[removeTransportId.bunkerId].removeTransportFromStack(removeTransportId.bunkerId===bunkerId&&removeTransportId.num>stackPosition?removeTransportId.num+1:removeTransportId.num);}},{key:"returnTransportFromBunkerStack",value:function returnTransportFromBunkerStack(bunkerId,num){_index.transportStore.addTransport(_index.receptionBunkersStore.receptionBunker[bunkerId].transportStack[num]);_index.receptionBunkersStore.receptionBunker[bunkerId].removeTransportFromStack(num);}}]);return ReceptionDispathcer;}();exports.default=ReceptionDispathcer;module.exports=exports["default"];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(30),
    _assign = __webpack_require__(9);

var ReactNoopUpdateQueue = __webpack_require__(66);

var canDefineProperty = __webpack_require__(68);
var emptyObject = __webpack_require__(69);
var invariant = __webpack_require__(23);
var lowPriorityWarning = __webpack_require__(228);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(39);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chooseEquipment":"_3nNu-rwd8ywpzAwxwKaJld","equipTableHeading":"_3kqjrGjen7Abmg-kSgss4C","equipRow":"_2dJcEx1kEcn2d7jkLakh29","columnEquipName":"_3XaelgfYabp24186fv714K","columnCrops":"_--rwYWAYWYwoHIacZU8sN","columnPrice":"_2TWAICp9_5UmeiUwjEo_HT","columnQuantity":"_2XHIay7oBCY0ANMNWEs9tW","columnAction":"_3U0PRw5KS0KdrUJ9LTt5KE","cultureCircle":"_3h22F-65E8LGerfeHxmbcf","wheat":"_1sos6OtgCSQ1BBg5ilwdPM","rape":"OFwWOqhZYk9XblGVfSFAy","soy":"_1-p8D5dYUhd1Z3zMJJ2eaA","sunflower":"_1qzbEUhA0dMaZfHoBcx-m4","corn":"_1v5h_D15ZScwcSu4C8STx","scrollableItems":"_3RNmCcCud8eHEJwRnwiSO3","equipList":"_3lg1RIDmitTdcpGVvduIcc","equipItem":"_2c6LnsnCeG8bSX_LNoFt3O","itemQuantity":"_2OeJr8Ek5VXlQ25HNN1ndZ","quantityDecrease":"_5Z-28ZjjamabwjgO1-RqX","quantityIncrease":"_3ctOMF9PIEoMoSp--LzcJd","openDropdown":"_1TzzPJz_NTLjHEa3Tam0K3","dropdown":"_1PVqjNz3VkWu560YxLeptG","dropdownArrow":"_2TWaKruIzZAFvMcTK9GbKa","dropdownPic":"_2E4dEqVHPOfUwu1bp1PNeJ","doc":"_1YvoJiyQ3LKdFnyuHxKbgN","button":"_1eMD22JzQVUjY9xyBvS51G","disabled":"_3Cgplx9JmNH5gEBAy34j_4","elementCounter":"_25xuE0mnAahUTwGgeEtxCF"};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Rail__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Ticks__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tracks__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Handles__ = __webpack_require__(78);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return __WEBPACK_IMPORTED_MODULE_0__Slider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Rail", function() { return __WEBPACK_IMPORTED_MODULE_1__Rail__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ticks", function() { return __WEBPACK_IMPORTED_MODULE_2__Ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tracks", function() { return __WEBPACK_IMPORTED_MODULE_3__Tracks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Handles", function() { return __WEBPACK_IMPORTED_MODULE_4__Handles__["a"]; });





__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Rail = __WEBPACK_IMPORTED_MODULE_1__Rail__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Ticks = __WEBPACK_IMPORTED_MODULE_2__Ticks__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Tracks = __WEBPACK_IMPORTED_MODULE_3__Tracks__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Handles = __WEBPACK_IMPORTED_MODULE_4__Handles__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rail__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Rail__["a"]; });


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ticks__ = __webpack_require__(270);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Ticks__["a"]; });


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tracks__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tracks__["a"]; });


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Handles__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Handles__["a"]; });


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return prfx; });
/* unused harmony export getSortByVal */
/* harmony export (immutable) */ __webpack_exports__["e"] = getUpdatedHandles;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSliderDomain;
/* harmony export (immutable) */ __webpack_exports__["c"] = getStepRange;
/* harmony export (immutable) */ __webpack_exports__["f"] = isNotValidTouch;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = getHandles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_warning__);


var prfx = 'react-compound-slider:';
function getSortByVal(reversed) {
  return function sortByVal(a, b) {
    if (a.val > b.val) {
      return reversed ? -1 : 1;
    }

    if (b.val > a.val) {
      return reversed ? 1 : -1;
    }

    return 0;
  };
}
function getUpdatedHandles(handles, updateKey, updateValue, reversed) {
  var index = handles.findIndex(function (v) {
    return v.key === updateKey;
  });

  if (index !== -1) {
    var _handles$index = handles[index],
        key = _handles$index.key,
        val = _handles$index.val;

    if (val === updateValue) {
      return handles;
    }

    return [].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(handles.slice(0, index)), [{
      key: key,
      val: updateValue
    }], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(handles.slice(index + 1))).sort(getSortByVal(reversed));
  }

  return handles;
}
function getSliderDomain(slider, vertical, scale) {
  if (!slider) {
    return [0, 0];
  }

  var s = slider.getBoundingClientRect();
  var d0 = vertical ? s.top : s.left;
  var d1 = vertical ? s.bottom : s.right;
  var k = Math.abs(d0 - d1) / scale.n / 2;
  return [d0 - k, d1 + k];
}

function precision(num) {
  var m = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

  if (!m) {
    return 0;
  }

  return Math.max(0, (m[1] ? m[1].length : 0) - (m[2] ? +m[2] : 0));
}

function getStepRange(min, max, step) {
  var fixed = precision(step);
  var pMin = +min.toFixed(fixed);
  var pMax = +max.toFixed(fixed);
  var range = [];
  var next = pMin;

  while (next <= pMax) {
    range.push(next);
    next = +(next + step).toFixed(fixed);

    if (range.length > 1000000) {
      throw new Error('Slider range is too large. Increase step value.');
    }
  }

  return range;
}
function isNotValidTouch(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type,
      touches = _ref.touches;
  return !touches || touches.length > 1 || type.toLowerCase() === 'touchend' && touches.length > 0;
}
function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function getHandles() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var reversed = arguments.length > 1 ? arguments[1] : undefined;
  var valueToStep = arguments.length > 2 ? arguments[2] : undefined;
  var warn = arguments.length > 3 ? arguments[3] : undefined;
  var changes = 0;
  var handles = values.map(function (x) {
    var val = valueToStep.getValue(x);

    if (x !== val) {
      changes += 1;
      __WEBPACK_IMPORTED_MODULE_1_warning___default()(!warn, "".concat(prfx, " Invalid value encountered. Changing ").concat(x, " to ").concat(val, "."));
    }

    return val;
  }).map(function (val, i) {
    return {
      key: "$$-".concat(i),
      val: val
    };
  }).sort(getSortByVal(reversed));
  return {
    handles: handles,
    changes: changes
  };
}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(21);
/* unused harmony reexport ascending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(82);
/* unused harmony reexport bisector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__(279);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__(280);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__(84);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__(86);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__(281);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__(284);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__(285);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__(90);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__(286);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__(287);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__(288);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__(289);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__(91);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__(83);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__(290);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__(42);
/* unused harmony reexport quantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__(88);
/* unused harmony reexport range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__(291);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__(292);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__(293);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* unused harmony reexport tickIncrement */
/* unused harmony reexport tickStep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__(92);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__(85);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__(294);
/* unused harmony reexport zip */





























/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(82);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(85);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tickIncrement */
/* harmony export (immutable) */ __webpack_exports__["b"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_youtube_player__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  }

  // Otherwise, a change in the start/end time playerVars also requires a player
  // update.
  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};

  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}

/**
 * Neutralise API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */
function filterResetOptions(opts) {
  return _extends({}, opts, {
    playerVars: _extends({}, opts.playerVars, {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}

/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldResetPlayer(prevProps, props) {
  return !__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}

/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id !== props.id || prevProps.className !== props.className;
}

var YouTube = function (_React$Component) {
  _inherits(YouTube, _React$Component);

  function YouTube(props) {
    _classCallCheck(this, YouTube);

    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));

    _this.onPlayerReady = function (event) {
      return _this.props.onReady(event);
    };

    _this.onPlayerError = function (event) {
      return _this.props.onError(event);
    };

    _this.onPlayerStateChange = function (event) {
      _this.props.onStateChange(event);
      switch (event.data) {

        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);
          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);
          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);
          break;

        default:
      }
    };

    _this.onPlayerPlaybackRateChange = function (event) {
      return _this.props.onPlaybackRateChange(event);
    };

    _this.onPlayerPlaybackQualityChange = function (event) {
      return _this.props.onPlaybackQualityChange(event);
    };

    _this.createPlayer = function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return;
      // create player
      var playerOpts = _extends({}, _this.props.opts, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });
      _this.internalPlayer = __WEBPACK_IMPORTED_MODULE_3_youtube_player___default()(_this.container, playerOpts);
      // attach event handlers
      _this.internalPlayer.on('ready', _this.onPlayerReady);
      _this.internalPlayer.on('error', _this.onPlayerError);
      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    };

    _this.resetPlayer = function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    };

    _this.updatePlayer = function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
      });
    };

    _this.updateVideo = function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();
        return;
      }

      // set queueing options
      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };
      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;
        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }
        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      }

      // if autoplay is enabled loadVideoById
      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);
        return;
      }
      // default behaviour just cues the video
      _this.internalPlayer.cueVideoById(opts);
    };

    _this.refContainer = function (container) {
      _this.container = container;
    };

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  /**
    * Expose PlayerState constants for convenience. These constants can also be
    * accessed through the global YT object after the YouTube IFrame API is instantiated.
    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
    */


  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all Youtube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }

    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onError
     *
     * @param {Object} event
     *   @param {Integer} data  - error type
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
     *
     * @param {Object} event
     *   @param {Integer} data  - status change type
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
     *
     * @param {Object} event
     *   @param {Float} data    - playback rate
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
     *
     * @param {Object} event
     *   @param {String} data   - playback quality
     *   @param {Object} target - actual YT player
     */


    /**
     * Initialize the Youtube Player API on the container and attach event handlers
     */


    /**
     * Shorthand for destroying and then re-creating the Youtube Player
     */


    /**
     * Method to update the id and class of the Youtube Player iframe.
     * React should update this automatically but since the Youtube Player API
     * replaced the DIV that is mounted by React we need to do this manually.
     */


    /**
     * Call Youtube Player API methods to update the currently playing video.
     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
     * Youtube Player API methods to update the video.
     */

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: this.props.containerClassName },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
      );
    }
  }]);

  return YouTube;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

YouTube.propTypes = {
  videoId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom ID for player element
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom class name for player element
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom class name for player container element
  containerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any),

  // event subscriptions
  onReady: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackRateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackQualityChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
YouTube.defaultProps = {
  id: null,
  className: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {}
};
YouTube.PlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};


/* harmony default export */ __webpack_exports__["default"] = (YouTube);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
module.exports = __webpack_require__(100);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(96).enable();
  window.Promise = __webpack_require__(98);
}

// fetch() polyfill for making API calls.
__webpack_require__(99);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(9);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(43);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(43);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(32);var _reactDom2=_interopRequireDefault(_reactDom);var _reactRouterDom=__webpack_require__(11);__webpack_require__(130);__webpack_require__(5);var _App=__webpack_require__(131);var _App2=_interopRequireDefault(_App);var _index=__webpack_require__(224);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(297);var _index4=_interopRequireDefault(_index3);var _index5=__webpack_require__(313);var _index6=_interopRequireDefault(_index5);var _registerServiceWorker=__webpack_require__(315);var _stores=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var PrivateRoute=function PrivateRoute(_ref){var Component=_ref.component,rest=_objectWithoutProperties(_ref,['component']);return _react2.default.createElement(_reactRouterDom.Route,Object.assign({},rest,{render:function render(props){return _stores.presets.gameCreate===true?_react2.default.createElement(Component,props):_react2.default.createElement(_reactRouterDom.Redirect,{to:'/'});}}));};var root=document.getElementById('root');_reactDom2.default.render(_react2.default.createElement(_reactRouterDom.BrowserRouter,null,_react2.default.createElement(_reactRouterDom.Switch,null,_react2.default.createElement(_reactRouterDom.Route,{path:'/',exact:true,component:_index4.default}),_react2.default.createElement(PrivateRoute,{path:'/app',exact:true,component:_App2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/elevatorbuild',exact:true,component:_index2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/settings',exact:true,component:_index6.default}),_react2.default.createElement(_reactRouterDom.Redirect,{to:"/"}))),root);(0,_registerServiceWorker.unregister)();

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(9),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(9),r=__webpack_require__(103);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(104);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(33);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(44);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(33);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(114);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(34);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(45);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(118);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(120);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(122);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(124);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(35);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(49);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(35);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(128);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(47);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _App=__webpack_require__(132);var _App2=_interopRequireDefault(_App);var _index=__webpack_require__(50);var _index2=__webpack_require__(1);var _Results=__webpack_require__(219);var _Results2=_interopRequireDefault(_Results);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=(0,_mobxReact.observer)(_class=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={tabs:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){document.querySelector("html").style.fontSize=window.innerWidth/120+'px';document.body.onresize=function(e){document.querySelector("html").style.fontSize=e.target.innerWidth/120+'px';};}},{key:'setTabs',value:function setTabs(id){this.setState({tabs:id});}},{key:'componentWillUnmount',value:function componentWillUnmount(){_index2.time.breaker();}},{key:'render',value:function render(){if(_index2.time.getTime&&_index2.date.day.getFullYear()>=2020)return _react2.default.createElement(_Results2.default,null);return _react2.default.createElement('div',{className:_App2.default.App},_react2.default.createElement('div',{className:_App2.default.topMenuContainer},_react2.default.createElement(_index.Menu,{score:_index2.score}),_react2.default.createElement(_index.News,{news:_index2.news}),_react2.default.createElement(_index.Weather,{time:_index2.time,date:_index2.date})),_react2.default.createElement('div',{className:_App2.default.shinkableOne}),_react2.default.createElement(_index.Tabs,{setTabs:this.setTabs.bind(this),active:this.state.tabs}),this.state.tabs===0&&_react2.default.createElement('div',{className:_App2.default.gameContainer},_react2.default.createElement(_index.InputFlow,null),_react2.default.createElement(_index.ElevatorField,null),_react2.default.createElement(_index.OutputFlow,null)),this.state.tabs===1&&_react2.default.createElement('div',{className:_App2.default.gameContainer},_react2.default.createElement(_index.Requests,null)),this.state.tabs===2&&_react2.default.createElement('div',{className:_App2.default.gameContainer},_react2.default.createElement(_index.Plan,null)),this.state.tabs===3&&_react2.default.createElement('div',{className:_App2.default.gameContainer},_react2.default.createElement(_index.FinanceData,null)),_react2.default.createElement('div',{className:_App2.default.shinkableTwo}),_react2.default.createElement(_index.FooterMenu,{time:_index2.time}),_index2.scenario.pathPopupStatus?_react2.default.createElement(_index.PathPopup,null):null);}}]);return App;}(_react.Component))||_class;exports.default=App;module.exports=exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"App":"_3HBQVYkxMAhMpjuje9UKIb","gameContainer":"_2LyiguZGzuPju7jWM-i3dG","topMenuContainer":"_33Eu3yh_m1FtouZ-JVA55n","shinkableOne":"_1ywb0jcNwUgLLxx4onRkgl","shinkableTwo":"_3VDrz4QW7VRvEiLrkQY3SG","menuButton":"_3wsCBSITTeFRv57RaIb1Az","active":"_18335YyhHL6SSv8uSHWB5Q","elevatorsScoreSettings":"JS_baZGugYHvG3Jomke-2","row":"_2zwpnwo2NMoJu7CcyRJgQh"};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(134);var _index2=_interopRequireDefault(_index);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tabs=function(_Component){_inherits(Tabs,_Component);function Tabs(){_classCallCheck(this,Tabs);return _possibleConstructorReturn(this,(Tabs.__proto__||Object.getPrototypeOf(Tabs)).apply(this,arguments));}_createClass(Tabs,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:_index2.default.container},_react2.default.createElement('div',{className:_index2.default.tabsContainer},_react2.default.createElement('div',{className:_index2.default.tabs},_react2.default.createElement('div',{className:this.props.active===0?_index2.default.tabsActiveItem:_index2.default.tabsItem,onClick:function onClick(){return _this2.props.setTabs(0);}},'\u0415\u041B\u0415\u0412\u0410\u0422\u041E\u0420'),_react2.default.createElement('div',{className:this.props.active===1?_index2.default.tabsActiveItem:_index2.default.tabsItem,onClick:function onClick(){return _this2.props.setTabs(1);}},'\u041E\u0411\u0420\u041E\u0411\u041A\u0410 \u0417\u0410\u041F\u0418\u0422\u0406\u0412'),_react2.default.createElement('div',{className:this.props.active===2?_index2.default.tabsActiveItem:_index2.default.tabsItem,onClick:function onClick(){return _this2.props.setTabs(2);}},'\u041F\u041B\u0410\u041D\u041E\u0412\u0406 \u041F\u041E\u041A\u0410\u0417\u041D\u0418\u041A\u0418'),_react2.default.createElement('div',{className:this.props.active===3?_index2.default.tabsActiveItem:_index2.default.tabsItem,onClick:function onClick(){return _this2.props.setTabs(3);}},'\u0424\u0406\u041D\u0410\u041D\u0421\u041E\u0412\u0406 \u041F\u041E\u041A\u0410\u0417\u041D\u0418\u041A\u0418'))));}}]);return Tabs;}(_react.Component);exports.default=Tabs;module.exports=exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1slTeG2qmowyU-I-Ey1KvU","tabsContainer":"_3Ne2LAS54PLqZ2QxxDUpUI","tabs":"_3wgtFn6OhVd4TFH1kkma-l","tabsActiveItem":"_1xpDAY8Urv3WORuIetlN7h","tabsItem":"_20QkUg0KN8jKiMHLENQyje"};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class3,_class4;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(136);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _mobxReact=__webpack_require__(2);var _index3=__webpack_require__(1);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FooterMenu=(0,_mobxReact.observer)(_class=function(_Component){_inherits(FooterMenu,_Component);function FooterMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FooterMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FooterMenu.__proto__||Object.getPrototypeOf(FooterMenu)).call.apply(_ref,[this].concat(args))),_this),_this.cultures={"rape":"рапс","wheat":"пшениця","soy":"соя","sunflower":"соняшник","corn":"кукурудза"},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FooterMenu,[{key:'render',value:function render(){var _this2=this;//побить на компоненты, ибо слишком много перерендерa
return _react2.default.createElement('div',{className:_index2.default.container},_react2.default.createElement('div',{className:_index2.default.item+' '+_index2.default.requests},_react2.default.createElement('div',{className:_index2.default.footerMenuHeading},'\u0412\u0425\u0406\u0414\u041D\u0406 \u0417\u0410\u041F\u0418\u0422\u0418'),_react2.default.createElement('div',{className:_index2.default.scrollableRequests},_index3.offers.offers.map(function(item,i){return item.status==='new'?_react2.default.createElement('div',{className:_index2.default.requestBar+' '+_index2.default[item.culture],key:i},_react2.default.createElement('span',{className:_index2.default.requestItemDateTime},item.date.toLocaleDateString('ru',{year:'numeric',month:'numeric',day:'numeric'})),'\xA0\xA0\xA0',_react2.default.createElement('span',{className:_index2.default.requestItemType},'\u0412\u0456\u0434\u0433\u0440\u0443\u0437\u043A\u0430'),'\xA0',_react2.default.createElement('span',{className:_index2.default.requestItemCulture},_this2.cultures[item.culture]),'\xA0\xA0\xA0',_react2.default.createElement('span',{className:_index2.default.requestItemWeight},item.amount,' \u0442.'),_react2.default.createElement('div',{className:_index2.default.requestBarRefuse,onClick:function onClick(){return _index3.offers.offers[i].setStatus('failed');}},' ',_react2.default.createElement(_reactFontawesome2.default,{name:'times-circle'}))):null;}))),_react2.default.createElement(Stats,null),_react2.default.createElement(Timer,null));}}]);return FooterMenu;}(_react.Component))||_class;exports.default=FooterMenu;var Stats=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(Stats,_Component2);function Stats(){_classCallCheck(this,Stats);return _possibleConstructorReturn(this,(Stats.__proto__||Object.getPrototypeOf(Stats)).apply(this,arguments));}_createClass(Stats,[{key:'cashTotal',value:function cashTotal(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var result=0;var expensesType=['cashYield','directExpends','indirectExpends'];expensesType.forEach(function(item,i){var sum=Object.keys(data).reduce(function(previousValue,currentValue){if(currentValue==='elem'||currentValue==='total')return previousValue;return previousValue+data[currentValue][item];},0);if(!i){result+=sum;}else{result-=sum;}});return result/_index3.score.total*100;}},{key:'render',value:function render(){var input=this.cashTotal(_index3.finance['input']);var drying=this.cashTotal(_index3.finance['drying']);var cleaning=this.cashTotal(_index3.finance['cleaning']);var storage=this.cashTotal(_index3.finance['storage']);var output=this.cashTotal(_index3.finance['output']);var transhipment=this.cashTotal(_index3.finance['transhipment']);var total=input+drying+cleaning+storage+output+transhipment;return _react2.default.createElement('div',{className:_index2.default.item+' '+_index2.default.finResults},_react2.default.createElement('div',{className:_index2.default.footerMenuHeading},'\u0424\u0406\u041D\u0410\u041D\u0421\u041E\u0412\u0406 \u041F\u041E\u041A\u0410\u0417\u041D\u0418\u041A\u0418'),_react2.default.createElement('div',{className:_index2.default.footerResultsContainer},_react2.default.createElement('div',{className:_index2.default.footerResultsItems},_react2.default.createElement('div',null,'\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F'),_react2.default.createElement('div',{className:_index2.default.footerResultsIcon},_react2.default.createElement('i',{className:_iconfonts2.default.iconInput})),_react2.default.createElement('div',{className:_index2.default.footerResultsPercent},input.toFixed(2),'%')),_react2.default.createElement('div',{className:_index2.default.footerResultsItems},_react2.default.createElement('div',null,'\u0421\u0443\u0448\u043A\u0430'),_react2.default.createElement('div',{className:_index2.default.footerResultsIcon},_react2.default.createElement('i',{className:_iconfonts2.default.iconDrying})),_react2.default.createElement('div',{className:_index2.default.footerResultsPercent},drying.toFixed(2),'%')),_react2.default.createElement('div',{className:_index2.default.footerResultsItems},_react2.default.createElement('div',null,'\u041E\u0447\u0438\u0449\u0435\u043D\u043D\u044F'),_react2.default.createElement('div',{className:_index2.default.footerResultsIcon},_react2.default.createElement('i',{className:_iconfonts2.default.iconCleaning})),_react2.default.createElement('div',{className:_index2.default.footerResultsPercent},cleaning.toFixed(2),'%')),_react2.default.createElement('div',{className:_index2.default.footerResultsItems},_react2.default.createElement('div',null,'\u0417\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F'),_react2.default.createElement('div',{className:_index2.default.footerResultsIcon},_react2.default.createElement('i',{className:_iconfonts2.default.iconStoring})),_react2.default.createElement('div',{className:_index2.default.footerResultsPercent},storage.toFixed(2),'%')),_react2.default.createElement('div',{className:_index2.default.footerResultsItems},_react2.default.createElement('div',null,'\u0412\u0438\u0433\u0440\u0443\u0437\u043A\u0430'),_react2.default.createElement('div',{className:_index2.default.footerResultsIcon},_react2.default.createElement('i',{className:_iconfonts2.default.iconOutput})),_react2.default.createElement('div',{className:_index2.default.footerResultsPercent},output.toFixed(2),'%')),_react2.default.createElement('div',{className:_index2.default.footerResultsItems},_react2.default.createElement('div',null,'\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043A\u0430\u043F\u0456\u0442\u0430\u043B\u0443'),_react2.default.createElement('div',{className:_index2.default.footerResultsIcon},_react2.default.createElement('i',{className:_iconfonts2.default.iconRoce})),_react2.default.createElement('div',{className:_index2.default.footerResultsPercent},total.toFixed(2),'%'))));}}]);return Stats;}(_react.Component))||_class3;var Timer=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(Timer,_Component3);function Timer(){_classCallCheck(this,Timer);return _possibleConstructorReturn(this,(Timer.__proto__||Object.getPrototypeOf(Timer)).apply(this,arguments));}_createClass(Timer,[{key:'render',value:function render(){var timerAnimation={strokeDashoffset:(245-Math.floor(_index3.time.currentTime*_index3.time.tickCoef/6.4))/16+'rem'};return _react2.default.createElement('div',{className:_index2.default.item+' '+_index2.default.gameControls},_react2.default.createElement('div',{className:_index2.default.footerMenuHeading},'\u041A\u0415\u0420\u0423\u0412\u0410\u041D\u041D\u042F \u041C\u041E\u0414\u0415\u041B\u042E\u0412\u0410\u041D\u041D\u042F\u041C'),_react2.default.createElement('div',{className:_index2.default.footerTime},_index3.time.getTime),_react2.default.createElement('div',{className:_index2.default.footerControlsContainer},_react2.default.createElement('div',{className:_index2.default.footerControlsContainerItems,onClick:function onClick(){_index3.time.breaker();_index3.time.setTimeSpeed(0);}},_react2.default.createElement('div',{className:_index2.default.footerControls+(_index3.time.timeSpeed===0?' '+_index2.default.footerControlsActive:'')},_react2.default.createElement('i',{className:_iconfonts2.default.iconPause}))),_react2.default.createElement('div',{className:_index2.default.footerControlsContainerItems,onClick:function onClick(){return Timer.setSimulationSpeed(1);}},_react2.default.createElement('div',{className:_index2.default.footerControls+' '+_index2.default.playButton+(_index3.time.timeSpeed!==0?' '+_index2.default.footerControlsActive:'')},_react2.default.createElement('i',{className:_iconfonts2.default.iconPlay}))),_react2.default.createElement('div',{className:_index2.default.footerControlsContainerItems,onClick:function onClick(){return Timer.setSimulationSpeed(2);}},_react2.default.createElement('div',{className:_index2.default.footerControls+(_index3.time.timeSpeed>=2?' '+_index2.default.footerControlsActive:'')},_react2.default.createElement('i',{className:_iconfonts2.default.iconPlay}),_react2.default.createElement('i',{className:_iconfonts2.default.iconPlay}))),_react2.default.createElement('div',{className:_index2.default.footerControlsContainerItems,onClick:function onClick(){return Timer.setSimulationSpeed(3);}},_react2.default.createElement('div',{className:_index2.default.footerControls+(_index3.time.timeSpeed===3?' '+_index2.default.footerControlsActive:'')},_react2.default.createElement('i',{className:_iconfonts2.default.iconPlay}),_react2.default.createElement('i',{className:_iconfonts2.default.iconPlay}),_react2.default.createElement('i',{className:_iconfonts2.default.iconPlay}))),_react2.default.createElement('div',{className:_index2.default.footerControlsContainerItems},_react2.default.createElement('div',{className:_index2.default.footerControls+' '+_index2.default.timerCircle},_react2.default.createElement('span',{className:_index2.default.footerControlsContainerTimer},'x',_index3.time.timeSpeed),_react2.default.createElement('svg',{className:_index2.default.circle,xmlns:'http://www.w3.org/2000/svg'},_react2.default.createElement('g',null,_react2.default.createElement('circle',{r:'2.25rem',cy:'2.5rem',cx:'2.5rem',strokeWidth:'2%',stroke:'#e6e6e6',fill:'none'}),_react2.default.createElement('circle',{style:timerAnimation,className:_index2.default.timerAnimation,r:'2.25rem',cy:'2.5rem',cx:'2.5rem',strokeWidth:'2%',stroke:'#0071e5',fill:'none',id:'timerAnimation'})))))),_react2.default.createElement('div',{className:_index2.default.footerTimerDefinition},'\u0428\u0432\u0438\u0434\u043A\u0456\u0441\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u044E\u0432\u0430\u043D\u043D\u044F'));}}],[{key:'setSimulationSpeed',value:function setSimulationSpeed(speed){if(speed!==_index3.time.timeSpeed){_index3.time.breaker();_index3.time.setTimeSpeed(speed);_index3.time.startTime();}}}]);return Timer;}(_react.Component))||_class4;module.exports=exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1_j0BtQUL0vlUdxMuh3tRC","item":"F_HxhhLS3hm4Tpl-jWush","requests":"_18NPP0hugznBUqQiiZFmA1","finResults":"_36g9eIZJ6sAL9oRFDJbBoL","gameControls":"-M1fLs0-QqZcTK-NxF1C9","footerMenuHeading":"_1LhKQ3QTOQz3uWYJ54wB5c","scrollableRequests":"_1SYe2T4YyxaRbQH2kGML2Q","doc":"_1u43uAedh-TXwmgGgf1G3B","requestBar":"VdcS0dnGIck2Ca6lIr3Tk","requestBarRefuse":"_3t8sVvcIPOgQNb5SZpeLms","wheat":"_1J4qNDfjbNFbmJnC93CGL","rape":"_37cDt1_pZG1deVtn6gEwu4","corn":"C_sQDo_3BXt9Mymz4p9ed","soy":"_1vQVQbls3KhGAmxV0JJ06T","sunflower":"SdaN6zn4_mYgRKtyzJrWo","footerResultsContainer":"_2vC58f10i0q_MebQi7XpX6","footerResultsItems":"_327RCZ4bYu4SWqJjoXhTzI","footerResultsIcon":"_2wG2hRE0G0K1Xq6rQ-diHz","footerResultsPercent":"_3f56GKYgnG5Kl-CwiYRT-b","footerTime":"_53MXnYwadOLpSvhy0fv1p","footerControlsContainer":"_1UCEnNHLxfueZtOz7F0MBX","footerControlsContainerItems":"kGOG4lzn5JKrt4bta6Cxb","footerControls":"neB8uUYJmY8JnrFtMo5CA","playButton":"_1IYRKb2G-HTpXyUHzCLc02","timerCircle":"_3LQ4-ilqNDYy4PnGDbsjyy","footerControlsContainerTimer":"yQsaOc_I1kFljJEEQMPSg","footerTimerDefinition":"_3V1Xax3ncnoEAiQowp4V87","timerAnimation":"_2-X4MFxHneMwB1N1yGm3lr","footerControlsActive":"gKiqdo_LIKKGu3Yx8d8f5","button":"_3KEehB74-0SRZz-zo66VsI","circle":"VFGLSMVpKHjtEL9BUZscA","outCircle":"_2gkrsWITHxkztJhFEZjuAB","incideCircle":"_2gZSXoBUCIVyU23b5wnTqz"};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;var _mobx=__webpack_require__(3);var _index=__webpack_require__(1);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}(0,_mobx.useStrict)(false);var NewsStore=(_class=function(){function NewsStore(){_classCallCheck(this,NewsStore);_initDefineProp(this,'newsList',_descriptor,this);this.cultures={wheat:"пшениці",corn:"кукурудзи",soy:"сої",sunflower:"соняшника",rape:"ріпаку"};this.setNewDay();}_createClass(NewsStore,[{key:'setNewDay',value:function setNewDay(){this.newsList=[{type:this.setMassageType('weather'),date:_index.date.day.getDate()+'.'+_index.date.day.getMonth()+'.'+_index.date.day.getFullYear()+' '+_index.time.getTime,font:_index.date.weather.type===0?'sun-o':_index.date.weather.type===1?'tint':'cloud',massage:_index.date.weather.type===0?"Погода: Сонячно.":_index.date.weather.type===1?"Погода: Дощі.":"Погода: Сьогодні хмарно."},{type:this.setMassageType('input'),date:_index.date.day.getDate()+'.'+_index.date.day.getMonth()+'.'+_index.date.day.getFullYear()+' '+_index.time.getTime,font:'exclamation-circle',massage:'Почався новий день.'}];}},{key:'addShipmentErrorMessage',value:function addShipmentErrorMessage(){this.newsList.unshift({type:this.setMassageType('alert'),date:_index.date.day.getDate()+'.'+_index.date.day.getMonth()+'.'+_index.date.day.getFullYear()+' '+_index.time.getTime,font:'arrow-circle-down',massage:'\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u0438\u0439 \u0432\u0430\u043C\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u043D\u0435 \u043F\u0440\u0438\u0431\u0443\u0432 \u0434\u043E \u0441\u0442\u0430\u043D\u0446\u0456\u0457 \u0432\u0456\u0434\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F. \u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0447\u0430\u0441 \u043F\u0440\u0438\u0431\u0443\u0442\u0442\u044F - \u0437\u0430\u0432\u0442\u0440\u0430.'});}},{key:'addInputMassage',value:function addInputMassage(transport,type){this.newsList.unshift({type:this.setMassageType('input'),date:_index.date.day.getDate()+'.'+_index.date.day.getMonth()+'.'+_index.date.day.getFullYear()+' '+_index.time.getTime,font:'arrow-circle-down',massage:'\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F: '+transport.item*20+' \u0442\u043E\u043D '+this.cultures[transport.culture]+' (\u0432\u043E\u043B\u043E\u0433\u0456\u0441\u0442\u044C '+transport.moisture+'%, \u0441\u043C\u0456\u0442\u043D\u0456\u0441\u0442\u044C '+transport.waste+'%) \u043F\u0440\u0438\u0431\u0443\u043B\u043E '+(type==="truck"?"автотранспортом":"залізницею")+'. '});}},{key:'setMassageType',value:function setMassageType(item){var result=void 0;switch(item){case'weather':result={color:"rgba(37,65,114,1)"};break;case'input':result={color:"rgba(80,80,80,1)"};break;case'output':result={color:"rgba(0,170,100,1)"};break;case'alert':result={color:"rgba(205,60,60,1)"};break;default:break;}return result;}}]);return NewsStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'newsList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'setNewDay',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setNewDay'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addShipmentErrorMessage',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addShipmentErrorMessage'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addInputMassage',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addInputMassage'),_class.prototype)),_class);exports.default=NewsStore;module.exports=exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _mobx=__webpack_require__(3);var _index=__webpack_require__(1);var _cropPlanSettings=__webpack_require__(51);var _cropPlanSettings2=_interopRequireDefault(_cropPlanSettings);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var DateStore=(_class=function(){function DateStore(){_classCallCheck(this,DateStore);_initDefineProp(this,'compositionFormation',_descriptor,this);_initDefineProp(this,'day',_descriptor2,this);_initDefineProp(this,'forecast',_descriptor3,this);_initDefineProp(this,'weather',_descriptor4,this);_initDefineProp(this,'temp',_descriptor5,this);_initDefineProp(this,'scheduleReception',_descriptor6,this);// this.initialDay = new Date(2017, 7, 1, 0, 0, 0);
this.day=new Date(2019,6,9,0,0,0);this.scheduleReception={truck:[],train:[]};this.forecastInitialization();this.setCurrentDay();this.compositionFormation=false;}_createClass(DateStore,[{key:'setDay',value:function setDay(){var _this=this;this.day.setDate(this.day.getDate()+1);_index.offers.offers.filter(function(item){return item.status==="new"&&item.date<_this.day;}).forEach(function(item){item.setStatus("failed");});}},{key:'setCompositionFormation',value:function setCompositionFormation(culture){if(!this.compositionFormation&&culture){this.compositionFormationCulture=culture;this.compositionFormation=true;}}},{key:'setTemp',value:function setTemp(){var min=Math.floor(Math.random()*14)+6;var max=min+Math.floor(Math.random()*3)+1;return{min:min,max:max};}},{key:'setScheduleReception',value:function setScheduleReception(){var _this2=this;this.setDay();_index.shipment.filterOutputTransport();var allCultures={};for(var key in _cropPlanSettings2.default){var cropPlanDate=new Date(_cropPlanSettings2.default[key].date);var delta=Math.floor((this.day-cropPlanDate)/1000/60/60/24);if(delta>=0&&delta<_index.cropPlan.scenario[key].length){allCultures[key]=_index.cropPlan.scenario[key][delta];_index.cropPlan.dayPlan[key]=_index.cropPlan.scenario[key][delta];_index.cropPlan.weekPlan[key]=0;_index.cropPlan.monthPlan[key]=0;for(var i=0;i<7;i++){if(delta+i<=_index.cropPlan.scenario[key].length-1)_index.cropPlan.weekPlan[key]+=_index.cropPlan.scenario[key][delta+i];}for(var _i=0;_i<30;_i++){if(delta+_i<=_index.cropPlan.scenario[key].length-1)_index.cropPlan.monthPlan[key]+=_index.cropPlan.scenario[key][delta+_i];}}else{if(delta>-7&&delta<0){_index.cropPlan.weekPlan[key]=0;_index.cropPlan.monthPlan[key]=0;for(var _i2=0;_i2<7;_i2++){if(delta+_i2>=0)if(delta+_i2<=_index.cropPlan.scenario[key].length-1)_index.cropPlan.weekPlan[key]+=_index.cropPlan.scenario[key][delta+_i2];}for(var _i3=0;_i3<30;_i3++){if(delta+_i3>=0)if(delta+_i3<=_index.cropPlan.scenario[key].length-1)_index.cropPlan.monthPlan[key]+=_index.cropPlan.scenario[key][delta+_i3];}}else{if(delta>-30&&delta<0){_index.cropPlan.monthPlan[key]=0;for(var _i4=0;_i4<30;_i4++){if(delta+_i4>=0)if(delta+_i4<=_index.cropPlan.scenario[key].length-1)_index.cropPlan.monthPlan[key]+=_index.cropPlan.scenario[key][delta+_i4];}}}}}var schedule={truck:[],train:[]};var matches=void 0;var amountTruck={};for(var _key in allCultures){if(allCultures[_key])_index.offers.addNewOffer(allCultures[_key],_key);amountTruck[_key]=Math.floor(allCultures[_key]/(20*_cultureSettings2.default[_key].volume));var _loop=function _loop(){var truckGroup=Math.floor(Math.random()*(10-5))+5;if(truckGroup>amountTruck[_key]){truckGroup=amountTruck[_key];}var waste=Math.floor(_cultureSettings2.default[_key].baseWaste+Math.floor(Math.random()*(_cultureSettings2.default[_key].critWaste-_cultureSettings2.default[_key].baseWaste)*1.3/2)*2);var moisture=Math.floor(_cultureSettings2.default[_key].baseMoisture+Math.floor(Math.random()*(_cultureSettings2.default[_key].critMoisture-_cultureSettings2.default[_key].baseMoisture)/2)*2+(_this2.weather===1?Math.random()*(_cultureSettings2.default[_key].critMoisture-_cultureSettings2.default[_key].baseMoisture)*0.3:0));amountTruck[_key]-=truckGroup;var result=Math.floor(Math.random()*_index.time.dayLength)+1;matches=schedule.truck.findIndex(function(element){if(element.time===result){return element;}return null;});if(matches!==-1){schedule.truck[matches].item+=truckGroup;}else{schedule.truck.push({item:truckGroup,time:result,culture:_key,waste:waste,moisture:moisture});}};while(amountTruck[_key]>0){_loop();}}schedule.truck.sort(function(a,b){return b.time-a.time;});schedule.train.sort(function(a,b){return b.time-a.time;});return schedule;}},{key:'setCurrentDay',value:function setCurrentDay(){if(this.compositionFormation){if(Math.random()*100>20){this.compositionFormation=false;var dayOutcame=new Date(this.day.getFullYear(),this.day.getMonth(),this.day.getDate(),0,0,0);var dayIncome=new Date(this.day.getFullYear(),this.day.getMonth(),this.day.getDate(),0,0,0);dayOutcame=dayOutcame.setDate(dayOutcame.getDate()+6+Math.floor(Math.random()*3));_index.shipment.addOutputTransport('train',this.compositionFormationCulture,dayIncome,new Date(dayOutcame),3599*_cultureSettings2.default[this.compositionFormationCulture].volume,_cultureSettings2.default[this.compositionFormationCulture].baseWaste,_cultureSettings2.default[this.compositionFormationCulture].baseMoisture);}else{_index.news.addShipmentErrorMessage();}}this.weather=this.forecast[0].weather;this.temp=this.forecast[0].temp;this.forecast=[{day:this.day.getDate()===31?1:this.day.getDate()+1,temp:this.forecast[1].temp,weather:this.forecast[1].weather},{day:this.day.getDate()>29?this.day.getDate()-29:this.day.getDate()+2,temp:this.forecast[2].temp,weather:this.forecast[2].weather},{day:this.day.getDate()>28?this.day.getDate()-28:this.day.getDate()+3,temp:this.setTemp(),weather:Math.floor(Math.random()*3)}];this.scheduleReception=this.setScheduleReception();}},{key:'forecastInitialization',value:function forecastInitialization(){this.forecast=[{day:this.day.getDate()+1,temp:this.setTemp(),weather:Math.floor(Math.random()*3)},{day:this.day.getDate()+2,temp:this.setTemp(),weather:Math.floor(Math.random()*3)},{day:this.day.getDate()+3,temp:this.setTemp(),weather:Math.floor(Math.random()*3)}];}}]);return DateStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'compositionFormation',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'day',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'forecast',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'weather',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'temp',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'scheduleReception',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'setDay',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setDay'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setCompositionFormation',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setCompositionFormation'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setTemp',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setTemp'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setScheduleReception',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setScheduleReception'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setCurrentDay',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setCurrentDay'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'forecastInitialization',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'forecastInitialization'),_class.prototype)),_class);exports.default=DateStore;module.exports=exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;var _mobx=__webpack_require__(3);var _transport=__webpack_require__(36);var _transport2=_interopRequireDefault(_transport);var _index=__webpack_require__(1);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}(0,_mobx.useStrict)(false);var TimeStore=(_class=function(){function TimeStore(){_classCallCheck(this,TimeStore);_initDefineProp(this,'timerId',_descriptor,this);_initDefineProp(this,'currentTime',_descriptor2,this);_initDefineProp(this,'timeSpeed',_descriptor3,this);_initDefineProp(this,'setTimeSpeed',_descriptor4,this);_initDefineProp(this,'setCurrent',_descriptor5,this);this.timerId=0;this.currentTime=0;this.timeSpeed=1;this.dayLength=360;this.tickCoef=1440/this.dayLength;}_createClass(TimeStore,[{key:'transportCheck',value:function transportCheck(time,schedule,stack,type){var _loop=function _loop(){// let amount = type === 'truck' ? 20 : 60;
var transport=schedule.pop();var amount=parseFloat((20*_cultureSettings2.default[transport.culture].volume).toFixed(1));var TransportPos=stack.findIndex(function(element){return element.moistureLevel===transport.moisture&&element.wasteLevel===transport.waste&&element.culture===transport.culture;});if(TransportPos!==-1){stack[TransportPos].groupQuantity+=transport.item;}else{stack.push(new _transport2.default(transport.culture,amount,amount,transport.moisture,transport.waste,transport.item,transport.moisture>=_cultureSettings2.default[transport.culture].critMoisture||transport.waste>=_cultureSettings2.default[transport.culture].critWaste?"alert":''));}_index.cropPlan.currentWeight[transport.culture]-=amount*transport.item;_index.cropPlan.dayPlan[transport.culture]-=amount*transport.item;_index.cropPlan.weekPlan[transport.culture]-=amount*transport.item;_index.cropPlan.monthPlan[transport.culture]-=amount*transport.item;_index.news.addInputMassage(transport,type);};while(schedule.length!==0&&time===schedule[schedule.length-1].time){_loop();}}},{key:'startShipping',value:function startShipping(){_index.shipment.shipmentBunker.forEach(function(item){item.shippingFrom();});_index.storageStore.silosList.forEach(function(item){item.checkUnit();});_index.storageStore.hoppersList.forEach(function(item){item.checkUnit();});_index.receptionBunkersStore.receptionBunker.forEach(function(item){item.checkBunker();});_index.dcUnitsStore.dryingList.forEach(function(item){item.checkUnit();});_index.dcUnitsStore.cleaningList.forEach(function(item){item.checkUnit();});_index.score.checkScore();}},{key:'startTime',value:function startTime(){var _this=this;var time=this.currentTime;this.timerId=setInterval(function(){time+=1;_this.transportCheck(time,_index.date.scheduleReception.truck,_index.transportStore.receptionTruck,'truck');_this.transportCheck(time,_index.date.scheduleReception.train,_index.transportStore.receptionTrain,'train');_this.startShipping();if(time>_this.dayLength){time=0;_index.news.setNewDay();_index.date.setCurrentDay();}_this.setCurrent(time);},125/(this.timeSpeed===1?this.timeSpeed:this.timeSpeed*2));}},{key:'breaker',value:function breaker(){clearInterval(this.timerId);}},{key:'getTime',get:function get(){var min=this.currentTime*this.tickCoef%60;var hour=Math.floor(this.currentTime*this.tickCoef/60);return''+(hour<10?0:'')+hour+':'+(min<10?0:'')+min;}}]);return TimeStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'timerId',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'currentTime',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'timeSpeed',[_mobx.observable],{enumerable:true,initializer:function initializer(){return 1;}}),_applyDecoratedDescriptor(_class.prototype,'getTime',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTime'),_class.prototype),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'setTimeSpeed',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this2=this;return function(item){_this2.timeSpeed=item;};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'setCurrent',[_mobx.action],{enumerable:true,initializer:function initializer(){var _this3=this;return function(item){_this3.currentTime=item;};}}),_applyDecoratedDescriptor(_class.prototype,'transportCheck',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'transportCheck'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'startShipping',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'startShipping'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'startTime',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'startTime'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'breaker',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'breaker'),_class.prototype)),_class);exports.default=TimeStore;module.exports=exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(3);var _index=__webpack_require__(1);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}(0,_mobx.useStrict)(false);var ScoreStore=(_class=function(){function ScoreStore(){var menu=arguments.length>0&&arguments[0]!==undefined?arguments[0]:100;var total=arguments.length>1&&arguments[1]!==undefined?arguments[1]:9900000;_classCallCheck(this,ScoreStore);_initDefineProp(this,'menu',_descriptor,this);_initDefineProp(this,'total',_descriptor2,this);this.menu=menu;this.total=total;this.elevatorsName='РЕГИОНАЛЬНЫЙ ЭЛЕВАТОР';}_createClass(ScoreStore,[{key:'setElevatorsName',value:function setElevatorsName(name){if(!name){this.elevatorsName="Elevator simulation #"+Math.floor(Math.random()*10000);}else{this.elevatorsName=name;}}},{key:'checkScore',value:function checkScore(){var fine=1;_index.transportStore.receptionTruck.forEach(function(item){if(!item.disabled)fine-=item.groupQuantity*0.0035;});_index.transportStore.receptionTrain.forEach(function(item){if(!item.disabled)fine-=item.groupQuantity*0.0035;});if(this.menu+fine<0){if(this.menu!==0){this.menu=0;}}else{if(this.menu+fine>100){this.menu=100;}else{this.menu+=fine;}}}}]);return ScoreStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'menu',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'total',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'setElevatorsName',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setElevatorsName'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'checkScore',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'checkScore'),_class.prototype)),_class);exports.default=ScoreStore;module.exports=exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;var _mobx=__webpack_require__(3);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ScenarioStore=(_class=function(){function ScenarioStore(){_classCallCheck(this,ScenarioStore);_initDefineProp(this,'currentScenario',_descriptor,this);_initDefineProp(this,'script',_descriptor2,this);_initDefineProp(this,'pathPopupStatus',_descriptor3,this);_initDefineProp(this,'active',_descriptor4,this);this.default={type:'default'};}_createClass(ScenarioStore,[{key:'openPathPopup',value:function openPathPopup(){var item=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var active=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;this.active=active;this.pathPopupStatus=true;if(active){var _script;this.currentScenario=item;this.script=(_script=this.script).concat.apply(_script,_toConsumableArray(item));}else{this.script=this.script.concat(item,this.default);}}},{key:'setDefaultScript',value:function setDefaultScript(){this.script.splice(1,this.script.length-1,this.default);}},{key:'closePathPopup',value:function closePathPopup(){this.script=[];this.pathPopupStatus=false;this.active=false;}},{key:'addScriptElem',value:function addScriptElem(elem,id){this.script.splice(id+1,0,elem);}},{key:'setLastElem',value:function setLastElem(elem){this.script.splice(this.script.length-1,1,elem);}},{key:'deleteElementFromScript',value:function deleteElementFromScript(id){if(id===this.script.length-1){this.setLastElem(this.default);}else{this.script.splice(id,1);}}},{key:'setScenario',value:function setScenario(){var _this=this;if(this.active&&this.script.length<=2&&this.script[this.script.length-1].type!=='output'&&this.script[this.script.length-1].type!=='silo'&&this.script[this.script.length-1].type!=='hopper'){this.currentScenario.forEach(function(item,i){if(item.type==='cleaning'||item.type==='drying'){item.setUnit();}if((item.type==='hopper'||item.type==='silo')&&_this.currentScenario.length-1!==i){item.initScenario([],0);}});this.script[0].initScenario([],-1);}else{this.script[0].initScenario(this.script,1);}this.closePathPopup();}},{key:'getIsActiveSetScenarioButton',get:function get(){return this.active&&this.script.length<=2||this.script.length>1&&(this.script[0].type==='bunker'||this.script[0].type==='silo'||this.script[0].type==='hopper')&&(this.script[this.script.length-1].type==='output'||this.script[this.script.length-1].type==='silo'||this.script[this.script.length-1].type==='hopper');}}]);return ScenarioStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'currentScenario',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'script',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'pathPopupStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'active',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'openPathPopup',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'openPathPopup'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setDefaultScript',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setDefaultScript'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'closePathPopup',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'closePathPopup'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'addScriptElem',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addScriptElem'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setLastElem',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setLastElem'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'deleteElementFromScript',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'deleteElementFromScript'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setScenario',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setScenario'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getIsActiveSetScenarioButton',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getIsActiveSetScenarioButton'),_class.prototype)),_class);exports.default=ScenarioStore;module.exports=exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;var _mobx=__webpack_require__(3);var _outputBunker=__webpack_require__(52);var _outputBunker2=_interopRequireDefault(_outputBunker);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);var _index=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ShipmentStore=(_class=function(){function ShipmentStore(){_classCallCheck(this,ShipmentStore);_initDefineProp(this,'lineStatus',_descriptor,this);_initDefineProp(this,'shipmentBunker',_descriptor2,this);_initDefineProp(this,'outputTransport',_descriptor3,this);this.outputTransport=[];// this.addOutputTransport('train','rape',new Date(2019, 6, 10, 0, 0, 0),new Date(2020,10,10),300,3,8)
}_createClass(ShipmentStore,[{key:'findOutputTransport',value:function findOutputTransport(culture){var _this=this;this.outputTransport.find(function(item){return item.culture===_this.culture;});}},{key:'addOutputTransport',value:function addOutputTransport(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'truck';var culture=arguments[1];var dateIncome=arguments[2];var endDate=arguments[3];var amount=arguments[4];var wasteLevel=arguments[5];var moistureLevel=arguments[6];var offerLink=arguments[7];var quantity=Math.ceil(amount/((type==='truck'?20:60)*_cultureSettings2.default[culture].volume));this.outputTransport.push({type:type,culture:culture,dateIncome:dateIncome,endDate:endDate,quantity:quantity,wasteLevel:wasteLevel,moistureLevel:moistureLevel,offer:offerLink});}},{key:'removeOutputTransport',value:function removeOutputTransport(id){this.outputTransport.splice(id,1);}},{key:'filterOutputTransport',value:function filterOutputTransport(){if(_index.date){this.outputTransport.filter(function(item){return item.endDate<_index.date.day;}).forEach(function(item){if(item.offer)item.offer.setStatus('failed');});this.outputTransport=this.outputTransport.filter(function(item){return item.endDate>=_index.date.day;});}}},{key:'getTotalWheat',get:function get(){return this.outputTransport.reduce(function(prev,current){return current.culture==='wheat'?current.quantity+prev:prev;},0);}},{key:'getTotalSoy',get:function get(){return this.outputTransport.reduce(function(prev,current){return current.culture==='soy'?current.quantity+prev:prev;},0);}},{key:'getTotalRape',get:function get(){return this.outputTransport.reduce(function(prev,current){return current.culture==='rape'?current.quantity+prev:prev;},0);}},{key:'getTotalSunflower',get:function get(){return this.outputTransport.reduce(function(prev,current){return current.culture==='sunflower'?current.quantity+prev:prev;},0);}},{key:'getTotalCorn',get:function get(){return this.outputTransport.reduce(function(prev,current){return current.culture==='corn'?current.quantity+prev:prev;},0);}},{key:'getLineStatus',get:function get(){var result=this.shipmentBunker.find(function(item){return item.status==='clogged';});if(result){return result.status;}else{result=this.shipmentBunker.find(function(item){return item.active;});if(result)return result.culture;}return'None';}}]);return ShipmentStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'lineStatus',[_mobx.observable],{enumerable:true,initializer:function initializer(){return'None';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'shipmentBunker',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[new _outputBunker2.default(0,'train'),new _outputBunker2.default(1,'train')];}}),_applyDecoratedDescriptor(_class.prototype,'findOutputTransport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'findOutputTransport'),_class.prototype),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'outputTransport',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'addOutputTransport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'addOutputTransport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'removeOutputTransport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'removeOutputTransport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'filterOutputTransport',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'filterOutputTransport'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalWheat',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalWheat'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalSoy',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalSoy'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalRape',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalRape'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalSunflower',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalSunflower'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getTotalCorn',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getTotalCorn'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getLineStatus',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getLineStatus'),_class.prototype)),_class);exports.default=ShipmentStore;module.exports=exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11;var _mobx=__webpack_require__(3);var _equipSettings=__webpack_require__(144);var _equipSettings2=_interopRequireDefault(_equipSettings);var _index=__webpack_require__(1);var _bunker=__webpack_require__(54);var _bunker2=_interopRequireDefault(_bunker);var _silos=__webpack_require__(55);var _silos2=_interopRequireDefault(_silos);var _outputBunker=__webpack_require__(52);var _outputBunker2=_interopRequireDefault(_outputBunker);var _ReceptionTransportStore=__webpack_require__(56);var _ReceptionTransportStore2=_interopRequireDefault(_ReceptionTransportStore);var _hopper=__webpack_require__(57);var _hopper2=_interopRequireDefault(_hopper);var _CleaningUnit=__webpack_require__(58);var _CleaningUnit2=_interopRequireDefault(_CleaningUnit);var _DryingUnit=__webpack_require__(59);var _DryingUnit2=_interopRequireDefault(_DryingUnit);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var PresetsStore=(_class=function(){function PresetsStore(){_classCallCheck(this,PresetsStore);_initDefineProp(this,'gameCreate',_descriptor,this);_initDefineProp(this,'region',_descriptor2,this);_initDefineProp(this,'inputEquip',_descriptor3,this);_initDefineProp(this,'cleaningEquip',_descriptor4,this);_initDefineProp(this,'dryingEquip',_descriptor5,this);_initDefineProp(this,'storageEquip',_descriptor6,this);_initDefineProp(this,'outputEquip',_descriptor7,this);_initDefineProp(this,'infrastructure',_descriptor8,this);_initDefineProp(this,'distributionCulture',_descriptor9,this);_initDefineProp(this,'cultureHoldingPlan',_descriptor10,this);_initDefineProp(this,'culturePlan',_descriptor11,this);this.inputEquip=_equipSettings2.default.inputEquip;this.outputEquip=_equipSettings2.default.outputEquip;this.cleaningEquip=_equipSettings2.default.cleaningEquip;this.dryingEquip=_equipSettings2.default.dryingEquip;this.storageEquip=_equipSettings2.default.storageEquip;this.infrastructure=4000000;this.elevatorsName='';}_createClass(PresetsStore,[{key:'setElevatorsName',value:function setElevatorsName(name){this.elevatorsName=name;}},{key:'incInfrastructure',value:function incInfrastructure(value){this.infrastructure=value;}},{key:'setElevatorsData',value:function setElevatorsData(){var _this=this;_index.cropPlan.constructor();_index.time.constructor();_index.offers.constructor();_index.transportStore.constructor();_index.date.constructor();_index.shipment.constructor();var bunkers=this.inputEquip.filter(function(item){return!!item.quantity;});var result=[];var count=0;bunkers.forEach(function(item){for(var i=0;i<item.quantity;i++){result.push(new _bunker2.default(i,+item.capacity,item.name));}count+=item.quantity;});_index.receptionBunkersStore.receptionBunker=result;var items=this.cleaningEquip.filter(function(item){return!!item.quantity;});result=[];count=0;items.forEach(function(item){for(var i=0;i<item.quantity;i++){result.push(new _CleaningUnit2.default(i+count,item.name,{wheat:item.wheatpercents,rape:item.rapepercents,soy:item.soypercents,sunflower:item.sunflowerpercents,corn:item.cornpercents},{wheat:item.wheateff,rape:item.rapeeff,soy:item.soyeff,sunflower:item.sunflowereff,corn:item.corneff}));}count+=item.quantity;});_index.dcUnitsStore.cleaningList=result;items=this.dryingEquip.filter(function(item){return!!item.quantity;});result=[];count=0;items.forEach(function(item){for(var i=0;i<item.quantity;i++){result.push(new _DryingUnit2.default(i+count,item.name,{wheat:item.wheatpercents,rape:item.rapepercents,soy:item.soypercents,sunflower:item.sunflowerpercents,corn:item.cornpercents},{wheat:item.wheateff,rape:item.rapeeff,soy:item.soyeff,sunflower:item.sunflowereff,corn:item.corneff}));}count+=item.quantity;});_index.dcUnitsStore.dryingList=result;items=this.storageEquip.filter(function(item){return!!item.quantity&&item.name!=="Хопер";});result=[];count=0;items.forEach(function(item){for(var i=0;i<item.quantity;i++){result.push(new _silos2.default(i+count,+item.capacity,item.name));}count+=item.quantity;});_index.storageStore.silosList=result;items=this.storageEquip.filter(function(item){return!!item.quantity&&item.name==="Хопер";});result=[];count=0;items.forEach(function(item){for(var i=0;i<item.quantity;i++){result.push(new _hopper2.default(i+count,+item.capacity,item.name));}count+=item.quantity;});_index.storageStore.hoppersList=result;items=this.outputEquip.filter(function(item){return!!item.quantity;});result=[];count=0;items.forEach(function(item){for(var i=0;i<item.quantity;i++){result.push(new _outputBunker2.default(i+count,item.type,item.name));}count+=item.quantity;});_index.shipment.shipmentBunker=result;var input=this.inputEquip.filter(function(item){return item.quantity;});var output=this.outputEquip.filter(function(item){return item.quantity;});var cleaning=this.cleaningEquip.filter(function(item){return item.quantity;});var drying=this.dryingEquip.filter(function(item){return item.quantity;});var storage=this.storageEquip.filter(function(item){return item.quantity&&item.name!=="Хопер";});var totalCost=function totalCost(){var result=0;input.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});output.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});cleaning.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});drying.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});storage.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});return result+_this.infrastructure;};_index.score.setElevatorsName(this.elevatorsName);_index.cropPlan.totalWeight=_extends({},this.culturePlan);_index.cropPlan.currentWeight=_extends({},this.culturePlan);_index.cropPlan.initScenario();_index.date.forecastInitialization();_index.date.setCurrentDay();_index.score.total=totalCost();_index.time.startTime();this.inputEquip=_equipSettings2.default.inputEquip;this.outputEquip=_equipSettings2.default.outputEquip;this.cleaningEquip=_equipSettings2.default.cleaningEquip;this.dryingEquip=_equipSettings2.default.dryingEquip;this.storageEquip=_equipSettings2.default.storageEquip;this.gameCreate=true;this.region=-1;this.culturePlan={"wheat":0,"rape":0,"soy":0,"sunflower":0,"corn":0};this.distributionCulture={"wheat":0,"rape":0,"soy":0,"sunflower":0,"corn":0};}},{key:'setRegion',value:function setRegion(region,distribution){this.distributionCulture=distribution;this.region=region;}},{key:'setCulturePlan',value:function setCulturePlan(id){for(var key in this.culturePlan){this.culturePlan[key]=this.storageEquip.reduce(function(sum,current){return sum+(current.name!=="Хоппер"?+current.capacity*current.quantity:0);},0)*this.distributionCulture[key]*5;}}}]);return PresetsStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'gameCreate',[_mobx.observable],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'region',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'inputEquip',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'cleaningEquip',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'dryingEquip',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'storageEquip',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'outputEquip',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'infrastructure',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'distributionCulture',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{"wheat":0,"rape":0,"soy":0,"sunflower":0,"corn":0};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'cultureHoldingPlan',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{"wheat":30,"rape":30,"soy":30,"sunflower":90,"corn":30};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'culturePlan',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{"wheat":0,"rape":0,"soy":0,"sunflower":0,"corn":0};}}),_applyDecoratedDescriptor(_class.prototype,'incInfrastructure',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'incInfrastructure'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setElevatorsData',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setElevatorsData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setRegion',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setRegion'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setCulturePlan',[_mobx.action],Object.getOwnPropertyDescriptor(_class.prototype,'setCulturePlan'),_class.prototype)),_class);exports.default=PresetsStore;module.exports=exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _auto_priemka=__webpack_require__(145);var _auto_priemka2=_interopRequireDefault(_auto_priemka);var _cleaning=__webpack_require__(146);var _cleaning2=_interopRequireDefault(_cleaning);var _storage=__webpack_require__(147);var _storage2=_interopRequireDefault(_storage);var _train_otgruzka=__webpack_require__(148);var _train_otgruzka2=_interopRequireDefault(_train_otgruzka);var _auto_otgruzka=__webpack_require__(149);var _auto_otgruzka2=_interopRequireDefault(_auto_otgruzka);var _BonfantiXL190CE=__webpack_require__(150);var _BonfantiXL190CE2=_interopRequireDefault(_BonfantiXL190CE);var _BonfantiL265CE=__webpack_require__(151);var _BonfantiL265CE2=_interopRequireDefault(_BonfantiL265CE);var _BuhlerSMA=__webpack_require__(152);var _BuhlerSMA2=_interopRequireDefault(_BuhlerSMA);var _BuhlerTAS204A=__webpack_require__(153);var _BuhlerTAS204A2=_interopRequireDefault(_BuhlerTAS204A);var _CimbriaAG=__webpack_require__(154);var _CimbriaAG2=_interopRequireDefault(_CimbriaAG);var _MathewsCompany=__webpack_require__(155);var _MathewsCompany2=_interopRequireDefault(_MathewsCompany);var _MC=__webpack_require__(156);var _MC2=_interopRequireDefault(_MC);var _SPO=__webpack_require__(157);var _SPO2=_interopRequireDefault(_SPO);var _Strahl18000FR=__webpack_require__(158);var _Strahl18000FR2=_interopRequireDefault(_Strahl18000FR);var _TORNUMHR=__webpack_require__(159);var _TORNUMHR2=_interopRequireDefault(_TORNUMHR);var _TORNUMTK=__webpack_require__(160);var _TORNUMTK2=_interopRequireDefault(_TORNUMTK);var _TORNUMTK3=__webpack_require__(161);var _TORNUMTK4=_interopRequireDefault(_TORNUMTK3);var _ZSO=__webpack_require__(162);var _ZSO2=_interopRequireDefault(_ZSO);var _no_photo=__webpack_require__(163);var _no_photo2=_interopRequireDefault(_no_photo);var _hopper=__webpack_require__(164);var _hopper2=_interopRequireDefault(_hopper);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import tas154 from './photos/TAS154A-4.jpg';
// import tas206 from './photos/TAS-206.jpg';
// import grainhandler from './photos/GrainHandler.jpg';
// import gsi7000 from './photos/GSI7000.jpg';
// import drying from './photos/drying.jpg';
var equipSettings={"inputEquip":[{"name":"Завальна яма 50т","price":"105.000","picture":_auto_priemka2.default,"quantity":0,"definition":"","capacity":"50"},{"name":"Завальна яма 100т","price":"320.000","picture":_auto_priemka2.default,"quantity":0,"definition":"","capacity":"100"},{"name":"Завальна яма 150т","price":"355.000","picture":_auto_priemka2.default,"quantity":0,"definition":"","capacity":"150"},{"name":"Завальна яма 175т","price":"380.000","picture":_auto_priemka2.default,"quantity":0,"definition":"","capacity":"175"}],"cleaningEquip":[{"name":"Buhler SMA-203","price":"100.000","picture":_BuhlerSMA2.default,"definition":"Благодаря совмещению двух этапов очистки в одной машине сепараторы SMA обеспечивают высокую производительность при минимальной площади размещения. Особенности конструкции машины включают доступ к ситам в передней части для упрощения процесса их замены и очистки.","wheatpercents":{min:2,max:9},"wheateff":{min:110,max:75},"rapepercents":{min:2,max:9},"rapeeff":{min:60,max:45},"soypercents":{min:2,max:9},"soyeff":{min:100,max:75},"sunflowerpercents":{min:2,max:9},"sunflowereff":{min:55,max:30},"cornpercents":{min:2,max:9},"corneff":{min:80,max:55},"quantity":0},{"name":"Buhler TAS 206","price":"250.000","picture":_cleaning2.default,"definition":"Сепараторы  TAS-206 предназначены для предварительной и основной очистки зерна.","wheatpercents":{min:2,max:9},"wheateff":{min:170,max:130},"rapepercents":{min:2,max:9},"rapeeff":{min:140,max:70},"soypercents":{min:2,max:9},"soyeff":{min:150,max:110},"sunflowerpercents":{min:2,max:9},"sunflowereff":{min:90,max:60},"cornpercents":{min:2,max:9},"corneff":{min:150,max:150},"quantity":0},{"name":"Buhler TAS 204-A4","price":"320.000","picture":_BuhlerTAS204A2.default,"definition":"","wheatpercents":{min:2,max:9},"wheateff":{min:130,max:60},"rapepercents":{min:2,max:9},"rapeeff":{min:120,max:50},"soypercents":{min:2,max:9},"soyeff":{min:120,max:50},"sunflowerpercents":{min:2,max:9},"sunflowereff":{min:112,max:45},"cornpercents":{min:2,max:9},"corneff":{min:130,max:60},"quantity":0},{"name":"СПО-175","price":"10.000","picture":_SPO2.default,"definition":"","wheatpercents":{min:2,max:9},"wheateff":{min:175,max:135},"rapepercents":{min:2,max:9},"rapeeff":{min:100,max:80},"soypercents":{min:2,max:9},"soyeff":{min:165,max:125},"sunflowerpercents":{min:2,max:9},"sunflowereff":{min:85,max:65},"cornpercents":{min:2,max:9},"corneff":{min:165,max:125},"quantity":0},// {
//     "name": "БЦСМ",
//     "price": "380.000",
//     "picture": nophoto,
//     "definition": "",
//     "wheatpercents": {min:2,max:9},
//     "wheateff": {min:50,max:30},
//     "rapepercents": {min:2,max:9},
//     "rapeeff": {min:40,max:20},
//     "soypercents": {min:2,max:9},
//     "soyeff": {min:50,max:30},
//     "sunflowerpercents": {min:2,max:9},
//     "sunflowereff": {min:25,max:15},
//     "cornpercents": {min:2,max:9},
//     "corneff": {min:50,max:30},
//     "quantity": 0
// },
// {
//     "name": "ЗСО-150",
//     "price": "35.000",
//     "picture": zso150,
//     "definition": "Зерноочистительный сепаратор предназначен для очистки зерна сельскохозяйственных культур от крупных, мелких и легких примесей.",
//     "wheatpercents": {min:2,max:9},
//     "wheateff": {min:100,max:60},
//     "rapepercents": {min:2,max:9},
//     "rapeeff": {min:80,max:40},
//     "soypercents": {min:2,max:9},
//     "soyeff": {min:100,max:60},
//     "sunflowerpercents": {min:2,max:9},
//     "sunflowereff": {min:50,max:30},
//     "cornpercents": {min:2,max:9},
//     "corneff": {min:100,max:60},
//     "quantity": 0
// },
{"name":"Buhler TAS 154A-4","price":"90.000","picture":_no_photo2.default,"definition":"Buhler 154A-4 оптимально подходят для применения на предприятиях учета и приемки зерна и прочих сыпучих материалов, в портовом хозяйстве, на мельницах, элеваторах и хранилищах, предприятиях обработки семенного материала, а также на солодовнях.","wheatpercents":{min:2,max:9},"wheateff":{min:125,max:120},"rapepercents":{min:2,max:9},"rapeeff":{min:95,max:90},"soypercents":{min:2,max:9},"soyeff":{min:135,max:130},"sunflowerpercents":{min:2,max:9},"sunflowereff":{min:65,max:60},"cornpercents":{min:2,max:9},"corneff":{min:165,max:160},"quantity":0}],"dryingEquip":[{"name":"TORNUM HR 8-27-3","price":"660.000","picture":_TORNUMHR2.default,"definition":"Зерновая сушилка TORNUM АВ модели HR разработана исключительно для проведения процесса сушки зерновых, зернобобовых, масличных культур. Особенность  данной сушилки является использование принципа  рециркуляции воздуха. В результате достигается снижение расхода энергии  на проведение сушки потока зерна.","wheatpercents":{min:2,max:10},"wheateff":{min:54,max:33},"rapepercents":{min:2,max:10},"rapeeff":{min:30,max:17},"soypercents":{min:2,max:10},"soyeff":{min:29,max:17},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:21,max:13},"cornpercents":{min:2,max:19},"corneff":{min:42,max:17},"quantity":0},{"name":"Strahl 18000 FR/14","price":"1.000.000","picture":_Strahl18000FR2.default,"definition":"Зерносушилка энергосберегающая Strahl 18000 FR/14 оснащена системой рекуперации тепла, вентиляторами  с  глушителями шума, системой компьютерного управления.  Полностью утепленная  зерносушильная колона.","wheatpercents":{min:2,max:10},"wheateff":{min:140,max:85},"rapepercents":{min:2,max:10},"rapeeff":{min:70,max:35},"soypercents":{min:2,max:10},"soyeff":{min:95,max:62},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:62,max:32},"cornpercents":{min:2,max:19},"corneff":{min:134,max:44},"quantity":0},{"name":"Tornum TK 12-28-4","price":"1.100.000","picture":_TORNUMTK2.default,"definition":"Сушилка для зерновых культур непрерывного действия шахтного типа модели TK 12-28-4 разработана исключительно для проведения процесса сушки таких культур как : пшеница, кукуруза, ячмень, рожь, овёс, рапс, горох, подсолнечник, соя и др. Также данная сушилка оснащена системой управления «Intelligient Dryer Control System» , которая позволяет управлять всеми процессами сушения в реальном времени при использовании и мониторинга всех параметров сушилки, системой очистки воздуха и системой обнаружения пожара.","wheatpercents":{min:2,max:10},"wheateff":{min:140,max:50},"rapepercents":{min:2,max:10},"rapeeff":{min:140,max:60},"soypercents":{min:2,max:10},"soyeff":{min:90,max:10},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:90,max:40},"cornpercents":{min:2,max:19},"corneff":{min:140,max:30},"quantity":0},{"name":"Mathews Company 3180","price":"250.000","picture":_MathewsCompany2.default,"definition":"Зерносушилка Mathews Company 3180 с многоступенчатыми зонами сушки, обеспечивает эффективность использования топлива и сохранение качества зерна","wheatpercents":{min:2,max:10},"wheateff":{min:90,max:64},"rapepercents":{min:2,max:10},"rapeeff":{min:70,max:32},"soypercents":{min:2,max:10},"soyeff":{min:70,max:32},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:45,max:20},"cornpercents":{min:2,max:10},"corneff":{min:70,max:32},"quantity":0},{"name":"Cimbria AG40","price":"550.000","picture":_CimbriaAG2.default,"definition":"Зерновая сушка Кимбрия шахтного типа, с линейной газовой горелкой, открытого типа.","wheatpercents":{min:2,max:10},"wheateff":{min:65,max:35},"rapepercents":{min:2,max:10},"rapeeff":{min:40,max:20},"soypercents":{min:2,max:10},"soyeff":{min:60,max:30},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:30,max:15},"cornpercents":{min:2,max:19},"corneff":{min:60,max:8},"quantity":0},{"name":"Bonfanti XL190CE","price":"700.000","picture":_BonfantiXL190CE2.default,"definition":"Зерносушилка Бонфанти, шахтная сушилка, с функцией рекуперации тепла, закритого типа, паралельно расположенные горелки –для лучшей эффективности сушки зерна.","wheatpercents":{min:2,max:10},"wheateff":{min:65,max:35},"rapepercents":{min:2,max:10},"rapeeff":{min:40,max:20},"soypercents":{min:2,max:10},"soyeff":{min:60,max:30},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:30,max:15},"cornpercents":{min:2,max:19},"corneff":{min:60,max:8},"quantity":0},{"name":"Bonfanti  XL265SE","price":"1.050.000","picture":_BonfantiL265CE2.default,"definition":"Зерносушилка Bonfanti ХL 265 CE предназначена для  бесперебойного сушения зерна пшеницы, ржи, ячменя, овса, кукурузы, риса, рапса и  других зерновых, бобовых культур.","wheatpercents":{min:2,max:10},"wheateff":{min:50,max:35},"rapepercents":{min:2,max:10},"rapeeff":{min:40,max:20},"soypercents":{min:2,max:10},"soyeff":{min:30,max:16},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:30,max:12},"cornpercents":{min:2,max:19},"corneff":{min:45,max:24},"quantity":0},{"name":"Mathews Company 1195","price":"615.000","picture":_MathewsCompany2.default,"definition":"Зерносушилка Mathews Company 1195 с многоступенчатыми зонами сушки, обеспечивает эффективность использования топлива и сохранение качества зерна","wheatpercents":{min:2,max:10},"wheateff":{min:60,max:40},"rapepercents":{min:2,max:10},"rapeeff":{min:40,max:20},"soypercents":{min:2,max:10},"soyeff":{min:45,max:25},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:35,max:15},"cornpercents":{min:2,max:19},"corneff":{min:50,max:15},"quantity":0},{"name":"Тornum TK 8-28-4","price":"390.000","picture":_TORNUMTK4.default,"definition":"Довговічність зернових сушарок від компанії Grain Handler в тому, що ми використовуємо тільки високоякісні матеріали для виготовлення всіх деталей. Всі поверхні модуля зернової сушарки, включаючи повітряні вентилятори і основу зернової сушарки, покриті цинком завтовшки 350 грам на м². А де необхідно, застосовується нержавіюча сталь. Термін служби до 30 років, в залежності від інтенсивності експлуатації. Завдяки цьому наші зернові сушарки – одні з найбільш надійних.","wheatpercents":{min:2,max:10},"wheateff":{min:110,max:80},"rapepercents":{min:2,max:10},"rapeeff":{min:75,max:50},"soypercents":{min:2,max:10},"soyeff":{min:110,max:70},"sunflowerpercents":{min:2,max:10},"sunflowereff":{min:70,max:45},"cornpercents":{min:2,max:19},"corneff":{min:120,max:45},"quantity":0}],"storageEquip":[{"name":"BEHLEN 5000","price":"315.000","picture":_storage2.default,"definition":" ","capacity":"5000","quantity":1},{"name":"BEHLEN 3000","price":"200.000","picture":_storage2.default,"definition":" ","capacity":"3000","quantity":0},{"name":"Хопер","price":"40.000","picture":_hopper2.default,"definition":"","capacity":"500","type":"truck","quantity":1}],"outputEquip":[// {
//     "name": "Авто отгрузка",
//     "price": "240.000",
//     "picture": truckOutput,
//     "definition": "",
//     "capacity": "175",
//     "type": "truck",
//     "quantity": 0
// },
{"name":"ЗД відгрузка","price":"365.000","picture":_train_otgruzka2.default,"definition":"","capacity":"175","type":"train","quantity":1}]};// import output from './photos/output.jpg';
// import input from './photos/input.jpg';
// import input from './photos/input.jpg';
exports.default=equipSettings;module.exports=exports['default'];

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/auto_priemka.f9235de9.jpg";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cleaning.b62c59ec.jpg";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/storage.57644103.jpg";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/train_otgruzka.f7e7037d.jpg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/auto_otgruzka.9ac37bc3.jpg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BonfantiXL190CE.3f9c855f.jpg";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BonfantiХL265CE.c305755c.jpg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BuhlerSMA-203.c2dff49a.jpg";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BuhlerTAS204-A4.cbeaa1a1.jpg";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CimbriaAG40.c5c487ef.jpg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MathewsCompany1195.ccf2b363.jpg";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MC-3180.cd54e97a.jpg";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SPO-125.9e1bc08c.jpg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Strahl18000FR14.e14e78c2.jpg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/TORNUMHR8-27-3.8e461425.jpg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/TORNUMTK12-28-4.4c7702b4.jpg";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/TORNUMTK-8-28-4.f0a7205d.jpg";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ZSO-150.616e327d.jpg";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_desc2,_value2,_class3,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12;var _mobx=__webpack_require__(3);var _priceSettings=__webpack_require__(166);var _priceSettings2=_interopRequireDefault(_priceSettings);var _index=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var FinanceData=(_class=function(){function FinanceData(){_classCallCheck(this,FinanceData);_initDefineProp(this,'input',_descriptor,this);_initDefineProp(this,'drying',_descriptor2,this);_initDefineProp(this,'cleaning',_descriptor3,this);_initDefineProp(this,'storage',_descriptor4,this);_initDefineProp(this,'output',_descriptor5,this);_initDefineProp(this,'docsFee',_descriptor6,this);this.input=new DataDetailed('input');this.drying=new DataDetailed('drying');this.cleaning=new DataDetailed('cleaning');this.storage=new DataDetailed('storage');this.output=new DataDetailed('output');this.docsFee=new DataDetailed('docsFee');}_createClass(FinanceData,[{key:'incParams',value:function incParams(param,culture,sum){this[param].incParam(culture,"cashYield",sum);this[param].incParam(culture,"directExpends",sum);this[param].incParam(culture,"indirectExpends",sum);this[param].incTotal(culture,sum);}},{key:'incDCParams',value:function incDCParams(param,culture,amount,variable){this[param].incParam(culture,"cashYield",variable*amount);this[param].incParam(culture,"directExpends",variable*amount);this[param].incParam(culture,"indirectExpends",amount);this[param].incTotal(culture,amount);}}]);return FinanceData;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'input',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'drying',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'cleaning',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'storage',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'output',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'docsFee',[_mobx.observable],{enumerable:true,initializer:null})),_class);exports.default=FinanceData;var DataDetailed=(_class3=function(){function DataDetailed(){var elem=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';_classCallCheck(this,DataDetailed);_initDefineProp(this,'soy',_descriptor7,this);_initDefineProp(this,'wheat',_descriptor8,this);_initDefineProp(this,'rape',_descriptor9,this);_initDefineProp(this,'sunflower',_descriptor10,this);_initDefineProp(this,'corn',_descriptor11,this);_initDefineProp(this,'total',_descriptor12,this);this.elem=elem;this.wheat={"cashYield":0,"directExpends":0,"indirectExpends":0};this.rape={"cashYield":0,"directExpends":0,"indirectExpends":0};this.soy={"cashYield":0,"directExpends":0,"indirectExpends":0};this.sunflower={"cashYield":0,"directExpends":0,"indirectExpends":0};this.corn={"cashYield":0,"directExpends":0,"indirectExpends":0};}_createClass(DataDetailed,[{key:'incTotal',value:function incTotal(culture,inc){this.total[culture]+=inc;}},{key:'incParam',value:function incParam(culture,param,val){this[culture][param]+=val*_priceSettings2.default[param][this.elem][culture];}}]);return DataDetailed;}(),(_descriptor7=_applyDecoratedDescriptor(_class3.prototype,'soy',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor8=_applyDecoratedDescriptor(_class3.prototype,'wheat',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor9=_applyDecoratedDescriptor(_class3.prototype,'rape',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor10=_applyDecoratedDescriptor(_class3.prototype,'sunflower',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor11=_applyDecoratedDescriptor(_class3.prototype,'corn',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor12=_applyDecoratedDescriptor(_class3.prototype,'total',[_mobx.observable],{enumerable:true,initializer:function initializer(){return{soy:0,wheat:0,rape:0,sunflower:0,corn:0};}}),_applyDecoratedDescriptor(_class3.prototype,'incTotal',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'incTotal'),_class3.prototype),_applyDecoratedDescriptor(_class3.prototype,'incParam',[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,'incParam'),_class3.prototype)),_class3);module.exports=exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = {"cashYield":{"input":{"rape":0.56,"wheat":0.56,"soy":0.62,"sunflower":1.12,"corn":0.62},"drying":{"rape":1.54,"wheat":1.14,"soy":1.69,"sunflower":2.21,"corn":1.6},"cleaning":{"rape":0.5,"wheat":0.5,"soy":0.55,"sunflower":0.71,"corn":0.55},"storage":{"rape":1.67,"wheat":1.39,"soy":1.5,"sunflower":3.05,"corn":1.39},"output":{"rape":3.42,"wheat":3.14,"soy":3.45,"sunflower":3.79,"corn":3.45},"transhipment":{"rape":0,"wheat":0,"soy":0,"sunflower":0,"corn":0},"docsFee":{"wheat":1.4,"rape":1.4,"soy":1.4,"sunflower":1.4,"corn":1.4}},"directExpends":{"input":{"rape":0.31,"wheat":0.31,"soy":0.31,"sunflower":0.33,"corn":0.31},"drying":{"rape":0.49,"wheat":0.48,"soy":0.57,"sunflower":0.46,"corn":0.57},"cleaning":{"rape":0.12,"wheat":0.12,"soy":0.12,"sunflower":0.12,"corn":0.12},"storage":{"rape":0.07,"wheat":0.07,"soy":0.07,"sunflower":0.07,"corn":0.07},"output":{"rape":0.46,"wheat":0.46,"soy":0.46,"sunflower":0.48,"corn":0.46},"transhipment":{"rape":0,"wheat":0,"soy":0,"sunflower":0,"corn":0}},"indirectExpends":{"input":{"rape":0.083,"wheat":0.0828,"soy":0.0917,"sunflower":0.1656,"corn":0.092},"drying":{"rape":0.227,"wheat":0,"soy":0.125,"sunflower":0.1634,"corn":1.183},"cleaning":{"rape":0.03697,"wheat":0,"soy":0.0407,"sunflower":0.105,"corn":0.041},"storage":{"rape":0.22934,"wheat":0.213,"soy":0.1386,"sunflower":0.5793,"corn":0.325},"output":{"rape":0.4982,"wheat":0.4644,"soy":0.5051,"sunflower":0.5521,"corn":0.482},"transhipment":{"rape":0,"wheat":0,"soy":0,"sunflower":0,"corn":0}}}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;var _mobx=__webpack_require__(3);var _cropPlanSettings=__webpack_require__(51);var _cropPlanSettings2=_interopRequireDefault(_cropPlanSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var CropPlan=(_class=function(){function CropPlan(){_classCallCheck(this,CropPlan);_initDefineProp(this,'currentWeight',_descriptor,this);_initDefineProp(this,'totalWeight',_descriptor2,this);_initDefineProp(this,'dayPlan',_descriptor3,this);_initDefineProp(this,'weekPlan',_descriptor4,this);_initDefineProp(this,'monthPlan',_descriptor5,this);this.totalWeight={wheat:0,rape:0,soy:0,sunflower:0,corn:0};this.currentWeight=_extends({},this.totalWeight);this.dayPlan={wheat:0,rape:0,soy:0,sunflower:0,corn:0};this.weekPlan={wheat:0,rape:0,soy:0,sunflower:0,corn:0};this.monthPlan={wheat:0,rape:0,soy:0,sunflower:0,corn:0};this.scenario={wheat:[],rape:[],soy:[],sunflower:[],corn:[]};// this.initScenario()
}_createClass(CropPlan,[{key:'initScenario',value:function initScenario(){var _this=this;Object.keys(this.scenario).forEach(function(item){var delta=Math.random()*0.1;var grow=Math.round(_cropPlanSettings2.default[item].duration*(0.4+delta-Math.random()*0.05));var max=Math.round(_cropPlanSettings2.default[item].duration*(0.5-delta+Math.random()*0.05));var recession=Math.round(_cropPlanSettings2.default[item].duration-grow-max+2+Math.random()*2);var min=1/((grow+max+recession)*4.3);var currentWeight=_this.totalWeight[item];for(var i=1;i<=grow;i++){min+=Math.round(Math.random())*(1/(grow+max+recession)/5);currentWeight-=Math.floor(min*_this.totalWeight[item]-min*_this.totalWeight[item]%20);_this.scenario[item].push(Math.floor(min*_this.totalWeight[item]-min*_this.totalWeight[item]%20));}min=currentWeight*0.8/max;for(var _i=1;_i<=max;_i++){currentWeight-=Math.floor(min-min%20);_this.scenario[item].push(Math.floor(min-min%20));}//y=kx линейно спадающая функция, со взятием частичного интеграла.
for(var _i2=recession-1;_i2>=0;_i2--){var k=currentWeight*2/((_i2+1)*(_i2+1));currentWeight-=Math.floor(k*(_i2+1)*(_i2+1)/2-k*_i2*_i2/2-(k*(_i2+1)*(_i2+1)/2-k*_i2*_i2/2)%20);_this.scenario[item].push(Math.floor(k*(_i2+1)*(_i2+1)/2-k*_i2*_i2/2-(k*(_i2+1)*(_i2+1)/2-k*_i2*_i2/2)%20));}_this.scenario[item][_this.scenario[item].length-1]+=currentWeight;});}}]);return CropPlan;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'currentWeight',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'totalWeight',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'dayPlan',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'weekPlan',[_mobx.observable],{enumerable:true,initializer:null}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'monthPlan',[_mobx.observable],{enumerable:true,initializer:null})),_class);exports.default=CropPlan;module.exports=exports['default'];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;var _mobx=__webpack_require__(3);var _bunker=__webpack_require__(54);var _bunker2=_interopRequireDefault(_bunker);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ReceptionBunkersStore=(_class=function(){function ReceptionBunkersStore(bunkersList){_classCallCheck(this,ReceptionBunkersStore);_initDefineProp(this,'receptionBunker',_descriptor,this);this.receptionBunker=[new _bunker2.default(0,60,'testbunker1',"corn",1000,1,1),new _bunker2.default(1,60,'testbunker1',"corn",10040,5,5),new _bunker2.default(3,60,'testbunker1',"corn",10040,55,55),new _bunker2.default(2,60,'testbunker1',"rape",10040,10,10),new _bunker2.default(3,60)];}_createClass(ReceptionBunkersStore,[{key:'getLineColor',get:function get(){var result=this.receptionBunker.find(function(item){return item.status==='clogged';});if(result){return'clogged';}else{result=this.receptionBunker.find(function(item){return item.active;});if(result)return result.culture;}return'None';}}]);return ReceptionBunkersStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'receptionBunker',[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'getLineColor',[_mobx.computed],Object.getOwnPropertyDescriptor(_class.prototype,'getLineColor'),_class.prototype)),_class);exports.default=ReceptionBunkersStore;module.exports=exports['default'];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(3);var _CleaningUnit=__webpack_require__(58);var _CleaningUnit2=_interopRequireDefault(_CleaningUnit);var _DryingUnit=__webpack_require__(59);var _DryingUnit2=_interopRequireDefault(_DryingUnit);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var DCunitsStore=(_class=function DCunitsStore(){var dryingList=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[0,1,2,3,4];var cleaningList=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[0,1,2,3];_classCallCheck(this,DCunitsStore);_initDefineProp(this,"dryingList",_descriptor,this);_initDefineProp(this,"cleaningList",_descriptor2,this);this.cleaningList=cleaningList.map(function(item,i){return new _CleaningUnit2.default(i,'name',{wheat:{min:2,max:10},rape:{min:2,max:10},soy:{min:2,max:10},sunflower:{min:2,max:10},corn:{min:2,max:10}},{wheat:{min:50,max:20},rape:{min:50,max:20},soy:{min:50,max:20},sunflower:{min:50,max:20},corn:{min:50,max:20}});});this.dryingList=dryingList.map(function(item,i){return new _DryingUnit2.default(i,'name',{wheat:{min:2,max:10},rape:{min:2,max:10},soy:{min:2,max:10},sunflower:{min:2,max:10},corn:{min:2,max:10}},{wheat:{min:200,max:100},rape:{min:200,max:100},soy:{min:200,max:100},sunflower:{min:200,max:100},corn:{min:200,max:100}});});},(_descriptor=_applyDecoratedDescriptor(_class.prototype,"dryingList",[_mobx.observable],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"cleaningList",[_mobx.observable],{enumerable:true,initializer:null})),_class);exports.default=DCunitsStore;module.exports=exports["default"];

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _desc,_value,_class,_descriptor,_descriptor2;var _mobx=__webpack_require__(3);var _silos=__webpack_require__(55);var _silos2=_interopRequireDefault(_silos);var _hopper=__webpack_require__(57);var _hopper2=_interopRequireDefault(_hopper);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var StorageStore=(_class=function StorageStore(){_classCallCheck(this,StorageStore);_initDefineProp(this,'silosList',_descriptor,this);_initDefineProp(this,'hoppersList',_descriptor2,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'silosList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[new _silos2.default(0,5000,'keke'),new _silos2.default(1,5000,'keke'),new _silos2.default(2,5000,'keke'),new _silos2.default(3,5000,'keke'),new _silos2.default(4,5000,'keke'),new _silos2.default(5,5000,'keke')];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'hoppersList',[_mobx.observable],{enumerable:true,initializer:function initializer(){return[new _hopper2.default(0,400,"Hopper"),new _hopper2.default(1,400,"Hopper")];}})),_class);exports.default=StorageStore;module.exports=exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_desc2,_value2,_class3,_descriptor4,_descriptor5;var _mobx=__webpack_require__(3);var _index=__webpack_require__(1);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var OffersStore=(_class=function(){function OffersStore(){_classCallCheck(this,OffersStore);_initDefineProp(this,"active",_descriptor,this);_initDefineProp(this,"history",_descriptor2,this);_initDefineProp(this,"offers",_descriptor3,this);this.active=[];this.history=[];this.offers=[new Offer(1000,"rape",8,8,new Date(2019,6,11,0,0,0),'train'),new Offer(10000,"rape",8,8,new Date(2019,6,30,0,0,0),'train'),new Offer(5000,"rape",8,8,new Date(2019,6,11,0,0,0),'train')];}_createClass(OffersStore,[{key:"addNewOffer",value:function addNewOffer(weight,culture){this.offers.unshift(new Offer(weight,culture,_cultureSettings2.default[culture].baseMoisture,_cultureSettings2.default[culture].baseWaste,new Date(_index.date.day.getFullYear(),_index.date.day.getMonth(),_index.date.day.getDate()+7+Math.floor(Math.random()*3),0,0,0),'train'));}}]);return OffersStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,"active",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,"history",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,"offers",[_mobx.observable],{enumerable:true,initializer:function initializer(){return[// new Offer(1000,"soy",8,8,new Date(2017, 6, 11, 0, 0, 0),'train'),
// new Offer(100,"rape",8,8,new Date(2017, 6, 30, 0, 0, 0),'train'),
// new Offer(5000,"soy",8,8,new Date(2017, 6, 11, 0, 0, 0),'train'),
// new Offer(600,"soy",8,8,new Date(2017, 6, 13, 0, 0, 0),'train'),
// new Offer(200,"soy",8,8,new Date(2017, 6, 30, 0, 0, 0),'train')
];}})),_class);exports.default=OffersStore;var Offer=(_class3=function(){function Offer(amount,culture,waste,moisture,date,type){var status=arguments.length>6&&arguments[6]!==undefined?arguments[6]:'new';_classCallCheck(this,Offer);_initDefineProp(this,"status",_descriptor4,this);_initDefineProp(this,"rem",_descriptor5,this);this.amount=amount;this.culture=culture;this.waste=waste;this.moisture=moisture;this.date=date;this.status=status;this.rem=amount;this.type=type;}_createClass(Offer,[{key:"decRem",value:function decRem(dec){this.rem-=dec;if(this.rem<=0){this.setStatus('success');}}},{key:"setStatus",value:function setStatus(status,type,endDate,culture,amount,moisture,waste){this.status=status;if(status==='inprogress'){var dayIncome=new Date(_index.date.day.getFullYear(),_index.date.day.getMonth(),_index.date.day.getDate(),0,0,0);_index.shipment.addOutputTransport(type,culture,dayIncome,endDate,amount+40,_cultureSettings2.default[culture].baseMoisture,_cultureSettings2.default[culture].baseWaste,this);}}}]);return Offer;}(),(_descriptor4=_applyDecoratedDescriptor(_class3.prototype,"status",[_mobx.observable],{enumerable:true,initializer:null}),_descriptor5=_applyDecoratedDescriptor(_class3.prototype,"rem",[_mobx.observable],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class3.prototype,"decRem",[_mobx.action],Object.getOwnPropertyDescriptor(_class3.prototype,"decRem"),_class3.prototype)),_class3);//success
//failed
//inprogress
module.exports=exports["default"];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0px',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0px, 0px, 0px, 0px)',
  border: '0px'
};
module.exports = exports['default'];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(174);var _index2=_interopRequireDefault(_index);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _logo=__webpack_require__(175);var _logo2=_interopRequireDefault(_logo);var _mobxReact=__webpack_require__(2);var _index3=__webpack_require__(1);var _reactRouterDom=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Menu=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Menu,_Component);function Menu(){_classCallCheck(this,Menu);return _possibleConstructorReturn(this,(Menu.__proto__||Object.getPrototypeOf(Menu)).apply(this,arguments));}_createClass(Menu,[{key:'render',value:function render(){var color={backgroundColor:'rgb('+(_index3.score.menu<=60?251:251-(_index3.score.menu.toFixed(1)-60)*3.5)+','+(_index3.score.menu<=60?_index3.score.menu.toFixed(1)*3.5:210)+','+19+')'};return _react2.default.createElement('div',{className:_index2.default.item+' '+_index2.default.title},_react2.default.createElement('div',null,_react2.default.createElement(_reactRouterDom.Link,{to:'/',className:_index2.default.burger},'\u2630'),_react2.default.createElement('div',{className:_index2.default.companyLogo},_react2.default.createElement('img',{src:_logo2.default,alt:'Company_logo'}))),_react2.default.createElement('div',{className:_index2.default.elevatorName},_index3.score.elevatorsName),_react2.default.createElement('div',{className:_index2.default.costContainer},_react2.default.createElement('div',{className:_index2.default.cost},'$',_index3.score.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g," ")),_react2.default.createElement('div',{className:_index2.default.score+' '+_index2.default.scoreDropDownTrigger,style:color},_react2.default.createElement(_reactFontawesome2.default,{name:_index3.score.menu<=50?'frown-o':'smile-o'}),'\xA0',Math.floor(_index3.score.menu),'\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'info-circle'}),_react2.default.createElement('div',{className:_index2.default.scoreDropDown},_react2.default.createElement('h3',null,'\u0420\u0435\u0439\u0442\u0438\u043D\u0433 \u044D\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0438\u0441\u0442\u0430'),_react2.default.createElement('p',null,'\u042D\u0442\u043E\u0442 \u0438\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442 \u043D\u0430\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u0430\u0448\u0438 \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u044B \u0434\u043E\u0432\u043E\u043B\u044C\u043D\u044B \u0440\u0430\u0431\u043E\u0442\u043E\u0439 \u0441\xA0\u0432\u0430\u043C\u0438.'),_react2.default.createElement('p',null,'\u0415\u0441\u043B\u0438 \u0432\u044B\xA0\u043D\u0430\u0440\u0443\u0448\u0430\u0435\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u0437\u0430\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0435 \u0434\u043E\u043B\u0433\u043E \u0436\u0434\u0430\u0442\u044C \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u043E\u0432 \u043D\u0430\xA0\u043F\u0440\u0438\u0451\u043C\u043A\u0435 \u0438\xA0\u043D\u0430\xA0\u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0435 \u0438\u043B\u0438 \u0435\u0441\u043B\u0438 \u0443\xA0\u0432\u0430\u0441 \u0434\u043E\u043B\u0433\u043E \u043F\u0440\u043E\u0441\u0442\u0430\u0438\u0432\u0430\u044E\u0442 \u043C\u043E\u0449\u043D\u043E\u0441\u0442\u0438 \u044D\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0430 \u0438\u0437-\u0437\u0430 \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\xA0\u2014 \u0432\u0430\u0448 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 \u0431\u0443\u0434\u0435\u0442 \u0441\u043D\u0438\u0436\u0430\u0442\u044C\u0441\u044F, \u0430\xA0\u0438\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F \u0432\u0441\u0451 \u0431\u043E\u043B\u0435\u0435 \u043A\u0440\u0430\u0441\u043D\u044B\u043C, \u044D\u0442\u043E \u0431\u0443\u0434\u0435\u0442 \u0432\u043B\u0438\u044F\u0442\u044C \u043D\u0430\xA0\u0442\u043E, \u043D\u0430\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u0430\u0448\u0438 \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u044B \u0431\u0443\u0434\u0443\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0441\u0432\u043E\u0438 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0438\xA0\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0430\u043C \u043F\u0440\u0438\u0451\u043C\u043A\u0438 \u0438\xA0\u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0438.'),_react2.default.createElement('p',null,'\u0418\xA0\u043D\u0430\u043E\u0431\u043E\u0440\u043E\u0442, \u0435\u0441\u043B\u0438 \u0432\u044B\xA0\u0432\u0441\u0451 \u0434\u0435\u043B\u0430\u0435\u0442\u0435 \u0432\xA0\u0441\u0440\u043E\u043A \u0438\xA0\u0432\u0430\u0448 \u044D\u043B\u0435\u0432\u0430\u0442\u043E\u0440 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043A\u0430\u043A \u0447\u0430\u0441\u044B\xA0\u2014 \u0432\u0430\u0448 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 \u0431\u0443\u0434\u0435\u0442 \u0440\u0430\u0441\u0442\u0438, \u0438\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F \u0437\u0435\u043B\u0435\u043D\u044B\u043C, \u0430\xA0\u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u044B \u0431\u0443\u0434\u0443\u0442 \u0441\u0442\u0440\u043E\u0433\u043E \u043F\u0440\u0438\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0442\u044C\u0441\u044F \u0433\u0440\u0430\u0444\u0438\u043A\u0430 \u043F\u043E\u0441\u0442\u0430\u0432\u043E\u043A, \u0447\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u0432\u0430\u043C \u0442\u043E\u0447\u043D\u0435\u0435 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u0448\u0438 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438.')))));}}]);return Menu;}(_react.Component))||_class;exports.default=Menu;module.exports=exports['default'];

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item":"CYxoVJwvpODX8FWP_wkMK","title":"_1yl870RvPADhg2yc5aT9Ov","burger":"_2n9GBpkU9Obd11xT9r2S-b","companyLogo":"_1NN6OyY9TqJtfl5LHAg5MT","elevatorName":"_35j5hj84pwB8MrC7X7jfqm","costContainer":"_3M1TOjh1uHH3B-Ta53dWhd","cost":"_3Lcd-qvamhlc_24mNT1c6q","score":"x-KD25D2ckGvERwMplwp0","scoreDropDown":"_1S-t6rXoan0ePLZDhUmznX","scoreDropDownTrigger":"_2qQ7UlcGGghnZH2RGrDLj9"};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.7dfc2f32.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(177);var _index2=_interopRequireDefault(_index);var _mobxReact=__webpack_require__(2);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var News=(0,_mobxReact.observer)(_class=function(_Component){_inherits(News,_Component);function News(){_classCallCheck(this,News);return _possibleConstructorReturn(this,(News.__proto__||Object.getPrototypeOf(News)).apply(this,arguments));}_createClass(News,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index2.default.item+' '+_index2.default.news},_react2.default.createElement('div',{className:_index2.default.topMenuHeading},'\u041F\u041E\u0422\u041E\u0427\u041D\u0406 \u041D\u041E\u0412\u0418\u041D\u0418'),_react2.default.createElement('div',{className:_index2.default.scrollableNews,id:'parent'},this.props.news.newsList.map(function(item,i){return _react2.default.createElement('div',{style:item.type,key:i},_react2.default.createElement('span',{className:_index2.default.newsItemDateTime},item.date),'\xA0',_react2.default.createElement('span',{className:_index2.default.newsItemIcon},_react2.default.createElement(_reactFontawesome2.default,{name:item.font})),'\xA0',_react2.default.createElement('span',{className:_index2.default.newsItemContent},item.massage));})));}}]);return News;}(_react.Component))||_class;exports.default=News;module.exports=exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item":"_2FyjlVQ0p5EO3SEb11smtB","news":"_2QU-PKgmor5TsCIwe9UOuR","topMenuHeading":"_33a8ysQw3gbHMMw3SIrJTp","scrollableNews":"_3j9nq9JKY4Pq8SHd7XKVN3","newsItemIcon":"_2rg-H_PmwB6toKqwhNJy31"};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(179);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _mobxReact=__webpack_require__(2);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _index3=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Weather=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Weather,_Component);function Weather(){_classCallCheck(this,Weather);return _possibleConstructorReturn(this,(Weather.__proto__||Object.getPrototypeOf(Weather)).apply(this,arguments));}_createClass(Weather,[{key:'showWeather',value:function showWeather(weather){switch(weather){case 0:return _iconfonts2.default.iconSunny;case 1:return _iconfonts2.default.iconRain;case 2:return _iconfonts2.default.iconCloudy;default:break;}}},{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:_index2.default.container},_react2.default.createElement('div',{className:_index2.default.item+' '+_index2.default.dateTimeWeather},_react2.default.createElement('div',{className:_index2.default.currentDate},_index3.date.day.toLocaleString("uk",{month:'long',day:'numeric'})),_react2.default.createElement('div',{className:_index2.default.currentTime},this.props.time.getTime),_react2.default.createElement('div',{className:_index2.default.currentWeather},_index3.date.weather===0?'Сонячно':_index3.date.weather===1?'Сильні опади':'Хмарно'),_react2.default.createElement('div',{className:_index2.default.currentTemperature},_react2.default.createElement('span',null,_index3.date.temp.min,'-',_index3.date.temp.max),' \xB0C'),_react2.default.createElement('div',{className:_index2.default.currentWeatherIcon},_react2.default.createElement('i',{className:this.showWeather(_index3.date.weather)}))),_react2.default.createElement('div',{className:_index2.default.item+' '+_index2.default.weatherForecast},_react2.default.createElement('div',{className:_index2.default.subWeatherContainer},_index3.date.forecast.map(function(item,i){return _react2.default.createElement('div',{className:_index2.default.subWeatherItem,key:i},_react2.default.createElement('div',{className:_index2.default.subWeatherItemDate},_index3.date.day.getDate()+i+1+'.'+(_index3.date.day.getMonth()<10?'0'+_index3.date.day.getMonth():_index3.date.day.getMonth())+'.'+_index3.date.day.getFullYear()),_react2.default.createElement('div',{className:_index2.default.subWeatherItemIcon},_react2.default.createElement('i',{className:_this2.showWeather(item.weather)})),_react2.default.createElement('div',{className:_index2.default.subWeatherItemTemp},item.temp.min,'-',item.temp.max,' \xB0C'));}))));}}]);return Weather;}(_react.Component))||_class;exports.default=Weather;module.exports=exports['default'];

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1taGdIgCgS7E-rRm5Q6a78","item":"_3mGnSuXmKbrCjETUDSR_dH","currentDate":"_1_9ngYEufaPfPj31Osk_Sp","currentTime":"_3F3ATn_07huhXEK3-DGdMy","currentWeather":"_1LXvYqM_-Q29hokaq0XvEC","currentWeatherIcon":"_3wc54HqGKIPxvUGM7IJBeQ","currentTemperature":"_3tow1WM19G0IYG3OfY1SCq","dateTimeWeather":"qBV90a-FpmFobzDKyDQqM","weatherForecast":"vobkYF0jjq8KyCb1UC5vc","subWeatherContainer":"_2zpSt94POaGuqb3EZFJTgo","subWeatherItem":"jtZsos52MUgAHr2ZPcwjj","subWeatherItemDate":"_1HI9kDxnBwC2acSG3qk86j","subWeatherItemIcon":"_1h-PGW_AgDFCGxp-TDcuUG","subWeatherItemTemp":"wJfbyrjFocFfsthwbdR_u","getForecast":"_3bob0jlsHRpwg0DAfVmBcz"};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(13);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(29);var _index4=_interopRequireDefault(_index3);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _index5=__webpack_require__(7);var _index6=__webpack_require__(1);var _ReceptionBunker=__webpack_require__(196);var _ReceptionBunker2=_interopRequireDefault(_ReceptionBunker);var _TransportField=__webpack_require__(197);var _TransportField2=_interopRequireDefault(_TransportField);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputFlow=(0,_mobxReact.observer)(_class=function(_Component){_inherits(InputFlow,_Component);function InputFlow(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InputFlow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InputFlow.__proto__||Object.getPrototypeOf(InputFlow)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InputFlow,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return nextState!==this.state;}},{key:'activeToggle',value:function activeToggle(){this.state.active?this.setState({active:false}):this.setState({active:true});}},{key:'render',value:function render(){var _this2=this;var bunker=_index6.receptionBunkersStore.receptionBunker;return _react2.default.createElement('div',{className:_index2.default.innerContainer+' '+_index2.default.inputFlow+(this.state.active?' '+_index2.default.activeTab:'')},_react2.default.createElement('div',{className:_index2.default.content},_react2.default.createElement('div',{className:_index2.default.queueContainer},_react2.default.createElement('div',{className:_index2.default.stateToggleButton,onClick:this.activeToggle.bind(this)},this.state.active?_react2.default.createElement(_reactFontawesome2.default,{name:'compress'}):_react2.default.createElement(_reactFontawesome2.default,{name:'expand'})),_react2.default.createElement('div',{className:_index2.default.indicator,style:{right:0}},_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.wheat+(this.state.selectedCrop===0?' '+_index4.default.selected:''),onClick:function onClick(){_this2.setCrop(0);}},_index6.transportStore.getTotalWheat),_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.rape+(this.state.selectedCrop===1?' '+_index4.default.selected:''),onClick:function onClick(){_this2.setCrop(1);}},_index6.transportStore.getTotalRape),_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.soy+(this.state.selectedCrop===2?' '+_index4.default.selected:''),onClick:function onClick(){_this2.setCrop(2);}},_index6.transportStore.getTotalSoy),_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.sunflower+(this.state.selectedCrop===3?' '+_index4.default.selected:''),onClick:function onClick(){_this2.setCrop(3);}},_index6.transportStore.getTotalSunflower),_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.corn+(this.state.selectedCrop===4?' '+_index4.default.selected:''),onClick:function onClick(){_this2.setCrop(4);}},_index6.transportStore.getTotalCorn)),_react2.default.createElement('div',{className:_index4.default.bunkerContainer},bunker.map(function(item,i){return _react2.default.createElement(_ReceptionBunker2.default,{item:item,i:i,key:i});})),_react2.default.createElement(_TransportField2.default,null),_react2.default.createElement('div',{className:_index2.default.queueBubbles},_react2.default.createElement(_index5.Bubbles,{culture:_index6.receptionBunkersStore.getLineColor})),_react2.default.createElement('div',{className:_index4.default.inputLine+' '+_index4.default[_index6.receptionBunkersStore.getLineColor]}))));}}]);return InputFlow;}(_react.Component))||_class;exports.default=InputFlow;module.exports=exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(182);var _index2=_interopRequireDefault(_index);var _mobxReact=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Popup=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Popup,_Component);function Popup(){_classCallCheck(this,Popup);return _possibleConstructorReturn(this,(Popup.__proto__||Object.getPrototypeOf(Popup)).apply(this,arguments));}_createClass(Popup,[{key:'render',value:function render(){var x=Math.floor(this.props.x);var y=Math.floor(this.props.y);var item=this.props.item;return _react2.default.createElement('div',{className:_index2.default.popupBody,style:{left:x/(window.innerWidth/120)+'rem',top:y/(window.innerWidth/120)+'rem'}},item.name?_react2.default.createElement('p',{style:{fontWeight:'700'}},item.name):null,_react2.default.createElement('p',null,item.culture==='None'?'Культура: пусто':'Культура:'+item.culture),_react2.default.createElement('p',null,item.groupQuantity?'Кількість машин:'+item.groupQuantity:null),_react2.default.createElement('p',null,'\u0412\u0430\u0433\u0430:',+item.amount.toFixed(1)),_react2.default.createElement('p',null,'\u0412\u043E\u043B\u043E\u0433\u0456\u0441\u0442\u044C: ',+item.moistureLevel.toFixed(2),'%'),_react2.default.createElement('p',null,'\u0421\u043C\u0456\u0442\u043D\u0456\u0442\u044C: ',+item.wasteLevel.toFixed(2),'%'),item.errorStatus?_react2.default.createElement('p',null,'\u041F\u043E\u043C\u0438\u043B\u043A\u0430: ',item.errorStatus):'');}}]);return Popup;}(_react.Component))||_class;exports.default=Popup;module.exports=exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"popupBody":"_2d9gdg-ZoraW2CbmZqlZIn","popup-show":"GQbyDcnSzKjavsutZDx99"};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(13);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(184);var _index4=_interopRequireDefault(_index3);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _index5=__webpack_require__(7);var _mobxReact=__webpack_require__(2);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Bunker=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Bunker,_Component);function Bunker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Bunker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Bunker.__proto__||Object.getPrototypeOf(Bunker)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Bunker,[{key:'coords',value:function coords(e){var target=e.target;var X=target.getBoundingClientRect().right+5;var Y=target.getBoundingClientRect().top-10;this.setState({active:true,x:X,y:Y});}},{key:'render',value:function render(){var _this2=this;var i=this.props.inPath?0:this.props.i;var item=this.props.item;var levelHeight={height:(item.type==='output'?50:item.amount/(item.totalCapacity*Math.pow(_cultureSettings2.default[item.culture].volume,2))*100)+'%'};var index={zIndex:item.active?1000-i:null};return _react2.default.createElement('div',{className:_index4.default.bunker+' '+_index2.default[item.culture]+' '+_index4.default[item.status]+(this.props.inPath?' '+_index4.default.inPath:''),onMouseOver:this.coords.bind(this),onMouseLeave:function onMouseLeave(){return _this2.setState({active:false});}},_react2.default.createElement('div',{className:_index2.default.bunkerFakeContainer},_react2.default.createElement('div',{className:_index2.default.bunkerLevel,style:levelHeight})),_react2.default.createElement('div',{className:_index4.default.bunkerType+(this.props.inPath?' '+_index4.default.hide:'')},_react2.default.createElement(_reactFontawesome2.default,{name:item.bunkerType?item.bunkerType:''})),item.type==='output'?null:_react2.default.createElement('div',{className:_index4.default.bunkerNumbers},_react2.default.createElement('span',null,Math.ceil(item.amount)),_react2.default.createElement('hr',null),_react2.default.createElement('span',null,Math.ceil(item.totalCapacity*_cultureSettings2.default[item.culture].volume))),_react2.default.createElement('div',{className:_index2.default.bunkerLines+(this.props.inPath?' '+_index4.default.hide:''),style:index},_react2.default.createElement(_index5.Noria,{culture:item.active?item.culture:'None',noriaStatus:item.status})),_react2.default.createElement('div',{className:_index4.default.bunkerInputLine+(this.props.inPath?' '+_index4.default.hide:'')+(item.status==='clogged'?' '+_index4.default['clogged']:item.active?' '+_index4.default[item.culture]:''),style:{zIndex:item.type==='output'||!item.active?'':1000-i}}),_react2.default.createElement('div',{className:_index2.default.bunkerBubbles+(this.props.inPath?' '+_index4.default.hide:'')},_react2.default.createElement(_index5.Bubbles,{culture:item.activeTransport.disabled?"None":item.culture})),this.state.active?_react2.default.createElement(_index5.Popup,{x:this.state.x,y:this.state.y,item:item}):null);}}]);return Bunker;}(_react.Component))||_class;exports.default=Bunker;module.exports=exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bunker":"_1pPbmJJMe-AQsP29b0a7K1","inPath":"_3_yR-mPZYKTNDpoydIWf97","clogged":"rxbSBC8zzj7xWDNUZO3yT","bunkerType":"_1iaXA9hD9FPBGlprr9UXjS","noria":"_1t8DxmfWxRWPqSnP4wheKu","bunkerInputLine":"_2iNKgIAF_93Lg2Lgac4qqT","wheat":"_2_MIjU7gg9LAetbgOQ3nGf","rape":"_3rmP884Pf8uM96CVi7DUBW","soy":"uCEMLnbwyvHL48aroSYIh","corn":"_2UKZZRZ8dDU4Mekn0YObHm","sunflowermpn":"_1ZY9xz4WOoI8DSw_Mw6OIV","bunkerNumbers":"_3ylugS2IhouHac8Znhbt1h","hide":"HSUIWRIUIymsNrqzfMVUu"};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(186);var _index2=_interopRequireDefault(_index);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Bubble=function Bubble(props){return _react2.default.createElement('div',{className:_index2.default.bubbling+' '+_index2.default[props.culture]},_react2.default.createElement('span',null),_react2.default.createElement('span',null));};exports.default=Bubble;module.exports=exports['default'];

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bubbling":"_1uxN5Pkm5BfkB7fghbKzHp","wheat":"_10u1RzdTZmA9o_cahJ0K-2","rape":"_2p9XWcfYPDsmipgOW6L8kN","soy":"_3UNhnlTlxkPUy7naB-0i84","corn":"_2d4_M9isHP57mpsMl1z8in","sunflower":"_3ZoF11tTnpQ2RzFLg_cesZ","clogged":"_3ceA9laWKmHOHmuK4-FpjV","white":"_1XDYIIUUL92ztVSNJAT8dZ"};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(13);var _index2=_interopRequireDefault(_index);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Noria=function Noria(props){return _react2.default.createElement('div',{className:_index2.default.noria+(props.culture?' '+_index2.default[props.culture]:'')+(props.noriaStatus?' '+_index2.default[props.noriaStatus]:'')},_react2.default.createElement('span',null),_react2.default.createElement('span',null),_react2.default.createElement('span',null),_react2.default.createElement('span',null),_react2.default.createElement('div',{className:_index2.default.noriaLineInput}),_react2.default.createElement('div',{className:_index2.default.noriaLineOutput}),_react2.default.createElement('div',{className:_index2.default.cloggedNoria},'!'));};exports.default=Noria;module.exports=exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(189);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _index3=__webpack_require__(7);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Truck=(0,_mobxReact.observer)(_class=(_temp2=_class2=function(_Component){_inherits(Truck,_Component);function Truck(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Truck);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Truck.__proto__||Object.getPrototypeOf(Truck)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Truck,[{key:'coords',value:function coords(e){var target=e.target;var X=target.getBoundingClientRect().right+5;var Y=target.getBoundingClientRect().top-10;this.setState({active:true,x:X,y:Y});}},{key:'render',value:function render(){var _this2=this;var item=this.props.item;var truckLevel={height:item.amount*0.14375/_cultureSettings2.default[item.culture].volume+'rem'};return _react2.default.createElement('div',{style:{position:'relative'}},item.transportStatus==='alert'?_react2.default.createElement('div',{className:_index2.default.deleteClickZone,onMouseDown:function onMouseDown(e){e.stopPropagation();_this2.props.deleteTransport(_this2.props.id);}}):'',_react2.default.createElement('div',{className:_index2.default.truckContainer,onMouseOver:this.coords.bind(this),onMouseLeave:function onMouseLeave(){return _this2.setState({active:false});}},_react2.default.createElement('div',{className:_index2.default.truck},_react2.default.createElement('div',{className:_index2.default.truckStatus+(item.transportStatus?' '+_index2.default[item.transportStatus]:'')+' '+(this.props.backwards?'':_index2.default.statusForvard)}),_react2.default.createElement('div',{className:this.props.backwards?_index2.default.cultureArea:_index2.default.cultureAreaForvard},_react2.default.createElement('div',{className:_index2.default.truckLevel+(item.culture?' '+_index2.default[item.culture]:''),style:truckLevel}),_react2.default.createElement('div',{className:_index2.default.truckCulture},_react2.default.createElement('i',{className:_iconfonts2.default[item.culture]})),_react2.default.createElement('div',{className:_index2.default.truckNumbers},_react2.default.createElement('span',null,item.moistureLevel,'%'),_react2.default.createElement('span',null,item.wasteLevel,'%')),_react2.default.createElement('div',{className:item.groupQuantity>1?_index2.default.truckQuantity:_index2.default.hideQuantity},item.groupQuantity),_react2.default.createElement('div',{className:_index2.default.truckDefinitions},_react2.default.createElement('span',null,_react2.default.createElement(_reactFontawesome2.default,{name:'tint'})),_react2.default.createElement('span',null,_react2.default.createElement(_reactFontawesome2.default,{name:'trash'})))),_react2.default.createElement('svg',{version:'1.1',xmlns:'http://www.w3.org/2000/svg',xlinkHref:'http://www.w3.org/1999/xlink',x:'0px',y:'0px',viewBox:'0 0 140 50'},_react2.default.createElement('path',{className:this.props.backwards?_index2.default.truckBase:_index2.default.hiddenPath,d:'M32,25V0h-3l-4,5h-8l-4,8L0,16v14h3v2h2c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8h17c0,4.4,3.6,8,8,8s8-3.6,8-8h2\r c0,4.4,3.6,8,8,8s8-3.6,8-8h2v-5h26v5h2c0,4.4,3.6,8,8,8s8-3.6,8-8h2c0,4.4,3.6,8,8,8s8-3.6,8-8h2v-7H32z M13,36c-2.2,0-4-1.8-4-4\r s1.8-4,4-4c2.2,0,4,1.8,4,4S15.2,36,13,36z M46,36c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S48.2,36,46,36z M64,36c-2.2,0-4-1.8-4-4\r s1.8-4,4-4s4,1.8,4,4S66.2,36,64,36z M110,36c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S112.2,36,110,36z M128,36c-2.2,0-4-1.8-4-4\r s1.8-4,4-4s4,1.8,4,4S130.2,36,128,36z'}),_react2.default.createElement('path',{className:this.props.backwards?_index2.default.hiddenPath:_index2.default.truckBase,d:'M0,25l0,7h2c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8h2c0,4.4,3.6,8,8,8s8-3.6,8-8h2v-5h26v5h2c0,4.4,3.6,8,8,8\r s8-3.6,8-8h2c0,4.4,3.6,8,8,8s8-3.6,8-8h17c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8h2v-2h3V16l-13-3l-4-8h-8l-4-5l-3,0v25H0z M121,32\r c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S121,34.2,121,32z M88,32c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C89.8,36,88,34.2,88,32z\r M70,32c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S70,34.2,70,32z M24,32c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S24,34.2,24,32z M6,32\r c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S6,34.2,6,32z'}))),this.state.active?_react2.default.createElement(_index3.Popup,{x:this.state.x,y:this.state.y,item:item}):null));}}]);return Truck;}(_react.Component),_class2.defaultProps={deleteTransport:function deleteTransport(){console.log('none event');},item:{transportStatus:'none',moistureLevel:0,wasteLevel:0,culture:'soy',groupQuantity:10,amount:0}},_temp2))||_class;exports.default=Truck;module.exports=exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"truckContainer":"NQbJZfEpK_QONM5HxceQw","truck":"_3VSYjYts5uCe2HNzEsBlmk","truckBase":"_1LIjZ6fDJ-iIwqSVhVGRNb","hiddenPath":"_3p6YKAZU1__Lox8FE2ErFU","cultureArea":"_1p5mXGHH8nqpTkOEuDJUSB","cultureAreaForvard":"_1ywNHEJylbBLvpsYhx3yfA","truckLevel":"_3kUXUgqx40frPg6gxKHpMB","wheat":"FqnCFtT8qo6S1Mcdw1pwi","rape":"_2wkNOC2rgg_xGJ-1DCkT0g","soy":"_5Anez6WdQ4QkuFOzx_JBo","corn":"UU11ahCnLeKhEY971XMoX","sunflower":"PQWCPo6eyq3wGz_g-vWLf","truckCulture":"_1DL7B_qKIveQEcGXbQ8KFU","truckNumbers":"_2C_lUwfacoIwSkuAv8ADvE","truckDefinitions":"_1a_glQtUhoWl_OX8-DC-yo","truckQuantity":"_3G6EcmKfUdBm1KD2VlMcca","hideQuantity":"_2d9Z0_lkfPLUmPnfAPsAtq","truckStatus":"_3UwWZPxL8uYfwnUIf5jAUu","statusForvard":"_3rKrrIZanJy9fNA0FfLdJS","question":"SSiXLklv8QQciXGrZR2gk","alert":"_38Ps66H2p3iLuwz_3w61ln","chosen":"_3RC794eWYCNV4BoXeaqS-F","truckPopup":"_2tKygJaT_ml6-opNYhblS4","deleteClickZone":"_2tBeBoWI3elCgFKfl08ACy"};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(191);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _index3=__webpack_require__(7);var _mobxReact=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RailCart=(0,_mobxReact.observer)(_class=(_temp2=_class2=function(_Component){_inherits(RailCart,_Component);function RailCart(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RailCart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RailCart.__proto__||Object.getPrototypeOf(RailCart)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RailCart,[{key:'coords',value:function coords(e){var target=e.target;var X=target.getBoundingClientRect().right+5;var Y=target.getBoundingClientRect().top-10;this.setState({active:true,x:X,y:Y});}},{key:'render',value:function render(){var _this2=this;var item=this.props.item;var railCartLevel={height:item.amount*2.3/48+'rem'};return _react2.default.createElement('div',{className:_index2.default.railCartContainer,onMouseOver:this.coords.bind(this),onMouseLeave:function onMouseLeave(){return _this2.setState({active:false});}},_react2.default.createElement('div',{className:_index2.default.railCart},_react2.default.createElement('div',{className:_index2.default.cultureArea},_react2.default.createElement('div',{className:_index2.default.railCartLevel+(item.culture?' '+_index2.default[item.culture]:''),style:railCartLevel}),_react2.default.createElement('div',{className:_index2.default.railCartCulture},_react2.default.createElement('i',{className:_iconfonts2.default[item.culture]})),_react2.default.createElement('div',{className:_index2.default.railCartNumbers},_react2.default.createElement('span',null,Math.floor(item.moistureLevel),'%'),_react2.default.createElement('span',null,Math.floor(item.wasteLevel),'%')),_react2.default.createElement('div',{className:item.groupQuantity?_index2.default.railCartQuantity:_index2.default.hideQuantity},item.groupQuantity),_react2.default.createElement('div',{className:_index2.default.railCartDefinitions},_react2.default.createElement('span',null,_react2.default.createElement(_reactFontawesome2.default,{name:'tint'})),_react2.default.createElement('span',null,_react2.default.createElement(_reactFontawesome2.default,{name:'trash'})))),_react2.default.createElement('svg',{version:'1.1',xmlns:'http://www.w3.org/2000/svg',xlinkHref:'http://www.w3.org/1999/xlink',x:'0',y:'0px',viewBox:'0 0 140 50'},_react2.default.createElement('path',{className:_index2.default.railCartBase,d:'M137,12.9L132.2,0l-1.1,2.8l3.8,10.1h-9.6c-1.5-1.8-3.7-3-6.2-3c-3.7,0-6.8,2.6-7.7,6h-3.5c-0.9-3.4-4-6-7.7-6\r s-6.8,2.6-7.7,6H47.7c-0.9-3.4-4-6-7.7-6s-6.8,2.6-7.7,6h-3.5c-0.9-3.4-4-6-7.7-6c-2.5,0-4.8,1.2-6.2,3H5.1L8.9,2.8L7.8,0L3,12.9H0\r v3h9l1,3h3.1c0.5,3.9,3.9,7,7.9,7s7.4-3.1,7.9-7h3.1c0.5,3.9,3.9,7,7.9,7s7.4-3.1,7.9-7H51l0.7-2h36.7l0.7,2h3.1\r c0.5,3.9,3.9,7,7.9,7s7.4-3.1,7.9-7h3.1c0.5,3.9,3.9,7,7.9,7s7.4-3.1,7.9-7h3.1l1-3h9v-3H137z M21,19.9c-1.1,0-2-0.9-2-2s0.9-2,2-2\r s2,0.9,2,2S22.1,19.9,21,19.9z M40,19.9c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S41.1,19.9,40,19.9z M100,19.9c-1.1,0-2-0.9-2-2\r s0.9-2,2-2s2,0.9,2,2S101.1,19.9,100,19.9z M119,19.9c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S120.1,19.9,119,19.9z'}))),this.state.active?_react2.default.createElement(_index3.Popup,{x:this.state.x,y:this.state.y,item:item}):null);}}]);return RailCart;}(_react.Component),_class2.defaultProps={deleteTransport:function deleteTransport(){console.log('none event');},item:{transportStatus:'none',moistureLevel:0,wasteLevel:0,culture:'soy',groupQuantity:10,amount:0}},_temp2))||_class;exports.default=RailCart;module.exports=exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"railCartContainer":"_2EQp5Z60fpUb1UhpZb5cTo","railCart":"fNri5Ve0_9ZKTyfBiv9HM","railCartBase":"_3a_OdBnhRfuDiy_JESNJX0","cultureArea":"_1yFWlv_gWnPRj1WSlN956z","railCartLevel":"_3mPJMkbHEPI0qkInfLGSYo","wheat":"_1t35bx61IMzAoBjPKuqRf4","rape":"_3nwEzj63LMDaQfYkWw7lX","soy":"_3fpoJ6q4xHduHYaAIpGLRP","corn":"_3KLJ709fLZMdxmfgGbquOo","sunflower":"_2AUV53zxOLesBSqMeGUSNV","railCartCulture":"_2XUFUBPoPAKpESn16p4pMM","railCartNumbers":"_24CkVrj3XZLZXHg5o8uruq","railCartDefinitions":"_3CqkuqkCJg4fCY86tdYeg6","railCartQuantity":"Dz9Bdnj8T9o_FGOcgqLXo","hideQuantity":"_28wxE0_gHMJDZnFXpJj0qk","railCartStatus":"_1tUWf_WQX9mQ-IzblO_zic","question":"k3rpBouzhwnt0vGm42V2f","alert":"_1twQevtLDKK0eSXB8XhBhr"};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(193);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DryingCleaningUnit=(0,_mobxReact.observer)(_class=function(_Component){_inherits(DryingCleaningUnit,_Component);function DryingCleaningUnit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DryingCleaningUnit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DryingCleaningUnit.__proto__||Object.getPrototypeOf(DryingCleaningUnit)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DryingCleaningUnit,[{key:'coords',value:function coords(e){var target=e.target;var X=target.getBoundingClientRect().right+4;var Y=target.getBoundingClientRect().top-14;this.setState({active:true,x:X,y:Y});}},{key:'render',value:function render(){var _this2=this;var item=this.props.item;return _react2.default.createElement('div',{className:_index2.default.dcUnitContainer},_react2.default.createElement('div',{className:_index2.default.dryingCleaningUnit+(item.culture?' '+_index2.default[item.culture]:'')+' '+_index2.default[item.status],onMouseOver:this.coords.bind(this),onMouseLeave:function onMouseLeave(){return _this2.setState({active:false});}},_react2.default.createElement('div',{className:_index2.default.dcLevel}),_react2.default.createElement('div',{className:_index2.default.dcProductivity},Math.floor(item.speed)),_react2.default.createElement('div',{className:_index2.default.cloggedDCUnit},'!')),this.state.active?_react2.default.createElement(_index3.Popup,{x:this.state.x,y:this.state.y,item:item}):null);}}]);return DryingCleaningUnit;}(_react.Component))||_class;exports.default=DryingCleaningUnit;module.exports=exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dcUnitContainer":"UInF3KPyNbK33ZQIJZmzE","dryingCleaningUnit":"_2R8Qre5DFwJVelBmbPiVOq","dcLevel":"_36TrejIyXHu0IYKUXiobpr","dcLevelWave":"_154AkvKh1tz6yMSBlUZtX3","wheat":"_2icbUCDFKidDOzgup4E1lE","rape":"bMtqoW0b_z10VPZHCoXB8","soy":"_3cvO0F36jILPaBcDXl-A_-","corn":"_2HtXNx7BoSubP8jL1EoN","sunflower":"_2E4PLwyBx_BVsVc6LWsMJr","idle":"_1jhzPMAVe1xHuFUwya0z2w","clogged":"_4QqB5SlFdfkpVc9hIjYQZ","dcWave":"_2loY8cSE7bz3Xke-5fcFS0","dcProductivity":"_2ZwRS-5XVbaRYwiXXPvsOQ","cloggedDCUnit":"_2bzzLuOtc_3mZRzJRYGAJu"};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"siloUnit":"sGP_EKnG1SopA65OB-uuK","siloLevel":"_2L_JJRUgWOMF6oIE6IWiEg","inPath":"_38Z-PFwn303DcwFHCE9XUx","increasing":"GMmfd1K2RwpAcmZiasRpx","increased":"_3AQc1r3NaXo5eWmUFJ_Vzt","decreasing":"_5XpL-EBBKFKrWaI26F2Ua","decreased":"_3A_fxsopY6zC3MsCToHjNw","siloBubbles":"_3_DQLLHpNsD7nzIr9WHfdt","wheat":"_2i3GVUDSQsUkixGoIcWhFk","rape":"C7z0mKjqzVgm0izG2Can-","soy":"_1mhRRadAft4xDEUUXFegMN","corn":"_1eKq2JmwZjiONB0yBESJqX","sunflower":"_2qKKwFRdFSsDHRusckOHzl","siloNumbers":"MeBHGhtkPyFoE1VYwglLZ","siloCulture":"cWNosk49xiJi9hNT0oPrG","siloDSNumbers":"_7xr4ot71U8BFnSeVOHK4U","siloLineOutput":"q22ncfQ-7bJ5KTfRzX7AM"};

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hopperContainer":"_22SXRIH4vQka4yZd-njwSR","hopper":"_2pAAaCTrFVgodfdQtGJX-1","hopperLevel":"_272ebRzIYBSejoW9j2TSJu","wheat":"_2EVrTsdgqjRMIBQFXZ8iRa","rape":"_3D2Dr1aBUJX0D4Hn6phaXd","soy":"OQj8vfyoZhbKtOrd4eXZp","corn":"_3yoNhJKB7Nd0Maiaj8LKgE","sunflower":"j1Bsn9hlflWy5ZaJXoQyD","idle":"_1336mBUpe4b6c-WKt2jezn","clogged":"_1mb44WP0DFg_3lUnecnwoD","cloggedHopper":"fejAoj0aRHIUbARyktkav","hopperNumbers":"_2SsjrheN60mOw4KYY843La","inPath":"_2Jf4K4pTZF32N-xYRH7FU3"};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _mobxReact=__webpack_require__(2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(29);var _index2=_interopRequireDefault(_index);var _SubComponents=__webpack_require__(7);var _stores=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReceptionBunker=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ReceptionBunker,_Component);function ReceptionBunker(){_classCallCheck(this,ReceptionBunker);return _possibleConstructorReturn(this,(ReceptionBunker.__proto__||Object.getPrototypeOf(ReceptionBunker)).apply(this,arguments));}_createClass(ReceptionBunker,[{key:"render",value:function render(){var item=this.props.item;var i=this.props.i;var activeTransport=item.activeTransport;return _react2.default.createElement("div",{className:_index2.default.bunkerRow},_react2.default.createElement("div",{className:_index2.default.bunkerInline,onClick:function onClick(){_stores.scenario.openPathPopup(!!item.scenario.length?item.scenario:item,!!item.scenario.length);}},_react2.default.createElement(_SubComponents.Bunker,{item:item,i:i})),_react2.default.createElement("div",{className:_index2.default.truckRailCartHolder},item.activeTransport.disabled?null:item.bunkerType==="train"?_react2.default.createElement(_SubComponents.RailCart,{item:activeTransport}):_react2.default.createElement(_SubComponents.Truck,{item:activeTransport,backwards:true})),_react2.default.createElement("div",{className:_index2.default.nearestQueueThumbs},item.getThumbs.map(function(thumb,i){return _react2.default.createElement(QueueThumb,{culture:thumb.culture,number:thumb.number,key:i});})));}}]);return ReceptionBunker;}(_react.Component))||_class;exports.default=ReceptionBunker;var QueueThumb=function QueueThumb(props){return _react2.default.createElement("span",{className:(props.culture?' '+_index2.default[props.culture]:'')+(props.number>1?'':' '+_index2.default.notGroup)},props.number>1?props.number:'');};module.exports=exports["default"];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _stores=__webpack_require__(1);var _index=__webpack_require__(29);var _index2=_interopRequireDefault(_index);var _SubComponents=__webpack_require__(7);var _index3=__webpack_require__(13);var _index4=_interopRequireDefault(_index3);var _DragNDrop=__webpack_require__(37);var _TransportStack=__webpack_require__(200);var _TransportStack2=_interopRequireDefault(_TransportStack);var _ReceptionDispathcer=__webpack_require__(64);var _ReceptionDispathcer2=_interopRequireDefault(_ReceptionDispathcer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TransportField=(0,_mobxReact.observer)(_class=function(_Component){_inherits(TransportField,_Component);function TransportField(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TransportField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TransportField.__proto__||Object.getPrototypeOf(TransportField)).call.apply(_ref,[this].concat(args))),_this),_this.state={dragItem:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TransportField,[{key:"deleteTransport",value:function deleteTransport(id){_stores.transportStore.removeTransport(id);}},{key:"returnTransport",value:function returnTransport(bunkerId,num){this.setState({dragItem:{bunkerId:bunkerId,num:num}});}},{key:"onDrag",value:function onDrag(id){this.setState({dragItem:id});}},{key:"render",value:function render(){var _this2=this;var bunker=_stores.receptionBunkersStore.receptionBunker;var trucks=_stores.transportStore.receptionTruck;var trains=_stores.transportStore.receptionTrain;return _react2.default.createElement("div",{className:_index2.default.queues},_react2.default.createElement("div",{className:_index2.default.bulkQueue},_react2.default.createElement("div",{className:_index2.default.railCartsBulkQueue},trains.map(function(item,i){if(item.disabled){return _react2.default.createElement("div",{className:_index2.default.activeTruck,style:{width:'9.0625rem',height:'3.125rem'},key:i});}return _react2.default.createElement("div",{key:i},_react2.default.createElement(_SubComponents.RailCart,{item:item}));})),_react2.default.createElement("div",{className:_index4.default.trucksContainer},_react2.default.createElement(_DragNDrop.Drop,{className:_index4.default.dropfieldBack,onDrop:function onDrop(){_ReceptionDispathcer2.default.returnTransportFromBunkerStack(_this2.state.dragItem.bunkerId,_this2.state.dragItem.num);},type:"back"},_react2.default.createElement("div",{className:_index2.default.dropPlaceBack+' '+_index2.default.activeTruck})),_react2.default.createElement("div",{className:_index2.default.trucksBulkQueue},trucks.map(function(item,i){return _react2.default.createElement(_DragNDrop.Drag,{type:"truck",maskClassName:_index4.default.transportMask,onDrag:_this2.onDrag.bind(_this2,i),key:i},_react2.default.createElement(_SubComponents.Truck,{item:item,id:i,deleteTransport:_this2.deleteTransport.bind(_this2)}));})))),_react2.default.createElement("div",{className:_index2.default.nearestQueue},bunker.map(function(item,i){return _react2.default.createElement(_TransportStack2.default,{returnTransport:_this2.returnTransport.bind(_this2),transportDrop:_this2.state.dragItem,item:item,num:i,key:i});})));}}]);return TransportField;}(_react.Component))||_class;exports.default=TransportField;module.exports=exports["default"];

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dragElement":"_15qG8Va38KCykntn2nrOG4"};

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fields":"_3BW3UTLQ0OZcViaudNtlEe","drop":"_3EIKslvTsYnZ9a2M6tBIAX"};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _mobxReact=__webpack_require__(2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(29);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(13);var _index4=_interopRequireDefault(_index3);var _DragNDrop=__webpack_require__(37);var _SubComponents=__webpack_require__(7);var _stores=__webpack_require__(1);var _ReceptionDispathcer=__webpack_require__(64);var _ReceptionDispathcer2=_interopRequireDefault(_ReceptionDispathcer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TransportStack=(0,_mobxReact.observer)(_class=function(_Component){_inherits(TransportStack,_Component);function TransportStack(){_classCallCheck(this,TransportStack);return _possibleConstructorReturn(this,(TransportStack.__proto__||Object.getPrototypeOf(TransportStack)).apply(this,arguments));}_createClass(TransportStack,[{key:"render",value:function render(){var _this2=this;var item=this.props.item;// const bunker = receptionBunkersStore.receptionBunker;
var num=this.props.num;return _react2.default.createElement("div",{className:_index2.default.queueRow,style:{zIndex:200+(this.props.transportDrop.bunkerId===num?1:0)}},item.transportStack.map(function(item,i){return _react2.default.createElement("div",{className:_index4.default.stackElement,key:i},item?_react2.default.createElement(_DragNDrop.Drag,{style:{height:"100%",width:"100%"},onDrag:function onDrag(){_this2.props.returnTransport(num,i);},type:"back,change"},_react2.default.createElement("div",null,_react2.default.createElement("div",null,_react2.default.createElement("div",{style:{pointerEvents:"none",position:"absolute",zIndex:1,cursor:"pointer"}},_react2.default.createElement(_SubComponents.Truck,{item:item,id:i}))))):null,!_this2.props.item.transportStack[3]?_react2.default.createElement(_DragNDrop.Drop,{className:_index4.default.dropfield+' '+_index4.default.stackDropfield,id:i,onDrop:function onDrop(){_ReceptionDispathcer2.default.addTransportToBunkerStack(num,i,_this2.props.transportDrop);},type:"truck"},_react2.default.createElement("div",{className:_index2.default.dropPlace+' '+_index2.default.activeTruck})):null,!_this2.props.item.transportStack[3]?_react2.default.createElement(_DragNDrop.Drop,{className:_index4.default.dropfield+' '+_index4.default.stackDropfield,id:i,onDrop:function onDrop(){_ReceptionDispathcer2.default.switchStack(num,i,_this2.props.transportDrop);},type:"change"},_react2.default.createElement("div",{className:_index2.default.dropPlace+' '+_index2.default.activeTruck})):null);}));}}]);return TransportStack;}(_react.Component))||_class;exports.default=TransportStack;module.exports=exports["default"];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(13);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(38);var _index4=_interopRequireDefault(_index3);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _index5=__webpack_require__(7);var _index6=__webpack_require__(1);var _Lines=__webpack_require__(202);var _Lines2=_interopRequireDefault(_Lines);var _elementBlock=__webpack_require__(203);var _elementBlock2=_interopRequireDefault(_elementBlock);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ElevatorField=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ElevatorField,_Component);function ElevatorField(){_classCallCheck(this,ElevatorField);return _possibleConstructorReturn(this,(ElevatorField.__proto__||Object.getPrototypeOf(ElevatorField)).apply(this,arguments));}_createClass(ElevatorField,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index2.default.innerContainer+' '+_index2.default.elevatorField},_react2.default.createElement('div',{className:_index2.default.content},_react2.default.createElement('div',{className:_index4.default.elevatorFieldContainer},_react2.default.createElement(_Lines2.default,null),_react2.default.createElement(NoriaBlock,{hopper:true,list:_index6.storageStore.hoppersList}),_react2.default.createElement(_elementBlock2.default,{title:'\u0425\u041E\u041F\u0415\u0420\u0418',icon:'iconStoring',list:_index6.storageStore.hoppersList,UIComponent:_index5.Hopper}),_react2.default.createElement(NoriaBlock,{list:_index6.dcUnitsStore.dryingList}),_react2.default.createElement(_elementBlock2.default,{title:'\u0441\u0443\u0448\u043A\u0430',icon:'iconDrying',list:_index6.dcUnitsStore.dryingList,UIComponent:_index5.DryingCleaningUnit}),_react2.default.createElement(NoriaBlock,{list:_index6.dcUnitsStore.cleaningList}),_react2.default.createElement(_elementBlock2.default,{title:'\u0447\u0438\u0441\u0442\u043A\u0430',icon:'iconCleaning',list:_index6.dcUnitsStore.cleaningList,UIComponent:_index5.DryingCleaningUnit}),_react2.default.createElement('div',{className:_index2.default.noriaContainer+' '+_index2.default.noriaContainerBeforeSilos},this.getNoria),_react2.default.createElement('div',{className:_index4.default.silosContainer},_index6.storageStore.silosList.map(function(item,i){return _react2.default.createElement('div',{className:_index4.default.silo,onClick:function onClick(){_index6.scenario.openPathPopup(!!item.scenario.length?item.scenario:item,!!item.scenario.length);},key:i},_react2.default.createElement(_index5.Silo,{item:item,i:i}));}),_react2.default.createElement('div',{className:_index4.default.siloLinesContainer},_react2.default.createElement('div',{className:_index4.default.fakeContainerForStackingIndex},_index6.storageStore.silosList.map(function(item,i){return _react2.default.createElement(SiloLine,{culture:item.culture!=='None'&&item.filingStatus?item.culture:'idle',lineStatus:item.filingStatus?item.status?'clogged':'active':'idle',i:i,key:i});}))),_react2.default.createElement('div',{className:_index4.default.siloContainerDSIcons},_react2.default.createElement('div',null,_react2.default.createElement(_reactFontawesome2.default,{name:'trash'})),_react2.default.createElement('div',null,_react2.default.createElement(_reactFontawesome2.default,{name:'tint'})))))));}},{key:'getNoria',get:function get(){var num=Math.round(_index6.storageStore.silosList.length/2);var arr=[];var list=_index6.storageStore.silosList.filter(function(item){return item.amountState==='increasing'||item.status==='clogged'&&item.filingStatus;});if(list.length){if(list.length>=num){for(var i=0;i<num;i++){arr.push(_react2.default.createElement(_index5.Noria,{culture:list[i].culture,noriaStatus:list[i].status,key:i}));}}else{for(var _i=0;_i<list.length;_i++){arr.push(_react2.default.createElement(_index5.Noria,{culture:list[_i].culture,noriaStatus:list[_i].status,key:_i}));}for(var _i2=0;_i2<num-list.length;_i2++){arr.push(_react2.default.createElement(_index5.Noria,{culture:'None',key:_i2+list.length}));}}}else{for(var _i3=0;_i3<num;_i3++){arr.push(_react2.default.createElement(_index5.Noria,{culture:'None',key:_i3}));}}return arr;}}]);return ElevatorField;}(_react.Component))||_class;exports.default=ElevatorField;var SiloLine=function SiloLine(props){return _react2.default.createElement('div',{style:{width:1.75+props.i*2.75+'rem'},className:_index4.default.siloLineInput+(props.culture?' '+_index4.default[props.culture]:' '+_index4.default.idle)+(props.lineStatus?' '+_index4.default[props.lineStatus]:'')});};var NoriaBlock=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(NoriaBlock,_Component2);function NoriaBlock(){_classCallCheck(this,NoriaBlock);return _possibleConstructorReturn(this,(NoriaBlock.__proto__||Object.getPrototypeOf(NoriaBlock)).apply(this,arguments));}_createClass(NoriaBlock,[{key:'render',value:function render(){var _this3=this;return _react2.default.createElement('div',{className:_index2.default.noriaContainer},this.props.list.map(function(item,i){return _react2.default.createElement(_index5.Noria,{culture:_this3.props.hopper?item.fillingStatus?item.culture:"None":item.culture,noriaStatus:item.status,key:i});}));}}]);return NoriaBlock;}(_react.Component))||_class2;;module.exports=exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _mobxReact=__webpack_require__(2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _stores=__webpack_require__(1);var _index=__webpack_require__(38);var _index2=_interopRequireDefault(_index);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Lines=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Lines,_Component);function Lines(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Lines);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Lines.__proto__||Object.getPrototypeOf(Lines)).call.apply(_ref,[this].concat(args))),_this),_this.graphDotsList=['hopper','drying','cleaning','silo','output'],_this.graphElementsBlock=[_stores.receptionBunkersStore.receptionBunker,_stores.storageStore.hoppersList,_stores.dcUnitsStore.dryingList,_stores.dcUnitsStore.cleaningList,_stores.storageStore.silosList],_this.map={'hopper':_stores.storageStore.hoppersList,'drying':_stores.dcUnitsStore.dryingList,'cleaning':_stores.dcUnitsStore.cleaningList,'silo':_stores.storageStore.silosList},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Lines,[{key:"findElem",value:function findElem(list,type){var result=list.find(function(item){return item.status==='clogged'&&item.active&&item.scenario.length&&!!item.scenario[item.currentOperation]&&item.scenario[item.currentOperation].type===type;});if(result)return result.status;result=list.find(function(item){return item.currentOperation>0&&item.active&&item.scenario.length&&!!item.scenario[item.currentOperation]&&item.scenario[item.currentOperation].type===type;});return result?result.culture:null;}},{key:"getLines",value:function getLines(){var _this2=this;var graphDotsList=this.graphDotsList;var graphElementsBlock=this.graphElementsBlock;var siloLines=[];var inheritColor="None";var graph=[[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]];var wayList=[];var line=[0,0,0,0,0,0,0,0];graphElementsBlock.forEach(function(item,i){graphDotsList.forEach(function(dots,j){graph[i][j]=_this2.findElem(item,dots);});});graph.forEach(function(item,i){item.forEach(function(elem,j){if(elem){wayList.push({culture:elem,out:i,in:j,length:i-(j+1)});}});});wayList.sort(function(a,b){if(b.culture==='clogged')return 1;if(a.culture==='clogged')return-1;var f=a.length<0?a.length+1:a.length;var s=b.length<0?b.length+1:b.length;return Math.abs(f)-Math.abs(s);}).forEach(function(item,i){if(item.length>=0){for(var j=item.out*2-1;j>=item.out*2-Math.abs(item.length*2)-1;j--){if(!line[j])line[j]=item.culture;}}else{for(var _j=item.out*2;_j<item.out*2+Math.abs(item.length*2)-1;_j++){if(!line[_j])line[_j]=item.culture;}}});//getSiloLines
var clogged=false;for(var i=0;i<graph.length-1;i++){if(graph[i][graphDotsList.length-1]==='clogged'){for(var j=0;j<graphElementsBlock[4].length;j++){siloLines[j]='clogged';}clogged=true;break;}}if(!clogged){graph.forEach(function(item,i){if(item[4]&&i!==graph.length-1){inheritColor=item[4];}});if(line[7]){for(var _j2=0;_j2<graphElementsBlock[4].length;_j2++){siloLines[_j2]='clogged';}if(graphElementsBlock[4].status==='clogged'){}}}else{inheritColor='clogged';}var map=this.map;var list=_stores.storageStore.silosList;var length=list.length-1;var baseline=void 0;var r=void 0,l=void 0,cr=void 0,cl=void 0,result=[],item=void 0;for(var _i=0;_i<length+1;_i++){result[_i]=0;}r=l=cr=cl=0;for(var _i2=0;_i2<=length;_i2++){item=list[length-_i2];if(!!item.scenario[item.currentOperation]){if(item.scenario[item.currentOperation].type==='output'){if(_stores.shipment.shipmentBunker[item.scenario[item.currentOperation].num].status==='clogged'){for(var _j3=length-cr;_j3>=length-_i2+1;_j3--){result[_j3]='clogged';baseline='clogged';}cr=r=_i2;}else{for(var _j4=length-r;_j4>=length-_i2+1;_j4--){if(!result[_j4])result[_j4]=item.culture;if(!baseline)baseline=item.culture;}r=_i2;}}}item=list[_i2];if(!!item.scenario[item.currentOperation]){if(item.scenario[item.currentOperation].type!=='output'){if(map[item.scenario[item.currentOperation].type][item.scenario[item.currentOperation].num].status==='clogged'){for(var _j5=cl;_j5<=_i2;_j5++){result[_j5]='clogged';}cl=l=_i2+1;}else{for(var _j6=l;_j6<=_i2;_j6++){if(!result[_j6])result[_j6]=item.culture;}l=_i2+1;}}}if(cl>length-cr||l>length-r)break;}if(!baseline){baseline=inheritColor;};return _react2.default.createElement("div",{className:_index2.default.lowerBus+' '+_index2.default[baseline]},line.map(function(item,i){if(i)return _react2.default.createElement("div",{className:_index2.default[item?item:'None'],key:i});return null;}),result.map(function(item,i){if(!i)return null;return _react2.default.createElement("div",{className:_index2.default.siloToSilo+' '+_index2.default[item?item:inheritColor],key:i});}));}},{key:"render",value:function render(){return _react2.default.createElement("div",null,this.getLines());}}]);return Lines;}(_react.Component))||_class;exports.default=Lines;module.exports=exports["default"];

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(38);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _SubComponents=__webpack_require__(7);var _stores=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ElementBlock=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ElementBlock,_Component);function ElementBlock(){_classCallCheck(this,ElementBlock);return _possibleConstructorReturn(this,(ElementBlock.__proto__||Object.getPrototypeOf(ElementBlock)).apply(this,arguments));}_createClass(ElementBlock,[{key:"render",value:function render(){var _this2=this;var List=this.props.list;var BlockLine=List.find(function(item){return item.status==='clogged';});if(!BlockLine){BlockLine=List.find(function(item){return item.active&&item.culture!=='None';});if(BlockLine){BlockLine=BlockLine.culture;}}else{BlockLine=BlockLine.status;}return _react2.default.createElement("div",{className:_index2.default.hopperContainer},_react2.default.createElement("div",{className:_index2.default.dcTitle},this.props.title),_react2.default.createElement("div",{className:_index2.default.dcIcon},_react2.default.createElement("i",{className:_iconfonts2.default[this.props.icon]})),List.map(function(item,i){return _react2.default.createElement("div",{key:i,onClick:function onClick(){if(item.type==='hopper'){_stores.scenario.openPathPopup(!!item.scenario.length?item.scenario:item,!!item.scenario.length);}}},_react2.default.createElement(_this2.props.UIComponent,{item:item}));}),_react2.default.createElement("div",{className:_index2.default.dcOutputBubbles},_react2.default.createElement(_SubComponents.Bubbles,{culture:BlockLine?BlockLine:'None'}),_react2.default.createElement("div",{className:_index2.default.dcOutputLine+' '+_index2.default[BlockLine?BlockLine:'None']})));}}]);return ElementBlock;}(_react.Component))||_class;exports.default=ElementBlock;module.exports=exports["default"];

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class3,_class4;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(13);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(205);var _index4=_interopRequireDefault(_index3);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _index5=__webpack_require__(7);var _index6=__webpack_require__(1);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OutputFlow=(0,_mobxReact.observer)(_class=function(_Component){_inherits(OutputFlow,_Component);function OutputFlow(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OutputFlow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OutputFlow.__proto__||Object.getPrototypeOf(OutputFlow)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OutputFlow,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return nextState.active!==this.state.active;}},{key:'activeToggle',value:function activeToggle(){this.state.active?this.setState({active:false}):this.setState({active:true});}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index2.default.innerContainer+' '+_index2.default.outputFlow+(this.state.active?' '+_index2.default.activeTab:'')},_react2.default.createElement('div',{className:_index2.default.content},_react2.default.createElement('div',{className:_index2.default.queueContainer},_react2.default.createElement('div',{className:_index2.default.stateToggleButton,onClick:this.activeToggle.bind(this)},this.state.active?_react2.default.createElement(_reactFontawesome2.default,{name:'compress'}):_react2.default.createElement(_reactFontawesome2.default,{name:'expand'})),_react2.default.createElement('div',{className:_index2.default.indicator,style:{left:0}},_react2.default.createElement('div',{className:_index4.default.indicatorCircle+' '+_index4.default.wheat},_index6.shipment.getTotalWheat),_react2.default.createElement('div',{className:_index4.default.indicatorCircle+' '+_index4.default.rape},_index6.shipment.getTotalRape),_react2.default.createElement('div',{className:_index4.default.indicatorCircle+' '+_index4.default.soy},_index6.shipment.getTotalSoy),_react2.default.createElement('div',{className:_index4.default.indicatorCircle+' '+_index4.default.sunflower},_index6.shipment.getTotalSunflower),_react2.default.createElement('div',{className:_index4.default.indicatorCircle+' '+_index4.default.corn},_index6.shipment.getTotalCorn)),_react2.default.createElement('div',{className:_index4.default.bunkerContainer},_index6.shipment.shipmentBunker.map(function(item,i){return _react2.default.createElement('div',{className:_index4.default.bunkerRow,key:i,onClick:function onClick(){console.log(item.type,item);}},_react2.default.createElement(_index5.Bunker,{item:item,i:i,output:true}),_react2.default.createElement('div',{className:_index4.default.truckRailCartHolder},item.activeTransport.disabled?null:item.bunkerType==="train"?_react2.default.createElement(_index5.RailCart,{item:item.activeTransport}):_react2.default.createElement(_index5.Truck,{item:item.activeTransport,backwards:false})));})),_react2.default.createElement('div',{className:_index4.default.queues+(!this.state.active?' '+_index4.default.noBorder:'')},_react2.default.createElement('div',{className:_index4.default.bulkQueue},_react2.default.createElement(OutputStack,null)),_react2.default.createElement('div',{className:_index4.default.nearestQueue},_react2.default.createElement(CompositionFormation,null))),_react2.default.createElement('div',{className:_index2.default.queueBubbles},_react2.default.createElement(_index5.Bubbles,{culture:_index6.shipment.getLineStatus})),_react2.default.createElement('div',{className:_index4.default.outputLine+' '+_index4.default[_index6.shipment.getLineStatus]}))));}}]);return OutputFlow;}(_react.Component))||_class;exports.default=OutputFlow;var OutputStack=(0,_mobxReact.observer)(_class3=function(_Component2){_inherits(OutputStack,_Component2);function OutputStack(){_classCallCheck(this,OutputStack);return _possibleConstructorReturn(this,(OutputStack.__proto__||Object.getPrototypeOf(OutputStack)).apply(this,arguments));}_createClass(OutputStack,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index4.default.outputStackContainer},_index6.shipment.outputTransport.map(function(item,i){return _react2.default.createElement(OutputTransport,Object.assign({},item,{key:i}));}));}}]);return OutputStack;}(_react.Component))||_class3;var OutputTransport=function OutputTransport(props){return _react2.default.createElement('div',{className:_index4.default.transportElement},_react2.default.createElement('div',null,props.type==='train'?_react2.default.createElement(_index5.RailCart,{item:{moistureLevel:props.moistureLevel,wasteLevel:props.wasteLevel,culture:props.culture,groupQuantity:props.quantity,amount:0}}):props.type==='truck'?_react2.default.createElement(_index5.Truck,{item:{moistureLevel:props.moistureLevel,wasteLevel:props.wasteLevel,culture:props.culture,groupQuantity:props.quantity,amount:0}}):null),_react2.default.createElement('div',{className:_index4.default.description},_react2.default.createElement('div',null,_react2.default.createElement('span',null,'\u041F\u0440\u0438\u0431\u044B\u0442\u0438\u0435:'),' ',_react2.default.createElement('span',null,props.dateIncome.toLocaleDateString('ru',{year:'numeric',month:'numeric',day:'numeric'}))),_react2.default.createElement('div',null,_react2.default.createElement('span',null,'\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430:'),' ',_react2.default.createElement('span',null,props.endDate.toLocaleDateString('ru',{year:'numeric',month:'numeric',day:'numeric'})))));};var CompositionFormation=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(CompositionFormation,_Component3);function CompositionFormation(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,CompositionFormation);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=CompositionFormation.__proto__||Object.getPrototypeOf(CompositionFormation)).call.apply(_ref2,[this].concat(args))),_this3),_this3.state={selectedCrop:0},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(CompositionFormation,[{key:'setCrop',value:function setCrop(id){this.setState({selectedCrop:id});}},{key:'render',value:function render(){var _this4=this;var culture=['wheat','rape','soy','sunflower','corn'];return _react2.default.createElement('div',{className:_index4.default.compositionFormation},_react2.default.createElement('div',null,_react2.default.createElement('div',{className:_index4.default.columnCrops},_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.wheat+(this.state.selectedCrop===0?' '+_index4.default.selected:''),onClick:function onClick(){_this4.setCrop(0);}},_react2.default.createElement('i',{className:_iconfonts2.default.wheat})),_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.rape+(this.state.selectedCrop===1?' '+_index4.default.selected:''),onClick:function onClick(){_this4.setCrop(1);}},_react2.default.createElement('i',{className:_iconfonts2.default.rape})),_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.soy+(this.state.selectedCrop===2?' '+_index4.default.selected:''),onClick:function onClick(){_this4.setCrop(2);}},_react2.default.createElement('i',{className:_iconfonts2.default.soy})),_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.sunflower+(this.state.selectedCrop===3?' '+_index4.default.selected:''),onClick:function onClick(){_this4.setCrop(3);}},_react2.default.createElement('i',{className:_iconfonts2.default.sunflower})),_react2.default.createElement('div',{className:_index4.default.cultureCircle+' '+_index4.default.corn+(this.state.selectedCrop===4?' '+_index4.default.selected:''),onClick:function onClick(){_this4.setCrop(4);}},_react2.default.createElement('i',{className:_iconfonts2.default.corn})))),_react2.default.createElement('div',{className:_index6.date.compositionFormation?_index4.default.messageActive:_index4.default.message},'\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u043C\u0438 \u0441\u043E\u0441\u0442\u0430\u0432 \u043F\u0440\u0438\u0431\u0443\u0434\u0435\u0442 \u0443\u0436\u0435 \u0437\u0430\u0432\u0442\u0440\u0430, \u0434\u043E\u0436\u0434\u0438\u0442\u0435\u0441\u044C \u0435\u0433\u043E \u043F\u0440\u0438\u0431\u044B\u0442\u0438\u044F!!'),_react2.default.createElement('div',{className:_index4.default.buttonContainer},_react2.default.createElement('div',{className:_index4.default.menuButton+(!_index6.date.compositionFormation?' '+_index4.default.active:''),onClick:function onClick(){_index6.date.setCompositionFormation(culture[_this4.state.selectedCrop]);}},'\u0421\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u043E\u0441\u0442\u0430\u0432')));}}]);return CompositionFormation;}(_react.Component))||_class4;module.exports=exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bunkerContainer":"_2dRNUglh65McINF_GltUky","queues":"_13dJA_Tx3KQpuNeCFRvrAP","bulkQueue":"_1Wt5dP0KA3OLiZqODfM_2s","nearestQueue":"_2dYZJQwrA-b-1ZuPnnt89n","menuButton":"_3TQXN1KpBMxC8sEP_Onv1v","compositionFormation":"_2mmDdR3uGmKRt_ZBbBqbMC","columnCrops":"_3woF1jeto5GK-qbOSQ9sfs","cultureCircle":"_3DNNUJ74-0b-FnXHVblghf","selected":"_18twINBdMA4hR8eScpflhY","indicatorCircle":"_1PhcognEZF-YhN2FhCzal1","wheat":"Vwhon2KLrydE-wJ8h4LWT","rape":"VQ2zhBoUwIYmC2RwzhXxQ","soy":"_25-9nnubLy7hqYmwx624P6","corn":"_2mAzP8serioIhM2IrL5pVm","sunflower":"_1eW9ior-QlZcqZtOmFEWgD","noBorder":"_2YZgEFG4tRcCqLm5_2ZGcc","message":"qnp1aoPFjatrRTlzBSX6X","outputStackContainer":"Ey-gJeGf6c8jzX4DVPKKo","description":"_1ktKcfJI8tNPjlGwR_HTmM","transportElement":"_28Env0ODc2C9cpGiAI5KGB","messageActive":"_3A-r4gRxZpaYVZj-RiQFQ6","buttonContainer":"_3EGbbN7_37yu56Xf3ZX04L","active":"_27GUL71Qs48_L2mNM-EyXv","outputLine":"_1eMlM7QHetXquoo2fmOX0c","None":"_1I2Qzuy8QvL1z4YR2OPglj","clogged":"_1z1lBP_cd5Bu0vtG62xwFx","bunkerRow":"_3ZwF6cPBqd8quiFr18QUJB","truckRailCartHolder":"_10uH49-RAPWuYAiA8breSb"};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(207);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _mobxReact=__webpack_require__(2);var _stores=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Requests=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Requests,_Component);function Requests(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Requests);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Requests.__proto__||Object.getPrototypeOf(Requests)).call.apply(_ref,[this].concat(args))),_this),_this.state={tabs:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Requests,[{key:'setTabs',value:function setTabs(id){this.setState({tabs:id});}},{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:_index2.default.requestTab},_react2.default.createElement('div',{className:_index2.default.requestLists},_react2.default.createElement('div',{className:_index2.default.button+(this.state.tabs===0?' '+_index2.default.active:''),onClick:function onClick(){return _this2.setTabs(0);}},'\u041D\u043E\u0432\u0456 \u0437\u0430\u043F\u0438\u0442\u0438'),_react2.default.createElement('div',{className:_index2.default.button+(this.state.tabs===1?' '+_index2.default.active:''),onClick:function onClick(){return _this2.setTabs(1);}},'\u0412 \u0440\u043E\u0431\u043E\u0442\u0456'),_react2.default.createElement('div',{className:_index2.default.button+(this.state.tabs===2?' '+_index2.default.active:''),onClick:function onClick(){return _this2.setTabs(2);}},'\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0437\u0430\u043F\u0438\u0442\u0456\u0432')),this.state.tabs===0&&_react2.default.createElement('div',{className:_index2.default.tableContainer},_react2.default.createElement('table',{className:_index2.default.tableHeading},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430\xA0\xA0\xA0'),_react2.default.createElement('th',null,'\u041D\u0430 \u0434\u0430\u0442\u0443\xA0\xA0\xA0'),_react2.default.createElement('th',null,'\u0422\u0438\u043F\xA0\xA0\xA0'),_react2.default.createElement('th',null,'\u041E\u0431\'\u0454\u043C (\u0442.)\xA0\xA0\xA0'),_react2.default.createElement('th',null,'\u0412\u043E\u043B\u043E\u0433\u0456\u0441\u0442\u044C (%)'),_react2.default.createElement('th',null,'\u0417\u0430\u0441\u043C\u0456\u0447\u0435\u043D\u0456\u0441\u0442\u044C (%)'),_react2.default.createElement('th',null)))),_react2.default.createElement('div',{className:_index2.default.tableScrollable},_react2.default.createElement('table',null,_react2.default.createElement('tbody',null,_stores.offers.offers.map(function(item,i){return item.status==='new'?_react2.default.createElement(RequestRow,Object.assign({},item,{num:i,key:i})):null;}))))),this.state.tabs===1&&_react2.default.createElement('div',{className:_index2.default.tableContainer},_react2.default.createElement('table',{className:_index2.default.tableHeading},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430\xA0\xA0\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'sort-down'})),_react2.default.createElement('th',null,'\u041D\u0430 \u0434\u0430\u0442\u0443\xA0\xA0\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'sort-up'})),_react2.default.createElement('th',null,'\u0422\u0438\u043F\xA0\xA0\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'sort-down'})),_react2.default.createElement('th',null,'\u041E\u0431\'\u0454\u043C (\u0442.)\xA0\xA0\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'sort-down'})),_react2.default.createElement('th',null,'\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C (\u0442.)'),_react2.default.createElement('th',null,'\u0412\u043E\u043B\u043E\u0433\u0456\u0441\u0442\u044C (%)'),_react2.default.createElement('th',{style:{width:"10%"}},'\u0417\u0430\u0441\u043C\u0456\u0447\u0435\u043D\u0456\u0441\u0442\u044C (%)'),_react2.default.createElement('th',null)))),_react2.default.createElement('div',{className:_index2.default.tableScrollable},_react2.default.createElement('table',null,_react2.default.createElement('tbody',null,_stores.offers.offers.filter(function(item){return item.status==="inprogress";}).map(function(item,i){return _react2.default.createElement(RequestRow,Object.assign({},item,{num:i,key:i}));}))))),this.state.tabs===2&&_react2.default.createElement('div',{className:_index2.default.tableContainer},_react2.default.createElement('table',{className:_index2.default.tableHeading},_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430\xA0\xA0\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'sort-down'})),_react2.default.createElement('th',null,'\u041D\u0430 \u0434\u0430\u0442\u0443\xA0\xA0\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'sort-up'})),_react2.default.createElement('th',null,'\u0422\u0438\u043F\xA0\xA0\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'sort-down'})),_react2.default.createElement('th',null,'\u041E\u0431\'\u0454\u043C (\u0442.)\xA0\xA0\xA0',_react2.default.createElement(_reactFontawesome2.default,{name:'sort-down'})),_react2.default.createElement('th',null,'\u0412\u043E\u043B\u043E\u0433\u0456\u0441\u0442\u044C (%)'),_react2.default.createElement('th',null,'\u0417\u0430\u0441\u043C\u0456\u0447\u0435\u043D\u0456\u0441\u0442\u044C (%)'),_react2.default.createElement('th',null)))),_react2.default.createElement('div',{className:_index2.default.tableScrollable},_react2.default.createElement('table',null,_react2.default.createElement('tbody',null,_stores.offers.offers.filter(function(item){return item.status==="failed"||item.status==="success";}).map(function(item,i){return _react2.default.createElement(RequestRow,Object.assign({},item,{num:i,key:i}));}))))));}}]);return Requests;}(_react.Component))||_class;exports.default=Requests;var RequestRow=function RequestRow(props){var cultureName="Пшениця";switch(props.culture){case"wheat":cultureName="Пшениця";break;case"rape":cultureName="Рапс";break;case"soy":cultureName="Соя";break;case"sunflower":cultureName="Соняшник";break;case"corn":cultureName="Кукурудза";break;default:console.log("чё?");}var type="Приймання";switch(props.type){case"truck":type="Вантажівка";break;case"train":type="Потяг";break;default:type="";}return _react2.default.createElement('tr',null,_react2.default.createElement('td',null,_react2.default.createElement('div',{className:_index2.default.culture},_react2.default.createElement('div',{className:_index2.default.cultureIcon+' '+_index2.default[props.culture]},_react2.default.createElement('i',{className:_iconfonts2.default[props.culture]})),_react2.default.createElement('div',{className:_index2.default.cultureName},cultureName))),_react2.default.createElement('td',null,props.date.toLocaleDateString('ru',{year:'numeric',month:'numeric',day:'numeric'})),_react2.default.createElement('td',null,type),_react2.default.createElement('td',null,props.amount),props.status==='inprogress'&&_react2.default.createElement('td',null,Math.floor(props.rem)),_react2.default.createElement('td',null,props.moisture),_react2.default.createElement('td',{style:{width:'10%'}},props.waste),_react2.default.createElement('td',null,props.status==='success'&&_react2.default.createElement('div',{className:_index2.default.success},'\u0417\u0430\u043F\u0438\u0442 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E'),props.status==='failed'&&_react2.default.createElement('div',{className:_index2.default.failed},'\u0417\u0430\u043F\u0438\u0442 \u043D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E'),props.status==='inprogress'&&_react2.default.createElement('div',null,'\u0417\u0430\u043F\u0438\u0442 \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0456 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F'),props.status==='new'&&_react2.default.createElement('div',null,_react2.default.createElement('div',{onClick:function onClick(){_stores.offers.offers[props.num].setStatus('failed');},className:_index2.default.button},'\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438'),_react2.default.createElement('div',{className:_index2.default.button+' '+_index2.default.active,onClick:function onClick(){_stores.offers.offers[props.num].setStatus('inprogress',props.type,props.date,props.culture,props.amount,props.moisture,props.waste);}},'\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0438'))));};module.exports=exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"requestTab":"_1vKuYERUT-Kkoduc__bQK0","requestLists":"NYZFHwdtC2oTbHoewNNZv","button":"rOreJ7gHd7RfV7ZiOrinm","active":"_16zo0TOnqtvRFZlaKbling","inactive":"_35CAzHTCPeexCzeRbfFeqk","tableContainer":"_2qSzMiDcYCJsRBd-3_EZOp","tableScrollable":"_3HQgujX90rLk4ZaqIiVN6b","tableHeading":"Q8fo3qWDqeNYNh5g7YLix","culture":"OySBuKLSUsK6_c_F3Lfxn","cultureIcon":"_3CRLcEMUP680_P1TxUO_lH","wheat":"EzpEDcNb7aQya99f59PUm","rape":"_2PuFrNrkrww17iougSA8W1","corn":"J1dJgkb6KTSBMtd_seGxR","soy":"JxEZ_HIq3ZyE211wOQJNV","sunflower":"_37zg0YD8pi3AydlOs4wpkt","failed":"_1rZHFIeIyULYewFJcDmk_","success":"_2egaLl5eZv5PhWN-MqklJN"};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(14);var _index2=_interopRequireDefault(_index);var _mobxReact=__webpack_require__(2);var _onHoverDescription=__webpack_require__(209);var _onHoverDescription2=_interopRequireDefault(_onHoverDescription);var _PathPopupButtons=__webpack_require__(210);var _PathPopupButtons2=_interopRequireDefault(_PathPopupButtons);var _PathPopupTabs=__webpack_require__(211);var _PathPopupTabs2=_interopRequireDefault(_PathPopupTabs);var _PathPopupBody=__webpack_require__(213);var _PathPopupBody2=_interopRequireDefault(_PathPopupBody);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PathPopup=(0,_mobxReact.observer)(_class=function(_Component){_inherits(PathPopup,_Component);function PathPopup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PathPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PathPopup.__proto__||Object.getPrototypeOf(PathPopup)).call.apply(_ref,[this].concat(args))),_this),_this.state={hoverItem:false,hoverId:0,hoverBody:true,drop:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PathPopup,[{key:'setDrop',value:function setDrop(drop){this.setState({drop:drop});}},{key:'setHoverElement',value:function setHoverElement(hoverItem,hoverId,hoveredDom){this.setState({hoverItem:hoverItem,hoverId:hoverId,hoveredDom:hoveredDom});}},{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index2.default.cover},_react2.default.createElement('div',{className:_index2.default.body},_react2.default.createElement('div',{className:_index2.default.descriptionPathBody},_react2.default.createElement('div',null,_react2.default.createElement(_onHoverDescription2.default,{container:this.state.hoverItem})),_react2.default.createElement(_PathPopupBody2.default,Object.assign({},this.state,{setHoverElement:this.setHoverElement.bind(this)}))),_react2.default.createElement('div',{className:_index2.default.bordur}),_react2.default.createElement(_PathPopupTabs2.default,Object.assign({setDrop:this.setDrop.bind(this),onMouseOver:this.setHoverElement.bind(this),setHoverElement:this.setHoverElement.bind(this)},this.state)),_react2.default.createElement(_PathPopupButtons2.default,null)));}}]);return PathPopup;}(_react.Component))||_class;exports.default=PathPopup;module.exports=exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _index=__webpack_require__(14);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var OnHoverDescription=function OnHoverDescription(props){var container=props.container;return _react2.default.createElement("div",{className:_index2.default.description},_react2.default.createElement("h3",null,"\u0421\u0444\u043E\u0440\u043C\u0443\u0432\u0430\u0442\u0438 \u0441\u0446\u0435\u043D\u0430\u0440\u0456\u0439"),props.container?_react2.default.createElement("div",null,_react2.default.createElement("div",{className:_index2.default.cultureIcon},_react2.default.createElement("i",{className:_iconfonts2.default[container.culture]})),_react2.default.createElement("h3",null,container.name),_react2.default.createElement("div",{className:_index2.default.groupData},"\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430: ",container.culture," ",_react2.default.createElement("br",null),(container.type==='silo'||container.type==='bunker'||container.type==='hopper'||container.type==='output')&&_react2.default.createElement("div",null,"\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0432\u0430\u0433\u0430: ",container.amount.toFixed(1)," \u0442\u043E\u043D",_react2.default.createElement("br",null)),"\u0421\u043C\u0456\u0442\u043D\u0456\u0441\u0442\u044C: ",Math.round(container.wasteLevel*10)/10,"%",_react2.default.createElement("br",null),"\u0412\u043E\u043B\u043E\u0433\u0456\u0441\u0442\u044C: ",Math.round(container.moistureLevel*10)/10,"%",_react2.default.createElement("br",null),container.errorStatus?"Помилка: "+container.errorStatus:'')):null);};exports.default=OnHoverDescription;module.exports=exports["default"];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _index=__webpack_require__(14);var _index2=_interopRequireDefault(_index);var _stores=__webpack_require__(1);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PathPopupButtons=(0,_mobxReact.observer)(_class=function(_Component){_inherits(PathPopupButtons,_Component);function PathPopupButtons(){_classCallCheck(this,PathPopupButtons);return _possibleConstructorReturn(this,(PathPopupButtons.__proto__||Object.getPrototypeOf(PathPopupButtons)).apply(this,arguments));}_createClass(PathPopupButtons,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:_index2.default.pathButtons},_react2.default.createElement("div",{className:_index2.default.button+' '+(_stores.scenario.script.length?_index2.default.disabled:_index2.default.inactive),onClick:function onClick(){_stores.scenario.setDefaultScript();}},"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0441\u0446\u0435\u043D\u0430\u0440\u0456\u0439"),_react2.default.createElement("div",{className:_index2.default.button+' '+_index2.default.disabled,onClick:function onClick(){_stores.scenario.closePathPopup();}},"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"),_react2.default.createElement("div",{className:_index2.default.button+(_stores.scenario.getIsActiveSetScenarioButton?'':" "+_index2.default.inactive),onClick:function onClick(){_stores.scenario.setScenario();}},"\u0437\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438"));}}]);return PathPopupButtons;}(_react.Component))||_class;;exports.default=PathPopupButtons;module.exports=exports["default"];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(14);var _index2=_interopRequireDefault(_index);var _mobxReact=__webpack_require__(2);var _TabListElement=__webpack_require__(212);var _TabListElement2=_interopRequireDefault(_TabListElement);var _stores=__webpack_require__(1);var _SubComponents=__webpack_require__(7);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PathPopupTabs=(0,_mobxReact.observer)(_class=function(_Component){_inherits(PathPopupTabs,_Component);function PathPopupTabs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PathPopupTabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PathPopupTabs.__proto__||Object.getPrototypeOf(PathPopupTabs)).call.apply(_ref,[this].concat(args))),_this),_this.state={tab:0},_this.itemList=[{name:"Хоппера",data:_stores.storageStore.hoppersList,endItem:false,unit:_SubComponents.Hopper},{name:"Сушка",data:_stores.dcUnitsStore.dryingList,endItem:false,unit:_SubComponents.DryingCleaningUnit},{name:"Чистка",data:_stores.dcUnitsStore.cleaningList,endItem:false,unit:_SubComponents.DryingCleaningUnit},{name:"Хранение",data:_stores.storageStore.silosList,endItem:true,unit:_SubComponents.Silo},{name:"Отгрузка",data:_stores.shipment.shipmentBunker,endItem:true,unit:_SubComponents.Bunker}],_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PathPopupTabs,[{key:'setTab',value:function setTab(id){this.setState({tab:id});}},{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:_index2.default.tabs},this.itemList.map(function(item,i){return _react2.default.createElement('div',{className:_this2.state.tab===i?_index2.default.activeTab:"",onClick:_this2.setTab.bind(_this2,i),key:i},item.name);})),_react2.default.createElement('div',{className:_index2.default.dragContainer},this.itemList[this.state.tab].data.filter(function(item){return!_stores.scenario.script.find(function(elem){return elem.num===item.num&&elem.type===item.type;});}).map(function(item,i){return _react2.default.createElement(_TabListElement2.default,{setDrop:_this2.props.setDrop.bind(_this2,item),DomElement:_this2.itemList[_this2.state.tab].unit,item:item,id:i,hoverElementCheck:{tabs:_this2.props.hoveredDom,id:_this2.props.hoverId},onMouseOver:_this2.props.setHoverElement.bind(_this2,item,i,'tabs'),key:i});})));}}]);return PathPopupTabs;}(_react.Component))||_class;exports.default=PathPopupTabs;module.exports=exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(14);var _index2=_interopRequireDefault(_index);var _mobxReact=__webpack_require__(2);var _Drag=__webpack_require__(62);var _Drag2=_interopRequireDefault(_Drag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TabListElement=(0,_mobxReact.observer)(_class=function(_Component){_inherits(TabListElement,_Component);function TabListElement(){_classCallCheck(this,TabListElement);return _possibleConstructorReturn(this,(TabListElement.__proto__||Object.getPrototypeOf(TabListElement)).apply(this,arguments));}_createClass(TabListElement,[{key:"render",value:function render(){var DomElement=this.props.DomElement;var item=this.props.item;var hoverElementCheck=this.props.hoverElementCheck;return _react2.default.createElement("div",{className:_index2.default.footerDND},_react2.default.createElement(_Drag2.default,{onDrag:this.props.setDrop,type:(item.type!=='output'?"intermediate":"endElement")+(item.type==='silo'||item.type==='hopper'?",endElement":''),maskClassName:_index2.default.mask,onMouseOver:this.props.onMouseOver.bind(this)},_react2.default.createElement("div",{className:_index2.default.actionCircle+(hoverElementCheck.tabs==="tabs"&&hoverElementCheck.id===this.props.id?" "+_index2.default.currentItem:'')},item.type==='output'||item.type==='silo'?_react2.default.createElement(DomElement,{item:item,inPath:true}):_react2.default.createElement("div",{className:_index2.default.actionDCContainer},_react2.default.createElement(DomElement,{item:item,inPath:true})))),_react2.default.createElement("div",{className:_index2.default.dragDesciption},"\u2116",item.num+1,_react2.default.createElement("br",null),item.name,_react2.default.createElement("br",null),item.totalCapacity?item.totalCapacity+'т':''));}}]);return TabListElement;}(_react.Component))||_class;exports.default=TabListElement;module.exports=exports["default"];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _mobxReact=__webpack_require__(2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(14);var _index2=_interopRequireDefault(_index);var _stores=__webpack_require__(1);var _PathPopupUnit=__webpack_require__(214);var _PathPopupUnit2=_interopRequireDefault(_PathPopupUnit);var _DragNDrop=__webpack_require__(37);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PathBody=(0,_mobxReact.observer)(_class=function(_Component){_inherits(PathBody,_Component);function PathBody(){_classCallCheck(this,PathBody);return _possibleConstructorReturn(this,(PathBody.__proto__||Object.getPrototypeOf(PathBody)).apply(this,arguments));}_createClass(PathBody,[{key:"render",value:function render(){var _this2=this;return _react2.default.createElement("div",{className:_index2.default.pathBody},_react2.default.createElement("div",{className:_index2.default.scrollablePath},_stores.scenario.script.map(function(item,i){return _react2.default.createElement("div",{className:_index2.default.itemContainer,key:i},_react2.default.createElement(_PathPopupUnit2.default,Object.assign({},item,{id:i,drop:_this2.props.drop,onMouseOver:function onMouseOver(){_this2.props.setHoverElement(item,i,'path');},active:_this2.props.hoveredDom==='path'&&_this2.props.hoverId===i})),_react2.default.createElement("div",{className:_index2.default.dropDownContainer,style:{display:i===_stores.scenario.script.length-1?"none":''}},_react2.default.createElement(_DragNDrop.Drop,{className:_index2.default.dropfield,id:i,onDrop:function onDrop(){_stores.scenario.addScriptElem(_this2.props.drop,i);},type:"intermediate"},_react2.default.createElement("div",{className:_index2.default.dropPlace})),_react2.default.createElement("div",{className:_index2.default.pathPlus+' '+_index2.default.pathBodyElement},"+")));})));}}]);return PathBody;}(_react.Component))||_class;exports.default=PathBody;module.exports=exports["default"];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(14);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _mobxReact=__webpack_require__(2);var _index3=__webpack_require__(7);var _index4=__webpack_require__(1);var _Drop=__webpack_require__(63);var _Drop2=_interopRequireDefault(_Drop);var _Hopper=__webpack_require__(61);var _Hopper2=_interopRequireDefault(_Hopper);var _Silo=__webpack_require__(60);var _Silo2=_interopRequireDefault(_Silo);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PathPopupUnit=(0,_mobxReact.observer)(_class=function(_Component){_inherits(PathPopupUnit,_Component);function PathPopupUnit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PathPopupUnit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PathPopupUnit.__proto__||Object.getPrototypeOf(PathPopupUnit)).call.apply(_ref,[this].concat(args))),_this),_this.objectName={'bunker':{name:"ПРИЙОМКА",domElement:_index3.Bunker,icon:_iconfonts2.default.iconInput},'hopper':{name:"ХОППЕР",domElement:_Hopper2.default,icon:_iconfonts2.default.iconStoring},'cleaning':{name:"ОЧИСТКА",domElement:_index3.DryingCleaningUnit,icon:_iconfonts2.default.iconCleaning},'drying':{name:"СУШКА",domElement:_index3.DryingCleaningUnit,icon:_iconfonts2.default.iconDrying},'silo':{name:"ЗБЕРІГАННЯ",domElement:_Silo2.default,icon:_iconfonts2.default.iconStoring},'output':{name:"ВИГРУЗКА",domElement:_index3.Bunker,icon:_iconfonts2.default.iconOutput},'default':{name:"Оберіть кінцевий елемент",domElement:EmptyData,data:'',icon:_iconfonts2.default.iconInput}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PathPopupUnit,[{key:'setItem',value:function setItem(id){_index4.scenario.script[this.props.i].elem=id;this.setState({active:false});}},{key:'render',value:function render(){var _this2=this;var type=this.props.type;var DomElement=this.objectName[type].domElement;return _react2.default.createElement('div',{className:(type==='cleaning'||type==='drying'||type==='hopper'?_index2.default.pathItem:_index2.default.startFinishItem)+' '+_index2.default.pathBodyElement},_react2.default.createElement('h4',null,this.objectName[type].name),_react2.default.createElement('div',{className:_index2.default.actionIcon},_react2.default.createElement('i',{className:this.objectName[type].icon})),_react2.default.createElement('div',{className:_index2.default.actionContainer,onMouseOver:type!=='default'?this.props.onMouseOver:null},_react2.default.createElement('div',{className:_index2.default.actionCircle+(this.props.active?" "+_index2.default.currentItem:"")},_react2.default.createElement('div',{className:type==='cleaning'||type==='drying'||type==='hopper'?_index2.default.actionDCContainer:''},_react2.default.createElement(DomElement,{drop:this.props.drop,item:this.props,inPath:true})),type!=="bunker"&&type!=="default"?_react2.default.createElement('div',{className:_index2.default.actionDismiss,onClick:function onClick(){_index4.scenario.deleteElementFromScript(_this2.props.id);}},'\xD7'):null)),_react2.default.createElement('div',{className:_index2.default.pathItemDefinition},this.props.num+1?"№"+(this.props.num+1):"",_react2.default.createElement('br',null),this.props.name,_react2.default.createElement('br',null),this.props.totalCapacity&&this.props.type!=='bunker'?this.props.totalCapacity+'т':''));}}]);return PathPopupUnit;}(_react.Component))||_class;exports.default=PathPopupUnit;var EmptyData=function EmptyData(props){return _react2.default.createElement('div',{className:_index2.default.actionCircle},_react2.default.createElement(_Drop2.default,{className:_index2.default.dropfield,onDrop:function onDrop(){_index4.scenario.setLastElem(props.drop);},type:"endElement"}),_react2.default.createElement('div',{className:_index2.default.pathEndPlus},'+'));};module.exports=exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class3,_class4,_temp2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(216);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _mobxReact=__webpack_require__(2);var _index3=__webpack_require__(1);var _cultureSettings=__webpack_require__(6);var _cultureSettings2=_interopRequireDefault(_cultureSettings);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Plan=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Plan,_Component);function Plan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Plan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Plan.__proto__||Object.getPrototypeOf(Plan)).call.apply(_ref,[this].concat(args))),_this),_this.cultures=['wheat','rape','soy','sunflower','corn'],_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Plan,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index2.default.planTab},_react2.default.createElement('div',{className:_index2.default.inputTab},_react2.default.createElement('h3',null,'\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F'),_react2.default.createElement('div',{className:_index2.default.planTable},_react2.default.createElement('div',{className:_index2.default.planRow},_react2.default.createElement('div',{className:_index2.default.planCulture},'\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430'),_react2.default.createElement('div',{className:_index2.default.planDay},'\u0414\u0435\u043D\u044C'),_react2.default.createElement('div',{className:_index2.default.planWeek},'\u0422\u0438\u0436\u0434\u0435\u043D\u044C'),_react2.default.createElement('div',{className:_index2.default.planMonth},'\u041C\u0456\u0441\u044F\u0446\u044C'),_react2.default.createElement('div',{className:_index2.default.planSeason},'\u0421\u0435\u0437\u043E\u043D (\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C / \u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E)')),this.cultures.map(function(item,i){return _react2.default.createElement(PlanRow,{culture:item,key:i,day:Math.round(_index3.cropPlan.dayPlan[item]),week:Math.round(_index3.cropPlan.weekPlan[item]),month:Math.round(_index3.cropPlan.monthPlan[item]),remainder:Math.floor(_index3.cropPlan.currentWeight[item]),total:Math.floor(_index3.cropPlan.totalWeight[item])});}))),_react2.default.createElement('div',{className:_index2.default.outputTab},_react2.default.createElement('h3',null,'\u0412\u0438\u0433\u0440\u0443\u0437\u043A\u0430'),_react2.default.createElement('div',{className:_index2.default.planTable},_react2.default.createElement('div',{className:_index2.default.planRow},_react2.default.createElement('div',{className:_index2.default.planCulture},'\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430'),_react2.default.createElement('div',{className:_index2.default.planDay},'\u0414\u0435\u043D\u044C'),_react2.default.createElement('div',{className:_index2.default.planWeek},'\u0422\u0438\u0436\u0434\u0435\u043D\u044C'),_react2.default.createElement('div',{className:_index2.default.planMonth},'\u041C\u0456\u0441\u044F\u0446\u044C'),_react2.default.createElement('div',{className:_index2.default.planSeason},'\u0421\u0435\u0437\u043E\u043D (\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C)')),this.cultures.map(function(item,i){var transport=_index3.shipment.outputTransport.filter(function(transport){return transport.culture===item;});var day=transport.reduce(function(prev,current){if(current.endDate.getFullYear()===_index3.date.day.getFullYear()&&current.endDate.getMonth()===_index3.date.day.getMonth()&&current.endDate.getDate()===_index3.date.day.getDate()){return prev+current.quantity*(current.type==='truck'?20:60)*_cultureSettings2.default[item].volume;}return prev;},0);var dateWeek=new Date(_index3.date.day.getFullYear(),_index3.date.day.getMonth(),_index3.date.day.getDate()+7,0,0,0);var week=transport.reduce(function(prev,current){if(current.endDate<=dateWeek){return prev+current.quantity*(current.type==='truck'?20:60)*_cultureSettings2.default[item].volume;}return prev;},0);var dateMonth=new Date(_index3.date.day.getFullYear(),_index3.date.day.getMonth()+1,_index3.date.day.getDate(),0,0,0);var month=transport.reduce(function(prev,current){if(current.endDate<=dateMonth){return prev+current.quantity*(current.type==='truck'?20:60)*_cultureSettings2.default[item].volume;}return prev;},0);var total=transport.reduce(function(prev,current){return prev+current.quantity*(current.type==='truck'?20:60)*_cultureSettings2.default[item].volume;},0);return _react2.default.createElement(PlanRow,{culture:item,key:i,day:Math.round(day),week:Math.round(week),month:Math.round(month),remainder:'',total:Math.round(total)});}))));}}]);return Plan;}(_react.Component))||_class;exports.default=Plan;var PlanRow=(0,_mobxReact.observer)(_class3=(_temp2=_class4=function(_Component2){_inherits(PlanRow,_Component2);function PlanRow(){_classCallCheck(this,PlanRow);return _possibleConstructorReturn(this,(PlanRow.__proto__||Object.getPrototypeOf(PlanRow)).apply(this,arguments));}_createClass(PlanRow,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index2.default.planRow},_react2.default.createElement('div',{className:_index2.default.planCulture},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default[this.props.culture]},_react2.default.createElement('i',{className:_iconfonts2.default[this.props.culture]}))),_react2.default.createElement('div',{className:_index2.default.planDay},this.props.day,' \u0442.'),_react2.default.createElement('div',{className:_index2.default.planWeek},this.props.week,' \u0442.'),_react2.default.createElement('div',{className:_index2.default.planMonth},this.props.month,' \u0442.'),this.props.remainder!==''?_react2.default.createElement('div',{className:_index2.default.planSeasonLeft},_react2.default.createElement('strong',null,this.props.remainder,'\u0442.'),'\xA0\u0437\xA0'):_react2.default.createElement('div',{className:_index2.default.planSeasonLeft},this.props.total,' \u0442.'),_react2.default.createElement('div',{className:_index2.default.planSeasonPlanned},this.props.remainder!==''?this.props.total+' \u0442.':''));}}]);return PlanRow;}(_react.Component),_class4.defaultProps={day:0,week:0,month:0,remainder:0,total:0},_temp2))||_class3;module.exports=exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"planTab":"_2mNs086I_JvrwbTMknvalu","inputTab":"_2TlYUxr5Vr8w3hnInULoWn","outputTab":"_3Mt3Hfhra85iLhs5LcsYfD","planTable":"_3jb8lURbV3-WC8hwi19CSF","planRow":"_2BFjS04hubySceW1CMX1s_","planCulture":"a9VscTvHA3cRae6i_5o28","planDay":"_1FsYaGaZKmg1zq0uWFaBJi","planWeek":"_12zY_l0gg29fPq08R0nFg9","planMonth":"_2qdSI_-FYYH88K0nvmWjNp","planSeason":"NymxZ-yjYuV0t40ShW0RI","planSeasonLeft":"T3BGQowiX1BHU06xTnAhB","planSeasonPlanned":"_25eBkzykI47ZCWUGsBAvn-","cultureCircle":"ExFpyvK5HW_caVJox_e8u","wheat":"_3bhe0TM5HgDxKJ53AoHSJB","rape":"CJpNDrpo1fJ3Pa1Im0BTd","soy":"uU2_rE2VX7ThjWwr0SDIW","sunflower":"WXUOiIofr1fOUUFO2sd6t","corn":"_3kZkXr_a7nX4WCDHlOcLQ3"};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(218);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _index3=__webpack_require__(1);var _stores=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FinanceData=(0,_mobxReact.observer)(_class=function(_Component){_inherits(FinanceData,_Component);function FinanceData(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FinanceData);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FinanceData.__proto__||Object.getPrototypeOf(FinanceData)).call.apply(_ref,[this].concat(args))),_this),_this.state={stage:'input'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FinanceData,[{key:'getElementsData',value:function getElementsData(id){switch(id){case'input':return{title:"Приймання",icon:_iconfonts2.default.iconInput};case'drying':return{title:"Сушка",icon:_iconfonts2.default.iconDrying};case'cleaning':return{title:"Очищення",icon:_iconfonts2.default.iconCleaning};case'storage':return{title:"Зберігання",icon:_iconfonts2.default.iconStoring};case'output':return{title:"Вигрузка",icon:_iconfonts2.default.iconOutput};case'transhipment':return{title:"Перевалка",icon:_iconfonts2.default.iconTranshipment};default:break;}}},{key:'getElements',value:function getElements(){var _this2=this;var data=void 0,result=[];var _loop=function _loop(key){if(key==='docsFee')return'continue';data=_this2.getElementsData(key);result.push(_react2.default.createElement('div',{className:_index2.default.tabs+(_this2.state.stage===key?" "+_index2.default.active:''),onClick:function onClick(){_this2.setState({stage:key});},key:key},_react2.default.createElement('div',{className:_index2.default.definition},_react2.default.createElement('h4',null,data.title),_react2.default.createElement('div',{className:_index2.default.icon},_react2.default.createElement('i',{className:data.icon}))),_react2.default.createElement(DefinitionRow,null),_react2.default.createElement('div',null,_react2.default.createElement(FinResRow,Object.assign({},_index3.finance[key].wheat,{total:_index3.finance[key].total["wheat"]})),_react2.default.createElement(FinResRow,Object.assign({},_index3.finance[key].rape,{total:_index3.finance[key].total["rape"]})),_react2.default.createElement(FinResRow,Object.assign({},_index3.finance[key].soy,{total:_index3.finance[key].total["soy"]})),_react2.default.createElement(FinResRow,Object.assign({},_index3.finance[key].sunflower,{total:_index3.finance[key].total["sunflower"]})),_react2.default.createElement(FinResRow,Object.assign({},_index3.finance[key].corn,{total:_index3.finance[key].total["corn"]})),_react2.default.createElement(FinResTotalRow,{data:_index3.finance[key],total:_index3.finance[key].total["wheat"]+_index3.finance[key].total["rape"]+_index3.finance[key].total["soy"]+_index3.finance[key].total["sunflower"]+_index3.finance[key].total["corn"]}))));};for(var key in _index3.finance){var _ret2=_loop(key);if(_ret2==='continue')continue;}return result;}},{key:'render',value:function render(){var _this3=this;return _react2.default.createElement('div',{className:_index2.default.financeTab},_react2.default.createElement('div',{className:_index2.default.mainField},_react2.default.createElement('div',{className:_index2.default.tabCulture},_react2.default.createElement('div',{className:_index2.default.definition}),_react2.default.createElement('div',{className:_index2.default.definitionDetailed},'\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u0430'),_react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.wheat},_react2.default.createElement('i',{className:_iconfonts2.default.wheat}))),_react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.rape},_react2.default.createElement('i',{className:_iconfonts2.default.rape}))),_react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.soy},_react2.default.createElement('i',{className:_iconfonts2.default.soy}))),_react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.sunflower},_react2.default.createElement('i',{className:_iconfonts2.default.sunflower}))),_react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.corn},_react2.default.createElement('i',{className:_iconfonts2.default.corn}))),_react2.default.createElement('div',{className:_index2.default.row},'\u0412\u0441\u044C\u043E\u0433\u043E')),this.getElements(),_react2.default.createElement('div',{className:_index2.default.rowcTab+(this.state.stage==="total"?" "+_index2.default.active:''),onClick:function onClick(){return _this3.setState({stage:"total"});}},_react2.default.createElement('div',{className:_index2.default.definition},_react2.default.createElement('h4',null,'\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043A\u0430\u043F\u0456\u0442\u0430\u043B\u0443'),_react2.default.createElement('div',{className:_index2.default.icon},_react2.default.createElement('i',{className:_iconfonts2.default.iconRoce}))),_react2.default.createElement(DefinitionRow,null),_react2.default.createElement(CultureResultRow,{data:_index3.finance,culture:'wheat'}),_react2.default.createElement(CultureResultRow,{data:_index3.finance,culture:'rape'}),_react2.default.createElement(CultureResultRow,{data:_index3.finance,culture:'soy'}),_react2.default.createElement(CultureResultRow,{data:_index3.finance,culture:'sunflower'}),_react2.default.createElement(CultureResultRow,{data:_index3.finance,culture:'corn'}),_react2.default.createElement(FinResTotalRoceRow,{data:_index3.finance}))));}}]);return FinanceData;}(_react.Component))||_class;exports.default=FinanceData;var FinResRow=function FinResRow(props){return _react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.hiddenData},_react2.default.createElement('div',{className:_index2.default.cashYield},props.cashYield.toFixed(0)),_react2.default.createElement('div',{className:_index2.default.directExpends},props.directExpends.toFixed(0)),_react2.default.createElement('div',{className:_index2.default.revenue},(props.cashYield-props.directExpends).toFixed(0),' /\xA0',props.directExpends?((props.cashYield-props.directExpends)/props.directExpends*100).toFixed(0):0,'%'),_react2.default.createElement('div',{className:_index2.default.indirectExpends},props.indirectExpends.toFixed(0)),_react2.default.createElement('div',{className:_index2.default.ebitda},!props.total?0:((props.cashYield-props.directExpends-props.indirectExpends)/props.total).toFixed(2))),_react2.default.createElement('div',{className:_index2.default.roce},((props.cashYield-props.directExpends-props.indirectExpends)/_index3.score.total*100).toFixed(2),'%'));};var FinResTotalRow=function FinResTotalRow(props){var data=props.data;function sum(){var element=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return Object.keys(data).reduce(function(previousValue,currentValue){if(currentValue==='elem'||currentValue==='total')return previousValue;return previousValue+data[currentValue][element];},0);}return _react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.hiddenData},_react2.default.createElement('div',{className:_index2.default.cashYield},sum('cashYield').toFixed(0)),_react2.default.createElement('div',{className:_index2.default.directExpends},sum('directExpends').toFixed(0)),_react2.default.createElement('div',{className:_index2.default.revenue},(sum('cashYield')-sum('directExpends')).toFixed(0),' /\xA0',sum('directExpends')?((sum('cashYield')-sum('directExpends'))/sum('directExpends')*100).toFixed(0):0,'%'),_react2.default.createElement('div',{className:_index2.default.indirectExpends},sum('indirectExpends').toFixed(0)),_react2.default.createElement('div',{className:_index2.default.ebitda},!props.total?0:((sum('cashYield')-sum('directExpends')-sum('indirectExpends'))/props.total).toFixed(2),' \xA0')),_react2.default.createElement('div',{className:_index2.default.roce},((sum('cashYield')-sum('directExpends')-sum('indirectExpends'))/_index3.score.total*100).toFixed(2),'%'));};var FinResTotalRoceRow=function FinResTotalRoceRow(props){var data=props.data;function sum(){var element=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return Object.keys(data).reduce(function(previousValue,currentValue){var newData=data[currentValue];return previousValue+Object.keys(data[currentValue]).reduce(function(previousValue,currentValue){if(currentValue!=='elem'&&currentValue!=='total'){return previousValue+newData[currentValue][element];}return previousValue;},0);},0);}return _react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.hiddenData},_react2.default.createElement('div',{className:_index2.default.cashYield},sum('cashYield').toFixed(0)),_react2.default.createElement('div',{className:_index2.default.directExpends},sum('directExpends').toFixed(0)),_react2.default.createElement('div',{className:_index2.default.revenue},(sum('cashYield')-sum('directExpends')).toFixed(0),' /\xA0',sum('directExpends')?((sum('cashYield')-sum('directExpends'))/sum('directExpends')*100).toFixed(0):0,'%'),_react2.default.createElement('div',{className:_index2.default.indirectExpends},sum('indirectExpends').toFixed(0)),_react2.default.createElement('div',{className:_index2.default.ebitda},((sum('cashYield')-sum('directExpends')-sum('indirectExpends'))/(_stores.cropPlan.totalWeight['wheat']+_stores.cropPlan.totalWeight['rape']+_stores.cropPlan.totalWeight['soy']+_stores.cropPlan.totalWeight['sunflower']+_stores.cropPlan.totalWeight['corn']-(_stores.cropPlan.currentWeight['wheat']+_stores.cropPlan.currentWeight['rape']+_stores.cropPlan.currentWeight['soy']+_stores.cropPlan.currentWeight['sunflower']+_stores.cropPlan.currentWeight['corn']))).toFixed(2),' \xA0')),_react2.default.createElement('div',{className:_index2.default.roce},_react2.default.createElement('div',{className:_index2.default.roce},((sum('cashYield')-sum('directExpends')-sum('indirectExpends'))/_index3.score.total*100).toFixed(2),'%')));};var DefinitionRow=function DefinitionRow(){return _react2.default.createElement('div',{className:_index2.default.definitionDetailed},_react2.default.createElement('div',{className:_index2.default.hiddenDefinition},_react2.default.createElement('div',{className:_index2.default.cashYield},'\u0412\u0438\u0440\u0443\u0447\u043A\u0430 ($)'),_react2.default.createElement('div',{className:_index2.default.directExpends},'\u041F\u0440\u044F\u043C\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u0438 ($)'),_react2.default.createElement('div',{className:_index2.default.revenue},'\u041C\u0430\u0440\u0436\u0438\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434 ($ / %)'),_react2.default.createElement('div',{className:_index2.default.indirectExpends},'\u041D\u0435\u043F\u0440\u044F\u043C\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u0438 ($)'),_react2.default.createElement('div',{className:_index2.default.ebitda},'EBITDA ($ / \u0442)')),_react2.default.createElement('div',{className:_index2.default.roce},'ROCE (%)'));};var CultureResultRow=function CultureResultRow(props){var resultsObject=props.data;var cashYield=Object.keys(resultsObject).reduce(function(previousValue,currentValue){var newData=resultsObject[currentValue][props.culture];return previousValue+newData.cashYield;},0).toFixed(0);var directExpends=Object.keys(resultsObject).reduce(function(previousValue,currentValue){var newData=resultsObject[currentValue][props.culture];return previousValue+newData.directExpends;},0).toFixed(0);var indirectExpends=Object.keys(resultsObject).reduce(function(previousValue,currentValue){var newData=resultsObject[currentValue][props.culture];return previousValue+newData.indirectExpends;},0).toFixed(0);var total=Object.keys(resultsObject).reduce(function(previousValue,currentValue){return previousValue+resultsObject[currentValue].total[props.culture];},0);return _react2.default.createElement('div',{className:_index2.default.row},_react2.default.createElement('div',{className:_index2.default.hiddenData},_react2.default.createElement('div',{className:_index2.default.cashYield},cashYield),_react2.default.createElement('div',{className:_index2.default.directExpends},directExpends),_react2.default.createElement('div',{className:_index2.default.revenue},(cashYield-directExpends).toFixed(0),' /\xA0',+directExpends?((cashYield-directExpends)/directExpends*100).toFixed(0):0,'%'),_react2.default.createElement('div',{className:_index2.default.indirectExpends},indirectExpends),_react2.default.createElement('div',{className:_index2.default.ebitda},!+total?0:((cashYield-directExpends-indirectExpends)/(_stores.cropPlan.totalWeight[props.culture]-_stores.cropPlan.currentWeight[props.culture])).toFixed(2))),_react2.default.createElement('div',{className:_index2.default.roce},Object.keys(resultsObject).reduce(function(previousValue,currentValue){var newData=resultsObject[currentValue][props.culture];return previousValue+(newData.cashYield-newData.directExpends-newData.indirectExpends)/_index3.score.total*100;},0).toFixed(2),'%'));};module.exports=exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"financeTab":"_2TIYeEbpJWn9Q4lugoTaei","mainField":"sq6gZBIWQIOurHjMjrJLc","tabCulture":"_14aj0qc0ORKdAHZ2cEYA8g","tabs":"_2h8kEzvDzL95ElnqDmBa_1","rowcTab":"_2JZlV8pN7ZL8Sf7KOzwLRO","active":"z44mL6LRcdSWhcIO_G-4e","definitionDetailed":"HKOZkef9h_5XVwrly9yev","row":"_2cKpDuyCt5LckCcxndfqXs","icon":"qfPbGacF08jYW_nnCcbRS","definition":"KWbf_ZB1q8di3q8L44WjI","hiddenDefinition":"_2XB4eH38PT8obEPdPY1XQW","hiddenData":"_3bgT4YME6RDaoFWLks7nXa","cashYield":"_1cExCa52MXsuGzdH5LtxA9","directExpends":"_7OrGqz6HBCqZheT9htHcR","revenue":"_3adWb4Q2nArY59dRYpiXvf","indirectExpends":"_3AmIhud-QG5aO5OBlxjk5d","ebitda":"_1ry9zAaWmwt0pELgv7p7EJ","roce":"XTA6px99TXP1qxD2KNjQx","cultureCircle":"aATYVHC8fNJgOjuVlEuyR","wheat":"_3Dmgje2erXW30khy1EqNaC","rape":"_26robmB337X-sL_wHEeTCV","soy":"_6CAIG53sPaLrCI1Tg7ktL","sunflower":"_28OFLYyw9KWSZMLdyJn3fD","corn":"_1hwR8Nrd32iOGB6c12DnXj"};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(220);var _index2=_interopRequireDefault(_index);var _index3=__webpack_require__(50);var _index4=__webpack_require__(1);var _reactRouterDom=__webpack_require__(11);var _Results=__webpack_require__(221);var _Results2=_interopRequireDefault(_Results);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _stores=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Results=(0,_mobxReact.observer)(_class=function(_Component){_inherits(Results,_Component);function Results(){_classCallCheck(this,Results);return _possibleConstructorReturn(this,(Results.__proto__||Object.getPrototypeOf(Results)).apply(this,arguments));}_createClass(Results,[{key:'componentDidMount',value:function componentDidMount(){_index4.time.breaker();_index4.storageStore.silosList.forEach(function(item){if(item.amount>0&&item.culture!=="None"){_index4.finance.incParams('output',item.culture,item.amount);}});_index4.storageStore.hoppersList.forEach(function(item){if(item.amount>0&&item.culture!=="None"){_index4.finance.incParams('output',item.culture,item.amount);}});}},{key:'sum',value:function sum(){var element=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return Object.keys(_index4.finance).reduce(function(previousValue,currentValue){var newData=_index4.finance[currentValue];return previousValue+Object.keys(_index4.finance[currentValue]).reduce(function(previousValue,currentValue){if(currentValue!=='elem'&&currentValue!=='total'){return previousValue+newData[currentValue][element];}return previousValue;},0);},0);}},{key:'render',value:function render(){var total=0;var arr=["wheat","rape","soy","sunflower","corn"];arr.forEach(function(item){total+=Object.keys(_index4.finance).reduce(function(previousValue,currentValue){return previousValue+_index4.finance[currentValue].total[item];},0);});return _react2.default.createElement('div',{style:{display:"flex",flexDirection:"column",alignItems:"center",margin:"1rem 0 2rem"}},_react2.default.createElement('h1',null,'\u041A\u0456\u043D\u0435\u0446\u044C \u0441\u0435\u0441\u0456\u0457!'),_react2.default.createElement('div',{className:_index2.default.elevatorsScoreSettings},_react2.default.createElement('div',{className:_index2.default.column},_react2.default.createElement('h2',null,'\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0430: ',_index4.score.total,'$'),_react2.default.createElement('h2',null,'EBITDA:  ',(this.sum('cashYield')-this.sum('directExpends')-this.sum('indirectExpends')).toFixed(2),' $'),_react2.default.createElement('h2',null,'EBITDA ($/\u0442):  ',((this.sum('cashYield')-this.sum('directExpends')-this.sum('indirectExpends'))/(_stores.cropPlan.totalWeight['wheat']+_stores.cropPlan.totalWeight['rape']+_stores.cropPlan.totalWeight['soy']+_stores.cropPlan.totalWeight['sunflower']+_stores.cropPlan.totalWeight['corn']-(_stores.cropPlan.currentWeight['wheat']+_stores.cropPlan.currentWeight['rape']+_stores.cropPlan.currentWeight['soy']+_stores.cropPlan.currentWeight['sunflower']+_stores.cropPlan.currentWeight['corn']))).toFixed(2),' $/\u0442'),_react2.default.createElement('h2',null,'Roce ($/\u0442): ',((this.sum('cashYield')-this.sum('directExpends')-this.sum('indirectExpends'))/_index4.score.total*100).toFixed(2),' %')),_react2.default.createElement('div',{className:_index2.default.column},_react2.default.createElement('h2',null,'\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u0431\u0441\u044F\u0433 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F: ',(_stores.cropPlan.totalWeight['wheat']+_stores.cropPlan.totalWeight['rape']+_stores.cropPlan.totalWeight['soy']+_stores.cropPlan.totalWeight['sunflower']+_stores.cropPlan.totalWeight['corn']-(_stores.cropPlan.currentWeight['wheat']+_stores.cropPlan.currentWeight['rape']+_stores.cropPlan.currentWeight['soy']+_stores.cropPlan.currentWeight['sunflower']+_stores.cropPlan.currentWeight['corn'])).toFixed(1),' \u0442.'),_react2.default.createElement('h2',null,'\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043E\u0431\u0435\u0440\u0442\u0456\u0432: ',((_stores.cropPlan.totalWeight['wheat']+_stores.cropPlan.totalWeight['rape']+_stores.cropPlan.totalWeight['soy']+_stores.cropPlan.totalWeight['sunflower']+_stores.cropPlan.totalWeight['corn']-(_stores.cropPlan.currentWeight['wheat']+_stores.cropPlan.currentWeight['rape']+_stores.cropPlan.currentWeight['soy']+_stores.cropPlan.currentWeight['sunflower']+_stores.cropPlan.currentWeight['corn']))/_index4.storageStore.silosList.reduce(function(prev,curr){return prev+curr.totalCapacity;},0)).toFixed(1)),_react2.default.createElement('div',null,_react2.default.createElement('h2',null,'\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E:')),_react2.default.createElement('div',{style:{width:"35rem"}},_react2.default.createElement('div',{className:_index2.default.cropPlanCultures},_react2.default.createElement(CultureStats,{culture:'wheat',title:'\u041F\u0448\u0435\u043D\u0438\u0446\u044F'}),_react2.default.createElement(CultureStats,{culture:'rape',title:'\u0420\u0456\u043F\u0430\u043A'}),_react2.default.createElement(CultureStats,{culture:'soy',title:'\u0421\u043E\u044F'}),_react2.default.createElement(CultureStats,{culture:'sunflower',title:'\u0421\u043E\u043D\u044F\u0448\u043D\u0438\u043A'}),_react2.default.createElement(CultureStats,{culture:'corn',title:'\u041A\u0443\u043A\u0443\u0440\u0443\u0434\u0437\u0430'})))),_react2.default.createElement(_Results2.default,null)),_react2.default.createElement(_index3.FinanceData,null),_react2.default.createElement(_reactRouterDom.Link,{to:'/',className:_index2.default.menuButton+' '+_index2.default.active},'\u0412\u0438\u0439\u0442\u0438'));}}]);return Results;}(_react.Component))||_class;exports.default=Results;var CultureStats=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(CultureStats,_Component2);function CultureStats(){_classCallCheck(this,CultureStats);return _possibleConstructorReturn(this,(CultureStats.__proto__||Object.getPrototypeOf(CultureStats)).apply(this,arguments));}_createClass(CultureStats,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index2.default.cropPlanCulture},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default[this.props.culture]},_react2.default.createElement('i',{className:_iconfonts2.default[this.props.culture]})),_react2.default.createElement('h4',null,this.props.title),_react2.default.createElement('p',null,Math.floor(_stores.cropPlan.totalWeight[this.props.culture])-Math.floor(_stores.cropPlan.currentWeight[this.props.culture]),' \u0442.'));}}]);return CultureStats;}(_react.Component))||_class2;module.exports=exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"elevatorsScoreSettings":"_2q2k-vOH0X-jzo6Y7F6Ub7","column":"NYFVuQ9CYP48Xc6XSH1EK","menuButton":"_10NntwDPFPzovIrLoJF8Qm","active":"_2Seeb8jtkVh-4iFmKPNx99","cropPlanCultures":"_1YHt9ERcRE0AvRq6z4ltpp","cropPlanCulture":"j7-LyYHKd_xDpdVhEx6-s","cultureCircle":"_1mBDmiP7F0_B0iBtGTyHhW","wheat":"_3M866_FS1E16NNoFcoKFMA","culture":"_2bvh4YS6YzKnsxCJNgC5","rape":"_3eqDkcDeg9GIK_azu-MEnw","soy":"ljCAZ7AgRCo3ePghgdN1a","sunflower":"OY8dLXlNrH8zsMprMu9nj","corn":"_1oVWoU3nSvd9A-eC_rBJKn","cropPlanAdjust":"_1UBUkEHu5cooc6mlMOUgLf"};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(222);var _index2=__webpack_require__(223);var _index3=_interopRequireDefault(_index2);var _stores=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GameResults=(0,_index.observer)(_class=function(_Component){_inherits(GameResults,_Component);function GameResults(){_classCallCheck(this,GameResults);return _possibleConstructorReturn(this,(GameResults.__proto__||Object.getPrototypeOf(GameResults)).apply(this,arguments));}_createClass(GameResults,[{key:"render",value:function render(){return _react2.default.createElement("div",{className:_index3.default.equipResult},_react2.default.createElement("h3",null,"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0430:"),_react2.default.createElement("div",{className:_index3.default.scrollContainer},_react2.default.createElement("div",{className:_index3.default.scrollableCheck},_react2.default.createElement(SelectedEquipment,{arr:_stores.receptionBunkersStore.receptionBunker,title:"\u041B\u0456\u043D\u0456\u0457 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F"}),_react2.default.createElement(SelectedEquipment,{arr:_stores.dcUnitsStore.cleaningList,title:"\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043E\u0447\u0438\u0441\u0442\u043A\u0438"}),_react2.default.createElement(SelectedEquipment,{arr:_stores.dcUnitsStore.dryingList,title:"\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u0441\u0443\u0448\u043A\u0438"}),_react2.default.createElement(SelectedEquipment,{arr:_stores.storageStore.silosList.concat(_stores.storageStore.hoppersList),title:"\u041F\u043E\u0442\u0443\u0436\u043D\u043E\u0441\u0442\u0456 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F"}),_react2.default.createElement(SelectedEquipment,{arr:_stores.shipment.shipmentBunker,title:"\u041B\u0456\u043D\u0456\u0457 \u0432\u0456\u0434\u0433\u0440\u0443\u0437\u043A\u0438"}))));}}]);return GameResults;}(_react.Component))||_class;exports.default=GameResults;var SelectedEquipment=function SelectedEquipment(props){if(props.arr.length){var obj={};props.arr.forEach(function(item){if(!obj[item.name])obj[item.name]=0;obj[item.name]+=1;});return _react2.default.createElement("div",{className:_index3.default.equipResultSection},_react2.default.createElement("h4",null,props.title),Object.keys(obj).map(function(item,i){return _react2.default.createElement("div",{className:_index3.default.equipCheckItem,key:i},_react2.default.createElement("p",null,item),_react2.default.createElement("p",null,obj[item],"\u0448\u0442"));}));}return null;};module.exports=exports["default"];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports, __webpack_require__(3), __webpack_require__(0), __webpack_require__(32)) :
	typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
	(factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
}(this, (function (exports,mobx,React,reactDom) { 'use strict';

var React__default = 'default' in React ? React['default'] : React;

// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return mobx.untracked(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return mobx.untracked(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = mobx.isObservableArray;
                    break;
                case "Object":
                    mobxChecker = mobx.isObservableObject;
                    break;
                case "Map":
                    mobxChecker = mobx.isObservableMap;
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return mobx.untracked(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return React.createElement(component, newProps);
            }
        }]);
        return Injector;
    }(React.Component), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (reactDom.findDOMNode) {
        try {
            return reactDom.findDOMNode(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) return;
        // Generate friendly name for debugging
        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = new mobx.Atom("reactive " + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, "props");
        // make state an observable reference
        makePropertyObservableReference.call(this, "state");

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new mobx.Reaction(initialName + "#" + rootNodeID + ".render()", function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) React.Component.prototype.forceUpdate.call(_this);
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) reaction.dispose();
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender();
        };

        var reactiveRender = function reactiveRender() {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderStart = Date.now();
                }
                try {
                    rendering = mobx.extras.allowStateChanges(false, baseRender);
                } catch (e) {
                    exception = e;
                }
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderEnd = Date.now();
                }
            });
            if (exception) {
                errorsReporter.emit(exception);
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistery) {
                componentByNodeRegistery.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    var InjectComponent = inject(observerInject)(component);
    return React__default.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return React.Children.only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }
        }
    }]);
    return Provider;
}(React.Component), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

if (!React.Component) throw new Error("mobx-react requires React to be available");
if (!mobx.extras) throw new Error("mobx-react requires mobx to be available");

if (typeof reactDom.unstable_batchedUpdates === "function") mobx.extras.setReactionScheduler(reactDom.unstable_batchedUpdates);else if (typeof unstable_batchedUpdates$1 === "function") mobx.extras.setReactionScheduler(unstable_batchedUpdates$1);

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: mobx.spy, extras: mobx.extras };
    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}

exports.propTypes = propTypes;
exports.PropTypes = propTypes;
exports.onError = onError;
exports.observer = observer;
exports.Observer = Observer;
exports.renderReporter = renderReporter;
exports.componentByNodeRegistery = componentByNodeRegistery;
exports.trackComponents = trackComponents;
exports.useStaticRendering = useStaticRendering;
exports.Provider = Provider;
exports.inject = inject;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"equipResult":"_20cA0oGAgQfhi0o-Ak0PLi","scrollContainer":"_2hOWjEQWYeIuGA-nGS1ZuU","scrollableCheck":"_3LAcBi2L8G-Kyg2WcyU9O-","doc":"_3aUAqUCtMCdDOeU82x2nVC","equipResultSection":"_3yr1JxlZDSYjeeqXGZkMTa","equipCheckItem":"_1ChIUPWcylPEK5IdqPVyVp"};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(225);var _index2=_interopRequireDefault(_index);var _reactSimpleLineIcons=__webpack_require__(22);var _reactSimpleLineIcons2=_interopRequireDefault(_reactSimpleLineIcons);var _index3=__webpack_require__(246);var _index4=_interopRequireDefault(_index3);var _index5=__webpack_require__(249);var _index6=_interopRequireDefault(_index5);var _index7=__webpack_require__(252);var _index8=_interopRequireDefault(_index7);var _index9=__webpack_require__(254);var _index10=_interopRequireDefault(_index9);var _index11=__webpack_require__(256);var _index12=_interopRequireDefault(_index11);var _index13=__webpack_require__(258);var _index14=_interopRequireDefault(_index13);var _index15=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var somethingElse=(0,_mobxReact.observer)(_class=function(_Component){_inherits(somethingElse,_Component);function somethingElse(){var _ref;var _temp,_this,_ret;_classCallCheck(this,somethingElse);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=somethingElse.__proto__||Object.getPrototypeOf(somethingElse)).call.apply(_ref,[this].concat(args))),_this),_this.state={stage:'region'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(somethingElse,[{key:'componentWillMount',value:function componentWillMount(){document.querySelector("html").style.fontSize=window.innerWidth/120+'px';document.body.onresize=function(e){document.querySelector("html").style.fontSize=e.target.innerWidth/120+'px';};}},{key:'render',value:function render(){var _this2=this;var input=_index15.presets.inputEquip.findIndex(function(item){return item.quantity;});var output=_index15.presets.outputEquip.findIndex(function(item){return item.quantity;});var cleaning=_index15.presets.cleaningEquip.findIndex(function(item){return item.quantity;});var drying=_index15.presets.dryingEquip.findIndex(function(item){return item.quantity;});var storage=_index15.presets.storageEquip.findIndex(function(item){return item.quantity;});return _react2.default.createElement('div',{className:_index2.default.elevatorBuildUp,style:{height:window.innerHeight}},_react2.default.createElement(_index4.default,null),_react2.default.createElement('div',{className:_index2.default.elevatorBuildupStageContainer},_react2.default.createElement('div',{className:_index2.default.equipStagesList},_react2.default.createElement('div',{className:_index2.default.equipStagesHeading},'\u041A\u041E\u041D\u0421\u0422\u0420\u0423\u041A\u0422\u041E\u0420 \u0415\u041B\u0415\u0412\u0410\u0422\u041E\u0420\u0423'),_react2.default.createElement('div',null,_react2.default.createElement('div',null,_react2.default.createElement('div',null,_react2.default.createElement('span',null,_react2.default.createElement('h2',{style:{fontWeight:300}},'\u041D\u0410\u0417\u0412\u0410 \u0415\u041B\u0415\u0412\u0410\u0422\u041E\u0420\u0423:')),_react2.default.createElement('span',{className:_index2.default.inputContainer},_react2.default.createElement('input',{name:'text',type:'text',onChange:function onChange(e){_index15.presets.setElevatorsName(e.target.value);},placeholder:'Elevator name #1'}))))),_react2.default.createElement('div',{className:_index2.default.equipStagesStage+(this.state.stage==='region'?" "+_index2.default.activeTab:''),onClick:function onClick(){_this2.setState({stage:'region'});}},_react2.default.createElement('div',{className:_index2.default.itemIcon+(_index15.presets.region?' '+_index2.default.active:'')},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:_index15.presets.region?'check':'plus',style:{fontSize:'1.25rem'}})),_react2.default.createElement('h3',null,'\u0420\u0415\u0413\u0406\u041E\u041D \u0420\u041E\u0417\u041C\u0406\u0429\u0415\u041D\u041D\u042F')),_react2.default.createElement('div',{className:_index2.default.equipStagesStage+(this.state.stage==='inputEquip'||this.state.stage==='cleaningEquip'||this.state.stage==='dryingEquip'||this.state.stage==='storageEquip'||this.state.stage==='outputEquip'?' '+_index2.default.activeTab:'')},_react2.default.createElement('div',{className:_index2.default.itemIcon+(input===-1||output===-1||cleaning===-1||drying===-1||storage===-1?"":' '+_index2.default.active)},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:input===-1||output===-1||cleaning===-1||drying===-1||storage===-1?'plus':'check',style:{fontSize:'1.25rem'}})),_react2.default.createElement('h3',null,'\u0415\u041B\u0415\u041C\u0415\u041D\u0422\u0418 \u0415\u041B\u0415\u0412\u0410\u0422\u041E\u0420\u0423'),_react2.default.createElement('div',{className:_index2.default.itemIcon+' '+_index2.default.dropdownArrow},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'arrow-down',style:{fontSize:'1.25rem'}})),_react2.default.createElement('div',{className:_index2.default.equipStagesStageDropdown},_react2.default.createElement('div',{className:_index2.default.equipStagesItem+(this.state.stage==='inputEquip'?" "+_index2.default.active:''),onClick:function onClick(){_this2.setState({stage:'inputEquip'});}},_react2.default.createElement('div',{className:_index2.default.itemIcon+(input===-1?"":' '+_index2.default.active)},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:input===-1?"plus":"check",style:{fontSize:'1.25rem'}})),_react2.default.createElement('h4',null,'\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F')),_react2.default.createElement('div',{className:_index2.default.equipStagesItem+(this.state.stage==='cleaningEquip'?" "+_index2.default.active:''),onClick:function onClick(){_this2.setState({stage:'cleaningEquip'});}},_react2.default.createElement('div',{className:_index2.default.itemIcon+(cleaning===-1?"":' '+_index2.default.active)},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:cleaning===-1?"plus":"check",style:{fontSize:'1.25rem'}})),_react2.default.createElement('h4',null,'\u041E\u0447\u0438\u0441\u0442\u043A\u0430')),_react2.default.createElement('div',{className:_index2.default.equipStagesItem+(this.state.stage==='dryingEquip'?" "+_index2.default.active:''),onClick:function onClick(){_this2.setState({stage:'dryingEquip'});}},_react2.default.createElement('div',{className:_index2.default.itemIcon+(drying===-1?"":' '+_index2.default.active)},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:drying===-1?"plus":"check",style:{fontSize:'1.25rem'}})),_react2.default.createElement('h4',null,'\u0421\u0443\u0448\u043A\u0430')),_react2.default.createElement('div',{className:_index2.default.equipStagesItem+(this.state.stage==='storageEquip'?" "+_index2.default.active:''),onClick:function onClick(){_this2.setState({stage:'storageEquip'});}},_react2.default.createElement('div',{className:_index2.default.itemIcon+(storage===-1?"":' '+_index2.default.active)},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:storage===-1?"plus":"check",style:{fontSize:'1.25rem'}})),_react2.default.createElement('h4',null,'\u0417\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F')),_react2.default.createElement('div',{className:_index2.default.equipStagesItem+(this.state.stage==='outputEquip'?" "+_index2.default.active:''),onClick:function onClick(){_this2.setState({stage:'outputEquip'});}},_react2.default.createElement('div',{className:_index2.default.itemIcon+(output===-1?"":' '+_index2.default.active)},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:output===-1?"plus":"check",style:{fontSize:'1.25rem'}})),_react2.default.createElement('h4',null,'\u0412\u0456\u0434\u0433\u0440\u0443\u0437\u043A\u0430')))),_react2.default.createElement('div',{className:_index2.default.equipStagesStage+(this.state.stage==='cropPlan'?" "+_index2.default.activeTab:''),onClick:function onClick(){_this2.setState({stage:'cropPlan'});}},_react2.default.createElement('div',{className:_index2.default.itemIcon+(storage===-1||!_index15.presets.region?"":' '+_index2.default.active)},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:storage===-1||!_index15.presets.region?"plus":'check',style:{fontSize:'1.25rem'}})),_react2.default.createElement('h3',null,'\u041F\u041B\u0410\u041D \u041E\u0411\u0415\u0420\u0422\u0423 \u041A\u0423\u041B\u042C\u0422\u0423\u0420')),_react2.default.createElement('div',{className:_index2.default.equipStagesStage+(this.state.stage==='difficulty'?" "+_index2.default.activeTab:''),onClick:function onClick(){_this2.setState({stage:'difficulty'});}},_react2.default.createElement('div',{className:_index2.default.itemIcon+' '+_index2.default.active},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'check',style:{fontSize:'1.25rem'}})),_react2.default.createElement('h3',null,'\u0420\u0406\u0412\u0415\u041D\u042C \u0421\u041A\u041B\u0410\u0414\u041D\u041E\u0421\u0422\u0406'))),_react2.default.createElement('div',{className:_index2.default.stage},this.state.stage==='region'&&_react2.default.createElement(_index6.default,null),this.state.stage==='inputEquip'&&_react2.default.createElement(_index8.default,{elem:this.state.stage,limit:6,data:{title:"Вибір обладнання для приймання",desc:"Пропускна спроможність (тон/год)"}}),this.state.stage==='dryingEquip'&&_react2.default.createElement(_index8.default,{elem:this.state.stage,limit:8,data:{title:"Вибір обладнання для сушки",desc:"Эфективність сушки (%) \n Продуктивність (тон/год)"}}),this.state.stage==='cleaningEquip'&&_react2.default.createElement(_index8.default,{elem:this.state.stage,limit:8,data:{title:"Вибір обладнання для очистки",desc:"Эфективність очистки (%) \n Продуктивність (тон/год)"}}),this.state.stage==='storageEquip'&&_react2.default.createElement(_index8.default,{elem:this.state.stage,refer:true,limit:12,data:{title:"Вибір потужностей зберігання",desc:"Об'єм зберігання (т.)"}}),this.state.stage==='outputEquip'&&_react2.default.createElement(_index8.default,{elem:this.state.stage,limit:6,data:{title:"Вибір обладнання для відгрузки",desc:"Пропускна спроможність (тон/год)"}}),this.state.stage==='cropPlan'&&_react2.default.createElement(_index10.default,null),this.state.stage==='difficulty'&&_react2.default.createElement(_index12.default,null)),_react2.default.createElement(_index14.default,null)));}}]);return somethingElse;}(_react.Component))||_class;exports.default=somethingElse;module.exports=exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"elevatorBuildUp":"_1KiSy_sskONoAHPhE1Mmf","elevatorBuildupStageContainer":"_348wBCpEWny5tiiDVZPEpb","inputContainer":"_140_ZOrHG9bGh00do74VqV","itemIcon":"_1imcZznvtW_95MP4vrGeqi","active":"VINWdLHoD3cPRnTS1JQHn","equipStagesList":"_3_Lo76uxLP3ZtKIc1ZZaUF","equipStagesHeading":"_8_GNPegfVC35MohunlXnI","equipStagesStage":"_1Rcj2i0bEwVzBM7wYkMsYR","activeTab":"_3B6DmI-LciU1batUZ3fv3b","dropdownArrow":"_3jJMDUi8ZwcUiUaRcNR3rj","equipStagesStageDropdown":"_2Bdzw1ZkWIlV8z2gnDaO-i","equipStagesItem":"_1EU31ppmJnQmruxNfVT0mA","stage":"_9qEcKUTe4D8OcizqJEGYn"};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(227);


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var ReactBaseClasses = __webpack_require__(65);
var ReactChildren = __webpack_require__(229);
var ReactDOMFactories = __webpack_require__(234);
var ReactElement = __webpack_require__(19);
var ReactPropTypes = __webpack_require__(235);
var ReactVersion = __webpack_require__(241);

var createReactClass = __webpack_require__(242);
var onlyChild = __webpack_require__(244);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(230);
var ReactElement = __webpack_require__(19);

var emptyFunction = __webpack_require__(67);
var traverseAllChildren = __webpack_require__(231);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(30);

var invariant = __webpack_require__(23);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(30);

var ReactCurrentOwner = __webpack_require__(70);
var REACT_ELEMENT_TYPE = __webpack_require__(71);

var getIteratorFn = __webpack_require__(232);
var invariant = __webpack_require__(23);
var KeyEscapeUtils = __webpack_require__(233);
var warning = __webpack_require__(39);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(19);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(19),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(236);

module.exports = factory(isValidElement);

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(237);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(238);
var assign = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(44);
var checkPropTypes = __webpack_require__(240);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(239);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(65),
    Component = _require.Component;

var _require2 = __webpack_require__(19),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(66);
var factory = __webpack_require__(243);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(9);

var emptyObject = __webpack_require__(69);
var _invariant = __webpack_require__(23);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(30);

var ReactElement = __webpack_require__(19);

var invariant = __webpack_require__(23);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon-user":"_2ObZbgA882xE1eZ8iOfO6I","icon-people":"_1OUm5kJuMvneDXq7AviAj8","icon-user-female":"W8Gr_HeZS7vRjYWuh27oF","icon-user-follow":"Vgjndo3Aq7GyiNymAKYTl","icon-user-following":"_1KB5NMwI-H-L6FZFlnPgZA","icon-user-unfollow":"chPC3GJByM-fLg2pTyYAx","icon-login":"jSa-tYc8Abq-ITJ5BdDMT","icon-logout":"_2yibuFAPOeO93YVmoiHMSF","icon-emotsmile":"szfu6OlXeq2WmKLkzZYc4","icon-phone":"_2egtcRUvq03285tw3AWWzG","icon-call-end":"_1zQpJRLDCLBvZ6BHctcl0R","icon-call-in":"_1xwzpiIOHYnXXQAEUfJ1pZ","icon-call-out":"_2fv0Rnky8UkmayrUd4TXEn","icon-map":"_2oFyznxhMNON7eQuLoBxaS","icon-location-pin":"_1XPgjKlU93bS-Be8AmDt7z","icon-direction":"_2DTLCQ1oq3WIiKn6fX6R1l","icon-directions":"_1uvuPTjeNL_ldzd2vGBJaY","icon-compass":"_3kxmRWSoelznrgEcDZB1X3","icon-layers":"_1IbtTa7mZL0FdyzOBzwvsB","icon-menu":"_1uNXwudmdUljVFI9LPY7RE","icon-list":"_3HYixR3a1gkYCP344sDIPn","icon-options-vertical":"m8ykQvX5Ez0XOz5Z28zV0","icon-options":"_2-ii0LV4C6HXXK-bEPl3bC","icon-arrow-down":"_2R2Q-6U381XRv3ie6gIgGR","icon-arrow-left":"_32mvrDK770QtqhIfudLmbR","icon-arrow-right":"_3rIWv40D2be5nLRYjSkwrw","icon-arrow-up":"Rw_dhApqFEERzy7_8gI4z","icon-arrow-up-circle":"_2TjQJROv_ho18nIdPMpGe8","icon-arrow-left-circle":"_3e8eJVyPIPlbBKdArGrdXU","icon-arrow-right-circle":"su46FLdIBSd7TaVP-_Kus","icon-arrow-down-circle":"_3EgCXx6Wy3URdhqCwuJAQ1","icon-check":"_7NuO8WkR9fyzL-EUi866W","icon-clock":"_3MbI2b_PPKYkJcRFLhM_L4","icon-plus":"_1WfyN0ajcMjk2afq4-e0QV","icon-minus":"ciPikbE8bX16bI9rp6gd2","icon-close":"_3MX6zBfHyZEHKc_-6WJ4-r","icon-event":"_2xdw3SKgtfbTftr4YQN48L","icon-exclamation":"_2GQBTnunyqMGcb_KntMFUS","icon-organization":"_1WjfX_i3s5su8mhc_ZB3N9","icon-trophy":"_1zrVs4pz66sV9opDIKuHGZ","icon-screen-smartphone":"qfa5Yn_10Wx9S1suPOtNH","icon-screen-desktop":"oqfxyOmiJinTMGwoUgcoi","icon-plane":"kHkgUu5o2IsmORBYEgXzf","icon-notebook":"RY7VitpY9EoPXuEw9OrZR","icon-mustache":"_3G_hETuiLYBJv-J7gCkFqy","icon-mouse":"_3xCQz_YSvwbqrOij3cRTaC","icon-magnet":"_2Y7Xabw1OWdT8sa3yDdkDd","icon-energy":"MCKJhEeumKeDr5lew1p8D","icon-disc":"_3uNmIE34jroyZTWel9BVoH","icon-cursor":"_15QLiutEtisPuxmbN866-W","icon-cursor-move":"_99woIV2pGlFUN7KS4m0P_","icon-crop":"_2U1tR8AgfnT05nNb_xtr6n","icon-chemistry":"GfsqO-EvuTBq0yLmdTRyt","icon-speedometer":"_27htMOHj2JYyUSW3BhiSQF","icon-shield":"wWPvh4OsHPUhOaPmQP44N","icon-screen-tablet":"_10ZA9RW742_l8wzfthwLks","icon-magic-wand":"_31qegd7IKc3gor9RvuIjlO","icon-hourglass":"_2rzZFLt_dr53-4JR-Zxlcg","icon-graduation":"_2pCAPBX1Kvtdb3jUi0k9wi","icon-ghost":"_1UuSJ4HFytwfw2xQb6dRIn","icon-game-controller":"_1Z1uHo8kHrNZTY3mvvhIYi","icon-fire":"_2GddlKTgY4if_03L-ijkmd","icon-eyeglass":"_2jANrzHuSR0mZfqm7VxzqN","icon-envelope-open":"_2m-Zo5zQZEGxzL7Jj16Fye","icon-envelope-letter":"_23G7ldpX5wivLRbrWAgQxN","icon-bell":"_2TYX1sjuQlahU7qBjNc5f0","icon-badge":"_1O1krC2qgJihtfQkICjMnj","icon-anchor":"z6B8ySXSwoGaCcw0cIEu9","icon-wallet":"_4BcLoQihGDYwctzoUCYCt","icon-vector":"Q2u8YIBcCq4PdnumWrTiO","icon-speech":"_1jamlrTNgaHuMU21LWWJ14","icon-puzzle":"_3jeQ3olFF31UhjkOZQh7rA","icon-printer":"_3ejY87AfEERCAqTDbhblZY","icon-present":"K9iasAWXR1Him1iHAK8Ev","icon-playlist":"_1xyr0KYVJ8hOy2i5EWiKNs","icon-pin":"_1jZATNUv7E1wCclJVQ0BNP","icon-picture":"_1VxdoyK69hdkAQl8xE9TTR","icon-handbag":"_1mce5j1Dkfn_74H4bCW8vb","icon-globe-alt":"_1qr_5J6rr4gU-savaso4ZC","icon-globe":"_3kmLbQzzTN031iePGboSrQ","icon-folder-alt":"o5eDJWV-xEiutXbAWWxxw","icon-folder":"rCOOVca9pzuknmXYa1cyS","icon-film":"_1Lz5K05Yq_tYEi8I0HKbOL","icon-feed":"_3f2hEaJ_GLe9-7KBq8ezOC","icon-drop":"_3REJra4AN68rXAnMeCGzWS","icon-drawer":"_1CHcnvrA2VL1PXE-_jyIdv","icon-docs":"_1NNvnZtpqNd7fJdrbsGcYJ","icon-doc":"IOW6rd8tWL6W_TRne-Sx3","icon-diamond":"Gjb_dzdKqxwMzyeuZtC4i","icon-cup":"_1CmXuTuFLDKEUzJPZLZhwV","icon-calculator":"_2gQuBXa_0FNIj2G00DzB5z","icon-bubbles":"_2AUcbyO1XniqyXTGfHlusw","icon-briefcase":"xNfaSvaQhuzjPX7a-aKa8","icon-book-open":"YDMuPPri426DJAOmI9YE5","icon-basket-loaded":"_3pMEMY9D7LSJ-tRGfgqe8A","icon-basket":"_2BuX25Q0PwQOwAT-obA9CY","icon-bag":"_35DUIK_u-3e1mArcFWMu7Z","icon-action-undo":"_2N1DnwdTQ_2VkSbf1lY0kx","icon-action-redo":"_360LMXAzolTQfZEJdnLKkw","icon-wrench":"_1_CPtbGmnfmsjtjPohaUWz","icon-umbrella":"_3WAuInTrHzzQkzFUoNl6w6","icon-trash":"z4-ytzYY8EjkL73uZfctX","icon-tag":"_2SDxUUtDYbRHoRJwz5V6wT","icon-support":"_2VNFMGJm55TPhcs4EPctP0","icon-frame":"_3gYyeFqVkQYQETyMifs04S","icon-size-fullscreen":"_3nOKvMeIgiqu4JVoulztw3","icon-size-actual":"_1yQfddPEb3LlS93A3grQTh","icon-shuffle":"aLXdWMm7bQt7jNlCgWTkM","icon-share-alt":"_131lZtUsp4Zwdqb4FgQZzN","icon-share":"_2W_sEmjTkF2EO4nMjFdZxQ","icon-rocket":"_3SzhA_RRM95BHxWTvaKCwC","icon-question":"_1vzmZ8TsZqN9nXOovsQEJd","icon-pie-chart":"_1JaFSTOea4g1yVDuyd3O4n","icon-pencil":"_2IYB6n43i3UQj0qHcp-GOe","icon-note":"_2WJzRoSr8CsO7cQwV2d0bO","icon-loop":"_34oKHNB-08oqaofzpr5IzD","icon-home":"_2E3pixDcWmhFLQRYjjPfOY","icon-grid":"_1vdzT5BEPUbe4iTHN--c_a","icon-graph":"WMTpn4Xc3mclp6WXbp50x","icon-microphone":"r4L8AwGhPViD0ekbDll-4","icon-music-tone-alt":"_1OAlbQ8k38Gjk1zoq_UMcF","icon-music-tone":"_1yMb1AA2dyXN2FMdULHlbT","icon-earphones-alt":"_37iw0VWhlbTN735_nfHibN","icon-earphones":"_9ds_wel923yYuOipymYj1","icon-equalizer":"_13Sft45W9ZCB8ZpgDtx76l","icon-like":"_3h0DGf3HeTPPdvq8IvZX14","icon-dislike":"_21R6R8mr1sKYpRTlpwhwqd","icon-control-start":"_1nTFpmkhyHM0WXC19yqjrc","icon-control-rewind":"_1pGb-FSSjwxMk_c_B5G1Lw","icon-control-play":"_hyujdKriVHh0sZSWOLn1","icon-control-pause":"AgCLDbwCn7P3Vz7Ny57do","icon-control-forward":"SRdqCs-aQUBs5pZd1JBKv","icon-control-end":"_3-WNWfF3N-oWkvhs46sZE-","icon-volume-1":"_1xNOD4I2PekXGHVeZse-c4","icon-volume-2":"FF1d8Tgt1hV2ngqXg8J9C","icon-volume-off":"Oe1_cnpqCIEazmESIt5q0","icon-calendar":"_2zQ9VVP_xN2hNY5aoofp6","icon-bulb":"_2HwPTUs86ZClvkgZMK3d4r","icon-chart":"_3Vgmg94aBTTeb-mfVNpo4d","icon-ban":"BcchVMQQMmvbDC-6xaz93","icon-bubble":"_2KglP0sbteHz7Ch-lVEBI9","icon-camrecorder":"_3WYWYerRXfC3T0cYOEFW6y","icon-camera":"ftIqTaoJ_HSbeY_0Ge6y_","icon-cloud-download":"kcUOKDtdkN2Cxhm0Mh0z_","icon-cloud-upload":"YWvaF28xsfbzu3KVRNKY2","icon-envelope":"_8vwVPvGxWwEMz-uEIJ8tx","icon-eye":"_1U-PzXZfJc_CYmPkmN_F13","icon-flag":"_1WyPpjZBKwbKWWhCN-3Ess","icon-heart":"_2U48XTJTKtJU87jyHckxPw","icon-info":"_2NOsrPfxxUvjWJkc4YaYKr","icon-key":"_1eRKmhuTQh370NIZnjIwJv","icon-link":"_3sTAb94-7asWAsbbnYd9cD","icon-lock":"_3GMKgHgNZkE4uDLyRnuDG","icon-lock-open":"_2Yg2dOQhveOiGksqDpzjv","icon-magnifier":"_2DGcQrowg9aRUin3UDFPkQ","icon-magnifier-add":"_2T7baUwJZnYmtGl0wx1u2J","icon-magnifier-remove":"_1Jj9GI2DYJwNFHmRjS1PST","icon-paper-clip":"_4mbZPvzSRPSUGZW-IElH3","icon-paper-plane":"_2wkTpkcDvot6EsC32i7Kzu","icon-power":"qsiDNE-LOqr8AYxsLQnW0","icon-refresh":"_2j33_a7hVO06dK6_coBnlT","icon-reload":"_2jjY9iM44pxYDBsY7Ilbzr","icon-settings":"eG5WaEdn8wplfOGxCrgP6","icon-star":"_3OcQfg6zpLQpnV14x693B6","icon-symbol-female":"_3k8zt4VWn9krb7GOHjSD9s","icon-symbol-male":"_1BM2h6hjoxsC18BvP-hZIx","icon-target":"_3N4Ep46E0UTdnmSozMTCX4","icon-credit-card":"_61VE3u11bUHZ6k_Ukfk4J","icon-paypal":"rsr2hZ47aPCinHyj5CQqP","icon-social-tumblr":"_3gx_hbvqytEI6WtezEI9Ok","icon-social-twitter":"_3ZPCN_u-eJfv96xaGFbOns","icon-social-facebook":"_1SarHe18XHzd4R_IRI2WGM","icon-social-instagram":"_3k8tRK3LVBPx5vSFkDtDQv","icon-social-linkedin":"_2MVCOzpXQlwrhVKEc1oMFO","icon-social-pinterest":"_1IOiGekhuT_MM5SzMfj4et","icon-social-github":"_1b46UOZAilEDWj6wvAvGsK","icon-social-google":"_21MfOyR5rgQdSFsWZ4_h9w","icon-social-reddit":"cNhcADYaQTF7lYCvr2k7F","icon-social-skype":"_35vl5GSiASvJm7WXv1NlLv","icon-social-dribbble":"_2aHdlHwPOd45EBvwPqmxm3","icon-social-behance":"AV1Xl11_oNXV2faVMJ9C5","icon-social-foursqare":"_1ScKu-unTd56fCFf38Qkiw","icon-social-soundcloud":"_3_pnd64Vn8MsMoOGOqp0Ny","icon-social-spotify":"_2X7TBhAOF338uqRYlAhuix","icon-social-stumbleupon":"_3SQ4cu3h7J1x1PwSfRDQ8I","icon-social-youtube":"_2FJ-WmvcDmYjJbf3V9cd4","icon-social-dropbox":"_31ZsuPZy3usdCWh4mUcjuq","icon-social-vkontakte":"_29h7nFtfTdKP2A9LM9CtY1","icon-social-steam":"_28QY2yncLqCVfwWZALSc1p"};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(247);var _index2=_interopRequireDefault(_index);var _logo=__webpack_require__(248);var _logo2=_interopRequireDefault(_logo);var _reactSimpleLineIcons=__webpack_require__(22);var _reactSimpleLineIcons2=_interopRequireDefault(_reactSimpleLineIcons);var _reactRouterDom=__webpack_require__(11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EquipMenu=function(_Component){_inherits(EquipMenu,_Component);function EquipMenu(){_classCallCheck(this,EquipMenu);return _possibleConstructorReturn(this,(EquipMenu.__proto__||Object.getPrototypeOf(EquipMenu)).apply(this,arguments));}_createClass(EquipMenu,[{key:'render',value:function render(){return _react2.default.createElement('div',{className:_index2.default.topMenu},_react2.default.createElement('div',{className:_index2.default.menuLogo},_react2.default.createElement(_reactRouterDom.Link,{to:'/',className:_index2.default.burger},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'menu',style:{fontSize:"1.125rem"}})),_react2.default.createElement('img',{src:_logo2.default,alt:'logo'})));}}]);return EquipMenu;}(_react.Component);exports.default=EquipMenu;module.exports=exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"topMenu":"_2ar6jUHSYGIvS4aBBhcPRz","menuLogo":"_1i8XcemkrGibc_SDKf9f6q","accountHelp":"_2wVJrl_y6Y_IS_Qu9-KkLH","burger":"_8urfMZOc_qPnhZs2UqQF6","accountDetails":"_3_zWv8aIiZwWvuip0YAHT8","accountAva":"WGkFQEqkMLYzNOYANj0l2","helpTrigger":"_2HuZ6Rr04owZIfJmowOXoQ"};

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(250);var _index2=_interopRequireDefault(_index);var _mobxReact=__webpack_require__(2);var _index3=__webpack_require__(1);var _regionData=__webpack_require__(251);var _regionData2=_interopRequireDefault(_regionData);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChooseRegion=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ChooseRegion,_Component);function ChooseRegion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChooseRegion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChooseRegion.__proto__||Object.getPrototypeOf(ChooseRegion)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:_index3.presets.region?_index3.presets.region.item:-1,over:-1},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChooseRegion,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:_index2.default.chooseRegion},_react2.default.createElement('h3',null,'\u041E\u0411\u0415\u0420\u0406\u0422\u042C \u0420\u0415\u0413\u0406\u041E\u041D \u0420\u041E\u0417\u041C\u0406\u0429\u0415\u041D\u041D\u042F'),_react2.default.createElement('div',{className:_index2.default.regionsList},_react2.default.createElement('ul',null,_regionData2.default.map(function(item,i){if(item.disabled){return null;}return _react2.default.createElement('li',{className:_this2.state.selected===i?' '+_index2.default.chosen:_this2.state.over===i?' '+_index2.default.over:'',key:i,onMouseOver:function onMouseOver(){_this2.setState({over:i});},onMouseLeave:function onMouseLeave(){_this2.setState({over:-1});},onClick:function onClick(){_this2.setState({selected:i});_index3.presets.setRegion({name:_regionData2.default[i].name,item:i},_regionData2.default[i].cultures);_index3.presets.setCulturePlan();}},item.name);}))),_react2.default.createElement('div',{className:_index2.default.regionsMap},_react2.default.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 724 490',preserveAspectRatio:'xMidYMid meet'},_regionData2.default.map(function(item,i){if(item.disabled){return _react2.default.createElement('polygon',{key:i,className:_index2.default.chosenRegion+' '+_index2.default.disabledRegion,points:item.points});}return _react2.default.createElement('polygon',{key:i,onMouseOver:function onMouseOver(){_this2.setState({over:i});},onMouseLeave:function onMouseLeave(){_this2.setState({over:-1});},onClick:function onClick(){_this2.setState({selected:i});_index3.presets.setRegion({name:_regionData2.default[i].name,item:i},_regionData2.default[i].cultures);_index3.presets.setCulturePlan();},className:_index2.default.chosenRegion+(_this2.state.selected===i?' '+_index2.default.chosen:_this2.state.over===i?' '+_index2.default.mapOver:''),points:item.points});}))));}}]);return ChooseRegion;}(_react.Component))||_class;exports.default=ChooseRegion;module.exports=exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chooseRegion":"_3DJ5TIzl0KMsMZSX_FbUd1","regionsList":"Bfgr8H5OMLQAIw_EARl1V","chosen":"_2FdbWlJ4aBqch6xAnLfj_U","over":"qzjm4scZB_H7lyX_3WMY5","regionsMap":"_349vl5mbAQydCmcZZHn18e","chosenRegion":"qknNlT2ur59KE-suhzeHW","mapOver":"lkHu9kUlhOgXt5YBgFFoM","button":"_2W7JzxVqpth1OQtzHEPB1z","disabled":"dgV9bdWj_SOJDPKIClE_D","mapButton":"jWOYN-QSXoKJT2tg8FY24","disabledRegion":"_1cBcVdi8GZun8EkzLd2xOX"};

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = [{"name":"АР Крым","cultures":{"wheat":0.43,"rape":0.03,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"471.68 395.13 422.18 423.49 427.86 434.83 439.71 430.71 469.62 442.57 475.29 457.01 464.46 476.6 480.45 487.43 500.04 483.3 521.7 459.07 546.97 453.4 559.34 439.99 569.65 447.21 596.47 439.48 604.72 418.33 578.93 413.69 550.06 429.68 531.5 409.57 480.45 388.43 478.39 375.02 469.62 378.63 471.68 395.13"},{"name":"Вінницька область","cultures":{"wheat":0.195,"rape":0.119,"sunflower":0.124,"soy":0.064,"corn":0.498},"disabled":false,"points":"303.59 208.73 308.49 197.91 298.95 185.01 297.92 169.29 279.61 172.12 276 154.34 255.12 160.01 234.48 160.6 230.11 177.54 234.5 197.13 218.25 199.45 214.13 216.47 212.32 230.13 226.59 239.1 253.32 258.23 265.95 259.26 272.04 268.3 292.25 259.01 314.13 255.52 322.15 241.73 303.59 208.73"},{"name":"Волинська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"107.22 113.58 131.58 120.15 135.06 104.68 159.43 102.75 170.26 74.9 154.79 56.34 157.47 25.18 156.64 24.91 114.87 23.37 81.69 54.4 96 100.81 95.98 100.84 104.9 102.75 107.22 113.58"},{"name":"Дніпропетровська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"598.01 254.74 596.08 226.12 587.18 220.32 571.71 227.28 557.4 203.3 540.39 204.85 522.21 192.86 509.83 192.47 490.5 206.01 493.98 215.29 487.4 222.64 474.25 213.75 471.16 226.12 457.23 235.79 459.94 252.81 442.92 265.96 445.61 294.01 456.46 298.45 471.54 298.06 489.33 294.58 520.27 296.13 514.09 257.84 560.11 255.52 567.85 270.21 584.48 267.89 584.09 255.13 598.01 254.74"},{"name":"Донецька область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"673.82 243.91 652.16 223.8 645.97 197.89 619.67 187.06 608.84 199.44 599.95 207.17 585.64 210.65 587.18 220.32 596.08 226.12 598.01 254.74 584.09 255.13 584.48 267.89 602.65 283.36 614.64 288.39 613.87 297.29 603.04 299.22 602.65 306.57 612.32 315.85 610.9 330.68 629.98 313.15 655.25 306.95 661.95 280.15 688.25 256.43 685.03 245.85 673.82 243.91"},{"name":"Житомирська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"276 154.34 279.61 172.12 297.92 169.29 297.4 158.72 308.49 150.98 305.39 127.78 295.86 120.56 303.33 101.48 294.31 78.54 294.82 62.04 285.8 47.34 262.86 51.73 235.96 50.56 214.9 81.37 215.93 99.16 211.29 108.7 211.21 108.73 218.51 125.97 227.54 129.33 228.82 142.22 223.67 149.18 234.5 160.52 234.48 160.6 255.12 160.01 276 154.34"},{"name":"Закарпатська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"81.61 226.26 60.98 210.79 51.45 210.54 26.71 184.01 1.25 223.8 27.93 254.36 44.56 250.88 81.69 264.8 95.09 261.35 99.66 252.56 81.61 226.26"},{"name":"Запорізька область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"602.65 306.57 603.04 299.22 613.87 297.29 614.64 288.39 602.65 283.36 584.48 267.89 567.85 270.21 560.11 255.52 514.09 257.84 520.27 296.13 489.33 294.58 502.48 307.73 503.64 320.11 516.79 333.64 510.61 344.08 527.62 356.85 534.37 367.7 553.67 354.4 610.9 330.68 612.32 315.85 602.65 306.57"},{"name":"Івано-Франківська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"112.32 256.5 130.88 238.52 142.09 235.23 143.83 221.5 142.09 210.29 124.69 207 111.04 168.75 111 168.77 98.89 165.68 95.79 187.59 68.21 189.14 60.99 210.79 60.98 210.79 81.61 226.26 99.66 252.56 95.09 261.35 95.23 261.32 109.41 277.95 114.25 268.68 112.32 256.5"},{"name":"Київська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"390.71 109.71 380.66 116.67 368.67 116.28 361.7 101.97 348.17 97.33 338.89 81.86 339.27 65.62 336.07 55.34 294.82 62.04 294.31 78.54 303.33 101.48 295.86 120.56 305.39 127.78 308.49 150.98 297.4 158.72 297.92 169.29 298.95 185.01 308.49 197.91 324.96 189.77 355.13 187.45 365.19 172.75 367.51 154.96 378.33 153.41 385.3 157.67 393.03 139.49 399.22 132.53 401.15 125.95 390.71 109.71"},{"name":"Кіровоградська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"457.23 235.79 471.16 226.12 474.25 213.75 436.35 194.8 430.93 209.11 411.21 205.63 396.13 213.75 382.98 212.97 372.92 224.58 348.56 222.64 340.82 234.63 322.15 241.73 314.13 255.52 330.66 261.84 360.93 256.29 388 269.05 404.63 283.36 423.97 281.82 428.61 265.96 442.92 265.96 459.94 252.81 457.23 235.79"},{"name":"Луганська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"673.82 243.91 685.03 245.85 688.25 256.43 719.7 254.37 721.25 226.01 707.33 200.74 719.84 169.27 716.09 150.21 681.94 142.2 656.03 131.75 633.59 137.32 631.27 157.67 630.89 174.3 644.81 187.45 645.97 197.89 652.16 223.8 673.82 243.91"},{"name":"Львівська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"60.99 210.79 68.21 189.14 95.79 187.59 98.89 165.68 111 168.77 141.94 143.51 140.99 137.51 140.91 137.58 131.6 120.09 131.58 120.15 107.22 113.58 104.9 102.75 95.98 100.84 87.49 110.48 78.21 113.19 30.25 157.67 32.19 175.46 26.71 184.01 51.45 210.54 60.99 210.79"},{"name":"Миколаївська область","cultures":{"wheat":0.725,"rape":0,"sunflower":0.072,"soy":0.019,"corn":0.184},"disabled":false,"points":"437.12 339.83 446.79 315.85 445.63 294.19 442.92 265.96 428.61 265.96 423.97 281.82 404.63 283.36 388 269.05 360.93 256.29 330.66 261.84 327.82 271.12 335.56 292.01 344.84 290.98 354.38 312.63 366.24 313.15 371.65 326.04 365.98 331.97 367.65 355.59 379.5 352.98 408.5 340.6 437.12 339.83"},{"name":"Одеська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"371.65 326.04 366.24 313.15 354.38 312.63 344.84 290.98 335.56 292.01 327.82 271.12 330.66 261.84 314.13 255.52 292.25 259.01 272.04 268.3 288.64 278.08 282.81 296.9 297.89 309.66 298.28 331.71 313.75 340.22 316.45 349.88 311.43 364.19 292.48 363.04 287.06 358.01 272.75 362.26 276.23 381.21 253.8 409.45 243.74 416.79 238.72 428.78 263.47 439.61 281.26 427.62 292.86 427.24 303.07 435.87 309.62 428.14 313.39 410.6 340.71 384.82 352.06 359.04 367.65 355.59 365.98 331.97 371.65 326.04"},{"name":"Полтавська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"531.88 158.44 510.61 147.61 509.83 133.69 499 136.4 489.72 127.5 482.76 112.42 458.01 116.28 437.12 114.74 429.39 122.86 419.33 124.79 410.44 121.7 401.15 125.95 399.22 132.53 414.69 147.61 411.98 157.28 428.61 171.59 429.77 185.51 436.35 194.8 474.25 213.75 487.4 222.64 493.98 215.29 490.5 206.01 509.83 192.47 515.25 192.64 515.25 183.58 527.24 184.35 534.59 171.59 531.88 158.44"},{"name":"Рівненська область","cultures":{"wheat":0.304,"rape":0.14,"sunflower":0.106,"soy":0.105,"corn":0.345},"disabled":false,"points":"149.42 130.87 172.62 127.52 172.88 135 185.77 129.33 199.69 112.05 211.29 108.7 215.93 99.16 214.9 81.37 235.96 50.56 233.98 50.18 197.37 35.23 157.47 25.18 154.79 56.34 170.26 74.9 159.43 102.75 135.06 104.68 131.6 120.09 140.91 137.58 149.42 130.87"},{"name":"Сумська область","cultures":{"wheat":0.165,"rape":0.095,"sunflower":0.038,"soy":0.139,"corn":0.563},"disabled":false,"points":"513.45 69.77 483.54 66.16 486.64 37.29 458.28 1.19 445.44 6.02 443.7 16.5 448.73 23.07 434.8 38.93 437.9 59.82 430.93 78.77 440.99 83.41 440.6 101.97 437.12 114.74 458.01 116.28 482.76 112.42 489.72 127.5 499 136.4 509.83 133.69 535.11 119.79 513.45 69.77"},{"name":"Тернопільська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"168.78 219.18 167.42 193.66 172.26 186.12 166.07 167.94 172.64 159.05 172.88 135 172.62 127.52 149.42 130.87 140.99 137.51 141.94 143.51 111.04 168.75 124.69 207 142.09 210.29 143.83 221.5 143.77 221.97 173.42 232.91 168.78 219.18"},{"name":"Харківська область","cultures":{"wheat":0.555,"rape":0.008,"sunflower":0.221,"soy":0.015,"corn":0.201},"disabled":false,"points":"540.39 204.85 557.4 203.3 571.71 227.28 587.18 220.32 585.64 210.65 599.95 207.17 608.84 199.44 619.67 187.06 645.97 197.89 644.81 187.45 630.89 174.3 631.27 157.67 633.59 137.32 606.26 107.93 574.81 125.46 559.34 115.15 535.11 119.79 521.65 127.19 509.83 133.69 510.61 147.61 531.88 158.44 534.59 171.59 527.24 184.35 515.25 183.58 515.25 192.64 522.21 192.86 540.39 204.85"},{"name":"Херсонська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"510.61 344.08 516.79 333.64 503.64 320.11 502.48 307.73 489.33 294.58 471.54 298.06 456.46 298.45 445.61 294.01 445.63 294.19 446.79 315.85 437.12 339.83 408.5 340.6 379.5 352.98 391.25 371.41 421.67 386.88 450.03 380.18 463.43 386.88 469.62 378.63 478.39 375.02 523.76 375.02 534.37 367.7 527.62 356.85 510.61 344.08"},{"name":"Хмельницька область","cultures":{"wheat":0.153,"rape":0.1,"sunflower":0.174,"soy":0.216,"corn":0.357},"disabled":false,"points":"190.41 230.65 212.32 230.13 214.13 216.47 218.25 199.45 234.5 197.13 230.11 177.54 234.5 160.52 223.67 149.18 228.82 142.22 227.54 129.33 218.51 125.97 211.21 108.73 199.69 112.05 185.77 129.33 172.88 135 172.64 159.05 166.07 167.94 172.26 186.12 167.42 193.66 168.78 219.18 173.42 232.91 181.65 238.9 190.41 230.65"},{"name":"Черкаська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"428.61 171.59 411.98 157.28 414.69 147.61 399.22 132.53 393.03 139.49 385.3 157.67 378.33 153.41 367.51 154.96 365.19 172.75 355.13 187.45 324.96 189.77 308.49 197.91 303.59 208.73 322.15 241.73 340.82 234.63 348.56 222.64 372.92 224.58 382.98 212.97 396.13 213.75 411.21 205.63 430.93 209.11 436.35 194.8 429.77 185.51 428.61 171.59"},{"name":"Чернігівська область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"419.33 124.79 429.39 122.86 437.12 114.74 440.6 101.97 440.99 83.41 430.93 78.77 437.9 59.82 434.8 38.93 448.73 23.07 443.7 16.5 445.44 6.02 402.07 22.34 362.37 20.79 336.07 55.34 339.27 65.62 338.89 81.86 348.17 97.33 361.7 101.97 368.67 116.28 380.66 116.67 390.71 109.71 401.15 125.95 410.44 121.7 419.33 124.79"},{"name":"Чернівецька область","cultures":{"wheat":0.25,"rape":0.12,"sunflower":0.4,"soy":0.08,"corn":0.15},"disabled":true,"points":"190.41 230.65 181.65 238.9 173.42 232.91 143.77 221.97 142.09 235.23 130.88 238.52 112.32 256.5 114.25 268.68 109.41 277.95 109.42 277.96 139.19 266.55 164.07 265.19 173.42 253.6 226.59 239.1 212.32 230.13 190.41 230.65"}]

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(72);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _index3=__webpack_require__(253);var _index4=_interopRequireDefault(_index3);var _index5=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChooseEquip=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ChooseEquip,_Component);function ChooseEquip(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChooseEquip);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChooseEquip.__proto__||Object.getPrototypeOf(ChooseEquip)).call.apply(_ref,[this].concat(args))),_this),_this.state={limit:_this.props.limit-_index5.presets[_this.props.elem].reduce(function(sum,current){if(current.name!=="Хопер"){return sum+current.quantity;};return sum;},0)},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChooseEquip,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:_index2.default.chooseEquipment},_react2.default.createElement('h3',null,this.props.data.title),_react2.default.createElement('div',{className:_index2.default.equipTableHeading},_react2.default.createElement('div',{className:_index2.default.equipRow},_react2.default.createElement('div',{className:_index2.default.columnEquipName},'\u041E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435'),_react2.default.createElement('div',{className:_index2.default.columnCrops},this.props.data.desc),_react2.default.createElement('div',{className:_index2.default.columnPrice},'\u0426\u0435\u043D\u0430 ($)'),_react2.default.createElement('div',{className:_index2.default.columnQuantity},'\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E')),_react2.default.createElement('div',{className:_index2.default.equipRow},_react2.default.createElement('div',{className:_index2.default.columnEquipName}),_react2.default.createElement('div',{className:_index2.default.columnCrops},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.wheat},_react2.default.createElement('i',{className:_iconfonts2.default.wheat})),_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.rape},_react2.default.createElement('i',{className:_iconfonts2.default.rape})),_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.soy},_react2.default.createElement('i',{className:_iconfonts2.default.soy})),_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.sunflower},_react2.default.createElement('i',{className:_iconfonts2.default.sunflower})),_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.corn},_react2.default.createElement('i',{className:_iconfonts2.default.corn}))),_react2.default.createElement('div',{className:_index2.default.columnPrice}),_react2.default.createElement('div',{className:_index2.default.columnQuantity}))),_react2.default.createElement('div',{className:_index2.default.scrollableItems},_react2.default.createElement('div',{className:_index2.default.equipList},_index5.presets[this.props.elem].map(function(item,i){return _react2.default.createElement(_index4.default,Object.assign({id:i},item,{func:function func(quantity){if(_this2.props.elem==='storageEquip'&&_index5.presets[_this2.props.elem][i].name==="Хопер"){if(item.quantity+quantity<=4){item.quantity+=quantity;}}else{if(quantity<=_this2.state.limit&&_this2.state.limit-_this2.props.limit-quantity<=0){item.quantity+=quantity;_this2.setState({limit:_this2.state.limit-quantity});if(_this2.props.refer){_index5.presets.setCulturePlan();}}}},key:i}));}))),_react2.default.createElement('div',{className:_index2.default.elementCounter},'\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432: ',this.state.limit));}}]);return ChooseEquip;}(_react.Component))||_class;exports.default=ChooseEquip;module.exports=exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(72);var _index2=_interopRequireDefault(_index);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);var _reactSimpleLineIcons=__webpack_require__(22);var _reactSimpleLineIcons2=_interopRequireDefault(_reactSimpleLineIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import samplePic from './sample_pic.jpg';
var DropItem=(0,_mobxReact.observer)(_class=function(_Component){_inherits(DropItem,_Component);function DropItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DropItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DropItem.__proto__||Object.getPrototypeOf(DropItem)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,inputValue:_this.props.quantity},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DropItem,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:_index2.default.equipItem+(this.state.open?' '+_index2.default.openDropdown:'')},_react2.default.createElement('div',{className:_index2.default.equipRow},_react2.default.createElement('div',{className:_index2.default.columnEquipName,onClick:function onClick(){_this2.setState({open:!_this2.state.open});}},this.props.name,_react2.default.createElement('div',{className:_index2.default.dropdownArrow},_react2.default.createElement(_reactFontawesome2.default,{name:'chevron-down'}))),_react2.default.createElement('div',{className:_index2.default.columnCrops},_react2.default.createElement('div',null,this.props.capacity?this.props.capacity*0.96:this.props.wheatpercents.min+"-"+this.props.wheatpercents.max+'\n'+this.props.wheateff.min+"-"+this.props.wheateff.max),_react2.default.createElement('div',null,this.props.capacity?this.props.capacity*0.8:this.props.rapepercents.min+"-"+this.props.rapepercents.max+'\n'+this.props.rapeeff.min+"-"+this.props.rapeeff.max),_react2.default.createElement('div',null,this.props.capacity?this.props.capacity*0.86:this.props.soypercents.min+"-"+this.props.soypercents.max+'\n'+this.props.soyeff.min+"-"+this.props.soyeff.max),_react2.default.createElement('div',null,this.props.capacity?this.props.capacity*0.52:this.props.sunflowerpercents.min+"-"+this.props.sunflowerpercents.max+'\n'+this.props.sunflowereff.min+"-"+this.props.sunflowereff.max),_react2.default.createElement('div',null,this.props.capacity?this.props.capacity*0.88:this.props.cornpercents.min+"-"+this.props.cornpercents.max+'\n'+this.props.corneff.min+"-"+this.props.corneff.max)),_react2.default.createElement('div',{className:_index2.default.columnPrice},this.props.price),_react2.default.createElement('div',{className:_index2.default.columnQuantity},_react2.default.createElement('div',{className:_index2.default.quantityDecrease,onClick:function onClick(){if(+_this2.props.quantity-1>=0){_this2.setState({inputValue:+_this2.state.inputValue-1});_this2.props.func(-1);}}},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'arrow-left',style:{fontSize:'1.25rem'}})),_react2.default.createElement('input',{className:_index2.default.itemQuantity,value:this.props.quantity,onChange:function onChange(e){if(!/\D+/g.test(e.target.value)){_this2.props.func(+e.target.value-_this2.props.quantity);}}}),_react2.default.createElement('div',{className:_index2.default.quantityIncrease,onClick:function onClick(){_this2.setState({inputValue:+_this2.state.inputValue+1});_this2.props.func(1);}},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'arrow-right',style:{fontSize:'1.25rem'}})))),_react2.default.createElement('div',{className:_index2.default.dropdown},_react2.default.createElement('div',null,_react2.default.createElement('h4',null,this.props.name),_react2.default.createElement('p',null,this.props.definition)),_react2.default.createElement('div',{className:_index2.default.dropdownPic},_react2.default.createElement('img',{src:this.props.picture,alt:''}))));}}]);return DropItem;}(_react.Component))||_class;exports.default=DropItem;module.exports=exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_class4;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(255);var _index2=_interopRequireDefault(_index);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _reactSimpleLineIcons=__webpack_require__(22);var _reactSimpleLineIcons2=_interopRequireDefault(_reactSimpleLineIcons);var _index3=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChooseCropPlan=(0,_mobxReact.observer)(_class=function(_Component){_inherits(ChooseCropPlan,_Component);function ChooseCropPlan(){_classCallCheck(this,ChooseCropPlan);return _possibleConstructorReturn(this,(ChooseCropPlan.__proto__||Object.getPrototypeOf(ChooseCropPlan)).apply(this,arguments));}_createClass(ChooseCropPlan,[{key:'render',value:function render(){var cultureTotal=_index3.presets.culturePlan.wheat+_index3.presets.culturePlan.rape+_index3.presets.culturePlan.soy+_index3.presets.culturePlan.sunflower+_index3.presets.culturePlan.corn;var totalWeight=_index3.presets.storageEquip.reduce(function(sum,current){return sum+ +current.capacity*current.quantity;},0);var turnover=(cultureTotal/totalWeight).toFixed(1);if(!cultureTotal||!totalWeight)turnover=0;return _react2.default.createElement('div',{className:_index2.default.chooseCropPlan},_react2.default.createElement('h3',null,'\u041F\u043B\u0430\u043D \u043E\u0431\'\u0454\u043C\u0456\u0432 \u043A\u0443\u043B\u044C\u0442\u0443\u0440'),_react2.default.createElement('div',{className:_index2.default.cropPlanCultures},_react2.default.createElement(CultureStats,{culture:'wheat',title:'\u041F\u0448\u0435\u043D\u0438\u0446\u044F'}),_react2.default.createElement(CultureStats,{culture:'rape',title:'\u0420\u0456\u043F\u0430\u043A'}),_react2.default.createElement(CultureStats,{culture:'soy',title:'\u0421\u043E\u044F'}),_react2.default.createElement(CultureStats,{culture:'sunflower',title:'\u0421\u043E\u043D\u044F\u0448\u043D\u0438\u043A'}),_react2.default.createElement(CultureStats,{culture:'corn',title:'\u041A\u0443\u043A\u0443\u0440\u0443\u0434\u0437\u0430'})),_react2.default.createElement('h3',null,'\u041F\u043B\u0430\u043D \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F \u043A\u0443\u043B\u044C\u0442\u0443\u0440'),_react2.default.createElement('div',{className:_index2.default.cropPlanCultures},_react2.default.createElement(Save,{culture:'wheat',title:'\u041F\u0448\u0435\u043D\u0438\u0446\u044F'}),_react2.default.createElement(Save,{culture:'rape',title:'\u0420\u0456\u043F\u0430\u043A'}),_react2.default.createElement(Save,{culture:'soy',title:'\u0421\u043E\u044F'}),_react2.default.createElement(Save,{culture:'sunflower',title:'\u0421\u043E\u043D\u044F\u0448\u043D\u0438\u043A'}),_react2.default.createElement(Save,{culture:'corn',title:'\u041A\u0443\u043A\u0443\u0440\u0443\u0434\u0437\u0430'})),_react2.default.createElement('div',{className:_index2.default.result},_react2.default.createElement('p',null,'\u0412\u0441\u044C\u043E\u0433\u043E \u0437\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E:'),_react2.default.createElement('h2',null,cultureTotal,' \u0442.'),_react2.default.createElement('p',null,'\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043E\u0431\u0435\u0440\u0442\u0456\u0432:'),_react2.default.createElement('h2',null,turnover)));}}]);return ChooseCropPlan;}(_react.Component))||_class;exports.default=ChooseCropPlan;var CultureStats=(0,_mobxReact.observer)(_class2=function(_Component2){_inherits(CultureStats,_Component2);function CultureStats(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,CultureStats);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=CultureStats.__proto__||Object.getPrototypeOf(CultureStats)).call.apply(_ref,[this].concat(args))),_this2),_this2.state={inputValue:_index3.presets.culturePlan[_this2.props.culture],interval:''},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(CultureStats,[{key:'render',value:function render(){var _this3=this;var cultureTotal=_index3.presets.culturePlan.wheat+_index3.presets.culturePlan.rape+_index3.presets.culturePlan.soy+_index3.presets.culturePlan.sunflower+_index3.presets.culturePlan.corn;return _react2.default.createElement('div',{className:_index2.default.cropPlanCulture},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default[this.props.culture]},_react2.default.createElement('i',{className:_iconfonts2.default[this.props.culture]})),_react2.default.createElement('h4',null,this.props.title),_react2.default.createElement('div',{className:_index2.default.cropPlanAdjust},_react2.default.createElement('div',{className:_index2.default.quantityDecrease,onMouseDown:function onMouseDown(){var internalfunc=setInterval(function(){if(+_this3.state.inputValue-60>=0){_this3.setState({inputValue:+_this3.state.inputValue-60});_index3.presets.culturePlan[_this3.props.culture]-=60;}},200);_this3.setState({interval:internalfunc});},onClick:function onClick(){if(+_this3.state.inputValue-60>=0){_this3.setState({inputValue:+_this3.state.inputValue-60});_index3.presets.culturePlan[_this3.props.culture]-=60;}},onMouseLeave:function onMouseLeave(){return clearInterval(_this3.state.interval);},onMouseUp:function onMouseUp(){return clearInterval(_this3.state.interval);}},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'arrow-left',style:{fontSize:'1.25rem'}})),_react2.default.createElement('input',{className:_index2.default.itemQuantity,value:Math.round(this.state.inputValue),onChange:function onChange(e){if(!/\D+/g.test(e.target.value)){_this3.setState({inputValue:e.target.value});}_index3.presets.culturePlan[_this3.props.culture]+=+e.target.value-_index3.presets.culturePlan[_this3.props.culture];},onBlur:function onBlur(e){if(e.target.value===''){_this3.setState({inputValue:0});_index3.presets.culturePlan[_this3.props.culture]=0;}}}),_react2.default.createElement('div',{className:_index2.default.quantityIncrease,onMouseDown:function onMouseDown(){var internalfunc=setInterval(function(){_this3.setState({inputValue:+_this3.state.inputValue+60});_index3.presets.culturePlan[_this3.props.culture]+=60;},200);_this3.setState({interval:internalfunc});},onMouseLeave:function onMouseLeave(){return clearInterval(_this3.state.interval);},onClick:function onClick(){_this3.setState({inputValue:+_this3.state.inputValue+60});_index3.presets.culturePlan[_this3.props.culture]+=60;},onMouseUp:function onMouseUp(){return clearInterval(_this3.state.interval);}},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'arrow-right',style:{fontSize:'1.25rem'}}))),_react2.default.createElement('p',null,cultureTotal?(_index3.presets.culturePlan[this.props.culture]/cultureTotal*100).toFixed(1):'0.0','%'));}}]);return CultureStats;}(_react.Component))||_class2;var Save=(0,_mobxReact.observer)(_class4=function(_Component3){_inherits(Save,_Component3);function Save(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,Save);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=Save.__proto__||Object.getPrototypeOf(Save)).call.apply(_ref2,[this].concat(args))),_this4),_this4.state={inputValue:_index3.presets.cultureHoldingPlan[_this4.props.culture],interval:''},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(Save,[{key:'render',value:function render(){var _this5=this;var cultureTotal=_index3.presets.culturePlan.wheat+_index3.presets.culturePlan.rape+_index3.presets.culturePlan.soy+_index3.presets.culturePlan.sunflower+_index3.presets.culturePlan.corn;return _react2.default.createElement('div',{className:_index2.default.cropPlanCulture,style:{border:'none'}},_react2.default.createElement('h4',null,this.props.title),_react2.default.createElement('div',{className:_index2.default.cropPlanAdjust},_react2.default.createElement('div',{className:_index2.default.quantityDecrease,onMouseDown:function onMouseDown(){var internalfunc=setInterval(function(){if(+_this5.state.inputValue-1>=0){_this5.setState({inputValue:+_this5.state.inputValue-1});_index3.presets.cultureHoldingPlan[_this5.props.culture]-=1;}},200);_this5.setState({interval:internalfunc});},onClick:function onClick(){if(+_this5.state.inputValue-1>=0){_this5.setState({inputValue:+_this5.state.inputValue-1});_index3.presets.cultureHoldingPlan[_this5.props.culture]-=1;}},onMouseLeave:function onMouseLeave(){return clearInterval(_this5.state.interval);},onMouseUp:function onMouseUp(){return clearInterval(_this5.state.interval);}},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'arrow-left',style:{fontSize:'1.25rem'}})),_react2.default.createElement('input',{className:_index2.default.itemQuantity,value:Math.round(this.state.inputValue),onChange:function onChange(e){if(!/\D+/g.test(e.target.value)&&e.target.value<=100){_this5.setState({inputValue:e.target.value});_index3.presets.cultureHoldingPlan[_this5.props.culture]+=+e.target.value-_index3.presets.cultureHoldingPlan[_this5.props.culture];}},onBlur:function onBlur(e){if(e.target.value===''){_this5.setState({inputValue:0});_index3.presets.culturePlan[_this5.props.culture]=0;}}}),_react2.default.createElement('div',{className:_index2.default.quantityIncrease,onMouseDown:function onMouseDown(){var internalfunc=setInterval(function(){if(+_this5.state.inputValue+1<=100){_this5.setState({inputValue:+_this5.state.inputValue+1});_index3.presets.cultureHoldingPlan[_this5.props.culture]+=1;}},200);_this5.setState({interval:internalfunc});},onClick:function onClick(){if(+_this5.state.inputValue+1<=100){_this5.setState({inputValue:+_this5.state.inputValue+1});_index3.presets.cultureHoldingPlan[_this5.props.culture]+=1;}},onMouseLeave:function onMouseLeave(){return clearInterval(_this5.state.interval);},onMouseUp:function onMouseUp(){return clearInterval(_this5.state.interval);}},_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'arrow-right',style:{fontSize:'1.25rem'}}))),_react2.default.createElement('p',null,'\u0414\u043D.'));}}]);return Save;}(_react.Component))||_class4;// @observer
// class Month extends Component{
//
//   render() {
//       let height = (
//           ( presets.culturePlan.wheat * this.props.cultureSpread.wheat[this.props.month]
//           + presets.culturePlan.rape * this.props.cultureSpread.rape[this.props.month]
//           + presets.culturePlan.soy * this.props.cultureSpread.soy[this.props.month]
//           + presets.culturePlan.sunflower * this.props.cultureSpread.sunflower[this.props.month]
//           + presets.culturePlan.corn * this.props.cultureSpread.corn[this.props.month] ) / 30 / 15
//           + 12).toFixed(0) + 'px';
//       return (
//           <div className={styles.month}>
//             <div className={styles.monthCultures} style={{height: height}}>
//               <Culture culture="wheat" quantity={presets.culturePlan.wheat * this.props.cultureSpread.wheat[this.props.month]}/>
//               <Culture culture="rape" quantity={presets.culturePlan.rape * this.props.cultureSpread.rape[this.props.month]}/>
//               <Culture culture="soy" quantity={presets.culturePlan.soy * this.props.cultureSpread.soy[this.props.month]}/>
//               <Culture culture="sunflower"
//                        quantity={presets.culturePlan.sunflower * this.props.cultureSpread.sunflower[this.props.month]}/>
//               <Culture culture="corn" quantity={presets.culturePlan.corn * this.props.cultureSpread.corn[this.props.month]}/>
//             </div>
//             <p>{this.props.name}</p>
//           </div>
//       )
//   }
// }
//
// const Culture = (props) => {
//   let height = (props.quantity/30/15).toFixed(0) + 'px';
//     return(
//       <div
//         className={styles.culture + " " + styles[props.culture]}
//         style={{height:height}}
//       />
//     )
// }
module.exports=exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chooseCropPlan":"_2OvNAptZeQ9z4NOTXwMQsb","cropPlanCultures":"_1kYiVjB4ejpv5ZMIMsoFBi","cropPlanCulture":"_3EOXhrmjZXi3-Q678CDvUJ","cropPlanAdjust":"_1P1_3_sc9Uwn9IOVxpjSrG","itemQuantity":"ipiw5VcqnleptQrCX0pze","quantityDecrease":"v10V3rkkefBp6kSjnz-Jq","quantityIncrease":"N1TrTjz2suQmvzSjej2l0","culturesTable":"_28j455ApOSReHSUbvpyFpO","month":"_9EptOZpdRJyQuLjr7yfBj","monthCultures":"_1f_NDtvZ-II_a4J6E8vj5_","culture":"_36iRXYvWbsy6k67OTBoAjq","cultureCircle":"_1qDb1AtNT1aOExoDXGlAgh","wheat":"_1lHmMAVz70qw-RA3SyLpQv","rape":"_3l0HCIyJrDfmJ5LRzYLhd-","soy":"_2D56XghALNto95-4uawC3_","sunflower":"_2hv4hdZObhIS473jZtSDgr","corn":"_2Ye7_dJNqs9J8QAmlJMZgq","result":"_23SEkahQq3xFQS_wn8h2gY","dailyTurnover":"_3Ws87pg-MfiMn66EJoV-gy"};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(257);var _index2=_interopRequireDefault(_index);var _reactSimpleLineIcons=__webpack_require__(22);var _reactSimpleLineIcons2=_interopRequireDefault(_reactSimpleLineIcons);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChooseDifficulty=function(_Component){_inherits(ChooseDifficulty,_Component);function ChooseDifficulty(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChooseDifficulty);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChooseDifficulty.__proto__||Object.getPrototypeOf(ChooseDifficulty)).call.apply(_ref,[this].concat(args))),_this),_this.state={difficulty:'easy'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChooseDifficulty,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:_index2.default.chooseDifficulty},_react2.default.createElement('h3',null,'\u0412\u0438\u0431\u0456\u0440 \u0440\u0456\u0432\u043D\u044F \u0441\u043A\u043B\u0430\u0434\u043D\u043E\u0441\u0442\u0456'),_react2.default.createElement('div',{className:_index2.default.difficultyVariants},_react2.default.createElement('div',{className:_index2.default.variant+(this.state.difficulty==='easy'?" "+_index2.default.active:'')},_react2.default.createElement('div',{className:_index2.default.variantPic+' '+_index2.default.easy}),_react2.default.createElement('h3',null,'\u041F\u041E\u0427\u0410\u0422\u041A\u041E\u0412\u0418\u0419'),_react2.default.createElement('p',null,'\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u0445\u0438\u043B\u0456\u0432 \u0432\u0456\u0434 \u0433\u0440\u0430\u0444\u0438\u043A\u0443 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0442\u0430 \u0432\u0456\u0434\u0433\u0440\u0443\u0437\u043A\u0438, \u043D\u0435\u043C\u0430\u0454 \u0432\u0438\u043F\u0430\u0434\u043A\u043E\u0432\u0438\u0445 \u044F\u0432\u0438\u0449, \u0432\u043F\u043B\u0438\u0432 \u0437\u0430\u0442\u0440\u0438\u043C\u043E\u043A \u0443 \u043E\u0431\u0440\u043E\u0431\u0446\u0456 \u043E\u0431\u043E\u0440\u043E\u0442\u0443 \u043A\u0443\u043B\u044C\u0442\u0443\u0440 \u0442\u0430 \u0437\u0430\u043F\u0438\u0442\u0456\u0432 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0438\u0439. \u0406\u0434\u0435\u0430\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u043F\u0435\u0440\u0448\u043E\u0433\u043E \u0434\u043E\u0441\u0432\u0456\u0434\u0443 \u043C\u043E\u0434\u0435\u043B\u044E\u0432\u0430\u043D\u043D\u044F \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0430.'),this.state.difficulty==='easy'&&_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'check',size:'large',style:{color:'#7ed321'}}),this.state.difficulty!=='easy'&&_react2.default.createElement('div',{className:_index2.default.button,onClick:function onClick(){_this2.setState({difficulty:'easy'});}},'\u041E\u0411\u0420\u0410\u0422\u0418')),_react2.default.createElement('div',{className:_index2.default.variant+(this.state.difficulty==='advanced'?" "+_index2.default.active:'')},_react2.default.createElement('div',{className:_index2.default.variantPic+' '+_index2.default.advanced}),_react2.default.createElement('h3',null,'\u0414\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u0438\u0439'),_react2.default.createElement('p',null,'\u041F\u043E\u043C\u0456\u0442\u043D\u0456 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u0433\u0440\u0430\u0444\u0438\u043A\u0443 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0442\u0430 \u0432\u0456\u0434\u0433\u0440\u0443\u0437\u043A\u0438 \u0432 \u0437\u0430\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0456 \u0432\u0456\u0434 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0443 \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0438\u0441\u0442\u0430, \u0456\u043D\u043A\u043E\u043B\u0438 \u0432\u0438\u043D\u0438\u043A\u0430\u044E\u0442\u044C \u0432\u0438\u043F\u0430\u0434\u043A\u043E\u0432\u0456 \u044F\u0432\u0438\u0449\u0430, \u044F\u043A\u0456 \u0437\u0430\u0432\u0430\u0436\u0430\u044E\u0442\u044C \u0440\u043E\u0431\u043E\u0442\u0456 \u0440\u0456\u0437\u043D\u0438\u0445 \u0432\u0443\u0437\u043B\u0456\u0432 \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0430. \u041F\u0456\u0434\u0456\u0439\u0434\u0435 \u0434\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u0438\u043C \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0438\u0441\u0442\u0430\u043C.'),this.state.difficulty==='advanced'&&_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'check',size:'large',style:{color:'#7ed321'}}),this.state.difficulty!=='advanced'&&_react2.default.createElement('div',{className:_index2.default.button,onClick:function onClick(){_this2.setState({difficulty:'advanced'});}},'\u041E\u0411\u0420\u0410\u0422\u0418')),_react2.default.createElement('div',{className:_index2.default.variant+(this.state.difficulty==='expert'?" "+_index2.default.active:'')},_react2.default.createElement('div',{className:_index2.default.variantPic+' '+_index2.default.expert}),_react2.default.createElement('h3',null,'\u0415\u041A\u0421\u041F\u0415\u0420\u0422'),_react2.default.createElement('p',null,'\u0420\u0435\u0439\u0442\u0438\u043D\u0433 \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0438\u0441\u0442\u0430 \u0441\u0443\u0442\u0442\u0454\u0432\u043E \u0432\u043F\u043B\u0438\u0432\u0430\u0454 \u043D\u0430 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u0433\u0440\u0430\u0444\u0438\u043A\u0443 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0442\u0430 \u0432\u0456\u0434\u0433\u0440\u0443\u0437\u043A\u0438, \u0432\u0438\u043F\u0430\u0434\u043A\u043E\u0432\u0456 \u044F\u0432\u0438\u0449\u0430 \u0447\u0430\u0441\u0442\u0456\u0448\u0435 \u0442\u0430 \u043C\u0430\u044E\u0442\u044C \u0431\u0456\u043B\u044C\u0448\u0438\u0439 \u0432\u043F\u043B\u0438\u0432 \u043D\u0430 \u043F\u0440\u043E\u0446\u0435\u0441\u0438.',_react2.default.createElement('br',null),'\u0414\u043B\u044F \u0441\u043F\u0440\u0430\u0432\u0436\u043D\u0456\u0445 \u0435\u043A\u0441\u043F\u0435\u0440\u0442\u0456\u0432 \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u043D\u043E\u0433\u043E \u0431\u0456\u0437\u043D\u0435\u0441\u0443.'),this.state.difficulty==='expert'&&_react2.default.createElement(_reactSimpleLineIcons2.default,{name:'check',size:'large',style:{color:'#7ed321'}}),this.state.difficulty!=='expert'&&_react2.default.createElement('div',{className:_index2.default.button,onClick:function onClick(){_this2.setState({difficulty:'expert'});}},'\u041E\u0411\u0420\u0410\u0422\u0418'))));}}]);return ChooseDifficulty;}(_react.Component);exports.default=ChooseDifficulty;module.exports=exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chooseDifficulty":"_3h6G_wyYS1bBfXnfsCjYmH","difficultyVariants":"_22kubSS3vsDhjuGKd6KjrS","variant":"_3Krk8_ITCPPv6VUwDzbwP4","variantPic":"_3KCbDYPQ1T4ZIpqxx0wUzM","easy":"_2iFYDDOXt7SOJ__MtHPrDg","advanced":"Ai712aw0zhypdxAXx0i0x","expert":"_1SMA5D21_8saTgw1Vhq3Kh","active":"aGm0UZiKUissVUsXA47qL","button":"qp8VgaKkFOGPoy0C00ULJ"};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _mobxReact=__webpack_require__(2);var _index=__webpack_require__(259);var _index2=_interopRequireDefault(_index);var _notYet=__webpack_require__(260);var _notYet2=_interopRequireDefault(_notYet);var _reactRouterDom=__webpack_require__(11);var _iconfonts=__webpack_require__(5);var _iconfonts2=_interopRequireDefault(_iconfonts);var _index3=__webpack_require__(1);var _reactCompoundSlider=__webpack_require__(73);var _CompoundSlider=__webpack_require__(296);var _CompoundSlider2=_interopRequireDefault(_CompoundSlider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EquipResults=(0,_mobxReact.observer)(_class=function(_Component){_inherits(EquipResults,_Component);function EquipResults(){_classCallCheck(this,EquipResults);return _possibleConstructorReturn(this,(EquipResults.__proto__||Object.getPrototypeOf(EquipResults)).apply(this,arguments));}_createClass(EquipResults,[{key:'render',value:function render(){var ebitda={"wheat":4.94,"rape":6.20,"soy":5.42,"sunflower":9.16,"corn":9.79};var cultureTotal=_index3.presets.culturePlan.wheat+_index3.presets.culturePlan.rape+_index3.presets.culturePlan.soy+_index3.presets.culturePlan.sunflower+_index3.presets.culturePlan.corn;cultureTotal=cultureTotal===0?1:cultureTotal;var totalWeight=_index3.presets.storageEquip.reduce(function(sum,current){return sum+ +current.capacity*current.quantity;},0);var turnover=(cultureTotal/totalWeight).toFixed(1);if(!cultureTotal||!totalWeight)turnover='0.0';var input=_index3.presets.inputEquip.filter(function(item){return item.quantity;});var output=_index3.presets.outputEquip.filter(function(item){return item.quantity;});var cleaning=_index3.presets.cleaningEquip.filter(function(item){return item.quantity;});var drying=_index3.presets.dryingEquip.filter(function(item){return item.quantity;});var storage=_index3.presets.storageEquip.filter(function(item){return item.quantity;});var totalCost=function totalCost(){var result=0;input.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});output.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});cleaning.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});drying.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});storage.forEach(function(item){result+=item.quantity*+item.price.replace(/[.| ]/gim,'');});return result+_index3.presets.infrastructure;};var totalStorage=storage.reduce(function(sum,current){return sum+ +current.capacity*current.quantity;},0);var capitalTurnover=function capitalTurnover(){var result=0;var holdingPrices={"wheat":1.39,"rape":1.67,"soy":1.50,"sunflower":3.05,"corn":1.39};for(var key in _index3.presets.culturePlan){result+=_index3.presets.culturePlan[key]*ebitda[key];result+=_index3.presets.culturePlan[key]*(_index3.presets.cultureHoldingPlan[key]/30)*holdingPrices[key];}if(totalCost()!==0){return(result/totalCost()*100).toFixed(2);}return 0 .toFixed(2);};return _react2.default.createElement('div',{className:_index2.default.equipResult},_react2.default.createElement('h3',null,'\u0412\u0418 \u041E\u0411\u0420\u0410\u041B\u0418:'),_react2.default.createElement('div',{className:_index2.default.notYet,style:{display:_index3.presets.region||input.length||output.length||cleaning.length||drying.length||storage.length?'none':''}},_react2.default.createElement('p',null,'\u041F\u043E\u043A\u0438\u0449\u043E \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u043E\u0431\u0440\u0430\u043D\u043E'),_react2.default.createElement('img',{src:_notYet2.default,alt:'\u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u043E\u0431\u0440\u0430\u043D\u043E'}),_react2.default.createElement('p',{className:_index2.default.hint},'\u0414\u043B\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0443 \u043E\u0431\u0435\u0440\u0456\u0442\u044C \u0432\u0441\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0443 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0430 \u0437 \u0432\u043A\u043B\u0430\u0434\u043E\u043A \u0432 \u043B\u0456\u0432\u0456\u0439 \u0447\u0430\u0441\u0442\u0438\u043D\u0456 \u0435\u043A\u0440\u0430\u043D\u0443')),_react2.default.createElement('div',{className:_index2.default.scrollContainer},_react2.default.createElement('div',{className:_index2.default.scrollableCheck},_index3.presets.region?_react2.default.createElement('div',{className:_index2.default.equipResultSection},_react2.default.createElement('h4',null,'\u0420\u0435\u0433\u0456\u043E\u043D \u0440\u043E\u0437\u043C\u0456\u0449\u0435\u043D\u043D\u044F'),_react2.default.createElement('p',null,_index3.presets.region.name)):null,_react2.default.createElement(SelectedEquipment,{arr:input,title:'\u041B\u0456\u043D\u0456\u0457 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F'}),_react2.default.createElement(SelectedEquipment,{arr:cleaning,title:'\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043E\u0447\u0438\u0441\u0442\u043A\u0438'}),_react2.default.createElement(SelectedEquipment,{arr:drying,title:'\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u0441\u0443\u0448\u043A\u0438'}),_react2.default.createElement(SelectedEquipment,{arr:storage,title:'\u041F\u043E\u0442\u0443\u0436\u043D\u043E\u0441\u0442\u0456 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F'}),_react2.default.createElement(SelectedEquipment,{arr:output,title:'\u041B\u0456\u043D\u0456\u0457 \u0432\u0456\u0434\u0433\u0440\u0443\u0437\u043A\u0438'}),_index3.presets.region&&storage.length?_react2.default.createElement('div',{className:_index2.default.equipResultSection},_react2.default.createElement('h4',null,'\u041F\u043B\u0430\u043D \u043E\u0431\u044A\u0451\u043C\u043E\u0432 \u043A\u0443\u043B\u044C\u0442\u0443\u0440 (\u0442\u043E\u043D\u043D / %)'),_react2.default.createElement('div',{className:_index2.default.equipCheckCultures},_react2.default.createElement('div',{className:_index2.default.equipCheckCulture},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.wheat},_react2.default.createElement('i',{className:_iconfonts2.default.wheat})),_react2.default.createElement('p',null,Math.floor(_index3.presets.culturePlan.wheat)),_react2.default.createElement('p',null,(_index3.presets.culturePlan.wheat/cultureTotal*100).toFixed(1),'%')),_react2.default.createElement('div',{className:_index2.default.equipCheckCulture},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.rape},_react2.default.createElement('i',{className:_iconfonts2.default.rape})),_react2.default.createElement('p',null,Math.floor(_index3.presets.culturePlan.rape)),_react2.default.createElement('p',null,(_index3.presets.culturePlan.rape/cultureTotal*100).toFixed(1),'%')),_react2.default.createElement('div',{className:_index2.default.equipCheckCulture},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.soy},_react2.default.createElement('i',{className:_iconfonts2.default.soy})),_react2.default.createElement('p',null,Math.floor(_index3.presets.culturePlan.soy)),_react2.default.createElement('p',null,(_index3.presets.culturePlan.soy/cultureTotal*100).toFixed(1),'%')),_react2.default.createElement('div',{className:_index2.default.equipCheckCulture},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.sunflower},_react2.default.createElement('i',{className:_iconfonts2.default.sunflower})),_react2.default.createElement('p',null,Math.floor(_index3.presets.culturePlan.sunflower)),_react2.default.createElement('p',null,(_index3.presets.culturePlan.sunflower/cultureTotal*100).toFixed(1),'%')),_react2.default.createElement('div',{className:_index2.default.equipCheckCulture},_react2.default.createElement('div',{className:_index2.default.cultureCircle+' '+_index2.default.corn},_react2.default.createElement('i',{className:_iconfonts2.default.corn})),_react2.default.createElement('p',null,Math.floor(_index3.presets.culturePlan.corn)),_react2.default.createElement('p',null,(_index3.presets.culturePlan.corn/cultureTotal*100).toFixed(1),'%'))),_react2.default.createElement('div',{className:_index2.default.finalResultsItem},_react2.default.createElement('p',null,'\u0412\u0441\u044C\u043E\u0433\u043E \u0437\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E:'),_react2.default.createElement('p',null,cultureTotal,' \u0442.'))):null)),_react2.default.createElement('div',{className:_index2.default.finalResults},_react2.default.createElement('h3',null,'\u0423 \u041E\u0411\u0420\u0410\u041D\u0406\u0419 \u041A\u041E\u041D\u0424\u0406\u0413\u0423\u0420\u0410\u0426\u0406\u0407:'),_react2.default.createElement('div',{className:_index2.default.finalResultsItem},_react2.default.createElement('p',null,'\u041E\u0431\'\u0454\u043C \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0432 \u0434\u0435\u043D\u044C:'),_react2.default.createElement('p',null,(input.reduce(function(sum,current){return sum+ +current.capacity*current.quantity;},0)*24).toString().replace(/\B(?=(\d{3})+(?!\d))/g," "),' \u0442.')),_react2.default.createElement('div',{className:_index2.default.finalResultsItem},_react2.default.createElement('p',null,'\u0421\u0443\u043C\u0430\u0440\u043D\u0438\u0439 \u043E\u0431\'\u0454\u043C \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F:'),_react2.default.createElement('p',null,totalStorage.toString().replace(/\B(?=(\d{3})+(?!\d))/g," "),' \u0442.')),_react2.default.createElement('div',{className:_index2.default.finalResultsItem},_react2.default.createElement('p',null,'\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043E\u0431\u0435\u0440\u0442\u0456\u0432 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D:'),_react2.default.createElement('p',null,turnover)),_react2.default.createElement('div',{className:_index2.default.finalResultsItem},_react2.default.createElement('p',null,'\u041E\u0446\u0456\u043D\u043A\u0430 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u0443:'),_react2.default.createElement('h2',{style:{transition:'500ms',color:capitalTurnover()<15?'#FF0000':"#7ed321"}},capitalTurnover(),'%')),_react2.default.createElement('div',{className:_index2.default.rangeSlider},_react2.default.createElement('h3',null,'\u0412\u0410\u0420\u0422\u0406\u0421\u0422\u042C \u0406\u041D\u0424\u0420\u0410\u0421\u0422\u0420\u0423\u041A\u0422\u0423\u0420\u0418:'),_react2.default.createElement(_CompoundSlider2.default,{width:"100%"})),_react2.default.createElement('div',{className:_index2.default.finalResultsItem},_react2.default.createElement('p',null,'\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0435\u043B\u0435\u0432\u0430\u0442\u043E\u0440\u0430:'),_react2.default.createElement('h2',null,'$ ',totalCost().toString().replace(/\B(?=(\d{3})+(?!\d))/g," ")))),_react2.default.createElement('br',null),_react2.default.createElement(_reactRouterDom.Link,{to:'/app',className:_index2.default.button+(_index3.presets.region&&input.length&&output.length&&cleaning.length&&drying.length&&storage.length?'':' '+_index2.default.disabled),onClick:function onClick(e){_index3.presets.region&&input.length&&output.length&&cleaning.length&&drying.length&&storage.length?_index3.presets.setElevatorsData():e.preventDefault();}},'\u0421\u0422\u0412\u041E\u0420\u0418\u0422\u0418 \u0415\u041B\u0415\u0412\u0410\u0422\u041E\u0420'));}}]);return EquipResults;}(_react.Component))||_class;exports.default=EquipResults;var SelectedEquipment=function SelectedEquipment(props){if(props.arr.length){return _react2.default.createElement('div',{className:_index2.default.equipResultSection},_react2.default.createElement('h4',null,props.title),props.arr.map(function(item,i){return _react2.default.createElement('div',{className:_index2.default.equipCheckItem,key:i},_react2.default.createElement('p',null,item.name),_react2.default.createElement('p',null,item.quantity,'\u0448\u0442'),_react2.default.createElement('p',null,'$',(+item.price.replace(/[.| ]/gim,'')*item.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g,".")));}));}return null;};// let culturePlan = {
//     "wheat":106260,
//     "rape":13380,
//     "soy":17280,
//     "sunflower":12480,
//     "corn":99660
// };
module.exports=exports['default'];

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"equipResult":"_2vojKUZSrLu4_igSu7vTN","rcSlider":"_7nBvqrCBcda2Wieayv6hS","equipResultSection":"_3hR1XZVJK7h0nV3gtq4ceG","scrollContainer":"_33OeeIfzNwughyvoAddOqE","scrollableCheck":"_2PbCUWLoQM6C10BZHVIOoj","doc":"LgLbkNkhey1FTHpCa7ecK","equipCheckItem":"_22yasvi82_Pfydxkon0WuQ","notYet":"_1bAB99H4ftMehGgX2lyqII","hint":"_2p4aNEQse-G3zPUyImB1hT","equipCheckCultures":"_3HJcT3vPCmZxCvznhWd-ZJ","equipCheckCulture":"_3Hn3PrEmHlMHbhOuCRmBLO","cultureCircle":"_3gK4kLt0pg3YoEqL0T5md7","wheat":"YTp2F63w6qOcKyFGwSJhu","rape":"_3Vst_LnYkGA-A30Z8jQYIf","soy":"TX7eP-7NCYJX__C2olO9V","sunflower":"_1RVp6_OsBAZKltBf3SEqdw","corn":"_1RjgTwdUtaO6oJON8dcUUY","button":"_2l5Dzwm-Fh79kysQMDtYsR","disabled":"_3u7-tBisc-1LMTa2b4mWAO","finalResults":"o23BbUkAkSm4qc7-G9Qym","finalResultsItem":"_3LLBipL0XFgtvPOBv8q_pP","rangeSlider":"_1nIpy6dVVJKMDN6BqGnacl"};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/notYet.e2c731cb.png";

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Slider__["a"]; });


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Rail__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Ticks__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tracks__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Handles__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modes__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LinearScale__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DiscreteScale__ = __webpack_require__(295);



















var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var noop = function noop() {};

var compare = function compare(b) {
  return function (m, d, i) {
    return m && b[i] === d;
  };
};

var equal = function equal(a, b) {
  return a === b || a.length === b.length && a.reduce(compare(b), true);
};

var getNextValue = function getNextValue(curr, step, domain, reversed) {
  var newVal = curr;
  newVal = reversed ? curr - step : curr + step;
  return reversed ? Math.max(domain[0], newVal) : Math.min(domain[1], newVal);
};

var getPrevValue = function getPrevValue(curr, step, domain, reversed) {
  var newVal = curr;
  newVal = reversed ? curr + step : curr - step;
  return reversed ? Math.min(domain[1], newVal) : Math.max(domain[0], newVal);
};

var Slider =
/*#__PURE__*/
function (_PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Slider, _PureComponent);

  function Slider() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Slider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      step: null,
      values: null,
      domain: null,
      handles: null,
      reversed: null,
      activeHandleID: null,
      valueToPerc: null,
      valueToStep: null,
      pixelToStep: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "slider", __WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef());

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onKeyDown", function (e, handleID) {
      var validUpKeys = ['ArrowRight', 'ArrowUp'];
      var validDownKeys = ['ArrowDown', 'ArrowLeft'];

      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
          handles = _assertThisInitialize.state.handles,
          _assertThisInitialize2 = _assertThisInitialize.props,
          step = _assertThisInitialize2.step,
          reversed = _assertThisInitialize2.reversed,
          vertical = _assertThisInitialize2.vertical,
          domain = _assertThisInitialize2.domain;

      var key = e.key || e.keyCode;

      if (!validUpKeys.concat(validDownKeys).includes(key)) {
        return;
      }

      if (vertical) {
        var _ref = [validDownKeys, validUpKeys];
        validUpKeys = _ref[0];
        validDownKeys = _ref[1];
      }

      e.stopPropagation && e.stopPropagation();
      e.preventDefault && e.preventDefault();
      var found = handles.find(function (value) {
        return value.key === handleID;
      });

      if (!found) {
        return;
      }

      var currVal = found.val;
      var newVal = currVal;

      if (validUpKeys.includes(key)) {
        newVal = getNextValue(currVal, step, domain, reversed);
      } else if (validDownKeys.includes(key)) {
        newVal = getPrevValue(currVal, step, domain, reversed);
      }

      var nextHandles = handles.map(function (v) {
        return v.key === handleID ? {
          key: v.key,
          val: newVal
        } : v;
      });

      _this.submitUpdate(nextHandles, true);
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMouseDown", function (e, handleID) {
      _this.onStart(e, handleID, false);
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchStart", function (e, handleID) {
      if (Object(__WEBPACK_IMPORTED_MODULE_16__utils__["f" /* isNotValidTouch */])(e)) {
        return;
      }

      _this.onStart(e, handleID, true);
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getEventData", function (e, isTouch) {
      var _assertThisInitialize3 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
          _assertThisInitialize4 = _assertThisInitialize3.state,
          pixelToStep = _assertThisInitialize4.pixelToStep,
          valueToPerc = _assertThisInitialize4.valueToPerc,
          vertical = _assertThisInitialize3.props.vertical;

      var value;

      if (isTouch) {
        value = pixelToStep.getValue(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["d" /* getTouchPosition */])(vertical, e));
      } else {
        value = pixelToStep.getValue(vertical ? e.clientY : e.pageX);
      }

      return {
        value: value,
        percent: valueToPerc.getValue(value)
      };
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMouseMove", function (e) {
      var _assertThisInitialize5 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
          _assertThisInitialize6 = _assertThisInitialize5.state,
          curr = _assertThisInitialize6.handles,
          pixelToStep = _assertThisInitialize6.pixelToStep,
          activeHandleID = _assertThisInitialize6.activeHandleID,
          _assertThisInitialize7 = _assertThisInitialize5.props,
          vertical = _assertThisInitialize7.vertical,
          reversed = _assertThisInitialize7.reversed;

      var _assertThisInitialize8 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
          slider = _assertThisInitialize8.slider; // double check the dimensions of the slider


      pixelToStep.setDomain(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["b" /* getSliderDomain */])(slider.current, vertical, pixelToStep)); // find the closest value (aka step) to the event location

      var updateValue = pixelToStep.getValue(vertical ? e.clientY : e.pageX); // generate a "candidate" set of values - a suggestion of what to do

      var nextHandles = Object(__WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getUpdatedHandles */])(curr, activeHandleID, updateValue, reversed); // submit the candidate values

      _this.submitUpdate(nextHandles);
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchMove", function (e) {
      var _assertThisInitialize9 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
          _assertThisInitialize10 = _assertThisInitialize9.state,
          curr = _assertThisInitialize10.handles,
          pixelToStep = _assertThisInitialize10.pixelToStep,
          activeHandleID = _assertThisInitialize10.activeHandleID,
          _assertThisInitialize11 = _assertThisInitialize9.props,
          vertical = _assertThisInitialize11.vertical,
          reversed = _assertThisInitialize11.reversed;

      var _assertThisInitialize12 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
          slider = _assertThisInitialize12.slider;

      if (Object(__WEBPACK_IMPORTED_MODULE_16__utils__["f" /* isNotValidTouch */])(e)) {
        return;
      } // double check the dimensions of the slider


      pixelToStep.setDomain(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["b" /* getSliderDomain */])(slider.current, vertical, pixelToStep)); // find the closest value (aka step) to the event location

      var updateValue = pixelToStep.getValue(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["d" /* getTouchPosition */])(vertical, e)); // generate a "candidate" set of values - a suggestion of what to do

      var nextHandles = Object(__WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getUpdatedHandles */])(curr, activeHandleID, updateValue, reversed); // submit the candidate values

      _this.submitUpdate(nextHandles);
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMouseUp", function () {
      var _assertThisInitialize13 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
          _assertThisInitialize14 = _assertThisInitialize13.state,
          handles = _assertThisInitialize14.handles,
          activeHandleID = _assertThisInitialize14.activeHandleID,
          _assertThisInitialize15 = _assertThisInitialize13.props,
          onChange = _assertThisInitialize15.onChange,
          onSlideEnd = _assertThisInitialize15.onSlideEnd;

      onChange(handles.map(function (d) {
        return d.val;
      }));
      onSlideEnd(handles.map(function (d) {
        return d.val;
      }), {
        activeHandleID: activeHandleID
      });

      _this.setState({
        activeHandleID: null
      });

      if (isBrowser) {
        document.removeEventListener('mousemove', _this.onMouseMove);
        document.removeEventListener('mouseup', _this.onMouseUp);
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchEnd", function () {
      var _assertThisInitialize16 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)),
          _assertThisInitialize17 = _assertThisInitialize16.state,
          handles = _assertThisInitialize17.handles,
          activeHandleID = _assertThisInitialize17.activeHandleID,
          _assertThisInitialize18 = _assertThisInitialize16.props,
          onChange = _assertThisInitialize18.onChange,
          onSlideEnd = _assertThisInitialize18.onSlideEnd;

      onChange(handles.map(function (d) {
        return d.val;
      }));
      onSlideEnd(handles.map(function (d) {
        return d.val;
      }), {
        activeHandleID: activeHandleID
      });

      _this.setState({
        activeHandleID: null
      });

      if (isBrowser) {
        document.removeEventListener('touchmove', _this.onTouchMove);
        document.removeEventListener('touchend', _this.onTouchEnd);
      }
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var pixelToStep = this.state.pixelToStep;
      var vertical = this.props.vertical;
      pixelToStep.setDomain(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["b" /* getSliderDomain */])(this.slider.current, vertical, pixelToStep));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (isBrowser) {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "onStart",
    value: function onStart(e, handleID, isTouch) {
      var handles = this.state.handles,
          onSlideStart = this.props.onSlideStart;
      e.stopPropagation && e.stopPropagation();
      e.preventDefault && e.preventDefault();
      var found = handles.find(function (value) {
        return value.key === handleID;
      });

      if (found) {
        this.setState({
          activeHandleID: handleID
        });
        onSlideStart(handles.map(function (d) {
          return d.val;
        }), {
          activeHandleID: handleID
        });
        isTouch ? this.addTouchEvents() : this.addMouseEvents();
      } else {
        this.setState({
          activeHandleID: null
        });
        this.handleRailAndTrackClicks(e, isTouch);
      }
    }
  }, {
    key: "handleRailAndTrackClicks",
    value: function handleRailAndTrackClicks(e, isTouch) {
      var _this$state = this.state,
          curr = _this$state.handles,
          pixelToStep = _this$state.pixelToStep,
          _this$props = this.props,
          vertical = _this$props.vertical,
          reversed = _this$props.reversed;
      var slider = this.slider; // double check the dimensions of the slider

      pixelToStep.setDomain(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["b" /* getSliderDomain */])(slider.current, vertical, pixelToStep)); // find the closest value (aka step) to the event location

      var updateValue;

      if (isTouch) {
        updateValue = pixelToStep.getValue(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["d" /* getTouchPosition */])(vertical, e));
      } else {
        updateValue = pixelToStep.getValue(vertical ? e.clientY : e.pageX);
      } // find the closest handle key


      var updateKey = null;
      var minDiff = Infinity;

      for (var i = 0; i < curr.length; i++) {
        var _curr$i = curr[i],
            key = _curr$i.key,
            val = _curr$i.val;
        var diff = Math.abs(val - updateValue);

        if (diff < minDiff) {
          updateKey = key;
          minDiff = diff;
        }
      } // generate a "candidate" set of values - a suggestion of what to do


      var nextHandles = Object(__WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getUpdatedHandles */])(curr, updateKey, updateValue, reversed); // submit the candidate values

      this.submitUpdate(nextHandles, true);
    }
  }, {
    key: "addMouseEvents",
    value: function addMouseEvents() {
      if (isBrowser) {
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
      }
    }
  }, {
    key: "addTouchEvents",
    value: function addTouchEvents() {
      if (isBrowser) {
        document.addEventListener('touchmove', this.onTouchMove);
        document.addEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "submitUpdate",
    value: function submitUpdate(next, callOnChange) {
      var _this$props2 = this.props,
          mode = _this$props2.mode,
          step = _this$props2.step,
          onUpdate = _this$props2.onUpdate,
          onChange = _this$props2.onChange,
          reversed = _this$props2.reversed;
      var getValue = this.state.valueToStep.getValue;
      this.setState(function (_ref2) {
        var curr = _ref2.handles;
        var handles; // given the current handles and a candidate set, decide what to do

        if (typeof mode === 'function') {
          handles = mode(curr, next, step, reversed, getValue);
          __WEBPACK_IMPORTED_MODULE_9_warning___default()(Array.isArray(handles), 'Custom mode function did not return an array.');
        } else {
          switch (mode) {
            case 1:
              handles = Object(__WEBPACK_IMPORTED_MODULE_15__modes__["a" /* mode1 */])(curr, next);
              break;

            case 2:
              handles = Object(__WEBPACK_IMPORTED_MODULE_15__modes__["b" /* mode2 */])(curr, next);
              break;

            case 3:
              handles = Object(__WEBPACK_IMPORTED_MODULE_15__modes__["c" /* mode3 */])(curr, next, step, reversed, getValue);
              break;

            default:
              handles = next;
              __WEBPACK_IMPORTED_MODULE_9_warning___default()(false, "".concat(__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* prfx */], " Invalid mode value."));
          }
        }

        onUpdate(handles.map(function (d) {
          return d.val;
        }));

        if (callOnChange) {
          onChange(handles.map(function (d) {
            return d.val;
          }));
        }

        return {
          handles: handles
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          handles = _this$state2.handles,
          valueToPerc = _this$state2.valueToPerc,
          activeHandleID = _this$state2.activeHandleID,
          _this$props3 = this.props,
          className = _this$props3.className,
          rootStyle = _this$props3.rootStyle,
          disabled = _this$props3.disabled;
      var mappedHandles = handles.map(function (_ref3) {
        var key = _ref3.key,
            val = _ref3.val;
        return {
          id: key,
          value: val,
          percent: valueToPerc.getValue(val)
        };
      });
      var children = __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.map(this.props.children, function (child) {
        if (child.type.name === __WEBPACK_IMPORTED_MODULE_11__Rail__["a" /* default */].name || child.type.name === __WEBPACK_IMPORTED_MODULE_12__Ticks__["a" /* default */].name || child.type.name === __WEBPACK_IMPORTED_MODULE_13__Tracks__["a" /* default */].name || child.type.name === __WEBPACK_IMPORTED_MODULE_14__Handles__["a" /* default */].name) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(child, {
            scale: valueToPerc,
            handles: mappedHandles,
            activeHandleID: activeHandleID,
            getEventData: _this2.getEventData,
            emitKeyboard: disabled ? noop : _this2.onKeyDown,
            emitMouse: disabled ? noop : _this2.onMouseDown,
            emitTouch: disabled ? noop : _this2.onTouchStart
          });
        }

        return child;
      });
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        style: rootStyle || {},
        className: className,
        ref: this.slider
      }, children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var step = nextProps.step,
          values = nextProps.values,
          domain = nextProps.domain,
          reversed = nextProps.reversed,
          onUpdate = nextProps.onUpdate,
          onChange = nextProps.onChange,
          warnOnChanges = nextProps.warnOnChanges;
      var valueToPerc = prevState.valueToPerc;
      var valueToStep = prevState.valueToStep;
      var pixelToStep = prevState.pixelToStep;
      var nextState = {};

      if (!valueToPerc || !valueToStep || !pixelToStep) {
        valueToPerc = new __WEBPACK_IMPORTED_MODULE_17__LinearScale__["a" /* default */]();
        valueToStep = new __WEBPACK_IMPORTED_MODULE_18__DiscreteScale__["a" /* default */]();
        pixelToStep = new __WEBPACK_IMPORTED_MODULE_18__DiscreteScale__["a" /* default */]();
        nextState.valueToPerc = valueToPerc;
        nextState.valueToStep = valueToStep;
        nextState.pixelToStep = pixelToStep;
      }

      if (prevState.step === null || prevState.domain === null || prevState.reversed === null || step !== prevState.step || domain[0] !== prevState.domain[0] || domain[1] !== prevState.domain[1] || reversed !== prevState.reversed) {
        var _domain = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(domain, 2),
            min = _domain[0],
            max = _domain[1];

        var range = Object(__WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getStepRange */])(min, max, step);
        valueToStep.setRange(range).setDomain([min - step / 2, max + step / 2]);

        if (reversed === true) {
          valueToPerc.setDomain([min, max]).setRange([100, 0]);
          range.reverse();
        } else {
          valueToPerc.setDomain([min, max]).setRange([0, 100]);
        }

        pixelToStep.setRange(range);
        __WEBPACK_IMPORTED_MODULE_9_warning___default()(max > min, "".concat(__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* prfx */], " Max must be greater than min (even if reversed). Max is ").concat(max, ". Min is ").concat(min, "."));
        var maxInRange = 100001;
        __WEBPACK_IMPORTED_MODULE_9_warning___default()(range.length <= maxInRange, "".concat(__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* prfx */], " Increase step value (set to ").concat(step, " currently). Found ").concat(range.length.toLocaleString(), " values in range. Max is ").concat(maxInRange.toLocaleString(), "."));
        var last = range.length - 1;
        __WEBPACK_IMPORTED_MODULE_9_warning___default()(range[reversed ? last : 0] === min && range[reversed ? 0 : last] === max, "".concat(__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* prfx */], " The range is incorrectly calculated. Check domain (min, max) and step values."));

        var _getHandles = Object(__WEBPACK_IMPORTED_MODULE_16__utils__["a" /* getHandles */])(values || prevState.values, reversed, valueToStep, warnOnChanges),
            handles = _getHandles.handles,
            changes = _getHandles.changes;

        if (changes || values === undefined || values === prevState.values) {
          onUpdate(handles.map(function (d) {
            return d.val;
          }));
          onChange(handles.map(function (d) {
            return d.val;
          }));
        }

        nextState.step = step;
        nextState.values = values;
        nextState.domain = domain;
        nextState.handles = handles;
        nextState.reversed = reversed;
      } else if (!equal(values, prevState.values)) {
        var _getHandles2 = Object(__WEBPACK_IMPORTED_MODULE_16__utils__["a" /* getHandles */])(values, reversed, valueToStep, warnOnChanges),
            _handles = _getHandles2.handles,
            _changes = _getHandles2.changes;

        if (_changes) {
          onUpdate(_handles.map(function (d) {
            return d.val;
          }));
          onChange(_handles.map(function (d) {
            return d.val;
          }));
        }

        nextState.values = values;
        nextState.handles = _handles;
      }

      if (Object.keys(nextState).length) {
        return nextState;
      }

      return null;
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Slider.propTypes =  false ? {
  /**
   * CSS class name applied to the root div of the slider.
   */
  className: PropTypes.string,

  /**
   * An object with any inline styles you want applied to the root div.
   */
  rootStyle: PropTypes.object,

  /**
   * Two element array of numbers providing the min and max values for the slider [min, max] e.g. [0, 100].
   * It does not matter if the slider is reversed on the screen, domain is always [min, max] with min < max.
   */
  domain: PropTypes.array,

  /**
   * An array of numbers. You can supply one for a value slider, two for a range slider or more to create n-handled sliders.
   * The values should correspond to valid step values in the domain.
   * The numbers will be forced into the domain if they are two small or large.
   */
  values: PropTypes.array,

  /**
   * The step value for the slider.
   */
  step: PropTypes.number,

  /**
   * The interaction mode. Value of 1 will allow handles to cross each other.
   * Value of 2 will keep the sliders from crossing and separated by a step.
   * Value of 3 will make the handles pushable and keep them a step apart.
   * ADVANCED: You can also supply a function that will be passed the current values and the incoming update.
   * Your function should return what the state should be set as.
   */
  mode: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),

  /**
   * Set to true if the slider is displayed vertically to tell the slider to use the height to calculate positions.
   */
  vertical: PropTypes.bool,

  /**
   * Reverse the display of slider values.
   */
  reversed: PropTypes.bool,

  /**
   * Function triggered when the value of the slider has changed. This will recieve changes at the end of a slide as well as changes from clicks on rails and tracks. Receives values.
   */
  onChange: PropTypes.func,

  /**
   * Function called with the values at each update (caution: high-volume updates when dragging). Receives values.
   */
  onUpdate: PropTypes.func,

  /**
   * Function triggered with ontouchstart or onmousedown on a handle. Receives values.
   */
  onSlideStart: PropTypes.func,

  /**
   * Function triggered on ontouchend or onmouseup on a handle. Receives values.
   */
  onSlideEnd: PropTypes.func,

  /**
   * Ignore all mouse, touch and keyboard events
   */
  disabled: PropTypes.bool,

  /**
   * Warn if values to are changed to fit domain and step values.
   */
  warnOnChanges: PropTypes.bool,

  /**
   * Component children to render
   */
  children: PropTypes.any
} : {};
Slider.defaultProps = {
  mode: 1,
  step: 0.1,
  domain: [0, 100],
  vertical: false,
  reversed: false,
  onChange: noop,
  onUpdate: noop,
  onSlideStart: noop,
  onSlideEnd: noop,
  disabled: false,
  warnOnChanges: false
};
/* harmony default export */ __webpack_exports__["a"] = (Slider);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(266);



function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(41);












var Rail =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Rail, _Component);

  function Rail() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Rail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Rail)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getRailProps", function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props = _this.props,
          emitMouse = _this$props.emitMouse,
          emitTouch = _this$props.emitTouch;
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, props, {
        onMouseDown: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* callAll */])(props.onMouseDown, emitMouse),
        onTouchStart: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* callAll */])(props.onTouchStart, emitTouch)
      });
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Rail, [{
    key: "render",
    value: function render() {
      var getRailProps = this.getRailProps,
          _this$props2 = this.props,
          getEventData = _this$props2.getEventData,
          activeHandleID = _this$props2.activeHandleID,
          children = _this$props2.children;
      var renderedChildren = children({
        getEventData: getEventData,
        activeHandleID: activeHandleID,
        getRailProps: getRailProps
      });
      return renderedChildren && __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.only(renderedChildren);
    }
  }]);

  return Rail;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Rail.propTypes =  false ? {
  /** @ignore */
  getEventData: PropTypes.func,

  /** @ignore */
  activeHandleID: PropTypes.string,

  /** @ignore */
  emitMouse: PropTypes.func,

  /** @ignore */
  emitTouch: PropTypes.func,

  /**
   * A function to render the rail. Note: `getEventData` can be called with an event and get the value and percent at that location (used for tooltips etc). `activeHandleID` will be a string or null.  Function signature: `({ getEventData, activeHandleID, getRailProps }): element`
   */
  children: PropTypes.func.isRequired
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Rail);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Ticks =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Ticks, _Component);

  function Ticks() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Ticks);

    return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Ticks).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Ticks, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          values = _this$props.values,
          scale = _this$props.scale,
          count = _this$props.count,
          getEventData = _this$props.getEventData,
          activeHandleID = _this$props.activeHandleID;
      var ticks = (values ? values : scale.getTicks(count)).map(function (value) {
        return {
          id: "$$-".concat(value),
          value: value,
          percent: scale.getValue(value)
        };
      });
      var renderedChildren = children({
        getEventData: getEventData,
        activeHandleID: activeHandleID,
        ticks: ticks
      });
      return renderedChildren && __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(renderedChildren);
    }
  }]);

  return Ticks;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Ticks.propTypes =  false ? {
  /** @ignore */
  scale: PropTypes.object,

  /**
   * Approximate number of ticks you want to render.
   * If you supply your own ticks using the values prop this prop has no effect.
   */
  count: PropTypes.number,

  /**
   * The values prop should be an array of unique numbers.
   * Use this prop if you want to specify your own tick values instead of ticks generated by the slider.
   * The numbers should be valid numbers in the domain and correspond to the step value.
   * Invalid values will be coerced to the closet matching value in the domain.
   */
  values: PropTypes.array,

  /** @ignore */
  getEventData: PropTypes.func,

  /** @ignore */
  activeHandleID: PropTypes.string,

  /** @ignore */
  emitMouse: PropTypes.func,

  /** @ignore */
  emitTouch: PropTypes.func,

  /**
   * A function to render the ticks.
   * The function receives an object with an array of ticks. Note: `getEventData` can be called with an event and get the value and percent at that location (used for tooltips etc). `activeHandleID` will be a string or null.  Function signature:
   * `({ getEventData, activeHandleID, ticks  }): element`
   */
  children: PropTypes.func.isRequired
} : {};
Ticks.defaultProps = {
  count: 10
};
/* harmony default export */ __webpack_exports__["a"] = (Ticks);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(41);












var Tracks =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Tracks, _Component);

  function Tracks() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Tracks);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Tracks)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getTrackProps", function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props = _this.props,
          emitMouse = _this$props.emitMouse,
          emitTouch = _this$props.emitTouch;
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, props, {
        onMouseDown: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* callAll */])(props.onMouseDown, emitMouse),
        onTouchStart: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* callAll */])(props.onTouchStart, emitTouch)
      });
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Tracks, [{
    key: "render",
    value: function render() {
      var getTrackProps = this.getTrackProps,
          _this$props2 = this.props,
          children = _this$props2.children,
          left = _this$props2.left,
          right = _this$props2.right,
          scale = _this$props2.scale,
          handles = _this$props2.handles,
          getEventData = _this$props2.getEventData,
          activeHandleID = _this$props2.activeHandleID;
      var domain = scale.getDomain();
      var tracks = [];

      for (var i = 0; i < handles.length + 1; i++) {
        var source = handles[i - 1];
        var target = handles[i];

        if (i === 0 && left === true) {
          source = {
            id: '$',
            value: domain[0],
            percent: 0
          };
        } else if (i === handles.length && right === true) {
          target = {
            id: '$',
            value: domain[1],
            percent: 100
          };
        }

        if (source && target) {
          tracks.push({
            id: "".concat(source.id, "-").concat(target.id),
            source: source,
            target: target
          });
        }
      }

      var renderedChildren = children({
        getEventData: getEventData,
        activeHandleID: activeHandleID,
        tracks: tracks,
        getTrackProps: getTrackProps
      });
      return renderedChildren && __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.only(renderedChildren);
    }
  }]);

  return Tracks;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Tracks.propTypes =  false ? {
  /**
   * Boolean value to control whether the left most track is included in the tracks array.
   */
  left: PropTypes.bool,

  /**
   * Boolean value to control whether the right most track is included in the tracks array.
   */
  right: PropTypes.bool,

  /** @ignore */
  getEventData: PropTypes.func,

  /** @ignore */
  activeHandleID: PropTypes.string,

  /** @ignore */
  scale: PropTypes.object,

  /** @ignore */
  handles: PropTypes.array,

  /** @ignore */
  emitMouse: PropTypes.func,

  /** @ignore */
  emitTouch: PropTypes.func,

  /**
   * A function to render the tracks. The function receives an object with an array of tracks. Note: `getEventData` can be called with an event and get the value and percent at that location (used for tooltips etc). `activeHandleID` will be a string or null.  Function signature:  `({ getEventData, activeHandleID, tracks, getTrackProps }): element`
   */
  children: PropTypes.func.isRequired
} : {};
Tracks.defaultProps = {
  left: true,
  right: true
};
/* harmony default export */ __webpack_exports__["a"] = (Tracks);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(41);












var Handles =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Handles, _Component);

  function Handles() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Handles);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Handles)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "autofocus", function (e) {
      e.target.focus();
    });

    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getHandleProps", function (id) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = _this.props,
          emitKeyboard = _this$props.emitKeyboard,
          emitMouse = _this$props.emitMouse,
          emitTouch = _this$props.emitTouch;
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, props, {
        onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* callAll */])(props.onKeyDown, function (e) {
          return emitKeyboard(e, id);
        }),
        onMouseDown: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* callAll */])(props.onMouseDown, _this.autofocus, function (e) {
          return emitMouse(e, id);
        }),
        onTouchStart: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* callAll */])(props.onTouchStart, function (e) {
          return emitTouch(e, id);
        })
      });
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Handles, [{
    key: "render",
    value: function render() {
      var getHandleProps = this.getHandleProps,
          _this$props2 = this.props,
          activeHandleID = _this$props2.activeHandleID,
          children = _this$props2.children,
          handles = _this$props2.handles;
      var renderedChildren = children({
        handles: handles,
        activeHandleID: activeHandleID,
        getHandleProps: getHandleProps
      });
      return renderedChildren && __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.only(renderedChildren);
    }
  }]);

  return Handles;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Handles.propTypes =  false ? {
  /** @ignore */
  activeHandleID: PropTypes.string,

  /** @ignore */
  handles: PropTypes.array,

  /** @ignore */
  emitKeyboard: PropTypes.func,

  /** @ignore */
  emitMouse: PropTypes.func,

  /** @ignore */
  emitTouch: PropTypes.func,

  /**
   * A function to render the handles.
   * The function receives an object with an array of handles and functions to get handle props
   * `({ handles, getHandleProps }): element`
   */
  children: PropTypes.func.isRequired
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Handles);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mode1;
/* harmony export (immutable) */ __webpack_exports__["b"] = mode2;
/* harmony export (immutable) */ __webpack_exports__["c"] = mode3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(79);
/* eslint complexity: "off", max-statements: "off", max-depth: "off" */
 // default mode

function mode1(curr, next) {
  return next;
} // prevent duplicate values and crossing

function mode2(curr, next) {
  for (var i = 0; i < curr.length; i++) {
    if (curr[i].key !== next[i].key) {
      return curr;
    }

    if (next[i + 1] && next[i].val === next[i + 1].val) {
      return curr;
    }
  }

  return next;
} // pushable mode

function mode3(curr, next, step, reversed, getValue) {
  var indexForMovingHandle = -1;
  var handleMoveIsPositive = true;

  for (var i = 0; i < curr.length; i++) {
    var c = curr[i];
    var n = next[i]; // make sure keys are in same order if not return curr

    if (!n || n.key !== c.key) {
      return curr;
    } else if (n.val !== c.val) {
      indexForMovingHandle = i;
      handleMoveIsPositive = n.val - c.val > 0;
    }
  } // nothing has changed (shouldn't happen but just in case).


  if (indexForMovingHandle === -1) {
    return curr;
  } else {
    var increment = handleMoveIsPositive ? step : -step;

    for (var _i = 0; _i < next.length; _i++) {
      var n0 = next[_i];
      var n1 = next[_i + 1];

      if (n1 && n0.val === n1.val) {
        if (_i === indexForMovingHandle) {
          var newStep = n1.val + increment;

          if (getValue(newStep) === newStep) {
            var clone = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* getUpdatedHandles */])(next, n1.key, n1.val + increment, reversed);
            var check = mode3(next, clone, step, reversed, getValue);

            if (check === next) {
              return curr;
            } else {
              return check;
            }
          } else {
            return curr;
          }
        } else {
          var _newStep = n0.val + increment;

          if (getValue(_newStep) === _newStep) {
            var _clone = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* getUpdatedHandles */])(next, n0.key, n0.val + increment, reversed);

            var _check = mode3(next, _clone, step, reversed, getValue);

            if (_check === next) {
              return curr;
            } else {
              return _check;
            }
          } else {
            return curr;
          }
        }
      }
    }
  }

  return next;
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(277);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinearScale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_array__ = __webpack_require__(80);




var LinearScale =
/*#__PURE__*/
function () {
  function LinearScale() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LinearScale);

    this.domain = [0, 1];
    this.range = [0, 1];
    this.interpolator = null;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(LinearScale, [{
    key: "createInterpolator",
    value: function createInterpolator(domain, range) {
      var d0 = domain[0];
      var d1 = domain[1];
      var r0 = range[0];
      var r1 = range[1];

      if (d1 < d0) {
        d0 = this.deinterpolateValue(d1, d0);
        r0 = this.interpolateValue(r1, r0);
      } else {
        d0 = this.deinterpolateValue(d0, d1);
        r0 = this.interpolateValue(r0, r1);
      }

      return function (x) {
        return r0(d0(x));
      };
    }
  }, {
    key: "interpolateValue",
    value: function interpolateValue(a, b) {
      return a = +a, b -= a, function i(t) {
        return a + b * t;
      };
    }
  }, {
    key: "deinterpolateValue",
    value: function deinterpolateValue(a, b) {
      return (b -= a = +a) ? function (x) {
        return (x - a) / b;
      } : function () {
        return b;
      }; // eslint-disable-line
    }
  }, {
    key: "rescale",
    value: function rescale() {
      this.interpolator = null;
      return this;
    }
  }, {
    key: "getValue",
    value: function getValue(x) {
      var domain = this.domain,
          range = this.range;
      return (this.interpolator || (this.interpolator = this.createInterpolator(domain, range)))(+x);
    }
  }, {
    key: "setDomain",
    value: function setDomain(val) {
      this.domain = val.map(function (d) {
        return +d;
      });
      this.rescale();
      return this;
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return this.domain;
    }
  }, {
    key: "setRange",
    value: function setRange(val) {
      this.range = val.map(function (d) {
        return +d;
      });
      return this;
    }
  }, {
    key: "getTicks",
    value: function getTicks(count) {
      var d = this.domain;
      return Object(__WEBPACK_IMPORTED_MODULE_2_d3_array__["b" /* ticks */])(d[0], d[d.length - 1], count ? count : 10);
    }
  }]);

  return LinearScale;
}();



/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(83);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(90);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["b" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(42);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(84);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(28);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(42);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(21);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(92);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_array__ = __webpack_require__(80);





var DiscreteScale =
/*#__PURE__*/
function () {
  function DiscreteScale() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DiscreteScale);

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "getValue", function (x) {
      var range = _this.range,
          domain = _this.domain,
          n = _this.n;
      return range[Object(__WEBPACK_IMPORTED_MODULE_3_d3_array__["a" /* bisect */])(domain, x, 0, n)];
    });

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "setDomain", function (val) {
      _this.x0 = +val[0];
      _this.x1 = +val[1];

      _this.rescale();

      return _this;
    });

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "setRange", function (val) {
      _this.range = val.slice();
      _this.n = _this.range.length - 1;
      return _this;
    });

    this.x0 = 0;
    this.x1 = 1;
    this.domain = [0.5];
    this.range = [0, 1];
    this.n = 1;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(DiscreteScale, [{
    key: "rescale",
    value: function rescale() {
      var x0 = this.x0,
          x1 = this.x1,
          n = this.n;
      var i = -1;
      this.domain = new Array(n);

      while (++i < n) {
        this.domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
      }
    }
  }]);

  return DiscreteScale;
}();

/* harmony default export */ __webpack_exports__["a"] = (DiscreteScale);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactCompoundSlider=__webpack_require__(73);var _mobxReact=__webpack_require__(2);var _stores=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompoundSlider=(0,_mobxReact.observer)(_class=function(_Component){_inherits(CompoundSlider,_Component);function CompoundSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CompoundSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CompoundSlider.__proto__||Object.getPrototypeOf(CompoundSlider)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(values){_stores.presets.incInfrastructure(values[0]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CompoundSlider,[{key:'render',value:function render(){var sliderStyle={// Give the slider some width
position:'relative',width:this.props.width,height:'100%',margin:'0 auto'};var railStyle={cursor:'pointer',position:'absolute',width:this.props.width,height:8,borderRadius:5,backgroundColor:'#d9d9d9'};return _react2.default.createElement('div',{style:{padding:'0 15px'}},_react2.default.createElement('div',{style:{margin:'2rem 0  4.3rem'}},_react2.default.createElement(_reactCompoundSlider.Slider,{rootStyle:sliderStyle,domain:[3000000,5000000],values:[_stores.presets.infrastructure],mode:2,step:100000,onUpdate:this.onChange,onChange:this.onChange},_react2.default.createElement(_reactCompoundSlider.Rail,null,function(_ref2){var getRailProps=_ref2.getRailProps;return(// adding the rail props sets up events on the rail
_react2.default.createElement('div',Object.assign({style:railStyle},getRailProps())));}),_react2.default.createElement(_reactCompoundSlider.Handles,null,function(_ref3){var handles=_ref3.handles,getHandleProps=_ref3.getHandleProps;return _react2.default.createElement('div',{className:'slider-handles'},handles.map(function(handle){return _react2.default.createElement(Handle,{key:handle.id,handle:handle,getHandleProps:getHandleProps});}));}),_react2.default.createElement(_reactCompoundSlider.Tracks,{right:false},function(_ref4){var tracks=_ref4.tracks,getTrackProps=_ref4.getTrackProps;return _react2.default.createElement('div',{className:'slider-tracks'},tracks.map(function(_ref5){var id=_ref5.id,source=_ref5.source,target=_ref5.target;return _react2.default.createElement(Track,{key:id,source:source,target:target,getTrackProps:getTrackProps});}));}),_react2.default.createElement(_reactCompoundSlider.Ticks,{count:2},function(_ref6){var ticks=_ref6.ticks;return _react2.default.createElement('div',null,ticks.map(function(tick){return _react2.default.createElement(Tick,{key:tick.id,tick:tick,count:ticks.length});}));}))));}}]);return CompoundSlider;}(_react.Component))||_class;exports.default=CompoundSlider;function Handle(_ref7){var _ref7$handle=_ref7.handle,id=_ref7$handle.id,value=_ref7$handle.value,percent=_ref7$handle.percent,getHandleProps=_ref7.getHandleProps;return _react2.default.createElement('div',Object.assign({style:{left:percent+'%',position:'absolute',marginLeft:-15,padding:'0 15',zIndex:2,width:30,top:-12,height:30,border:0,textAlign:'center',cursor:'pointer',borderRadius:'50%',backgroundColor:'rgb(126, 211, 33)',color:'#333'}},getHandleProps(id)),_react2.default.createElement('div',{style:{fontFamily:'Roboto',fontSize:11,marginTop:-35}}));}function Track(_ref8){var source=_ref8.source,target=_ref8.target,getTrackProps=_ref8.getTrackProps;return _react2.default.createElement('div',Object.assign({style:{position:'absolute',height:24,zIndex:1,top:-8,backgroundColor:'#f00',opacity:0,borderRadius:5,cursor:'pointer',left:source.percent+'%',width:'100%'}},getTrackProps()));}function Tick(_ref9){var tick=_ref9.tick,count=_ref9.count;return _react2.default.createElement('div',null,_react2.default.createElement('div',{style:{position:'absolute',marginTop:22,marginLeft:-0.5,width:1,height:8,backgroundColor:'silver',left:tick.percent+'%'}}),_react2.default.createElement('div',{style:{position:'absolute',marginTop:30,fontSize:10,textAlign:'center',marginLeft:-(100/count)/2+'%',width:100/count+'%',left:tick.percent+'%'}},tick.value/1000000+' млн'));}module.exports=exports['default'];

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(11);var _index=__webpack_require__(298);var _index2=_interopRequireDefault(_index);var _reactYoutube=__webpack_require__(93);var _reactYoutube2=_interopRequireDefault(_reactYoutube);var _index3=__webpack_require__(1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Landing=function(_Component){_inherits(Landing,_Component);function Landing(){_classCallCheck(this,Landing);return _possibleConstructorReturn(this,(Landing.__proto__||Object.getPrototypeOf(Landing)).apply(this,arguments));}_createClass(Landing,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:_index2.default.youtubeContainer},_react2.default.createElement(_reactYoutube2.default,{className:_index2.default.video,videoId:'T8hxgjIOcZ0',opts:{playerVars:{autoplay:1,loop:0,rel:0,modestbranding:1,showinfo:0,controls:0,start:4}},onReady:function onReady(e){e.target.mute();_this2.setState({video:e.target});}})),_react2.default.createElement('div',{className:_index2.default.hoverWindow},_react2.default.createElement(_reactRouterDom.Link,{to:_index3.presets.gameCreate?"/app":"/",className:_index2.default.menuButton+(_index3.presets.gameCreate?' '+_index2.default.active:'')},'\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0441\u0438\u043C\u0443\u043B\u044F\u0446\u0456\u044E'),_react2.default.createElement(_reactRouterDom.Link,{to:'/elevatorbuild',className:_index2.default.menuButton+' '+_index2.default.active},'\u041D\u043E\u0432\u0430 \u0441\u0438\u043C\u0443\u043B\u044F\u0446\u0456\u044F'),_react2.default.createElement('a',{href:'/logout',onClick:function onClick(){return fetch('/logout');},className:_index2.default.menuButton+' '+_index2.default.active},'\u0412\u0438\u0439\u0442\u0438')));}}]);return Landing;}(_react.Component);exports.default=Landing;module.exports=exports['default'];

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"youtubeContainer":"_2BYPL74Bm7f-HhIhITSJtP","hoverWindow":"_2ZEfHFVaU2fRsEvc2BQNGq","menuButton":"_2cVlicT6ICXSLWwiiy8-YZ","active":"Iy-qOw7R8jcdzvHpEfmvd","kekek":"_32S_I7KDS6QSDuoHiNcyrV"};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a!==a && b!==b;
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(301);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(302);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(304);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(303);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),
/* 303 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__(305);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(309);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(310);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(311);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(307);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(306)))

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(308);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__(312);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(11);var _index=__webpack_require__(314);var _index2=_interopRequireDefault(_index);var _reactYoutube=__webpack_require__(93);var _reactYoutube2=_interopRequireDefault(_reactYoutube);var _reactFontawesome=__webpack_require__(8);var _reactFontawesome2=_interopRequireDefault(_reactFontawesome);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Login=function(_Component){_inherits(Login,_Component);function Login(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Login);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Login.__proto__||Object.getPrototypeOf(Login)).call.apply(_ref,[this].concat(args))),_this),_this.state={visible:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Login,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:_index2.default.youtubeContainer},_react2.default.createElement(_reactYoutube2.default,{className:_index2.default.video,videoId:'T8hxgjIOcZ0',opts:{playerVars:{autoplay:1,loop:0,rel:0,modestbranding:1,showinfo:0,controls:0,start:4}},onReady:function onReady(e){e.target.mute();_this2.setState({video:e.target});}})),_react2.default.createElement('div',{className:_index2.default.hoverWindow},_react2.default.createElement('form',{noValidate:true},_react2.default.createElement('div',null,_react2.default.createElement('h2',null,'Login')),_react2.default.createElement('div',null,_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Enter your Email:'),_react2.default.createElement('span',{className:_index2.default.inputContainer},_react2.default.createElement('input',{name:'email',type:'email',placeholder:'Enter your account email please'})))),_react2.default.createElement('div',null,_react2.default.createElement('div',null,_react2.default.createElement('span',null,'Enter your Password:'),_react2.default.createElement('span',{className:_index2.default.inputContainer},_react2.default.createElement('input',{name:'password',type:this.state.visible?"text":"password",placeholder:'Enter your account password'}),this.state.visible?_react2.default.createElement(_reactFontawesome2.default,{name:'far fa-eye',className:_index2.default.eyeIcon,onClick:function onClick(){_this2.setState({visible:!_this2.state.visible});}}):_react2.default.createElement(_reactFontawesome2.default,{name:'far fa-eye-slash',className:_index2.default.eyeIcon,onClick:function onClick(){_this2.setState({visible:!_this2.state.visible});}})))),_react2.default.createElement('div',{className:_index2.default.submit},_react2.default.createElement('div',null,_react2.default.createElement('span',null,_react2.default.createElement(_reactRouterDom.Link,{to:'/repassword'},'Forgot your password?')),_react2.default.createElement('span',null,'Don\u2019t have an account?',_react2.default.createElement(_reactRouterDom.Link,{to:'/signup'},' Please Register'))),_react2.default.createElement(_reactRouterDom.Link,{to:'/',className:_index2.default.menuButton},'Login')))));}}]);return Login;}(_react.Component);exports.default=Login;module.exports=exports['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"youtubeContainer":"_2X1KVYrb3A0SV_Viyndw8t","hoverWindow":"_2kvoCD-vxJOaRZhlwGvLyZ","menuButton":"_2LouU4uba9C9CU3IQTpkb","eyeIcon":"_247Pv142MgjOhMG7BHqVKj","inputContainer":"NL-HDzD7ySP_dVuSG2zfX","submit":"_1Nhsujx69EzNL_nVq0fuhW"};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=register;exports.unregister=unregister;// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.3741da49.js